import React, { useEffect, useState, useRef, useCallback } from "react";
import { IoIosFootball, IoMdArrowRoundBack } from "react-icons/io";
import {
  MdClose,
  MdContentCopy,
  MdOutlineEdit,
  MdOutlineFlipCameraIos,
  MdOutlineResetTv,
} from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";
import { CgNotes } from "react-icons/cg";
import { MdChecklistRtl } from "react-icons/md";
import { FaMinus, FaPlus, FaRegSquareFull } from "react-icons/fa6";
import { HiOutlineCube } from "react-icons/hi";
import { FaChevronLeft, FaChevronRight, FaMapMarkerAlt, FaRegUser } from "react-icons/fa";
import { IoMdAddCircleOutline } from "react-icons/io";
import { LuMoreVertical, LuPlusCircle } from "react-icons/lu";
import { RxCross2 } from "react-icons/rx";
import * as THREE from "three";
import "./twilio.scss";
import { MdDeleteOutline } from "react-icons/md";
import Accordion from "react-bootstrap/Accordion";
import { LuPencil } from "react-icons/lu";
import { FaArrowRightLong } from "react-icons/fa6";
import feedbackIcon from "../../icons/chilllIcons/icon.svg";
import CameraAlertImg from "../../media/images/CameraAlertImg.png";
import { FaExclamation } from "react-icons/fa";
import { TbRulerMeasure, TbZoomCancel } from "react-icons/tb";
import { IoIosQrScanner } from "react-icons/io";
import { GrPowerReset } from "react-icons/gr";
import {
  BsFillMicFill,
  BsFillCameraVideoFill,
  BsFillCameraVideoOffFill,
  BsFillMicMuteFill,
  BsCircle,
  BsPip,
  BsZoomIn,
  BsZoomOut,
} from "react-icons/bs";
import { VscSend } from "react-icons/vsc";
import { FiDownload, FiMoreVertical } from "react-icons/fi";
import {
  ImAttachment,
  ImCancelCircle,
  ImCross,
  ImPhoneHangUp,
} from "react-icons/im";
import {
  MdCameraswitch,
  MdDraw,
  MdFlashlightOn,
  MdFormatColorReset,
  MdOutlineDraw,
  MdOutlineFlashlightOff,
  MdResetTv,
  MdScreenSearchDesktop,
  MdSend,
  MdSettings,
} from "react-icons/md";
import { BiScreenshot } from "react-icons/bi";
import cv from "opencv-ts";
import { BsSquareFill, BsArrowLeftRight } from "react-icons/bs";
import { HiZoomIn, HiZoomOut } from "react-icons/hi";
import { GrCircleAlert } from "react-icons/gr";

import { BiText } from "react-icons/bi";

import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { drawActive, drawDisable, setIsCheckInCall } from "../../feature/userData/userData";
import { FaCloudDownloadAlt, FaUserAlt } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
// import MessageBox from "../../ui/messageBox/messageBox";
import { callNote } from "../../service/api/callHistory/callNote";

import { useLocation, useNavigate } from "react-router-dom";
import sendOverallFeedback from "../../service/api/user/sendOverallFeedback";
import { callDetails } from "../../service/api/callHistory/callDetails";
import { deleteCallHistory } from "../../service/api/callHistory/deleteSingleDetails";
import { callNoteDetails } from "../../service/api/callHistory/callNoteDetails";
import InternationalPhoneFormatFun from "../../ui/InternationalPhoneFormatFun";
import disconnectFromCall from "../../service/api/twilio-video/disconnectCall";

// import audioSound from "../../media/sounds/joineffect.mp3";
// import audioLeaveSound from "../../media/sounds/leaveeffect.mp3"
import PrimaryButton from "../../jsx/components/button/primaryButton";
import {
  Button,
  Col,
  Modal,
  OverlayTrigger,
  Popover,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import InputField from "../../jsx/components/fields/inputField";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import DrawTextModal from "../../component/videoCallModals/drawTextModal";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import TextArea from "../../jsx/components/fields/textArea";
import FeedbackModal from "../../jsx/components/feedback/feedback";
import { getCountryCode } from "../../service/api/countryCode/countryCode";
import { RemoteAudioTrack } from "twilio-video";
import CallDuration from "./callDuration/callDuration";
import PurchaseList from "../../jsx/components/purchaseList/purchaseList";
import { TbHandFinger } from "react-icons/tb";
import { getPurchaseList } from "../../service/api/ticket/getPurchaseList";
import { createPurchaseItem } from "../../service/api/ticket/createPurchaseItem";
import deletePurchaseItem from "../../service/api/ticket/deletePurchaseItem";
import updatePurchaseItem from "../../service/api/ticket/updatePurchaseItem";
import {
  emailValidation,
  formatTimeCommon,
  noSpaceOnChange,
  phoneValidation,
} from "../../functions/validations";
import sharePurchaseList from "../../service/api/ticket/sharePurchaseList";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import { validEmail_OR_MobileNumberText } from "../../dataBaseFile/error";
import { FaCircleInfo } from "react-icons/fa6";
import { txtMessage, txtTypeComments } from "../../dataBaseFile/label";
import { PiCircleDashedFill, PiToolboxBold } from "react-icons/pi";
import { deleteCallLogNoteById } from "../../service/api/callHistory/deleteCallLogNoteById";
import AvailableResources from "./avaialbleResources";
import { GiLaserburn } from "react-icons/gi";
import TwilioRoomModal from "../../jsx/components/twilioRoom/twilioCallScreenshot";
import TwilioRoomScreenShotModal from "../../jsx/components/twilioRoom/twilioCallScreenshot";
import RecogObj from "../../service/api/recognition/captureAndRecognize";
import ocr from "../../service/api/recognition/ocr";
import OcrResponseModal from "../../jsx/components/resultModal/resultModal";
import NetworkQualityBar from "./networkBars/networkBars";
import ResponceForAPI from "../../component/backDrop/responcesForAPI";
import BackDropReconnecting from "../../component/backDrop/backDropReconnecting";
import { IoBagCheck, IoChevronBackSharp, IoCloseSharp } from "react-icons/io5";
import searchImg from '../../media/images/servicesAssets/searchImg.png'
import emptyListImg from '../../media/images/servicesAssets/emptyListImg.png'
import { getHomeAreaListApi } from "../../service/api/homeMaintenance/getHomeAreaList";
import { addNewHomeAreaApi } from "../../service/api/homeMaintenance/addNewHomeArea";
import SelectInputFrequency from "../../jsx/components/fields/selectInputFrequency";
import SelectInputPeriod from "../../jsx/components/fields/selectInputPeriod";
import addUpdateMaintenancePlanApi from "../../service/api/homeMaintenance/addUpdateMaintenancePlan";
import SelectInputProductTypes from "../../jsx/components/fields/selectInputProductTypes";
import SelectInputCondition from "../../jsx/components/fields/selectInputCondition";
import { getAllProductTypeListApi } from "../../service/api/object/getAllProductTypeList";
import addUpdateInventoryItemApi from "../../service/api/homeMaintenance/addUpdateInventoryItem";
import deleteInventoryItemApi from "../../service/api/homeMaintenance/deleteInventoryItem";
import startStopCheckingItemApi from "../../service/api/homeMaintenance/startStopCheckingItem";
import { urlPattern } from "../../validations/validation";

import houseImg from '../../media/images/maintenanceAssets/houseImg.png'
import checkUpResultImg from '../../media/images/maintenanceAssets/checkUpResultImg.png'
import proInspectorImg from '../../media/images/maintenanceAssets/proInspectorImg.png'
import customerImg from '../../media/images/authAssets/customerImg.png'
import { getCheckupReportApi } from "../../service/api/homeMaintenance/getCheckupReport";
import { getHomeMaintenancePlansApi } from "../../service/api/homeMaintenance/getHomeMaintenancePlans";

import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { TiSpanner } from 'react-icons/ti';
import { MdOutlineCancel } from 'react-icons/md';
import { LuArrowUpDown } from 'react-icons/lu';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaSearch } from 'react-icons/fa';
import deleteMaintenancePlanApi from "../../service/api/homeMaintenance/deleteMaintenancePlan";
import deleteNewHomeAreaApi from "../../service/api/homeMaintenance/deleteNewHomeArea";
import { ticketDetailsApi } from "../../service/api/ticket/getTicketDetails";
import { saveCallDurationApi } from "../../service/api/video/saveCallDuration";
import ResetTimerDuration from "./callDuration/resetTimerDuration";
import ScanQrModalTwilio from "./scanQrModalTwilio";
import sourcingInfoFromDeviceModelApi from "../../service/api/object/sourcingInfoFromDeviceModel";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement";
import VideoCropperModal from "./videoCropModal";
import googleSourcingInfoFromDeviceModelApi from "../../service/api/object/googleSourcingInfoFromDeviceModel";
import updateTicketDetail from "../../service/api/ticket/updateTicketDetail";
import { HiMiniWrenchScrewdriver } from "react-icons/hi2";
import { RiQrScan2Line } from "react-icons/ri";
import videoGIFMeasure from "../../icons/photos/loaderImg.gif"
import giif from "../../images/GIF/giif.gif"
import ImagePreviewer from "../../jsx/components/imagePreviewer/imagePreviewer";
import updateTicketSummaryApi from "../../service/api/ticket/updateTicketSummary";
import { getPaymentConfigApi } from "../../service/api/paymentGateway/getPaymentConfig";
import { createComposeRecordingApi } from "../../service/api/video/createComposeRecording";
const newChatArr = [];

const Room = ({
  roomName,
  room,
  handleLogout,
  remoteU,
  remoteParId,
  joinCallRes,
  ReconnectingAfterTimeout,
  saveDurationByPro,
  saveDurationByCustomer,
  disconnectMyRoom
}) => {
  const { role, userName, totalCallTimeRedux } = useSelector((state) => state.user);
  const { permissionArr } = useSelector((state) => state.user);
  const permissionArray = permissionArr[0] || [];
  const audioSoundRef = useRef(null);
  const audioLeaveSoundRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [usePhoneApp, setUsePhoneApp] = useState(false);
  const [usePhoneMessageAlert, setUsePhoneMessaegAlert] = useState(false);
  const [usePhoneModalMessage, setUsePhoneModalMessage] = useState("");
  const { drawingArea } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hiddenFileInput = useRef(0);
  const hiddenFileInputDrawer = useRef(0);

  // const [elements, setElements] = useState([]);
  const [callDetailsObj, setCallDetailsObj] = useState({});
  const [receiverData, setReceiverData] = useState([]);
  const [roomConnectedStatus, setRoomConnectedStatus] = useState("")
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [time, setTime] = useState(0);
  const [openCallDialog, setOpenCallDialog] = useState(false);
  const [discussionVal, setDiscussionVal] = useState("");
  const [callNoteDetailsArr, setCallNoteDetailsArr] = useState([]);
  const [wakeLock, setWakeLock] = React.useState(null);
  const [ticketDisplayName, setTicketDisplayName] = useState("");
  const [ocrCropModal, setOcrCropModal] = useState(false)
  // =============================

  const [detailsSection, setDetailsSection] = useState(true);
  const [attachmentSection, setAttachmentSection] = useState(false);
  const [fileName, setFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [selectedFileLimit, setSelectedFileLimit] = useState("");
  // const [preview, setPreview] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const [discussionLoading, setDiscussionLoading] = useState(false);
  const [deleteIconVisiblity, setDeleteIconVisiblity] = useState({
    visibility: "hidden",
  });
  const [showUserRating, setShowUserRating] = useState(0);

  const [phoneNumberFormat, setphoneNumberFormat] = useState();
  const [shapes, setShapes] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedShape, setSelectedShape] = useState(null);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const [resizing, setResizing] = useState(false);
  const [resizingShape, setResizingShape] = useState(false);
  const [cursorValue, setCursorValue] = useState("default");
  const [dummyShape, setDummyShape] = useState({});
  const [resizeArea, setResizeArea] = useState("");
  const intervalIdRef = useRef(null);
  const [laserLinesArr, setLaserLinesArr] = useState([]);
  const [freehandLinesArr, setFreehandLinesArr] = useState([]);
  const [laserPointToSend, setLaserPointToSend] = useState([]);
  const [freehandPointToSend, setFreehandPointToSend] = useState([]);
  const [image, setImage] = useState(null);
  const [ocrResultModal, setOcrResultModal] = useState(false);
  const [ocrOutput, setOcrOutput] = useState("");
  const [micControl, setMicControl] = useState("micOff");
  const [flashLightControl, setFlashLightControl] = useState("flashOff");
  const [participantMicStatus, setParticipantMicStatus] = useState(false);
  const [recievedDimensionHeight, setRecievedDimensionHeight] = useState(1);
  const [recievedDimensionWidth, setRecievedDimensionWidth] = useState(1);
  const [isDrawShapes, setIsDrawShapes] = useState(false);
  const [remoteSayOcr, setRemoteSayOcr] = useState(false);
  const [messageFromOcr, setMessageFromOcr] = useState(false);
  const [measuringStatus, setMeasuringStatus] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [micStatus, setMicStatus] = useState(true);
  const [videoStatus, setVideoStatus] = useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [remoteSayMuteMic, setRemoteSayMuteMic] = useState(false);
  const [remoteSayUnmuteMic, setRemoteSayUnmuteMic] = useState(false);
  const [remoteSayFlipCamera, setRemoteSayFlipCamera] = useState(false);
  const [recStartX, setRecStartX] = useState(0);
  const [recStartY, setRecStartY] = useState(0);
  const [recWidth, setRecWidth] = useState(0);
  const [recHeight, setRecHeight] = useState(0);
  const [trackingVal, setTrackingVal] = useState(false);
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);
  const [dataTracks, setDataTracks] = useState([]);
  const [videoTracksRemote, setVideoTracksRemote] = useState([]);
  const [audioTracksRemote, setAudioTracksRemote] = useState([]);
  const [dataTracksRemote, setDataTracksRemote] = useState([]);
  const [videoWidth, setVideoWidth] = useState();
  const [videoHeight, setVideoHeight] = useState();
  const [drawingStarted, setDrawingStarted] = useState(false);
  const [audioAndVideoAlert, setAudioAndVideoAlert] = useState(false);
  const [zoomScale, setZoomScale] = useState({ scale: 0 });
  const [remoteAvatar, setRemoteAvatar] = useState(false);
  const [localAvatar, setLocalAvatar] = useState(false);
  const [zeroParticipant, setZeroParticipant] = useState(true);
  const [drawCircle, setDrawCircle] = useState(false);
  const [drawLine, setDrawLine] = useState(false);
  const [drawRectangle, setDrawRectangle] = useState(false);
  const [drawText, setDrawText] = useState(false);
  const [laserLine, setLaserLine] = useState(false);
  const [textAlert, setTextAlert] = useState(false);
  const [freehand, setFreehand] = useState(false)
  const [messageOfChat, setMessageOfChat] = useState("");
  const [networkLevel, setNetworkLevel] = useState(1);
  const [newBox, setNewBox] = useState(true);
  const [localMessage, setLocalMessage] = useState("");

  const [showTrackControl, setShowTrackControl] = useState(false);
  const [messageArrLength, setMessageArrLength] = useState(0);

  const [showChat, setShowChat] = useState(false);

  const [renderMenuBar, setRenderMenuBar] = useState(1);
  const [professionalName, setProfessionalName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [shapesLength, setShapesLength] = useState(0);
  const [textShapeMessageErr, setTextShapeMessageErr] = useState(false);

  const [shapesArr, setShapesArr] = useState([]);

  const [chatAlertArrLength, setChatAlertArrLength] = useState(0);

  const [liveDrawingChecks, setLiveDrawingChecks] = useState(false);
  const [cameraCheckCustomer, setCameraCheckCustomer] = useState(true);

  const [openDialog, setOpenDialog] = useState(true);
  const [uploadPhoto, setUplaodPhoto] = useState(false);
  const [keyText, setKeyText] = useState("");
  const [openChatAlert, setOpenChatAlert] = useState(false);
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [timer, setTimer] = useState();

  const [openParticipantDisconnectMsg, setOpenParticipantDisconnectMsg] =
    useState(false);
  const [toggleCheckDrawingType, setToggleCheckDrawingType] = useState(false);

  const [zoomCounter, setZoomCounter] = useState(0);
  const [toggleFlashLight, setToggleFlashLight] = useState(false);

  const [isProGivingEstimationsReport, setIsProGivingEstimationsReport] = useState(false);

  const [customerDisconnected, setCustomerDisconnected] = useState(false);
  const [currentHeightOfVideoBox, setCurrentHeightOfVideoBox] = useState(
    window.innerHeight
  );
  const [currentWidthOfVideoBox, setCurrentWidthOfVideoBox] = useState(
    window.innerWidth
  );
  const [isSavingScreen, setIsSavingScreen] = useState(false);

  const [resourceModal, setResourceModal] = useState(false);
  const [screenshotModal, setScreenshotModal] = useState(false);
  const [isLoadingActive, setIsLoadingActive] = useState(false);
  const [notesCounter, setNotesCounter] = useState(0);
  const [shoppingListCounter, setShoppingListCounter] = useState(0);
  const [reconnectingScreen, setReconnectingScreen] = useState(false);

  const [checkUpCounter, setCheckUpCounter] = useState(0);

  const [OCRSteps, setOCRSteps] = useState(1);

  const [OCRText, setOCRText] = useState(``)
  const [localParticipantReconnecting, setLocalParticipantReconnecting] = useState(false);

  const [serviceDetailsObj, setServiceDetailsObj] = useState({});

  const [timeLeftToEndCall, setTimeLeftToEndCall] = useState(joinCallRes.remaining_time_in_sec * 1000)
  const [chargeForCallModalStatus, setChargeForCallModalStatus] = useState(false)
  const [chargeMeStatus, setChargeMeStatus] = useState(false)
  const [threeDStatus, setThreeDModeStatus] = useState(false)
  const [showMeasureGif, setShowMeasureGif] = useState(false)

  const [remotePlatform, setRemotePlatform] = useState("")
  const [manualsFormHeight, setManualsFormHeight] = useState(0)
  const manualsFormHeightRef = useRef();

  const shoppingItemLinkWidthRef = useRef();
  const [shoppingItemLinkWidth, setShoppingItemLinkWidth] = useState(0);

  const [notesMessage, setNotesMessage] = useState("");

  const [estimateCost, setEstimateCost] = useState(`0`);
  const [estimateDisposal, setEstimateDisposal] = useState(`0`);
  const [estimateLabor, setEstimateLabor] = useState(`0`);
  const [estimatedCostByPro, setEstimatedCostByPro] = useState(`0`);
  const [updateTicketSummaryLoading, setUpdateTicketSummaryLoading] = useState(false);
  const [serviceSummaryMetaData, setServiceSummaryMetaData] = useState({});

  const [proCheckInfoModalTrigger, setProCheckInfoModalTrigger] = useState(false);

  const [proCheckInfoModalConfirmTrigger, setProCheckInfoModalConfirmTrigger] = useState(false);

  const [proDiagnosis, setProDiagnosis] = useState("");
  const [proEstimatedCostMin, setProEstimatedCostMin] = useState(``);
  const [proEstimatedCostMax, setProEstimatedCostMax] = useState(``);
  const [proRecommendedSolution, setProRecommendedSolution] = useState(0);

  const [proDiagnosisErr, setProDiagnosisErr] = useState(false);
  const [proRecommendedSolutionErr, setProRecommendedSolutionErr] = useState(false);

  const [paymentGatewayFlag, setPaymentGatewayFlag] = useState(0);
  const [callChargeAmount, setCallChargeAmount] = useState(0);
  const [callDurationTimeLimit, setCallDurationTimeLimit] = useState(0);
  const [callChargeDescription, setCallChargeDescription] = useState("");

  const [tabsForEstimationsModal, setTabsForEstimationsModal] = useState(1);

  const handleProDiagnosis = (e) => {
    setProDiagnosisErr(false);
    setProDiagnosis(e.target.value);
  };

  const handleProEstimatedCostMin = (e) => {
    setProEstimatedCostMin(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  const handleProEstimatedCostMax = (e) => {
    setProEstimatedCostMax(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  useEffect(() => {
    if (+proEstimatedCostMin > +proEstimatedCostMax) {
      setProEstimatedCostMax((+proEstimatedCostMin * 1.2).toFixed(2));
    }
  }, [proEstimatedCostMin])

  useEffect(() => {
    setProRecommendedSolutionErr(false);
  }, [proRecommendedSolution])

  const handleEstimateCost = (e) => {
    setEstimateCost(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  const handleEstimateDisposal = (e) => {
    setEstimateDisposal(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  const handleEstimateLabor = (e) => {
    setEstimateLabor(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  const handleEstimatedCostByPro = (e) => {
    setEstimatedCostByPro(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  const handleUpdateTicketSummary = (e) => {
    e?.preventDefault();

    const safeNum = (val) => isNaN(parseFloat(val)) ? 0 : parseFloat(val);

    if (!proDiagnosis.trim()) {
      setProDiagnosisErr(true);
    }

    if (!proRecommendedSolution) {
      setProRecommendedSolutionErr(true);
    }

    if (proDiagnosis && proRecommendedSolution) {
      let summary_meta_data = {
        recognized_image_summary: serviceSummaryMetaData?.recognized_image_summary || '',
        recognized_estimation_summary: serviceSummaryMetaData?.recognized_estimation_summary || '',
        recognized_repair_and_install_summary: serviceSummaryMetaData?.recognized_repair_and_install_summary || '',
        estimate_costing: {
          cost: safeNum(estimateCost),
          disposal_cost: safeNum(estimateDisposal),
          labor_cost: safeNum(estimateLabor),
          total_range: safeNum(estimateCost) + safeNum(estimateDisposal) + safeNum(estimateLabor),
        },
        repair_install_costing: {
          estimated_cost_by_pro: safeNum(estimatedCostByPro),
        },
        pro_check_info: {
          pro_diagnosis: proDiagnosis,
          pro_estimated_cost_min: safeNum(proEstimatedCostMin),
          pro_estimated_cost_max: safeNum(proEstimatedCostMax),
          pro_recommended_solution: proRecommendedSolution,
        },
        is_estimations_call: 0,
        is_recommendation_updated_by_cust: 0,
      }

      setUpdateTicketSummaryLoading(true);

      // setProductManualFlag(val);

      let formData = new FormData();

      formData.append("ticket_id", localStorage.getItem("ticket_id"));
      formData.append("summary", JSON.stringify(summary_meta_data));


      dispatch(
        updateTicketSummaryApi(
          formData,
          (res) => {
            dispatch(setIsCheckInCall(true));

            getServiceDetailsFn();

            // saveCallDurationForEstimationsCall();
            // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
            // console.log(res?.data?.data?.manual, "here");

            // Real time update service estimation and installation data on customer side
            // const [localValue] = [...room.localParticipant.dataTracks.values()];
            // localValue.track.send("parts_manual");

            setResponceMsg(res.data.message);
            setToasterType("success");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);

            // setTimeout(() => {
            //   setUpdateTicketSummaryLoading(false);
            //   setProCheckInfoModalConfirmTrigger(false);
            //   handleLogout();
            // }, 2000)
          },
          (res) => {
            console.log(res);
            setUpdateTicketSummaryLoading(false);

            setResponceMsg(res.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }
  }

  const formatEstimatesRepairStrings = (str) => {
    if (!str) return `Description not specified`;
    str?.split(/\\n|\n/)
      .map((line, idx) => {
        const match = line.match(/\*\*(.+?)\*\*/);
        if (match) {
          const label = match[1];
          const value = line.replace(/^\d+\.\s+\*\*(.+?)\*\*:\s?/, "");
          return (
            <div key={idx}>
              <strong>{label}:</strong> {value}
            </div>
          );
        }
        return <div key={idx}>{line}</div>;
      })
  }


  const partsAndManualsInfo = (
    <Tooltip id="tooltip">
      <strong>
        {`Device type eg: Refrigerator, Air Conditioner, etc`}
      </strong>
    </Tooltip>
  );

  const handleClearOCRSteps = () => {
    setOCRSteps(2);
    setOCRText("")
    if (!drawingArea) {
      const video = document.getElementById("LP");

      if (!video) return;
      video.play();
    }
    setOcrResultModal(false);
    const [localValue] = [
      ...room.localParticipant.dataTracks.values(),
    ];

    localValue.track.send("stop_ocr");
  }

  const handleStartOCR = () => {

    setOCRSteps(2);

  }



  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const requestWakeLock = async () => {
    try {
      const lock = await navigator.wakeLock.request("screen");
      setWakeLock(lock);
      console.log("Wake Lock is active");

      lock.addEventListener("release", () => {
        console.log("Wake Lock was released");
        setWakeLock(null);
      });
    } catch (err) {
      console.error(`Failed to obtain wake lock: ${err.message}`);
    }
  };


  React.useEffect(() => {
    console.log("HH", room)
    requestWakeLock();

    return () => {
      wakeLock?.release().then(() => {
        console.log("Wake Lock was released on cleanup");
      });
    };
  }, []);

  useEffect(() => {
    const height = myDivRef?.current.getBoundingClientRect().height;
    const width = myDivRef?.current.getBoundingClientRect().width;

    setCurrentHeightOfVideoBox(height);
    setCurrentWidthOfVideoBox(width);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setToggleCheckDrawingType(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [toggleCheckDrawingType]);

  const [feedbackModal, setFeedbackModal] = useState(false);

  function handleFeedbackModal() {
    setFeedbackModal(false);
  }

  //  ====================   Local Video audio track ===============================

  const videoRef = useRef();
  const audioRef = useRef();

  // ====================== Toggle Mic and flash light ==========================

  // ----------------handling zooming & panning---------------------------

  const pipSupported = document.pictureInPictureEnabled;

  useEffect(() => {
    setTimeout(() => {
      setOpenChatAlert(false);
    }, 15000);
  }, [openChatAlert]);

  useEffect(() => {
    localStorage.setItem("keyText", "");

    setShowTrackControl(false);
  }, [room]);
  const setHeightWidthFn = () => {
    if (window.innerWidth > 520) {
      setVideoHeight(window.innerHeight);

      setVideoWidth(
        (window.innerHeight * recievedDimensionWidth) /
        recievedDimensionHeight
      );
    }

    if (
      window.innerWidth > 480 &&
      window.innerWidth < 519 &&
      window.innerHeight > 620
    ) {
      setVideoWidth(window.innerWidth);
      setVideoHeight(
        (window.innerWidth * recievedDimensionHeight) / recievedDimensionWidth
      );
    }
    if (window.innerWidth < 480) {
      if (role === 2 || joinCallRes.is_sender_flag === 0) {
        console.log(window.innerWidth, window.innerHeight);
        setVideoWidth(window.innerWidth);
        setVideoHeight(window.innerHeight);
      } else {
        setVideoWidth(window.innerWidth);
        setVideoHeight(
          (window.innerWidth * recievedDimensionHeight) /
          recievedDimensionWidth
        );
      }
    }
    if (window.innerWidth < 600) {
      setNewBox(false);
    } else {
      setNewBox(true);
    }
  };
  window.addEventListener("resize", () => {
    setHeightWidthFn()
    // const height = myDivRef?.current?.getBoundingClientRect()?.height;
    // const width = myDivRef?.current?.getBoundingClientRect()?.width;

    // setCurrentHeightOfVideoBox(height);
    // setCurrentWidthOfVideoBox(width);
    // if (window.innerWidth > 520) {
    //   setVideoHeight(height);

    //   setVideoWidth(
    //     (height * recievedDimensionWidth) / recievedDimensionHeight
    //   );
    // }

    // if (
    //   window.innerWidth > 480 &&
    //   window.innerWidth < 520 &&
    //   window.innerHeight > 620
    // ) {
    //   setVideoWidth(window.innerWidth);
    //   setVideoHeight(
    //     (window.innerWidth * recievedDimensionHeight) / recievedDimensionWidth
    //   );
    // }

    // if (window.innerWidth < 480) {
    //   if (role === 2 || joinCallRes?.is_sender_flag === 0) {
    //     setVideoWidth(window.innerWidth);
    //     setVideoHeight(window.innerHeight);
    //   } else {
    //     setVideoWidth(window.innerWidth);
    //     setVideoHeight(
    //       (window.innerWidth * recievedDimensionHeight) / recievedDimensionWidth
    //     );
    //   }
    // }
  });

  useEffect(() => {

    setHeightWidthFn();
  }, [recievedDimensionHeight, recievedDimensionWidth]);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      for (var i = 0; i < devices.length; i++) {
        var device = devices[i];
        if (device.kind === "videoinput") {
          var option = document.createElement("option");
          option.value = device.deviceId;
          option.text = device.label || "camera " + (i + 1);
          // document.querySelector('select#videoSource').appendChild(option);
        }
      }
    });
  }, [audioAndVideoAlert]);

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication?.track)
      .filter((track) => track !== null);

  useEffect(() => {
    setVideoTracks(trackpubsToTracks(room.localParticipant.videoTracks));
    setAudioTracks(trackpubsToTracks(room.localParticipant.audioTracks));
    setDataTracks(trackpubsToTracks(room.localParticipant.dataTracks));

    const trackSubscribed = (track) => {
      if (track.kind === "video") {

        setVideoTracks((videoTracks) => [...videoTracks, track]);
      } else if (track.kind === "audio") {
        setAudioTracks((audioTracks) => [...audioTracks, track]);
      } else if (track.kind === "data") {
        setDataTracks((dataTracks) => [...dataTracks, track]);
      }
    };

    const trackUnsubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => videoTracks.filter((v) => v !== track));
      } else if (track.kind === "audio") {
        setAudioTracks((audioTracks) => audioTracks.filter((a) => a !== track));
      }
    };

    room.localParticipant.on("trackSubscribed", trackSubscribed);
    room.localParticipant.on("trackUnsubscribed", trackUnsubscribed);

    if (!videoStatus) {
      room.localParticipant.videoTracks.forEach(function (track) {
        track.track.disable();
      });
    }
    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      setDataTracks([]);
      room.localParticipant.removeAllListeners();
    };
  }, [room.localParticipant]);

  useEffect(() => {
    const videoTrack = videoTracks[0];
    if (videoTrack) {
      videoTrack.attach(videoRef.current);
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracks[0]]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      audioTrack.attach(audioRef.current);
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioTracks]);

  const toggleFacingMode = () => {
    const newFacingMode =
      videoTracks[0].mediaStreamTrack.getSettings().facingMode === "user"
        ? "environment"
        : "user";
    videoTracks[0]?.restart({
      ...{ video: true },
      facingMode: newFacingMode,
    });
  };

  function zoomIn() {
    const [localValue] = [...room.localParticipant.dataTracks.values()];
    localValue.track.send("zoom-in");
    if (zoomCounter < 10) {
      setZoomCounter(zoomCounter + 2);
    }
  }
  function zoomOut() {
    const [localValue] = [...room.localParticipant.dataTracks.values()];
    localValue.track.send("zoom-out");
    if (zoomCounter > 1) {
      setZoomCounter(zoomCounter - 2);
    }
  }
  function zoomReset() {
    const [localValue] = [...room.localParticipant.dataTracks.values()];
    localValue.track.send("zoom-reset");

    setZoomCounter(0);
  }
  function userHighlight() {
    const [localValue] = [...room.localParticipant.dataTracks.values()];
    localValue.track.send("user-highlight");
  }

  const videoRefRemote = useRef();
  const audioRefRemote = useRef();
  const dataRefRemote = useRef();

  const trackpubsToTracksRemote = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  useEffect(() => {
    if (participants[0]) {
      setParticipantMicStatus(false);
      setVideoTracksRemote(
        trackpubsToTracksRemote(participants[0].videoTracks)
      );
      setAudioTracksRemote(
        trackpubsToTracksRemote(participants[0].audioTracks)
      );
      setDataTracksRemote(trackpubsToTracksRemote(participants[0].audioTracks));

      const trackSubscribedRemote = (track) => {
        if (track.kind === "video") {
          if (track.isEnabled) {

          } else {
            setRemoteAvatar(true)
          }
          setVideoTracksRemote((videoTracks) => [...videoTracks, track]);
        } else if (track.kind === "audio") {
          setAudioTracksRemote((audioTracks) => [...audioTracks, track]);
        } else if (track.kind === "data") {
          setDataTracksRemote((dataTracks) => [...dataTracks, track]);
        }
        if (!micStatus) {
          room.localParticipant.audioTracks.forEach(function (track) {
            track.track.disable();
          });
        }
        if (role == 2) {
          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue?.track?.send(
            JSON.stringify({
              message: "",
              mouseDown: true,
              platform: "web",
              shape_type: "",
              aspect_ratio_width: window.innerWidth,
              aspect_ratio_height: window.innerHeight,
              mouseCoordinates: {
                recStartX: 0.0,
                recStartY: 0.0,
                recWidth: 0.0,
                recHeight: 0.0,
              },
            })
          );
        }
      };

      const trackUnsubscribedRemote = (track) => {
        if (track.kind === "video") {
          setVideoTracksRemote((videoTracks) =>
            videoTracks.filter((v) => v !== track)
          );
        } else if (track.kind === "audio") {
          setAudioTracksRemote((audioTracks) =>
            audioTracks.filter((a) => a !== track)
          );
        } else if (track.kind === "data") {
          setDataTracksRemote((dataTracks) =>
            dataTracks.filter((a) => a !== track)
          );
        }
      };

      participants[0].on("trackSubscribed", trackSubscribedRemote);
      participants[0].on("trackUnsubscribed", trackUnsubscribedRemote);

      return () => {
        setVideoTracksRemote([]);
        setAudioTracksRemote([]);
        setDataTracksRemote([]);
        participants[0].removeAllListeners();
      };
    }
  }, [participants[0], room.participants]);

  useEffect(() => {
    const videoTrack = videoTracksRemote[0];
    if (videoTrack) {
      videoTrack.attach(videoRefRemote.current);

      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracksRemote]);

  useEffect(() => {
    const audioTrack = audioTracksRemote[0];
    if (audioTrack) {
      audioTrack.attach(audioRefRemote.current);
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioTracksRemote]);

  useEffect(() => {
    const dataTrack = dataTracks[0];
  }, [dataTracksRemote]);

  // ======================================================================================
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMicStatus = () => {
    setMicStatus(false);
    room.localParticipant.audioTracks.forEach(function (track) {
      track.track.disable();
    });
  };

  const handleMicOffStatus = () => {
    setMicStatus(true);
    room.localParticipant.audioTracks.forEach(function (track) {
      track.track.enable();
    });
  };

  const handleVideoStatus = () => {
    setVideoStatus(false);
    room.localParticipant.videoTracks.forEach(function (track) {
      track.track.disable();
    });
    const [localValue] = [...room.localParticipant.dataTracks.values()];
    localValue?.track?.send("camera-off");
  };
  const handleVideoOffStatus = () => {
    setVideoStatus(true);
    room.localParticipant.videoTracks.forEach(function (track) {
      track.track.enable();
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue?.track?.send("camera-on");
    });
  };

  const handleScreenShot = (blob) => {
    setIsLoadingActive(true);
    let formData = new FormData();

    formData.append("image", blob, "screenshot.png");

    dispatch(
      ocr(
        formData,
        (res) => {
          // setOcrResultModal(true);
          setRemoteSayOcr(false);
          console.log(res.data.data);
          setOcrOutput(res.data);

          setOCRText(res.data?.note_chr)

          setIsLoadingActive(false);
        },
        (err) => {
          setRemoteSayOcr(false);
          setIsLoadingActive(false);
        }
      )
    );
    // html2canvas(document.getElementById("LP"))
    //   .then((canvas) => {
    //     canvas.style.display = "none";
    //     document.body.appendChild(canvas);
    //     return canvas;
    //   })
    //   .then((canvas) => {
    //     const image = canvas
    //       .toDataURL("image/png")
    //       .replace("data:", "")
    //       .replace(/^.+,/, "");

    //     const byteCharacters = atob(image);
    //     const byteNumbers = new Array(byteCharacters.length);
    //     for (let i = 0; i < byteCharacters.length; i++) {
    //       byteNumbers[i] = byteCharacters.charCodeAt(i);
    //     }

    //     const byteArray = new Uint8Array(byteNumbers);
    //     const blob = new Blob([byteArray]);

    //     setImage(blob);


    //   });
  };

  function handleStaticDrawing() {
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("start-draw");
    const video = document.getElementById("LP");
    video.pause();
    localStorage.setItem("currentShape", "rec");
    dispatch(drawActive());
  }
  const handleDrawing = () => {

    setLiveDrawingChecks(true);
    // setOpenDialog(true);

    if (!drawingArea) {
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue.track.send("start-draw");

      const video = document.getElementById("LP");
      video.pause();

      localStorage.setItem("currentShape", "rec");
      dispatch(drawActive());
    }

    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }

    localStorage.setItem("currentShape", "rec");
    setIsDrawShapes(true);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawRectangle(true);
    setDrawText(false);
    setLaserLine(false);
    setFreehand(false)
    setMeasuringStatus(false);
  };

  const handleCircle = () => {
    setLiveDrawingChecks(true);

    if (!drawingArea) {
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue.track.send("start-draw");

      const video = document.getElementById("LP");
      video.pause();

      localStorage.setItem("currentShape", "circle");
      dispatch(drawActive());
    }

    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }
    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "cir");
    setDrawRectangle(false);
    setDrawLine(false);
    setDrawCircle(true);
    setDrawText(false);
    setLaserLine(false);
    setFreehand(false)
    setMeasuringStatus(false);
  };

  const handleline = () => {
    setLiveDrawingChecks(true);

    if (!drawingArea) {
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue.track.send("start-draw");
      const video = document.getElementById("LP");
      video.pause();
      localStorage.setItem("currentShape", "arrow");
      dispatch(drawActive());
    }

    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }
    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "arrow");
    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(true);
    setDrawText(false);
    setLaserLine(false);
    setMeasuringStatus(false);
  };

  const handleLaserLine = () => {
    setLiveDrawingChecks(true);

    if (!drawingArea) {
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue.track.send("start-draw");
      const video = document.getElementById("LP");
      video.pause();
      localStorage.setItem("currentShape", "laser");
      dispatch(drawActive());

      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: [],
      };

      // setDummyShape(newRectangle);
      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }
    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }

    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "laser");
    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawText(false);
    setLaserLine(true);
    setFreehand(false)
    setMeasuringStatus(false);
  };
  const handleFreehand = () => {
    setLiveDrawingChecks(true);

    if (!drawingArea) {
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue.track.send("start-draw");
      const video = document.getElementById("LP");
      video.pause();
      localStorage.setItem("currentShape", "freehand");
      dispatch(drawActive());

      const newRectangle = {
        id: shapes.length + 1,
        type: "freehand",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: [],
        freehandPoints: freehandPointToSend
      };

      // setDummyShape(newRectangle);
      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }
    const isRectangleExists = shapes.some((shape) => shape.type === "freehand");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "freehand",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: [],
        freehandPoints: freehandPointToSend
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
      console.log(updatedShapes, "updatedShapes");
    }

    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "freehand");
    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawText(false);
    setLaserLine(false);
    setFreehand(true)
    setMeasuringStatus(false);
  };
  function handleText() {
    setLiveDrawingChecks(true);

    if (!drawingArea) {
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue.track.send("start-draw");
      const video = document.getElementById("LP");
      video.pause();
      localStorage.setItem("currentShape", "rec");
      dispatch(drawActive());
    }

    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }
    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "Text");
    // setTextAlert(true);
    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawText(true);
    setLaserLine(false);
    setFreehand(false)
    setMeasuringStatus(false);
  }

  const handleLaserLineAlone = () => {
    setLiveDrawingChecks(true);

    if (!drawingArea) {
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue.track.send("start_laser");

      localStorage.setItem("currentShape", "laser");
      dispatch(drawActive());

      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: [],
      };

      // setDummyShape(newRectangle);
      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    } else {
      dispatch(drawDisable());
      setLaserLine(false);
      setFreehand(false)
      setMeasuringStatus(false);
      return;
    }
    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }

    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "laser");
    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawText(false);
    setLaserLine(true);
    setFreehand(false)
    setMeasuringStatus(false);
  };

  function handleTextMobile() {
    setLiveDrawingChecks(true);

    if (!drawingArea) {
      const [localValue] = [...room.localParticipant.dataTracks.values()];

      localValue.track.send("start-draw");
      const video = document.getElementById("LP");
      video.pause();
      localStorage.setItem("currentShape", "rec");
      dispatch(drawActive());
    }
    localStorage.setItem("currentShape", "Text");
    setTextAlert(true);
    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawText(true);
  }

  const handleMute = () => {
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("mute-mic");
    setAnchorEl(null);
    setMicControl("micOff");
  };

  const handleUnmute = () => {
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("unmute-mic");

    setAnchorEl(null);
    setMicControl("micOn");
  };
  const handleAnotherFlipCamera = () => {
    setAnchorEl(null);
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("flip-camera");
  };
  const handleFlashOn = () => {
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("flash-light-on");
    setAnchorEl(null);
    setFlashLightControl("flashOff");
    setToggleFlashLight(!toggleFlashLight);
  };

  function handleOcrSend() {
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("video-pause");

    const video = document.getElementById("LP");
    video.pause();

    setOcrCropModal(true)

  }

  const handleFlashOff = () => {
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("flash-light-off");
    setAnchorEl(null);
    setFlashLightControl("flashOn");
    setToggleFlashLight(!toggleFlashLight);
  };


  const [inspectionItemReceived, setInspectionItemReceived] = useState({});


  const trackSubscribed = (participant, track) => {
    if (track.kind === "data") {
      track.on("message", (data) => {
        // console.log(data, "DtaaTrackr")
        if (data === undefined) {
          return;
        }


        if (data === "mute-mic") {
          setRemoteSayMuteMic(true);
        } else if (data === "add_point") {
        } else if (data === "measuring_started") {
          setShowMeasureGif(false)
          setMeasuringStatus(true);
        }
        else if (data === "end_measuring") {
          setRecHeight(0);
          setRecWidth(0);
          setRecStartX(0);
          setRecStartY(0);

          setDrawCircle(false);
          setDrawLine(false);
          setDrawRectangle(false);
          setDrawText(false);
          setShapesArr([]);


          return
        } else if (data === "unmute-mic") {
          setRemoteSayUnmuteMic(true);
        } else if (data === "start_laser") {
          dispatch(drawActive());
          setLaserLine(true);
          setMeasuringStatus(false);
          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue.track.send(
            JSON.stringify({
              message: "",
              mouseDown: true,
              platform: "web",
              shape_type: "",
              aspect_ratio_width: window.innerWidth,
              aspect_ratio_height: window.innerHeight,
              mouseCoordinates: {
                recStartX: 0.0,
                recStartY: 0.0,
                recWidth: 0.0,
                recHeight: 0.0,
              },
            })
          );
        } else if (data === "stop_laser") {
          dispatch(drawDisable());
          setLaserLine(false);
          setMeasuringStatus(false);
        } else if (data === "start_ocr") {
          setMessageFromOcr(true);
          const video = document.getElementById("LP");
          video.pause();
          // handleScreenShot()
        } else if (data === "stop_ocr") {
          // setRemoteSayOcr(true)
          setMessageFromOcr(false);
          if (!drawingArea) {
            const video = document.getElementById("LP");
            video.play();
          }
          // handleScreenShot()
        } else if (data === "hand-shake") {
        } else if (data === "remove-participant") {
        } else if (data === "start-draw") {
          const video = document.getElementById("LP");
          video.pause();
          setDrawingStarted(true);
          setCameraCheckCustomer(false);
          dispatch(drawActive());
          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue.track.send(
            JSON.stringify({
              message: "",
              mouseDown: true,
              platform: "web",
              shape_type: "",
              aspect_ratio_width: window.innerWidth,
              aspect_ratio_height: window.innerHeight,
              mouseCoordinates: {
                recStartX: 0.0,
                recStartY: 0.0,
                recWidth: 0.0,
                recHeight: 0.0,
              },
            })
          );
        } else if (data === "shopping_list") {
          onLoadData();
          if (tabOpen == 4) {
            setShoppingListCounter(0);
          } else {
            setShoppingListCounter(shoppingListCounter + 1);
          }
        } else if (data === "notes_attachment") {
          callNoteData();
          if (tabOpen == 3) {
            setNotesCounter(0);
          } else {
            setNotesCounter(notesCounter + 1);
          }
        } else if (data === "checkup_list") {
          getHomeAreaListFn();
          if (tabOpen == 6) {
            setCheckUpCounter(0);
          } else {
            setCheckUpCounter(checkUpCounter + 1);
          }
        } else if (data === "parts_manual") {
          getServiceDetailsFn(true);
        } else if (data === "pro_giving_estimations_report") {
          setIsProGivingEstimationsReport(true);
          handleLogout();
        } else if (data === "clear-draw") {
          shapesArr.splice(0, shapesArr.length);

          var canvas = document.getElementById("canvas");
          var ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, videoWidth, videoHeight);
        } else if (data === "end-draw") {
          setThreeDModeStatus(false)
          setRecHeight(0);
          setRecWidth(0);
          setRecStartX(0);
          setRecStartY(0);

          dispatch(drawDisable());
          setTrackingVal(false);
          setDrawCircle(false);
          setDrawLine(false);
          setDrawRectangle(false);
          setDrawText(false);
          setCameraCheckCustomer(true);
          setShapesArr([]);

          const video = document.getElementById("LP");
          video.play();
        } else if (data === "video-resume") {
          const video = document.getElementById("LP");
          video.play();
        } else if (data === "video-pause") {
          const video = document.getElementById("LP");
          video.pause();
        } else if (data === "flip-camera") {
          setRemoteSayFlipCamera(true);
        } else if (data === "flash-light-on") {
          const SUPPORTS_MEDIA_DEVICES = "mediaDevices" in navigator;

          if (SUPPORTS_MEDIA_DEVICES) {
            //Get the environment camera (usually the second one)
            handleTorchOn();

            setTorchTrigger(true);
          }
        } else if (data === "flash-light-off") {
          // if (SUPPORTS_MEDIA_DEVICES) {
          //   setTorchTrigger(false);
          // }
        } else if (data === "camera-on") {
          // setCameraCheck(true);
        } else if (data === "camera-off") {
        } else if (data === "zoom-in") {
          setZoomCounter((prevZoomCounter) => {
            if (prevZoomCounter < 10) {
              return prevZoomCounter + 2;
            }
            return prevZoomCounter;
          });

          // Zoom in logic
          videoTracks[0]?.mediaStreamTrack?.applyConstraints({ zoom: 100 });

        } else if (data === "zoom-out") {
          setZoomCounter((prevZoomCounter) => {
            if (prevZoomCounter > 1) {
              return prevZoomCounter - 2;
            }
            return prevZoomCounter;
          });

          videoTracks[0]?.mediaStreamTrack?.applyConstraints({ zoom: 0 });

        } else if (data === "zoom-reset") {
          setZoomCounter(0);

          videoTracks[0]?.mediaStreamTrack?.applyConstraints({ zoom: 0 });

        } else if (data === "arrow") {
          setDrawLine(true);
          setDrawCircle(false);
          setDrawRectangle(false);
          setDrawText(false);
        } else if (data === "rect") {
          setDrawLine(false);
          setDrawCircle(false);
          setDrawRectangle(true);
          setDrawText(false);
        } else if (data === "circle") {
          setDrawLine(false);
          setDrawCircle(true);
          setDrawRectangle(false);
          setDrawText(false);
        } else if (data === "text") {
          setDrawLine(false);
          setDrawCircle(false);
          setDrawRectangle(false);
          setDrawText(true);
        } else if (data === "2D") {
          // setDrawingToggle(false);
        } else if (data === "3D") {
          // setDrawingToggle(true);
          // ARcore();
        } else if (data === undefined) {
          return true;
        } else {
          if (data) {
            var objectForPoints = JSON.parse(data);
            setRemotePlatform(objectForPoints.platform);
            if (objectForPoints.platform == "web") {
              setUsePhoneApp(true);
            } else {
              setUsePhoneApp(false)
            }

            if (
              objectForPoints?.aspect_ratio_width != undefined &&
              objectForPoints?.aspect_ratio_height != undefined
            ) {
              if (
                objectForPoints?.aspect_ratio_width != 0 ||
                objectForPoints?.aspect_ratio_width != 0.0
              ) {
                if (
                  permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  joinCallRes?.is_sender_flag == 1
                ) {
                  setRecievedDimensionWidth(
                    parseInt(objectForPoints.aspect_ratio_width)
                  );

                  setRecievedDimensionHeight(
                    parseInt(objectForPoints.aspect_ratio_height)
                  );
                }
              }
            }

            if (objectForPoints?.type === 'inspection') {
              console.log("Received inspection object:", objectForPoints);

              setInspectionItemReceived(objectForPoints)
            } else {
              if (joinCallRes.is_sender_flag === 0) {
                var canvas = document.getElementById("canvas");
                console.log(videoWidth, videoHeight);

                const ctx = canvas?.getContext("2d");
                if (ctx) {
                  ctx.strokeStyle = "red";
                  ctx.lineWidth = 4;
                  ctx.canvas.width = window.innerWidth;
                  ctx.canvas.height = window.innerHeight;
                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                }

                // canvas.width = window.innerWidth;
                // canvas.height = window.innerHeight;
                // window.innerHeight -70
                // var ctx = canvas.getContext("2d");
                // style the context

                function checkIfArray(value) {
                  return Array.isArray(value);
                }
                const result = checkIfArray(objectForPoints);

                if (result) {
                  for (const shape of objectForPoints) {
                    console.log(shape, "Freehand Shape");
                    if (shape.shape_type === "laser") {
                      const canvas = document.getElementById("canvas");
                      const context = canvas.getContext("2d");
                      // // context.clearRect(0, 0, canvas.width, canvas.height); // Clears the canvas

                      context.strokeStyle = "red";
                      // context.lineJoin = "round";
                      // context.lineWidth = 2;

                      for (let i = 0; i < shape.laserPoints.length; i++) {
                        const line = shape.laserPoints[i];

                        ctx.beginPath();
                        if (i > 0) {
                          ctx.moveTo(
                            shape.laserPoints[i - 1].recStartX *
                            window.innerWidth,
                            shape.laserPoints[i - 1].recStartY *
                            window.innerHeight
                          );
                        } else {
                          ctx.moveTo(
                            line.recStartX * window.innerWidth - 1,
                            line.recStartY * window.innerHeight
                          );
                        }
                        ctx.lineTo(
                          line.recStartX * window.innerWidth,
                          line.recStartY * window.innerHeight
                        );
                        ctx.closePath();
                        ctx.stroke();
                      }

                      if (shape.laserPoints.length > 0) {
                        // Move both the glitter effect and circle drawing to the end of the line
                        const endLine =
                          shape.laserPoints[shape.laserPoints.length - 1];
                        addGlitterEffect(
                          context,
                          endLine.recStartX * window.innerWidth,
                          endLine.recStartY * window.innerHeight
                        );

                        // Draw a red circle at the end of the line for visual emphasis
                        context.beginPath();
                        context.arc(
                          endLine.recStartX * window.innerWidth,
                          endLine.recStartY * window.innerHeight,
                          5,
                          0,
                          2 * Math.PI,
                          false
                        ); // Circle at the end
                        context.fillStyle = "red";
                        context.fill();
                      }
                    } else if (shape.shape_type === "rect") {
                      ctx.strokeStyle = "red";
                      ctx.lineWidth = 4;

                      ctx.strokeRect(
                        shape.mouseCoordinates.recStartX * canvas.width,
                        shape.mouseCoordinates.recStartY * canvas.height,
                        shape.mouseCoordinates.recWidth * canvas.width,
                        shape.mouseCoordinates.recHeight * canvas.height
                      );

                      // You can add similar indicators for edges if needed
                    } else if (shape.shape_type === "circle") {
                      ctx.strokeStyle = "red";
                      ctx.lineWidth = 4;
                      circleShowFn(
                        shape.mouseCoordinates.recStartX * canvas.width,
                        shape.mouseCoordinates.recStartY * canvas.height,
                        shape.mouseCoordinates.recWidth * canvas.width,
                        shape.mouseCoordinates.recHeight * canvas.height
                      );
                    } else if (shape.shape_type === "text") {
                      ctx.strokeStyle = "red";
                      ctx.lineWidth = 4;
                      commonFillTextFn(
                        shape.mouseCoordinates.recStartX * canvas.width,
                        shape.mouseCoordinates.recStartY * canvas.height,
                        shape.mouseCoordinates.recWidth * canvas.width,
                        shape.mouseCoordinates.recHeight * canvas.height,
                        shape.object_text
                      );
                      // ctx.strokeRect(shape.x, shape.y, shape.width, shape.height);
                    } else if (shape.shape_type === "arrow") {
                      ctx.strokeStyle = "red";
                      ctx.lineWidth = 4;
                      arrowShowFn(
                        shape.mouseCoordinates.recStartX * canvas.width,
                        shape.mouseCoordinates.recStartY * canvas.height,
                        shape.mouseCoordinates.recWidth * canvas.width,
                        shape.mouseCoordinates.recHeight * canvas.height
                      );
                    } else if (shape.shape_type === "freehand") {
                      ctx.strokeStyle = "red";
                      ctx.lineJoin = "round";
                      ctx.lineWidth = 4;
                      ctx.fillStyle = "red";   // for single-point dots

                      // shape.freehandPoints is [[...],[...],…]
                      shape.freehandPoints.forEach(stroke => {
                        if (!Array.isArray(stroke) || stroke.length === 0) {
                          // nothing to draw
                          return;
                        }

                        // If there's only one point, draw a dot:
                        if (stroke.length === 1) {
                          const pt = stroke[0];
                          ctx.beginPath();
                          ctx.arc(
                            pt.recStartX * canvas.width,
                            pt.recStartY * canvas.height,
                            2, 0, 2 * Math.PI
                          );
                          ctx.fill();
                          return;
                        }

                        // Otherwise draw the full stroke:
                        ctx.beginPath();
                        // move to first valid point
                        const first = stroke[0];
                        ctx.moveTo(
                          first.recStartX * canvas.width,
                          first.recStartY * canvas.height
                        );

                        // connect subsequent points, guarding undefined
                        for (let i = 1; i < stroke.length; i++) {
                          const pt = stroke[i];
                          if (pt && typeof pt.recStartX === "number") {
                            ctx.lineTo(
                              pt.recStartX * canvas.width,
                              pt.recStartY * canvas.height
                            );
                          }
                        }

                        ctx.stroke();
                      });
                    }
                  }
                }
              }
            }

          }


        }
      });
    }
  };
  function waitForNetworkConnection(callback) {

    setReconnectingScreen(true);
    if (navigator.onLine) {
      myFunctionTimeout();
    } else {
      const onlineHandler = () => {
        myFunctionTimeout(); // Call the function once online
        window.removeEventListener("online", onlineHandler);
      };
      window.addEventListener("online", onlineHandler);
    }
  }

  // Example usage
  function myFunctionTimeout() {
    setReconnectingScreen(false);

    ReconnectingAfterTimeout();
  }


  const timeoutRef = useRef(null);
  const timeLogoutRef = useRef(null)

  useEffect(() => {
    if (participants.length > 0 && joinCallRes.is_sender_flag == 0) {
      console.log(timeLeftToEndCall, "Logo")
      // Clear any existing timeout
      if (timeoutRef.current) {

        clearTimeout(timeoutRef.current);
      }
      if (timeLogoutRef.current) {
        clearTimeout(timeLogoutRef.current);
      }
      // Set a new timeout
      timeoutRef.current = setTimeout(() => {


        console.log("called")
        setChargeForCallModalStatus(true)
      }, timeLeftToEndCall - 120000);

      timeLogoutRef.current = setTimeout(() => {

        checkFunctionChargeOrNot()
      }, timeLeftToEndCall);
    }

    // Cleanup function to clear the timeout when component unmounts or dependencies change
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (timeLogoutRef.current) {
        clearTimeout(timeLogoutRef.current);
      }
      localStorage.removeItem("ChargeMe")
    };
  }, [participants, timeLeftToEndCall]);

  const callDurationRef = useRef();

  const handleResetCounter = () => {
    if (callDurationRef.current) {
      callDurationRef.current.resetTimer();
    }
  };
  function checkFunctionChargeOrNot() {
    if (localStorage.getItem("ChargeMe") == 1) {


      const data = new FormData()
      if (joinCallRes.is_sender_flag == 0) {
        data.append("user_id_ids", localStorage.getItem("user_id") || "")

        data.append("call_log_id_ids", joinCallRes?.call_log_id_ids)
        data.append("joinee_name_chr", userName)
        data.append("call_duration_in_second", localStorage.getItem("timeUsedInSecondsReset"))

        dispatch(saveCallDurationApi(data, (res) => {
          handleResetCounter()
          const [localValue] = [...room.localParticipant.dataTracks.values()];
          localValue.track.send("reset-slot-time");
          localStorage.setItem("ChargeMe", 0)

          clearTimeout(timeLogoutRef.current);
          console.log(totalCallTimeRedux, "Time to ")

          if (timeLeftToEndCall == totalCallTimeRedux) {
            setTimeLeftToEndCall(totalCallTimeRedux - 1)
          } else {
            setTimeLeftToEndCall(totalCallTimeRedux)

          }

          console.log(res)
        }, (err) => {
          localStorage.setItem("ChargeMe", 0)
          handleLogout()
          alert(err.data.message)
        }))
      }





    } else {
      localStorage.setItem("ChargeMe", 0)
      handleLogout()
    }

  }

  useEffect(() => {
    const participantConnected = (participant) => {

      setTimeout(() => {
        const [localValue] = [...room.localParticipant.dataTracks.values()];

        localValue?.track.send(
          JSON.stringify({
            message: "",
            mouseDown: true,
            platform: "web",
            shape_type: "",
            aspect_ratio_width: window.innerWidth,
            aspect_ratio_height: window.innerHeight,
            mouseCoordinates: {
              recStartX: 0.0,
              recStartY: 0.0,
              recWidth: 0.0,
              recHeight: 0.0,
            },
          })
        );
      }, 3000);

      console.log(room, "Room Values");
      // const localParticipant = room.localParticipant;
      // localParticipant.publishTrack(audioTracks)
      setParticipants((prevParticipants) => [...prevParticipants, participant]);
      participant.on("trackSubscribed", (track) =>
        trackSubscribed(participant, track)
      );

      printNetworkQualityStats(
        participant.networkQualityLevel,
        participant.networkQualityStats
      );
      participant.on("networkQualityLevelChanged", printNetworkQualityStats);

      participant.on("reconnecting", (participant) => {
        setReconnectingScreen(true);
        console.log(`Participant "${participant}" reconnecting.`);
        // Handle reconnection logic or update UI
      });

      participant.on("reconnected", (participant) => {
        setReconnectingScreen(false);
        console.log(`Participant "${participant}" reconnected.`);
        // Handle reconnection logic or update UI
      });
      participant.on("disconnected", (participant) => {
        setReconnectingScreen(false);
        console.log("Participant Disconnected", participant);
        setReconnectingScreen(false);
        dispatch(drawDisable());
        setLaserLine(false);
        setFreehand(false)
        setMeasuringStatus(false);
        setParticipants((prevParticipants) =>
          prevParticipants.filter((p) => p !== participant)
        );

        setOpenParticipantDisconnectMsg(true);
        setTimeout(() => {
          setOpenParticipantDisconnectMsg(false);
        }, 3000);
        setTabOpen(1);

        {
          permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
            handleClearCanvas();
        }
        console.log(`Participant "${participant.identity}" was disconnected.`);
        // Handle reconnection logic or update UI
      });

      var intervalTime
      room.on("reconnecting", (participant) => {
        setLocalParticipantReconnecting(true);
        console.log("Me reconnecting")
        intervalTime = setTimeout(() => {


          navigate("/page-error-503")
          window.location.reload()

        }, 30000)
        // Handle reconnection logic or update UI
      });

      room.on("reconnected", (participant) => {
        setLocalParticipantReconnecting(false);
        clearInterval(intervalTime)
        console.log("Me reconnetec")
        // Handle reconnection logic or update UI
      });

      // room.on('disconnected', (room, error) => {
      //   error((err)=>{console.log(err)})
      //   console.log(`Local participant disconnected. Error: ${error ? error.message : 'No error'}`);
      //   console.log(`Room participants upon disconnect: ${room.participants.size}`);
      // });
      //   room.on("disconnected", (participant) => {
      //     console.log("On disconnected LOcal")

      //     // Handle reconnection logic or update UI
      //   });

      participant.on("trackUnsubscribed", (track) => {
        // if (track.kind === "data") {
        //   setReconnectingScreen(false);
        //   dispatch(drawDisable());
        //   setLaserLine(false);
        //   setMeasuringStatus(false);
        //   setParticipants((prevParticipants) =>
        //     prevParticipants.filter((p) => p !== participant)
        //   );

        //   setOpenParticipantDisconnectMsg(true);
        //   setTimeout(() => {
        //     setOpenParticipantDisconnectMsg(false);
        //   }, 3000);
        //   setTabOpen(1);

        //   {
        //     permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
        //       handleClearCanvas();
        //   }
        //   console.log(`Track unsubscribed for ${participant.identity}`);
        // }
      });

      setCheckbox1Checked(true);
      setCheckbox2Checked(false);
    };

    const participantDisconnected = (participant) => {
      setThreeDModeStatus(false)
      setShowMeasureGif(false)
      if (joinCallRes.is_sender_flag == 0) {
        clearTimeout(timeLogoutRef.current);
        clearTimeout(timeoutRef.current);

        const vall = (localStorage.getItem("timeUsedInSeconds") * 1000) - timeLeftToEndCall

        let absNum = Math.abs(vall);
        console.log(absNum, "My remaining time to show ")
        setTimeLeftToEndCall(absNum)
      }
      console.log("Participant Disconnected", participant);

      if (permissionArray.includes("CONNECT TO PRO")) {
        if (!JSON.parse(localStorage.getItem("is_estimations_call"))) {
          saveDurationByPro();
        }
      } else {
        saveDurationByPro();
      }

      setReconnectingScreen(false);
      dispatch(drawDisable());
      setLaserLine(false);
      setFreehand(false)
      setMeasuringStatus(false);
      setParticipants((prevParticipants) =>
        prevParticipants.filter((p) => p !== participant)
      );


      setOpenParticipantDisconnectMsg(true);
      setTimeout(() => {
        setOpenParticipantDisconnectMsg(false);
      }, 3000);

      setTimeout(() => {
        // room.disconnect()
        // disconnectMyRoom()

        if (((serviceDetailsObj?.ticket_type_int == 1) || (serviceDetailsObj?.ticket_type_int == 2)) && (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS"))) {
          if (!proDiagnosis || !proRecommendedSolution) {

          } else {
            room.disconnect();
            disconnectMyRoom();
          }
        } else {
          room.disconnect();
          disconnectMyRoom();
        }

      }, 2000)
      setTabOpen(1);

      {
        permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
          handleClearCanvas();
      }
    };

    const handleDisconnected = (room, error) => {
      console.log(room, error?.code, "On disconnected LOcal")
      switch (error?.code) {
        case 20101: // Invalid token or expired token error
          console.log("Authentication error: Check your Twilio token.");
          break;
        case 53000: // Media connection failed
          waitForNetworkConnection();
          break;
        case 53405: // Media connection timeout
          waitForNetworkConnection();
          break;
        case 53001:
          waitForNetworkConnection();
        default:
          console.log("An unknown error occurred.");
          break;
      }
      if (error) {
        console.error(
          `Disconnected from the room due to an error: ${error.message}`
        );
      } else {
        console.log("Disconnected from the room successfully.");
      }
      // setRoom(null);
    };

    const handleReconnecting = (error) => {
      setReconnectingScreen(true);
      console.log(`Attempting to reconnect due to ${error.message}`);
    };

    const handleReconnected = () => {
      setReconnectingScreen(false);
      console.log("Reconnected to the room!");
    };

    function printNetworkQualityStats(
      networkQualityLevel,
      networkQualityStats
    ) {
      // Print in console the networkQualityLevel using bars

      setNetworkLevel(networkQualityLevel);
    }

    // printNetworkQualityStats(participants[0].networkQualityLevel, participants[0].networkQualityStats)
    room.on("participantConnected", participantConnected);
    room.on("participantDisconnected", participantDisconnected);
    room.participants.forEach(participantConnected);
    room.on("disconnected", handleDisconnected);
    room.on("reconnecting", handleReconnecting);
    room.on("reconnected", handleReconnected);

    room.on("error", (error) => {
      console.error("Room encountered an error:", error);
      // You might want to log this error to your server for further analysis
      // or adjust the user interface to inform the user of the issue.
    });
    return () => {
      room.off("participantConnected", participantConnected);
      room.off("participantDisconnected", participantDisconnected);
      room.off("reconnecting", handleReconnecting);
      room.off("reconnected", handleReconnected);
    };
  }, [room]);

  useEffect(() => {
    if (room) {
      setRoomConnectedStatus(room.state)
      console.log(room.state, "Value hande");
    }
  }, [room.state]);

  function timeStampFormat(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  window.addEventListener("unload", async () => {
    await room.disconnect();
  });

  // Code for the FlashLight ON/OFF ->>>
  //Test browser support
  // const SUPPORTS_MEDIA_DEVICES = 'mediaDevices' in navigator;

  const [torchTrigger, setTorchTrigger] = useState(false);

  const elementsArrayNew = [];

  const myAreaShapes = () => { };

  let timerId = null;

  function timeFunction() {
    localStorage.setItem("participant", participants[0].identity);
    localStorage.setItem("roomNameCode", room.name);

    clearTimeout(timerId);
    timerId = setTimeout(() => {
      const dataForDisconnect = new FormData();
      dataForDisconnect.append(
        "room_name_chr",
        localStorage.getItem("roomNameCode")
      );
      dataForDisconnect.append(
        "participant_identity_chr",
        localStorage.getItem("participant")
      );
      dispatch(
        disconnectFromCall(dataForDisconnect, (res) => {
          clearInterval(timeOutInterval);
          const [localValue] = [...room.localParticipant.dataTracks.values()];
          localValue.track.send("remove-participant");
        })
      );
    }, 15000);
  }

  // document.addEventListener("visibilitychange", (event) => {
  //   if (document.visibilityState == "visible") {

  // if(videoStatus){
  //       setVideoStatus(true);
  //     room.localParticipant.videoTracks.forEach(function (track) {
  //       track.track.enable();
  //     });
  // }

  //   } else {

  //     room.localParticipant.videoTracks.forEach(function (track) {
  //       track.track.disable();
  //     });
  //   }
  // });
  function handleTorchOn() {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      const cameras = devices.filter((device) => device.kind === "videoinput");

      if (cameras.length === 0) {
        throw "No camera found on this device.";
      }
      const camera = cameras[cameras.length - 1];

      // Create stream and get video track
      navigator.mediaDevices
        .getUserMedia({
          video: {
            deviceId: camera.deviceId,
            facingMode: ["user", "environment"],
            height: { ideal: 1080 },
            width: { ideal: 1920 },
          },
        })
        .then((stream) => {
          const track = stream.getVideoTracks()[0];

          //Create image capture object and get camera capabilities
          const imageCapture = new ImageCapture(track);
          const photoCapabilities = imageCapture
            .getPhotoCapabilities()
            .then(() => {
              //todo: check if camera has a torch

              //let there be light!

              track.applyConstraints({
                advanced: [{ torch: true }],
              });
            })
            .catch(() => {
              alert("not capable");
            });
        });
    });

    //The light will be on as long the track exists
  }

  function setMessageFn(data) {
    var newLength = newChatArr.push(data);

    setMessageArrLength(newLength);
  }

  useEffect(() => {
    if (messageArrLength > 0) {
    }

    callNoteData();
  }, [messageArrLength, chatAlertArrLength]);

  useEffect(() => {
    if (videoTracks) {
      // =====================    Code for local Avatar   =============================
      if (videoTracks[0]?.isEnabled) {
        setLocalAvatar(true);
      } else {
        setLocalAvatar(false);
      }
    }
  }, []);

  // -------------------------------------------  Tracking code =-----------------------------------------

  function shapesMakingFunction() {
    if (drawingArea) {
      if (shapesArr.length > 0) {
        var canvas = document.getElementById("canvas");

        var ctx = canvas.getContext("2d");
        ctx.strokeStyle = "red";
        ctx.lineWidth = 4;
        //  ctx.clearRect(0, 0, canvas.width, canvas.height);
        shapesArr.map((element) => {
          if (element.type === "rec" || element.type == "rect") {
            ctx.strokeRect(element.x, element.y, element.width, element.height);
          }
          if (element.type === "circle" || element.type == "cir") {
            var startX = element.x;
            var startY = element.y;
            var mouseX = element.x + element.width;
            var mouseY = element.y + element.height;
            ctx.save();
            ctx.beginPath();
            //Dynamic scaling
            var scalex = 1 * ((mouseX - startX) / 2);
            var scaley = 1 * ((mouseY - startY) / 2);
            ctx.scale(scalex, scaley);
            //Create ellipse
            var centerx = startX / scalex + 1;
            var centery = startY / scaley + 1;
            ctx.arc(centerx, centery, 1, 0, 2 * Math.PI);
            //Restore and draw
            ctx.restore();
            ctx.strokeStyle = "red";
            ctx.lineWidth = 4;

            ctx.stroke();
          }
          if (element.type === "arrow" || element.type == "arrow") {
            var startX = element.x;
            var startY = element.y;
            var height = element.height;
            var width = element.width;

            ctx.beginPath();
            var newStartY = parseInt(height / 2) + startY;
            var center = width / 2;

            ctx.moveTo(startX + center, newStartY);
            ctx.lineTo(startX - 100, newStartY);
            ctx.stroke();

            ctx.beginPath();
            var newStartY = parseInt(height / 2) + startY;

            ctx.moveTo(startX + center, newStartY);
            ctx.lineTo(startX - 20 + center, newStartY - 10);
            ctx.stroke();

            ctx.beginPath();
            var newStartY = parseInt(height / 2) + startY;

            ctx.moveTo(startX + center, newStartY);
            ctx.lineTo(startX - 20 + center, newStartY + 10);
            ctx.stroke();
          }

          if (element.type === "Text" || element.type == "text") {
            commonFillTextFn(
              element.x,
              element.y,
              element.width,
              element.height,
              element.text
            );
          }
        });
      } else {
        var canvas = document.getElementById("canvas");

        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, videoWidth, videoHeight);
      }
    }
  }
  useEffect(() => {
    shapesMakingFunction();
  }, [shapesArr]);

  // draw Fill text function

  function commonFillTextFn(x, y, w, h, text) {
    var canvas = document.getElementById("canvas");

    var ctx = canvas.getContext("2d");
    // ctx.strokeRect(x, y, w, h);

    var pointX = x;
    var pointY = y + 18;

    ctx.font = "20px poppins";
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "red");
    gradient.addColorStop("0.5", "red");
    gradient.addColorStop("1.0", "red");
    // Fill with gradient
    ctx.fillStyle = gradient;

    const words = text.split("") || localStorage.getItem("keyText");

    drawWords(
      ctx,
      text,
      pointX,
      pointY,
      canvas.width - x,
      canvas.height - y,
      18,
      canvas.height - y,
      words
    );
  }

  function drawWords(
    context,
    text,
    x,
    y,
    maxWidth,
    maxHeight,
    lineHeight,
    rectHeight,
    words
  ) {
    var line = "";
    for (var n = 0; n < words.length; n++) {
      var testLine = line + words[n] + " ";
      var metrics = context.measureText(testLine);
      var testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        context.fillText(line, x, y);
        line = words[n] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    context.fillText(line, x, y);
    rectHeight = rectHeight + lineHeight;
  }

  // const addPoint = (x, y, dragging) => {
  //   if (!dragging) return; // Ensure point is only added when dragging (mouse down)
  //   const newLine = { x, y };

  //   setLaserLinesArr((prevLines) => {
  //     // Ensure we don't exceed 90 points in the lines array
  //     const newLines = [...prevLines, newLine];
  //     while (newLines.length > 30) {
  //       newLines.shift(); // Remove the oldest points if array exceeds 90 points
  //     }
  //     return newLines;
  //   });
  // };
  const addPoint = (x, y, dragging) => {
    if (!dragging) return; // only when mouse is down

    const newLine = { x, y };

    if (laserLine) {
      // exactly your existing laser logic:
      setLaserLinesArr(prevLines => {
        const newLines = [...prevLines, newLine];
        while (newLines.length > 30) {
          newLines.shift();
        }
        return newLines;
      });

    } else if (freehand) {
      setFreehandLinesArr(prev => {
        // 1) Ensure we have an array
        const strokes = Array.isArray(prev) ? prev : [];

        // 2) On first point, start a brand-new stroke:
        if (strokes.length === 0) {
          return [[newLine]];
        }

        // 3) Otherwise, build a new array of strokes,
        //    cloning only the ones that really are arrays:
        const newStrokes = strokes.map(s =>
          Array.isArray(s) ? [...s] : []
        );

        // 4) Append into the last (now cloned) stroke:
        newStrokes[newStrokes.length - 1].push(newLine);

        return newStrokes;
      });
    }
  };

  // const addPointToSend = (x, y, dragging) => {
  //   if (!dragging) return; // Ensure point is only added when dragging (mouse down)
  //   if (drawingArea) {
  //     var canvas = document.getElementById("canvas");
  //     const newLine = {
  //       recStartX: x / canvas.width,
  //       recStartY: y / canvas.height,
  //     };

  //     setLaserPointToSend((prevLines) => {
  //       // Ensure we don't exceed 90 points in the lines array
  //       const newLines = [...prevLines, newLine];
  //       while (newLines.length > 30) {
  //         newLines.shift(); // Remove the oldest points if array exceeds 90 points
  //       }
  //       return newLines;
  //     });
  //   }
  // };

  const addPointToSend = (x, y, dragging) => {
    if (!dragging || !drawingArea) return;
    const canvas = document.getElementById("canvas");
    const newPoint = {
      recStartX: x / canvas.width,
      recStartY: y / canvas.height,
    };

    if (laserLine) {
      setLaserPointToSend(prev => {
        const newLines = [...prev, newPoint];
        // enforce max length
        while (newLines.length > 30) {
          newLines.shift();
        }
        return newLines;
      });

    } else if (freehand) {
      setFreehandPointToSend(prevStrokes => {
        // if no stroke exists yet, start one
        if (prevStrokes.length === 0) {
          return [[newPoint]];
        }
        // clone the strokes array
        const strokes = prevStrokes.map(st => [...st]);
        // append to the current (last) stroke
        strokes[strokes.length - 1].push(newPoint);
        return strokes;
      });
    }
  };



  const redraw = () => {
    if (!drawingArea) return;

    const canvas = document.getElementById("canvas");
    const context = canvas.getContext("2d");

    // 1) Clear the whole canvas
    context.clearRect(0, 0, canvas.width, canvas.height);

    // 2) Draw your laser line (flat array)
    if (laserLinesArr.length > 0) {
      context.strokeStyle = "red";
      context.lineJoin = "round";
      context.lineWidth = 4;

      for (let i = 0; i < laserLinesArr.length; i++) {
        const p = laserLinesArr[i];
        context.beginPath();
        if (i > 0) {
          const prev = laserLinesArr[i - 1];
          context.moveTo(prev.x, prev.y);
        } else {
          context.moveTo(p.x - 1, p.y);
        }
        context.lineTo(p.x, p.y);
        context.stroke();
      }

      // glitter + circle at end
      const end = laserLinesArr[laserLinesArr.length - 1];
      addGlitterEffect(context, end.x, end.y);
      context.beginPath();
      context.arc(end.x, end.y, 5, 0, 2 * Math.PI);
      context.fillStyle = "red";
      context.fill();
    }

    // 3) Draw your freehand strokes (array of arrays)
    if (freehandLinesArr.length > 0) {
      context.strokeStyle = "red";   // or whatever color you like
      context.lineJoin = "round";
      context.lineWidth = 4;

      freehandLinesArr.forEach(stroke => {
        if (stroke.length < 2) return; // need at least 2 points to draw
        context.beginPath();
        context.moveTo(stroke[0].x, stroke[0].y);
        for (let i = 1; i < stroke.length; i++) {
          const pt = stroke[i];
          context.lineTo(pt.x, pt.y);
        }
        context.stroke();
      });
    }
  };


  // The addGlitterEffect function definition remains the same

  // Function to add glitter effect at a given position
  function addGlitterEffect(context, x, y) {
    const glitterCount = 20; // Number of glitter particles
    for (let i = 0; i < glitterCount; i++) {
      const angle = Math.random() * Math.PI * 2; // Random angle for glitter direction
      const distance = Math.random() * 10; // Random distance from the point
      const glitterX = x + Math.cos(angle) * distance;
      const glitterY = y + Math.sin(angle) * distance;

      const glitterSize = Math.random() * 3; // Random size for each glitter particle

      // Draw glitter
      context.beginPath();
      context.arc(glitterX, glitterY, glitterSize, 0, Math.PI * 2, false);
      context.fillStyle = "yellow"; // Glitter color
      context.fill();
    }
  }
  // Continuous update and fade logic

  // Redraw when lines change
  useEffect(() => {
    redraw();
  }, [laserLinesArr, freehandLinesArr]);

  useEffect(() => {
    if (drawingArea && role !== 2) {
      if (role !== 2) {
        var canvas = document.getElementById("canvas");
        let modifiedArray = shapes.map((element) => {
          if (element.type === "laser") {
            return {
              ...element,
              x: element.x / canvas.width,
              y: element.y / canvas.height,
              width: element.width / canvas.width,
              height: element.height / canvas.height,
              mouseCoordinates: {
                recStartX: element.x / canvas.width,
                recStartY: element.y / canvas.height,
                recWidth: element.width / canvas.width,
                recHeight: element.height / canvas.height,
              },
              shape_type: "laser",
              object_text: "",
              platform: "web",
              aspect_ratio_width: 0,
              aspect_ratio_height: 0,
              mouseDown: true,
              laserPoints: laserPointToSend,
            };
          }
          else if (element.type === "freehand") {
            return {
              ...element,
              x: element.x / canvas.width,
              y: element.y / canvas.height,
              width: element.width / canvas.width,
              height: element.height / canvas.height,
              mouseCoordinates: {
                recStartX: element.x / canvas.width,
                recStartY: element.y / canvas.height,
                recWidth: element.width / canvas.width,
                recHeight: element.height / canvas.height,
              },
              shape_type: "freehand",
              object_text: "",
              platform: "web",
              aspect_ratio_width: 0,
              aspect_ratio_height: 0,
              mouseDown: true,
              laserPoints: laserPointToSend,
              freehandPoints: freehandPointToSend
            };
          }
          else if (element.type === "rectangle") {
            return {
              ...element,
              x: element.x / canvas.width,
              y: element.y / canvas.height,
              width: element.width / canvas.width,
              height: element.height / canvas.height,
              mouseCoordinates: {
                recStartX: element.x / canvas.width,
                recStartY: element.y / canvas.height,
                recWidth: element.width / canvas.width,
                recHeight: element.height / canvas.height,
              },
              shape_type: "rect",
              object_text: "",
              platform: "web",
              aspect_ratio_width: 0,
              aspect_ratio_height: 0,
              mouseDown: true,
            };
          } else if (element.type === "text") {
            return {
              ...element,

              x: element.x / canvas.width,
              y: element.y / canvas.height,
              width: element.width / canvas.width,
              height: element.height / canvas.height,
              mouseCoordinates: {
                recStartX: element.x / canvas.width,
                recStartY: element.y / canvas.height,
                recWidth: element.width / canvas.width,
                recHeight: element.height / canvas.height,
              },
              shape_type: "text",
              object_text: "",
              platform: "web",
              aspect_ratio_width: 0,
              aspect_ratio_height: 0,
              mouseDown: true,

              object_text: element.text,
            };
          } else if (element.type === "circle") {
            return {
              ...element,
              x: element.x / canvas.width,
              y: element.y / canvas.height,
              mouseCoordinates: {
                recStartX: element.x / canvas.width,
                recStartY: element.y / canvas.height,
                recWidth: element.width / canvas.width,
                recHeight: element.height / canvas.height,
              },
              shape_type: "circle",
              object_text: "",
              platform: "web",
              aspect_ratio_width: 0,
              aspect_ratio_height: 0,
              mouseDown: true,
              // Assuming radius should also be scaled, though it's not explicitly mentioned in your requirement
              radius: element.radius / canvas.width,
            };
          } else if (element.type === "arrow") {
            return {
              ...element,
              x: element.x / canvas.width,
              y: element.y / canvas.height,
              mouseCoordinates: {
                recStartX: element.x / canvas.width,
                recStartY: element.y / canvas.height,
                recWidth: element.width / canvas.width,
                recHeight: element.height / canvas.height,
              },
              shape_type: "arrow",
              object_text: "",
              platform: "web",
              aspect_ratio_width: 0,
              aspect_ratio_height: 0,
              mouseDown: true,
              // Assuming radius should also be scaled, though it's not explicitly mentioned in your requirement
              radius: element.radius / canvas.width,
            };
          }
        });
        const [localValue] = [...room.localParticipant.dataTracks.values()];

        localValue.track.send(JSON.stringify(modifiedArray));
      }

      var canvas = document.getElementById("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = videoWidth;
      canvas.height = videoHeight;
      // window.innerHeight -70
      // var ctx = canvas.getContext("2d");
      // style the context
      ctx.strokeStyle = "red";
      ctx.lineWidth = 4;

      function drawDummyShape() {
        ctx.setLineDash([1, 3]);
        ctx.strokeStyle = "red";
        ctx.strokeRect(
          dummyShape.x,
          dummyShape.y,
          dummyShape.width,
          dummyShape.height
        );
        ctx.strokeStyle = "red";

        ctx.fillStyle = "white";

        ctx.fillRect(
          dummyShape.x + dummyShape.width - 12 / 2,
          dummyShape.y + dummyShape.height - 12 / 2,
          12,
          12
        );
        ctx.fillStyle = "blue";

        ctx.fillRect(
          dummyShape.x - 3,
          dummyShape.y - 3 + dummyShape.height / 2,
          6,
          6
        );

        ctx.fillRect(
          dummyShape.x - 3 + dummyShape.width / 2,
          dummyShape.y - 3,
          6,
          6
        );
        ctx.fillRect(
          dummyShape.x - 3 + dummyShape.width,
          dummyShape.y - 3 + dummyShape.height / 2,
          6,
          6
        );
        ctx.fillRect(
          dummyShape.x - 3 + dummyShape.width / 2,
          dummyShape.y - 3 + dummyShape.height,
          6,
          6
        );
        ctx.setLineDash([]);
        // ctx.beginPath();

        // ctx.arc(dummyShape.x , dummyShape.y , 6, 0, 2 * Math.PI);
        // ctx.fill();
      }

      const drawShapes = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        redraw();

        drawDummyShape(dummyShape);

        for (const shape of shapes) {
          if (shape.type === "rectangle") {
            ctx.strokeStyle = "red";
            ctx.setLineDash([]);
            ctx.strokeRect(shape.x, shape.y, shape.width, shape.height);
          } else if (shape.type === "circle") {
            circleShowFn(shape.x, shape.y, shape.width, shape.height);
          } else if (shape.type === "text") {
            commonFillTextFn(
              shape.x,
              shape.y,
              shape.width,
              shape.height,
              shape.text
            );
          } else if (shape.type === "arrow") {
            arrowShowFn(shape.x, shape.y, shape.width, shape.height);
          }
        }
      };

      const handleMouseDown = (event) => {
        setIsDrawShapes(false);
        setDrawCircle(false)
        setDrawRectangle(false)
        setDrawLine(false)
        setDrawText(false)
        // setLaserLine(false)
        const rect = canvas.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;

        if (laserLine || measuringStatus || freehand) {
          if (laserLine || freehand) {
            if (freehand) {
              setFreehandLinesArr(prev => [...prev, []]);
              setFreehandPointToSend(prev => [...prev, []]);
            }
            setIsDragging(true);
            addPointToSend(mouseX, mouseY, isDragging);
            addPoint(mouseX, mouseY, isDragging);
          }
          if (measuringStatus) {
            sendPointMeasure(mouseX, mouseY);
          }
        } else {
          if (isDrawShapes) {
            if (drawRectangle) {
              const newRectangle = {
                id: shapes.length + 1,
                type: "rectangle",
                x: mouseX - 50, // Adjusting to center the rectangle on the mouse click
                y: mouseY - 50, // Adjusting to center the rectangle on the mouse click
                width: 100,
                height: 100,
              };

              setDummyShape(newRectangle);
              const updatedShapes = [...shapes, newRectangle];
              setShapes(updatedShapes);
            }

            if (drawCircle) {
              const newCircle = {
                id: shapes.length + 1,
                type: "circle",
                x: mouseX - 50, // Adjusting to center the rectangle on the mouse click
                y: mouseY - 50, // Adjusting to center the rectangle on the mouse click
                width: 100,
                height: 100,
                radius: 50, // Default radius
              };
              setDummyShape(newCircle);
              // Update the shapes array by adding the new circle
              const updatedShapes = [...shapes, newCircle];
              setShapes(updatedShapes);
            }

            if (drawText) {
              const newText = {
                id: shapes.length + 1,
                type: "text",
                x: mouseX - 35, // Adjusting to center the rectangle on the mouse click
                y: mouseY - 15, // Adjusting to center the rectangle on the mouse click
                width: 70,
                height: 30,
                text: localStorage.getItem("keyText"),
              };
              setDummyShape(newText);
              const updatedShapes = [...shapes, newText];
              setShapes(updatedShapes);
            }
            if (drawLine) {
              const newLine = {
                id: shapes.length + 1,
                type: "arrow",
                x: mouseX - 50, // Adjusting to center the rectangle on the mouse click
                y: mouseY - 50, // Adjusting to center the rectangle on the mouse click
                width: 100,
                height: 100,
              };
              setDummyShape(newLine);
              const updatedShapes = [...shapes, newLine];
              setShapes(updatedShapes);
            }
          }

          for (const shape of shapes) {
            setDummyShape(shape);

            if (
              (mouseX >= shape.x + shape.width - 6) &
              (mouseX <= shape.x + shape.width + 6) &&
              mouseY >= shape.y + shape.height - 6 &&
              mouseY <= shape.y + shape.height + 6
            ) {
              setResizeArea("right-corner");
              setDummyShape(shape);
              setResizingShape(true);
              setCursorValue("nwse-resize");
              setIsDragging(true);
              setResizing(true);
              setSelectedShape(shape);
              setOffsetX(mouseX - shape.x);
              setOffsetY(mouseY - shape.y);
              break;
            }
            if (
              (mouseX >= shape.x - 3 + shape.width) &
              (mouseX <= shape.x + shape.width + 3) &&
              mouseY >= shape.y - 3 + shape.height / 2 &&
              mouseY <= shape.y + 3 + shape.height / 2
            ) {
              setResizeArea("right");
              setCursorValue("ew-resize");
              setDummyShape(shape);
              setResizingShape(true);
              setIsDragging(true);
              setResizing(true);
              setSelectedShape(shape);
              setOffsetX(mouseX - shape.x);
              setOffsetY(mouseY - shape.y);

              break;
            } else if (
              (mouseX >= shape.x - 3) & (mouseX <= shape.x + 3) &&
              mouseY >= shape.y - 3 + shape.height / 2 &&
              mouseY <= shape.y + 3 + shape.height / 2
            ) {
              setResizeArea("left");
              setCursorValue("ew-resize");
              setDummyShape(shape);
              setResizingShape(true);
              setIsDragging(true);
              setResizing(true);
              setSelectedShape(shape);
              setOffsetX(mouseX - shape.x);
              setOffsetY(mouseY - shape.y);
            } else if (
              (mouseX >= shape.x - 3 + shape.width / 2) &
              (mouseX <= shape.x + 3 + shape.width / 2) &&
              mouseY >= shape.y - 3 &&
              mouseY <= shape.y + 3
            ) {
              setResizeArea("top");
              setCursorValue("ns-resize");
              setDummyShape(shape);
              setResizingShape(true);
              setIsDragging(true);
              setResizing(true);
              setSelectedShape(shape);
              setOffsetX(mouseX - shape.x);
              setOffsetY(mouseY - shape.y);
            } else if (
              (mouseX >= shape.x - 3 + shape.width / 2) &
              (mouseX <= shape.x + 3 + shape.width / 2) &&
              mouseY >= shape.y - 3 + shape.height &&
              mouseY <= shape.y + 3 + shape.height
            ) {
              setResizeArea("bottom");
              setCursorValue("ns-resize");
              setDummyShape(shape);
              setResizingShape(true);
              setIsDragging(true);
              setResizing(true);
              setSelectedShape(shape);
              setOffsetX(mouseX - shape.x);
              setOffsetY(mouseY - shape.y);
            }
          }

          if (resizingShape) {
            const rect = canvas.getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const mouseY = event.clientY - rect.top;

            for (const shape of shapes) {
              if (
                mouseX >= shape.x &&
                mouseX <= shape.x + shape.width &&
                mouseY >= shape.y &&
                mouseY <= shape.y + shape.height
              ) {
                setDummyShape(shape);
                setIsDragging(true);
                setSelectedShape(shape);
                setOffsetX(mouseX - shape.x);
                setOffsetY(mouseY - shape.y);
                break;
              }
              if (
                (mouseX >= shape.x - 3 + shape.width) &
                (mouseX <= shape.x + shape.width + 3) &&
                mouseY >= shape.y - 3 + shape.height / 2 &&
                mouseY <= shape.y + 3 + shape.height / 2
              ) {
                setResizeArea("right");
                setCursorValue("ew-resize");
              } else if (
                (mouseX >= shape.x - 3) & (mouseX <= shape.x + 3) &&
                mouseY >= shape.y - 3 + shape.height / 2 &&
                mouseY <= shape.y + 3 + shape.height / 2
              ) {
                setResizeArea("left");
                setCursorValue("ew-resize");
              } else if (
                (mouseX >= shape.x - 3 + shape.width / 2) &
                (mouseX <= shape.x + 3 + shape.width / 2) &&
                mouseY >= shape.y - 3 &&
                mouseY <= shape.y + 3
              ) {
                setResizeArea("top");
                setCursorValue("ns-resize");
              } else if (
                (mouseX >= shape.x - 3 + shape.width / 2) &
                (mouseX <= shape.x + 3 + shape.width / 2) &&
                mouseY >= shape.y - 3 + shape.height &&
                mouseY <= shape.y + 3 + shape.height
              ) {
                setResizeArea("bottom");
                setCursorValue("ns-resize");
              }
            }
          } else {
            const rect = canvas.getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const mouseY = event.clientY - rect.top;

            for (const shape of shapes) {
              if (
                mouseX >= shape.x &&
                mouseX <= shape.x + shape.width &&
                mouseY >= shape.y &&
                mouseY <= shape.y + shape.height
              ) {
                setDummyShape(shape);
                setIsDragging(true);
                setResizing(true);
                setSelectedShape(shape);
                setOffsetX(mouseX - shape.x);
                setOffsetY(mouseY - shape.y);
                break;
              }
            }
          }
        }
      };

      const handleMouseMove = (event) => {
        const rect = canvas.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;
        setCursorValue("default");
        if (laserLine || freehand) {
          // drawShapes()
          if (freehand && isDragging) {
            // begin a new freehand stroke
            setFreehandPointToSend(prev => [...prev, []]);
          }
          addPointToSend(mouseX, mouseY, isDragging);
          addPoint(mouseX, mouseY, isDragging);
        }

        else {
          for (const shape of shapes) {
            const rect = canvas.getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const mouseY = event.clientY - rect.top;

            if (
              (mouseX >= shape.x + shape.width - 6) &
              (mouseX <= shape.x + shape.width + 6) &&
              mouseY >= shape.y + shape.height - 6 &&
              mouseY <= shape.y + shape.height + 6
            ) {
              setDummyShape(shape);
              setCursorValue("nwse-resize");
            } else {
              if (
                (mouseX >= shape.x) & (mouseX <= shape.x + shape.width) &&
                mouseY >= shape.y &&
                mouseY <= shape.y + shape.height
              ) {
                setDummyShape(shape);
                setCursorValue("all-scroll");
              }
            }

            if (
              (mouseX >= shape.x - 3 + shape.width) &
              (mouseX <= shape.x + shape.width + 3) &&
              mouseY >= shape.y - 3 + shape.height / 2 &&
              mouseY <= shape.y + 3 + shape.height / 2
            ) {
              setResizing(true);
              setSelectedShape(shape);
              setResizeArea("right");
              setCursorValue("ew-resize");
            } else if (
              (mouseX >= shape.x - 3) & (mouseX <= shape.x + 3) &&
              mouseY >= shape.y - 3 + shape.height / 2 &&
              mouseY <= shape.y + 3 + shape.height / 2
            ) {
              setResizing(true);
              setSelectedShape(shape);
              setResizeArea("left");
              setCursorValue("ew-resize");
            } else if (
              (mouseX >= shape.x - 3 + shape.width / 2) &
              (mouseX <= shape.x + 3 + shape.width / 2) &&
              mouseY >= shape.y - 3 &&
              mouseY <= shape.y + 3
            ) {
              setResizing(true);
              setSelectedShape(shape);
              setResizeArea("top");
              setCursorValue("ns-resize");
            } else if (
              (mouseX >= shape.x - 3 + shape.width / 2) &
              (mouseX <= shape.x + 3 + shape.width / 2) &&
              mouseY >= shape.y - 3 + shape.height &&
              mouseY <= shape.y + 3 + shape.height
            ) {
              setResizing(true);
              setSelectedShape(shape);
              setResizeArea("bottom");
              setCursorValue("ns-resize");
            }
          }

          if (resizingShape) {
            if (isDragging && selectedShape && resizing) {
              const rect = canvas.getBoundingClientRect();
              const mouseX = event.clientX - rect.left;
              const mouseY = event.clientY - rect.top;

              const dx = mouseX - selectedShape.x - offsetX;
              const dy = mouseY - selectedShape.y - offsetY;

              if (resizeArea == "right-corner") {
                if (
                  selectedShape.width + dx >= 20 &&
                  selectedShape.height + dy >= 20
                ) {
                  const updatedShape = {
                    ...selectedShape,
                    width: selectedShape.width + dx,
                    height: selectedShape.height + dy,
                  };
                  setDummyShape(updatedShape);
                  const updatedShapes = shapes.map((shape) =>
                    shape.id === selectedShape.id ? updatedShape : shape
                  );
                  setShapes(updatedShapes);
                }
              } else if (resizeArea == "left") {
                if (selectedShape.width + (selectedShape.x - mouseX) >= 20) {
                  const updatedShape = {
                    ...selectedShape,
                    x: mouseX,
                    width: selectedShape.width + (selectedShape.x - mouseX),
                  };
                  setDummyShape(updatedShape);
                  const updatedShapes = shapes.map((shape) =>
                    shape.id === selectedShape.id ? updatedShape : shape
                  );
                  setShapes(updatedShapes);
                }
              } else if (resizeArea == "right") {
                if (mouseX - selectedShape.x >= 20) {
                  const updatedShape = {
                    ...selectedShape,

                    width: mouseX - selectedShape.x,
                  };
                  setDummyShape(updatedShape);
                  const updatedShapes = shapes.map((shape) =>
                    shape.id === selectedShape.id ? updatedShape : shape
                  );
                  setShapes(updatedShapes);
                }
              } else if (resizeArea == "top") {
                if (selectedShape.height + (selectedShape.y - mouseY) >= 20) {
                  const updatedShape = {
                    ...selectedShape,
                    y: mouseY,
                    height: selectedShape.height + (selectedShape.y - mouseY),
                  };
                  setDummyShape(updatedShape);
                  const updatedShapes = shapes.map((shape) =>
                    shape.id === selectedShape.id ? updatedShape : shape
                  );
                  setShapes(updatedShapes);
                }
                // y: mouseY, height: prev.height + (prev.y - mouseY)
              } else if (resizeArea == "bottom") {
                if (mouseY - selectedShape.y >= 20) {
                  const updatedShape = {
                    ...selectedShape,

                    height: mouseY - selectedShape.y,
                  };
                  setDummyShape(updatedShape);
                  const updatedShapes = shapes.map((shape) =>
                    shape.id === selectedShape.id ? updatedShape : shape
                  );
                  setShapes(updatedShapes);
                }
              }
            }
          } else {
            if (isDragging && selectedShape) {
              const rect = canvas.getBoundingClientRect();
              const mouseX = event.clientX - rect.left;
              const mouseY = event.clientY - rect.top;
              const updatedShape = {
                ...selectedShape,
                x: mouseX - offsetX,
                y: mouseY - offsetY,
              };
              setDummyShape(updatedShape);
              const updatedShapes = shapes.map((shape) =>
                shape.id === selectedShape.id ? updatedShape : shape
              );
              setShapes(updatedShapes);
            }
          }
        }
      };

      const handleMouseUp = () => {
        setIsDragging(false);
        setResizingShape(false);
        setCursorValue("default");
        setSelectedShape(null);
        setResizeArea("");
        setDummyShape({
          x: 0,
          y: 0,
          width: 0,
          height: 0,
        });
      };

      // Touch event handlers
      const handleTouchStart = (event) => {
        const rect = canvas.getBoundingClientRect();
        const touchX = event.touches[0].clientX - rect.left;
        const touchY = event.touches[0].clientY - rect.top;
        handleMouseDown({ clientX: touchX, clientY: touchY });
      };

      const handleTouchMove = (event) => {
        const rect = canvas.getBoundingClientRect();
        const touchX = event.touches[0].clientX - rect.left;
        const touchY = event.touches[0].clientY - rect.top;
        handleMouseMove({ clientX: touchX, clientY: touchY });
      };

      const handleTouchEnd = () => {
        handleMouseUp();
      };

      canvas.addEventListener("mousedown", handleMouseDown);
      canvas.addEventListener("mousemove", handleMouseMove);
      canvas.addEventListener("mouseup", handleMouseUp);
      canvas.addEventListener("touchstart", handleTouchStart);
      canvas.addEventListener("touchmove", handleTouchMove);
      canvas.addEventListener("touchend", handleTouchEnd);

      drawShapes();

      const fadePoints = () => {
        if (laserLinesArr.length > 1) {
          setLaserLinesArr((prevLines) => prevLines.slice(1));
          setLaserPointToSend((prevLines) => prevLines.slice(1));
        } else if (laserLinesArr.length === 1) {
          setLaserLinesArr([]);
          setLaserPointToSend([]);
        } else {
          // If no lines left, clear the interval
          clearInterval(intervalIdRef.current);
        }
      };

      // Only set the interval if it's not already running
      if (laserLinesArr.length > 0 && intervalIdRef.current === null) {
        intervalIdRef.current = setInterval(fadePoints, 40);
      }

      return () => {
        canvas.removeEventListener("mousedown", handleMouseDown);
        canvas.removeEventListener("mousemove", handleMouseMove);
        canvas.removeEventListener("mouseup", handleMouseUp);
        canvas.removeEventListener("touchstart", handleTouchStart);
        canvas.removeEventListener("touchmove", handleTouchMove);
        canvas.removeEventListener("touchend", handleTouchEnd);
        if (intervalIdRef.current !== null) {
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null; // Reset the ref after clearing the interval
        }
      };
    }
  }, [
    shapes,
    isDragging,
    selectedShape,
    offsetX,
    offsetY,
    drawingArea,
    drawRectangle,
    drawCircle,
    drawText,
    localStorage.getItem("keyText"),
    isDrawShapes,
    dummyShape,
    laserLinesArr,
    resizeArea,
    freehandLinesArr
  ]);

  function sendPointMeasure(x, y) {
    var canvas = document.getElementById("canvas");
    const objj = [
      {
        mouseCoordinates: {
          recStartX: x / canvas.width,
          recStartY: y / canvas.height,
        },
        shape_type: "measure",
        object_text: "",
        platform: "web",
        aspect_ratio_width: 0,
        aspect_ratio_height: 0,
        mouseDown: true,
      },
    ];

    const [localValue] = [...room.localParticipant.dataTracks.values()];
    localValue?.track.send(JSON.stringify(objj));
  }

  // function arrowShowFn(x, y, w, h) {
  //   var canvas = document.getElementById("canvas");
  //   const context = canvas.getContext("2d");
  //   if (!context) {
  //     return;
  //   }

  //   const rectWidth = w;
  //   const rectHeight = h;
  //   const startX = x;
  //   const startY = y;

  //   context.fillStyle = "#000";
  //   context.strokeStyle = "red";
  //   context.lineWidth = 2;

  //   context.beginPath();
  //   context.stroke();

  //   const centerA = { x: startX, y: startY + rectHeight / 2 };
  //   const centerB = { x: startX + rectWidth / 2, y: startY };
  //   const centerC = { x: startX + rectWidth, y: startY + rectHeight / 2 };
  //   const centerD = { x: startX + rectWidth / 2, y: startY + rectHeight };
  //   const offset = rectHeight / 6;

  //   context.beginPath();
  //   context.moveTo(centerC.x, centerC.y);
  //   context.lineTo(centerB.x, centerB.y);

  //   const verticalLineEndB = { x: centerB.x, y: centerB.y + offset };
  //   context.lineTo(verticalLineEndB.x, verticalLineEndB.y);
  //   context.lineTo(startX, verticalLineEndB.y);

  //   context.moveTo(startX, verticalLineEndB.y);
  //   context.lineTo(centerA.x, centerA.y);

  //   context.moveTo(centerC.x, centerC.y);
  //   context.lineTo(centerD.x, centerD.y);

  //   const verticalLineEndD = { x: centerD.x, y: centerD.y - offset };
  //   context.lineTo(verticalLineEndD.x, verticalLineEndD.y);
  //   context.lineTo(startX, verticalLineEndD.y);

  //   context.moveTo(startX, verticalLineEndD.y);
  //   context.lineTo(centerA.x, centerA.y);

  //   // Finish the drawing
  //   context.stroke();
  // }

  function arrowShowFn(x, y, w, h) {
    var canvas = document.getElementById("canvas");
    var ctx = canvas.getContext("2d");
    // ctx.clearRect(0, 0, canvas.width, canvas.height)

    var startX = x;
    var startY = y;
    var height = h;
    var width = w;

    ctx.beginPath();
    var newStartY = parseInt(height / 2) + startY;
    var center = width / 2;

    ctx.moveTo(startX + center, newStartY);
    ctx.lineTo(startX - 100, newStartY);
    ctx.stroke();

    ctx.beginPath();
    var newStartY = parseInt(height / 2) + startY;

    ctx.moveTo(startX + center, newStartY);
    ctx.lineTo(startX - 20 + center, newStartY - 10);
    ctx.stroke();

    ctx.beginPath();
    var newStartY = parseInt(height / 2) + startY;

    ctx.moveTo(startX + center, newStartY);
    ctx.lineTo(startX - 20 + center, newStartY + 10);
    ctx.stroke();
  }

  function circleShowFn(x, y, w, h) {
    var startX = x;
    var startY = y;
    var mouseX = x + w;
    var mouseY = y + h;

    var canvas = document.getElementById("canvas");

    var ctx = canvas.getContext("2d");
    // ctx.clearRect(0, 0, canvas.width, canvas.height)

    ctx.save();
    ctx.beginPath();
    //Dynamic scaling
    var scalex = 1 * ((mouseX - startX) / 2);
    var scaley = 1 * ((mouseY - startY) / 2);
    ctx.scale(scalex, scaley);
    //Create ellipse
    var centerx = startX / scalex + 1;
    var centery = startY / scaley + 1;
    ctx.arc(centerx, centery, 1, 0, 2 * Math.PI);
    //Restore and draw
    ctx.restore();

    ctx.stroke();
  }

  function rectangleShowFn(x, y, w, h) {
    var canvas = document.getElementById("canvas");

    var ctx = canvas.getContext("2d");
    // ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.strokeRect(x, y, w, h);
  }

  function textShowFn(x, y, w, h) {
    commonFillTextFn(x, y, w, h, localStorage.getItem("keyText"));
  }

  function sendMessage(e) {
    e.preventDefault();
    if (localMessage != "") {
      setDiscussionVal(localMessage);
      var newObj = {
        message: localMessage,
        mouseDown: false,
        shape_type: "",
        aspect_ratio_width: 0,
        mouseCoordinates: {
          recStartX: 0.0,
          recStartY: 0.0,
          recWidth: 0.0,
          recHeight: 0.0,
        },
      };

      var Obj = {
        name: "You",
        message: localMessage,
        // time: new Date().toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3")
        time: timeStampFormat(new Date()),
      };

      setMessageFn(Obj);

      // setMessageArr([...messageArr,Obj])

      //  setMessageArr([...messageArr,newObj])
      const [localValue] = [...room.localParticipant.dataTracks.values()];
      localValue.track.send(JSON.stringify(newObj));
      // console.log(JSON.stringify(newObj),"new oBject")
      handleSaveDiscussion();
      setLocalMessage("");
    }
  }

  function onMessageChange(e) {
    setLocalMessage(e.target.value);
  }

  function UploadToCallNote() {
    html2canvas(document.getElementById("forSC"))
      .then((canvas) => {
        canvas.style.display = "none";
        document.body.appendChild(canvas);
        return canvas;
      })
      .then((canvas) => {
        const image = canvas
          .toDataURL("image/png")
          .replace("data:", "")
          .replace(/^.+,/, "");
        const byteCharacters = atob(image);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray]);
        const newblob = blob.slice(0, blob.size, "image/png");
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id") || "");
        data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
        data.append("attachment0", newblob, "Screenshot.png");
        data.append("receiver_user_id_ids", joinCallRes?.remote_user_id || "");
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        dispatch(
          callNote(
            data,
            () => {
              setShowTrackControl(false);
              setUplaodPhoto(true);
            },
            () => { }
          )
        );
      });
  }

  function handleSaveNoteFromOcr() {
    setIsLoadingActive(true);
    let data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
    data.append("attachment0", image, "Screenshot.png");
    data.append("receiver_user_id_ids", joinCallRes?.remote_user_id || "");
    data.append("call_note", OCRText);
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    dispatch(
      callNote(
        data,
        () => {
          setIsLoadingActive(false);
          setOcrResultModal(false);
          callNoteData();
          handleClearOCRSteps()
          handleTab(3);

          handleCloseMobileBottomDrawer();
          setMobileTabs();
        },
        () => {
          setIsLoadingActive(false);
          setOcrResultModal(false);
        }
      )
    );
  }

  function handleClearCanvas() {
    // setTabOpen(1)
    setFreehand(false)
    setFreehandLinesArr([]);
    setFreehandPointToSend([]);
    setLaserLine(false);
    setShapes([]);
    setLaserLinesArr([]);
    setDummyShape({ x: 0, y: 0, width: 0, height: 0 });
    toggleDrawingTools();

    setLiveDrawingChecks(false);

    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("end-draw");
    const video = document.getElementById("LP");
    video.play();
    dispatch(drawDisable());
    setRecHeight(0);
    setRecStartX(0);
    setRecStartY(0);
    setRecWidth(0);
    setDrawCircle(false);
    setShowTrackControl(false);
    setDrawRectangle(false);
    setDrawLine(false);
    setDrawText(false);
    setLaserLine(false);
    setFreehand(false);
    setMeasuringStatus(false);
    setTrackingVal(false);
    setShapesArr([]);
  }
  function handleClearOnly() {
    setLaserLinesArr([]);
    setFreehandLinesArr([]);
    setLaserPointToSend([]);
    setShapes([]);
    setLaserLine(false);
    setFreehand(false);
    setMeasuringStatus(false);
    setDummyShape({ x: 0, y: 0, width: 0, height: 0 });
    shapesArr.splice(0, shapesArr.length);
    setShapesArr([]);
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("clear-draw");

    var canvas = document.getElementById("canvas");
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, videoWidth, videoHeight);
    setShapesArr([]);
  }

  function handleTextChange(e) {
    setTextShapeMessageErr(false);
    if (e.target.value.trim().split("").length < 31) {
      setKeyText(e.target.value);
      localStorage.setItem("keyText", e.target.value);
    }
  }

  // Function toggling between Menus
  const toggleMenu = (num) => {
    setRenderMenuBar(num);
  };

  const startDrawing = () => {
    const [localValue] = [...room.localParticipant.dataTracks.values()];

    localValue.track.send("start-draw");
    const video = document.getElementById("LP");
    video.pause();

    setDrawCircle(false);
    setDrawRectangle(false);
    setDrawLine(false);
    setDrawText(false);
  };

  // =========== for toggle Menu when the screen size less than 550px =================

  function handleResize() {
    const [localValue] = [...room.localParticipant.dataTracks.values()];
    setShapes([]);
    setDummyShape({ x: 0, y: 0, width: 0, height: 0 });
    localValue?.track?.send("end-draw");
    const video = document.getElementById("LP");
    video.play();
    dispatch(drawDisable());
    setRecHeight(0);
    setRecStartX(0);
    setRecStartY(0);
    setRecWidth(0);
    setDrawCircle(false);
    setShowTrackControl(false);
    setDrawRectangle(false);
    setDrawLine(false);
    setDrawText(false);
    setTrackingVal(false);
    setShapesArr([]);
    setLiveDrawingChecks(false);
  }
  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 780) {
        handleResize();
      }
    });
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // ============= Showing the names of professional and customer on Video ===========
  let timeOutInterval;
  useEffect(() => {
    participants?.map((participant) => {
      setRemoteAvatar(false);
      if (
        participant.identity.substring(0, participant.identity.indexOf("("))
      ) {
        if (role != 2) {
          setCustomerName(
            participant.identity.substring(0, participant.identity.indexOf("("))
          );
        } else {
          setProfessionalName(
            participant.identity.substring(0, participant.identity.indexOf("("))
          );
        }
      }
    });

    if (participants.length > 0) {
      setCustomerDisconnected(false);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [room, participants]);

  useEffect(() => {
    if (role != 2) {
      setProfessionalName(userName);
    } else {
      setCustomerName(userName);
    }
  }, []);

  const buttonRef = useRef(null);

  // Log new Participants as they connect to the Room

  useEffect(() => {
    if (openParticipantDisconnectMsg) {
      setRoomTimer(0);
      setCustomerDisconnected(true);

      const video = document.getElementById("LP");
      video.play();
      dispatch(drawDisable());
      setRecHeight(0);
      setRecStartX(0);
      setRecStartY(0);
      setRecWidth(0);
      setDrawCircle(false);
      setShowTrackControl(false);
      setDrawRectangle(false);
      setDrawLine(false);
      setDrawText(false);
      setTrackingVal(false);
      setShapesArr([]);
      // setOpenParticipantDisconnectMsg(false)
      setCustomerName("");
      setProfessionalName("");
      //  setLocalAvatar('')
      setRemoteAvatar(false);

      setDrawingToolToggle(false);

      setZoomCounter(0);
    }
  }, [openParticipantDisconnectMsg]);

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.addEventListener("click", handleClickPip);
    }

    // Return a cleanup function to remove the event listener
    return () => {
      if (buttonRef.current) {
        buttonRef.current.removeEventListener("click", handleClickPip);
      }
    };
  }, []);

  useEffect(() => {
    particularCallDetails();
  }, []);

  const particularCallDetails = () => {
    let details = {
      user_id_ids: localStorage.getItem("user_id") || "",
      call_log_id_ids: localStorage.getItem("call_log_id"),
    };
    dispatch(
      callDetails(details, (e) => {
        localStorage.setItem("ticket_id", e.data.data.ticket_id_ids);
        setCallDetailsObj(e.data.data);
        setReceiverData(e.data.data.receiver_data);
        setTime(e.data.data.created_date_dtm + "000");
        setShowUserRating(e.data.data.user_rating?.rating_value_int);
        setTicketDisplayName(e.data.data?.ticket_detail?.display_id_int);
      })
    );
  };

  const deleteSingleDetails = (e) => {
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      user_call_log_id_ids: localStorage.getItem("user_call_log_id_ids"),
    };
    dispatch(
      deleteCallHistory(details, (res) => {
        navigate("/callHistory");
      })
    );
  };

  const handleOpenCallDialog = () => {
    setOpenCallDialog(true);
  };
  const handleCloseCallDialog = () => {
    setOpenCallDialog(false);
  };

  const handleAttach = () => {
    hiddenFileInput.current.click();
  };

  const inputFileTarget = (e) => {
    const selectedFileLength = [...selectedFile];
    if (selectedFileLength.length < 10) {
      setDeleteIconVisiblity({ visibility: "visible" });
      setSelectedFile([...selectedFile, e.target.files[0]]);

      return;
    }
    return setSelectedFileLimit("*You can't add more than 10 files.");
  };

  const deleteUpload = (fileIndex) => {
    const updatedFile = selectedFile.filter((delElem, delElemIndex) => {
      return fileIndex !== delElemIndex;
    });
    setSelectedFile([...updatedFile]);
    setSelectedFileLimit("");
  };

  const discussionOnChange = (e) => {
    setDiscussionVal(e.target.value);
  };

  const handleSaveDiscussion = () => {
    let data = new FormData();
    setSelectedFileLimit("");
    setSaveLoading(true);
    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("call_log_id_ids", localStorage.getItem("call_log_id"));

    data.append("call_note", discussionVal + (localMessage || ""));
    selectedFile?.map((attachmentData, attachmentI) => {
      data.append(`attachment${attachmentI}`, attachmentData);
    });

    data.append("receiver_user_id_ids", joinCallRes?.remote_user_id || "");
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    toggleForAddPersonalNote && data.append("is_personal_note_ysn", 1);

    dispatch(
      callNote(
        data,
        () => {
          const [localValue] = [...room.localParticipant.dataTracks.values()];

          !toggleForAddPersonalNote && localValue.track.send("notes_attachment");

          if (discussionVal != "") {
            setDiscussionVal(discussionVal);
            var newObj = {
              message: discussionVal,
              mouseDown: false,
              shape_type: "",
              mouseCoordinates: {
                recStartX: 0.0,
                recStartY: 0.0,
                recWidth: 0.0,
                recHeight: 0.0,
              },
            };

            var Obj = {
              name: "You",
              message: discussionVal,
              // time: new Date().toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3")
              time: timeStampFormat(new Date()),
            };

            setMessageFn(Obj);

            // setMessageArr([...messageArr,Obj])

            //  setMessageArr([...messageArr,newObj])
            const [localValue] = [...room.localParticipant.dataTracks.values()];
            !toggleForAddPersonalNote && localValue.track.send(JSON.stringify(newObj));
            // console.log(JSON.stringify(newObj),"new oBject")

            setLocalMessage("");
          }
          setSelectedFile([]);
          setLocalMessage();
          setDiscussionVal("");
          setSaveLoading(false);
          !toggleForAddPersonalNote && callNoteData();
          toggleForAddPersonalNote && getServiceDetailsFn();
          setToggleForAddPersonalNote(false);

          handleCloseMobileMoreActionsDrawer();
        },
        () => {
          setSaveLoading(false);
        }
      )
    );
  };

  const callNoteData = () => {
    setDiscussionLoading(true);
    let details = {
      user_id_ids: localStorage.getItem("user_id") || "",
      call_log_id_ids: localStorage.getItem("call_log_id"),
    };

    let data = new FormData();

    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));

    dispatch(
      callNoteDetails(data, (res) => {
        console.log(res.data);
        setCallNoteDetailsArr(res.data.data);
        setDiscussionLoading(false);
      })
    );
  };

  useEffect(() => {
    if (renderMenuBar === 3) {
      callNoteData();
    }
  }, [renderMenuBar]);

  useEffect(() => {
    receiverData?.map((element) => {
      if (
        receiverData[0].phone_number == null ||
        receiverData[0].phone_number == ""
      ) {
        setphoneNumberFormat("NA");
      } else {
        setphoneNumberFormat(
          InternationalPhoneFormatFun(
            `${receiverData[0].country_code}`,
            `${receiverData[0].phone_number}`
          )
        );
      }
    });
  }, [receiverData]);

  useEffect(() => {
    const id = setTimeout(() => {
      setDrawingStarted(false);
    }, 2000);
  }, [drawingStarted]);

  const handleClickPip = async () => {
    if (!videoRefRemote.current) return;
    try {
      if (videoRefRemote.current !== document.pictureInPictureElement) {
        if (!document.pictureInPictureElement) {
          await videoRefRemote.current.requestPictureInPicture();
        }
      } else {
        await document.exitPictureInPicture();
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    try {
      setTimeout(() => {
        if (role == 2) {
          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue?.track?.send(
            JSON.stringify({
              message: "",
              mouseDown: true,
              platform: "web",
              shape_type: "",
              aspect_ratio_width: window.innerWidth,
              aspect_ratio_height: window.innerHeight,
              mouseCoordinates: {
                recStartX: 0.0,
                recStartY: 0.0,
                recWidth: 0.0,
                recHeight: 0.0,
              },
            })
          );
        }
      }, 2000);
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    const onTrackEnabled = (track, participant) => {
      if (track.kind === "audio") {
        setParticipantMicStatus(false); // Assuming this function unmutes the mic in the UI
      }
      if (track.kind === "video") {
        console.log(
          `Video track from ${participant.identity} has been enabled.`
        );
        setRemoteAvatar(false);

        // dispatch(drawActive());
        // shapesMakingFunction();
      }
    };

    const onTrackDisabled = (track, participant) => {
      if (track.kind === "audio") {
        setParticipantMicStatus(true); // Assuming this function mutes the mic in the UI
      }
      if (track.kind === "video") {
        console.log(
          `Video track from ${participant.identity} has been disabled.`
        );

        setRemoteAvatar(true);
      }
    };

    room.on("trackEnabled", onTrackEnabled);
    room.on("trackDisabled", onTrackDisabled);

    // Cleanup function to remove both event listeners
    return () => {
      room.off("trackEnabled", onTrackEnabled);
      room.off("trackDisabled", onTrackDisabled);
    };
  }, [room]);

  // Call duration functions ->>

  // Timer for the video call
  const [roomTimer, setRoomTimer] = useState(0);

  // state to check stopwatch running or not

  const [checkbox1Checked, setCheckbox1Checked] = useState(true);
  const [checkbox2Checked, setCheckbox2Checked] = useState(false);

  // Bottom drawer starts -----
  const [drawingToolToggle, setDrawingToolToggle] = useState(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [isChatOpenDrawer, setIsChatOpenDrawer] = useState(false);
  const [isNotesOpenDrawer, setIsNotesOpenDrawer] = useState(false);

  const toggleDrawer = () => setIsOpenDrawer(!isOpenDrawer);
  const toggleChatDrawer = () => setIsChatOpenDrawer(!isChatOpenDrawer);
  const toggleNotesDrawer = () => setIsNotesOpenDrawer(!isNotesOpenDrawer);
  const toggleDrawingTools = () => setDrawingToolToggle(!drawingToolToggle);

  useEffect(() => {
    if (
      //localStorage.getItem("user_id") != 0 &&
      isNotesOpenDrawer
    ) {
      callNoteData();
    }
  }, [isNotesOpenDrawer]);

  // Bottom drawer ends -----

  // Message Toaster to open the chat directly
  const handleMessageToast = () => {
    setNewBox(true);
    toggleMenu(3);
    setChatAlertArrLength(0);

    // setIsChatOpenDrawer(true);
    setIsNotesOpenDrawer(true);
  };

  // Modal functions for the image preview
  const [openDoc, setOpenDoc] = React.useState(false);
  const [imageAttachURL, setImageAttachURL] = useState("");
  const handleOpenDoc = () => {
    setOpenDoc(true);
  };
  const handleCloseDoc = () => {
    setOpenDoc(false);
    setNotesMessage('');
  }

  // Modal triggers for the Purchase List
  const [purchaseListTrigger, setPurchaseListTrigger] = useState(false);
  const handleClosePurchaseList = () => {
    setPurchaseListTrigger(false);
    handleCloseCreatePurchaseItem();
  };
  const handleShowPurchaseList = (e) => {
    setPurchaseListTrigger(true);
  };

  // Purchase list code start here -----------------
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [sortByValue, setSortByValue] = useState("DESC");
  const [searchValue, setSearchValue] = useState("");
  const [skeltonVal, setSkeltonVal] = useState(false);
  const [columnName, setColumnName] = useState("");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [elements, setElements] = useState([]);
  const [customeSkeletonLoaing, setCustomeSkeletonLoaing] = useState(false);

  const [flag, setFlag] = useState(false);

  const [currentTimeString, setCurrentTimeString] = useState("");
  const [toggleForPurchase, setToggleForPurchase] = useState(1);

  const [purchaseItemId, setPurchaseItemId] = useState();
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [totalEstimatedCost, setTotalEstimatedCost] = useState("");
  const [purchaseLink, setPurchaseLink] = useState("");
  const [itemDescription, setItemDescription] = useState("");

  const [itemNameErr, setItemNameErr] = useState(false);
  const [quantityErr, setQuantityErr] = useState(false);
  const [totalEstimatedCostErr, setTotalEstimatedCostErr] = useState(false);
  const [purchaseLinkErr, setPurchaseLinkErr] = useState(false);
  const [itemDescriptionErr, setItemDescriptionErr] = useState(false);

  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState("");
  const [handleToaster, setHandleToaster] = useState(false);

  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const [totalCost, setTotalCost] = useState(0);
  const [shoppingItemId, setShoppingItemId] = useState('');

  const rows = elements;

  // console.log(rows, "rows")

  const getCallHistoryDetails = (res) => {
    // console.log(res, "Res")
    setElements(res.data.data);
    setTotalNoRecord(res.data.total_count);
    setTotalCost(res.data?.total_estimated_cost);
    if (res.data.total_count % pageSize === 0) {
      setTotalPage(parseInt(res.data.total_count / pageSize));
    } else {
      setTotalPage(parseInt(res.data.total_count / pageSize + 1));
    }

    if (res.data.total_count === 0) {
      setTimeout(() => {
        setSkeltonVal(true);
      }, "3000");
    } else {
      setSkeltonVal(true);
    }
    // console.log(parseInt(res.total_records / pageSize), 'quoitent')
  };

  function getCurrentDateTime() {
    const now = new Date();

    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return now.toLocaleString("en-US", options);
  }

  function encodeDateString(currentTimeString) {
    return encodeURIComponent(currentTimeString);
  }

  useEffect(() => {
    setCurrentTimeString(getCurrentDateTime());
  }, []);

  const onLoadData = () => {
    setCustomeSkeletonLoaing(true);

    let data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    data.append("generated_date_dtm", getCurrentDateTime());
    data.append("page_index", page);
    data.append("page_size", pageSize);
    data.append("sorting_order", sortByValue);
    data.append("sorting_column_name", columnName);
    data.append("search_area", searchValue);

    dispatch(
      getPurchaseList(data, (res) => {
        getCallHistoryDetails(res);
        setCustomeSkeletonLoaing(false);
        setPurchaseLoading(false)
      })
    );
  };

  useEffect(() => {
    if (renderMenuBar == 4) {
      onLoadData();
    }
  }, [renderMenuBar]);

  function onLoadSearch() {
    let data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    data.append("generated_date_dtm", getCurrentDateTime());
    data.append("page_index", page);
    data.append("page_size", pageSize);
    data.append("sorting_order", sortByValue);
    data.append("sorting_column_name", columnName);
    data.append("search_area", searchValue);

    dispatch(
      getPurchaseList(data, (res) => {
        getCallHistoryDetails(res);
        setCustomeSkeletonLoaing(false);
      })
    );
  }

  useEffect(() => {
    if (searchValue.trim().length > 2) {
      setFlag(true);
      const timeOutId = setTimeout(onLoadSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValue.trim().length === 0) {
      if (flag) {
        onLoadSearch();
      }
    }
  }, [searchValue]);

  const handleItemName = (e) => {
    setItemNameErr(false);
    setItemName(e.target.value);
  };

  const handleQuantity = (e) => {
    setQuantityErr(false);
    setQuantity(e.target.value.replace(/\D/g, ""));
  };

  const handleTotalEstimatedCost = (e) => {
    setTotalEstimatedCostErr(false);
    setTotalEstimatedCost(
      e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
    );
  };

  const handlePurchaseLink = (e) => {
    setPurchaseLinkErr(false);
    setPurchaseLink(e.target.value);
  };

  const handleDescription = (e) => {
    setItemDescriptionErr(false);
    setItemDescription(e.target.value);
  };

  const handleItemNameBlurCheck = () => {
    if (itemName === "") {
      setItemNameErr(true);
    }
  };

  const handleSubmitPurchase = (e) => {
    e.preventDefault();

    if (itemName === "") {
      setItemNameErr(true);
    }

    if (itemName) {
      // console.log(itemName, quantity, totalEstimatedCost, purchaseLink, itemDescription)
      setPurchaseLoading(true);

      let data = new FormData();
      data.append("user_id_ids", localStorage.getItem("user_id") || "");
      data.append("call_log_id_ids", localStorage.getItem("call_log_id") || "");
      data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
      data.append("item_name_chr", itemName);
      data.append("quantity_int", quantity == "" ? 1 : quantity);
      data.append(
        "estimated_price_float",
        parseFloat(
          ((quantity || 1) * totalEstimatedCost).toFixed(2)
        )
      );
      data.append("description_chr", itemDescription);
      data.append("purchase_link_chr", purchaseLink);

      dispatch(
        createPurchaseItem(
          data,
          (res) => {
            setPurchaseLoading(false);
            setResponceMsg(res.data.message);
            setToasterType("success");
            // setToggleForPurchase(1);

            handleClosePurchaseList();

            handleCloseCreatePurchaseItem();

            handleCloseMobileMoreActionsDrawer();

            onLoadData();

            handleAddNotesView();
            const [localValue] = [...room.localParticipant.dataTracks.values()];

            localValue.track.send("shopping_list");
            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 11000);
          },
          (err) => {
            setPurchaseLoading(false);
            setResponceMsg(err.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }
  };

  const handleCloseCreatePurchaseItem = (e) => {
    e?.preventDefault();
    setToggleForPurchase(1);
    setItemNameErr(false);
    setQuantityErr(false);
    setTotalEstimatedCostErr(false);
    setPurchaseLinkErr(false);
    setItemDescriptionErr(false);

    setItemName("");
    setQuantity("");
    setTotalEstimatedCost("");
    setPurchaseLink("");
    setItemDescription("");

    setEmailPhoneValue("");
    setIsEmailPhoneVal(false);
  };

  const handleUpdatePurchaseList = (element, e) => {
    e.stopPropagation();

    // setPurchaseLoading(true)

    setPurchaseItemId(element?.item_id_ids);
    setItemName(element?.item_name_chr);
    setQuantity(element?.quantity_int);
    setTotalEstimatedCost(
      (element?.estimated_price_float / element?.quantity_int).toFixed(2)
    );
    setPurchaseLink(element?.purchase_link_chr);
    setItemDescription(element?.description_chr);
    setToggleForPurchase(2);
    // handleShowPurchaseList();
  };

  const handleViewPurchaseItem = (element) => {
    setPurchaseItemId(element?.item_id_ids);
    setItemName(element?.item_name_chr);
    setQuantity(element?.quantity_int);
    setTotalEstimatedCost(element?.estimated_price_float);
    setPurchaseLink(element?.purchase_link_chr);
    setItemDescription(element?.description_chr);
    setToggleForPurchase(5);
  };

  const handleViewPurchaseItemDesktop = (element, val) => {
    setPurchaseItemId(element?.item_id_ids);
    setItemName(element?.item_name_chr);
    setQuantity(element?.quantity_int);
    setTotalEstimatedCost(element?.estimated_price_float);
    setPurchaseLink(element?.purchase_link_chr);
    setItemDescription(element?.description_chr);
    handleShowPurchaseList();
    setToggleForPurchase(val);
  };

  const handleDeletePurchaseList = (element, e) => {
    e.stopPropagation();
    setPurchaseLoading(true);

    setPurchaseItemId(element?.item_id_ids);

    let details = {
      user_id_ids: localStorage.getItem("user_id") || "",
      item_id_ids: element?.item_id_ids,
    };

    dispatch(
      deletePurchaseItem(
        details,
        (res) => {
          setPurchaseLoading(false);
          setResponceMsg(res.data.message);
          setToasterType("success");

          onLoadData();

          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue.track.send("shopping_list");

          handleCloseMobileMoreActionsDrawer();

          handleClosePurchaseList();

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);
        },
        (err) => {
          setPurchaseLoading(false);
          setResponceMsg(err.data.message);
          setToasterType("error");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  };

  const handleUpdatePurchase = (e) => {
    e.preventDefault();
    setPurchaseLoading(true);
    let data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("item_id_ids", purchaseItemId);
    data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    data.append("item_name_chr", itemName);
    data.append("quantity_int", quantity == "" ? 1 : quantity);
    data.append(
      "estimated_price_float",
      parseFloat(
        ((quantity || 1) * totalEstimatedCost).toFixed(2)
      )
    );
    data.append("description_chr", itemDescription);
    data.append("purchase_link_chr", purchaseLink);

    dispatch(
      updatePurchaseItem(
        data,
        (res) => {
          setPurchaseLoading(false);
          setResponceMsg(res.data.message);
          setToasterType("success");
          // setToggleForPurchase(1);

          handleClosePurchaseList();

          handleCloseCreatePurchaseItem();

          onLoadData();

          handleCloseMobileMoreActionsDrawer();

          handleAddNotesView();

          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue.track.send("shopping_list");

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);
        },
        (err) => {
          setPurchaseLoading(false);
          setResponceMsg(err.data.message);
          setToasterType("error");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  };

  // Send purchase list via email or phone number

  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  const [codeValue, setCodeValue] = useState();
  const [isPhone, setIsPhone] = useState(false);

  const handleSendPurchaseList = (e) => {
    e.preventDefault();
    if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
      setPurchaseLoading(true);
      if (isPhone) {
        const data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id") || "");
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        data.append("generated_date_dtm", getCurrentDateTime());
        data.append("email_chr", "");
        data.append("phone_code_id_int", parseInt(codeValue) || 1);
        data.append("phone_number_int", emailPhoneValue);

        dispatch(
          sharePurchaseList(
            data,
            (res) => {
              setPurchaseLoading(false);
              setResponceMsg(res.data.message);
              setToasterType("success");
              // setToggleForPurchase(1);
              handleClosePurchaseList();

              handleCloseCreatePurchaseItem();

              handleCloseMobileMoreActionsDrawer();

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            },
            (err) => {
              setPurchaseLoading(false);
              setResponceMsg(err.data.message);
              setToasterType("error");

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      } else if (!isPhone) {
        const data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id") || "");
        data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        data.append("generated_date_dtm", getCurrentDateTime());
        data.append("email_chr", emailPhoneValue);
        // data.append("phone_code_id_int", null);
        // data.append("phone_number_int", null);

        dispatch(
          sharePurchaseList(
            data,
            (res) => {
              setPurchaseLoading(false);
              setResponceMsg(res.data.message);
              setToasterType("success");
              // setToggleForPurchase(1);
              handleClosePurchaseList();

              handleCloseCreatePurchaseItem();

              handleCloseMobileMoreActionsDrawer();

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            },
            (err) => {
              setPurchaseLoading(false);
              setResponceMsg(err.data.message);
              setToasterType("error");

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    } else {
      setIsEmailPhoneVal(true);
    }
  };

  const handleEmailPhone = (e) => {
    setIsEmailPhoneVal(false);

    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
  };
  const handleDropdownValue = (e) => {
    setCodeValue(e);
  };

  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  function handleEmailPhoneBlur() {
    if (isPhone) {
      if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
      }
    } else {
      if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
      }
    }
  }

  const copyToClipboard = () => {
    setResponceMsg("Link copied to clipboard!");
    setToasterType("success");

    setHandleToaster(true);
    setTimeout(() => {
      setHandleToaster(false);
    }, 11000);
  };

  const [toggleForNotesMobileView, setToggleForNotesMobileView] = useState(1);
  useEffect(() => {
    if (toggleForNotesMobileView == 2) {
      onLoadData();
    }
  }, [toggleForNotesMobileView]);

  // Format the price to USD

  // Purchase list code end here -------------------

  const [tabOpen, setTabOpen] = useState(1);
  function handleTab(v) {
    setTabOpen(v);
  }

  useEffect(() => {
    if (callDetailsObj?.ticket_detail?.category_name_chr == `Inspection`) {
      setTabOpen(6);
      getHomeAreaListFn();
    }
  }, [callDetailsObj]);

  const [toggleNoteView, setToggleNoteView] = useState(false);
  function handleAddNotesView() {
    setToggleNoteView(!toggleNoteView);
  }

  const [toggleEditNotePopUp, setToggleEditNotePopUp] = useState();
  const [toggleEditShoppingPopUp, setToggleEditShoppingPopUp] = useState();
  function handleEditNotePopUp(e) {
    if (e == toggleEditNotePopUp) {
      setToggleEditNotePopUp();
    } else {
      setToggleEditNotePopUp(e);
    }
  }
  function handleEditShoppingPopUp(e) {
    if (e == toggleEditShoppingPopUp) {
      setToggleEditShoppingPopUp();
    } else {
      setToggleEditShoppingPopUp(e);
    }
  }

  const myDivRef = useRef();
  useEffect(() => {
    setToggleNoteView(false);

    localStorage.setItem("keyText", "");
  }, [tabOpen]);

  const [endCallPopUp, setEndCallPopUp] = useState(false);

  // Functions for the mobile view starts here
  const [mobileTabs, setMobileTabs] = useState();
  const [toggleDrawingInstructionMobile, setToggleDrawingInstructionMobile] =
    useState(true);
  const [mobileBottomDrawer, setMobileBottomDrawer] = useState(false);

  const [mobileMoreActionsTabs, setMobileMoreActionsTabs] = useState();
  const [mobileMoreActionsDrawer, setMobileMoreActionsDrawer] = useState(false);

  const [mobileNotesTabs, setMobileNotesTabs] = useState(1);
  const [mobileShoppingListTabs, setMobileShoppingListTabs] = useState(1);
  const [mobileCheckUpTabs, setMobileCheckUpTabs] = useState(2);

  const [shoppingItemObject, setShoppingItemObject] = useState({});
  const [noteObject, setNoteObject] = useState({});

  const [toggleForInspectionItemReceived, setToggleForInspectionItemReceived] = useState(true);

  const handleOpenMobileBottomDrawer = () => {
    setMobileBottomDrawer(true);
  };

  const handleCloseMobileBottomDrawer = () => {
    setMobileBottomDrawer(false);
  };

  const handleCloseMobileBottomBackdrop = () => {
    setMobileBottomDrawer(false);
    setMobileTabs();
  };

  const handleMobileTabs = (index) => {
    setMobileTabs(index);
    setToggleDrawingInstructionMobile(true);
  };

  const handleOpenMobileMoreActionsDrawer = () => {
    setMobileMoreActionsDrawer(true);
  };

  const handleCloseMobileMoreActionsDrawer = () => {
    setMobileMoreActionsDrawer(false);
    setMobileNotesTabs(1);
    setMobileShoppingListTabs(1);
    setMobileCheckUpTabs(2);
    handleCloseCreatePurchaseItem();
    handleClearInventoryStates();
  };

  const handleCloseMobileMoreActionsBackdrop = () => {
    setMobileMoreActionsDrawer(false);
    setMobileMoreActionsTabs();
    setMobileNotesTabs(1);
    setMobileShoppingListTabs(1);
    handleCloseCreatePurchaseItem();
    handleClearInventoryStates();
  };

  const handleMobileMoreActionsTabs = (index) => {
    setMobileMoreActionsTabs(index);
  };

  const handleMenuClickShoppingMobile = (element, index) => {
    setShoppingItemObject(element);
    setMobileMoreActionsTabs(2);
    handleOpenMobileMoreActionsDrawer();
    setMobileShoppingListTabs(2);
  };

  const handleMenuClickNoteMobile = (element, index) => {
    setNoteObject(element);
    setMobileMoreActionsTabs(1);
    handleOpenMobileMoreActionsDrawer();
    setMobileNotesTabs(2);
  };

  const handleMenuClickCheckUpMobile = (element, index) => {
    setIndividualProductObj(element)
    setMobileMoreActionsTabs(3);
    handleOpenMobileMoreActionsDrawer();
    setMobileCheckUpTabs(1);
  };

  // Functions for the mobile view ends here

  const handleDeleteNote = (element, e) => {
    e?.preventDefault();

    setSaveLoading(true);

    setPurchaseItemId(element?.item_id_ids);

    let details = {
      user_id_ids: localStorage.getItem("user_id") || "",
      call_log_note_id_ids: element?.call_log_note_id_ids,
    };

    dispatch(
      deleteCallLogNoteById(
        details,
        (res) => {
          setSaveLoading(false);
          setResponceMsg(res.data.message);
          setToasterType("success");

          callNoteData();

          handleCloseMobileMoreActionsDrawer();

          handleCloseModalNotes();

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        },
        (err) => {
          setSaveLoading(false);
          setResponceMsg(err.data.message);
          setToasterType("error");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  };

  const [showPopoverShopping, setShowPopoverShopping] = useState(false);
  // More actions for both customer and pro
  const popoverShopping = (
    <Popover id="popover-basic" style={{ minWidth: "100px", border: "none" }}>
      <Popover.Body
        className="p-2 popover-body"
        style={{
          //   padding: "5px",
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
        }}>
        <div className="d-flex flex-column font-w500 fs-6">
          <div
            onClick={(e) => {
              // editExpertise(e, expertiseObject);
              // setActivePopover(null)
              setShowPopoverShopping(false);
              handleAddNotesView();
            }}
            className="border-bottom cursor-pointer p-2  text-black overlay-action-btn">
            <span className="me-2">
              <i className="bi bi-list-check"></i>
            </span>
            <span>{"Add list item"}</span>
          </div>

          <div
            onClick={(e) => {
              handleShowPurchaseList();
              setToggleForPurchase(3);
              setShowPopoverShopping(false);
            }}
            className="border-bottom cursor-pointer p-2  text-black overlay-action-btn"
            style={{
              pointerEvents: rows.length > 0 ? "auto" : "none",
              opacity: rows.length > 0 ? "1" : "0.5",
            }}>
            <span className="me-2">
              <i className="bi bi-send"></i>
            </span>
            <span>{"Share shopping list"}</span>
          </div>

          <a
            download
            href={
              process.env.REACT_APP_BASE_URL +
              `ServiceRequest/DownloadPurchaseList?user_id_ids=${localStorage.getItem("user_id") || ""
              }&ticket_id_ids=${localStorage.getItem(
                "ticket_id"
              )}&generated_date_dtm=${encodeDateString(currentTimeString)}`
            }
            target="_blank"
            rel="noreferrer noopen"
            style={{
              pointerEvents: rows.length > 0 ? "auto" : "none",
              opacity: rows.length > 0 ? "1" : "0.5",
            }}>
            <div
              onClick={(e) => {
                // editExpertise(e, expertiseObject);
                // setActivePopover(null)
                setShowPopoverShopping(false);
              }}
              className="cursor-pointer p-2  text-black overlay-action-btn">
              <span className="me-2">
                <i className="bi bi-download"></i>
              </span>
              <span>{"Download shopping list"}</span>
            </div>
          </a>
        </div>
      </Popover.Body>
    </Popover>
  );

  const [isShoppingItemEdit, setIsShoppingItemEdit] = useState(false);
  const popoverShoppingActions = (index) => (
    <Popover
      // id="popover-basic"
      id={`popover-basic-${index}`}
      //   className="custom-popover"
      style={{ minWidth: "100px", border: "none" }}>
      <Popover.Body
        className="p-2 popover-body"
        style={{
          //   padding: "5px",
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
        }}>
        <div className="d-flex flex-column font-w500 fs-6" style={{}}>
          <div
            onClick={(e) => {
              // editExpertise(e, shoppingItemObject);
              setActivePopoverShopping(null);
              handleUpdatePurchaseList(shoppingItemObject, e);
              handleAddNotesView();
              setIsShoppingItemEdit(true);
            }}
            className="border-bottom cursor-pointer p-2  text-black overlay-action-btn">
            <span className="me-2">
              <i className="bi bi-pencil"></i>
            </span>
            <span>Edit</span>
          </div>
          <div
            onClick={(e) => {
              e?.preventDefault();
              e?.stopPropagation();
              // handleOpenExpertiseTrigger(e, 3, expertiseObject.expertise_id_ids);
              setActivePopoverShopping(null);
              handleViewPurchaseItemDesktop(shoppingItemObject, 4);
            }}
            className=" cursor-pointer p-2 text-danger overlay-action-btn">
            <span className="me-2">
              <i className="bi bi-trash"></i>
            </span>
            <span>Delete</span>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );

  const [activePopoverShopping, setActivePopoverShopping] = useState(null);

  const handleMenuClickShopping = (element, index) => {
    setShoppingItemObject(element);
    setActivePopoverShopping(activePopoverShopping === index ? null : index);
  };

  // Popover for the delete call notes
  const [modalTriggerNotes, setModalTriggerNotes] = useState(false);
  const [activePopoverNotes, setActivePopoverNotes] = useState(null);

  const handleOpenModalNotes = () => {
    setModalTriggerNotes(true);
  };
  const handleCloseModalNotes = () => {
    setModalTriggerNotes(false);
  };
  const popoverNoteActions = (index) => (
    <Popover
      // id="popover-basic"
      id={`popover-basic-${index}`}
      //   className="custom-popover"
      style={{ minWidth: "100px", border: "none" }}>
      <Popover.Body
        className="p-2 popover-body"
        style={{
          //   padding: "5px",
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
        }}>
        <div className="d-flex flex-column font-w500 fs-6" style={{}}>
          <div
            onClick={(e) => {
              // handleOpenExpertiseTrigger(e, 3, expertiseObject.expertise_id_ids);
              setActivePopoverNotes(null);
              handleOpenModalNotes();
            }}
            className=" cursor-pointer p-2 text-danger overlay-action-btn">
            <span className="me-2">
              <i className="bi bi-trash"></i>
            </span>
            <span>Delete</span>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );

  const handleMenuClickNotes = (element, index) => {
    setNoteObject(element);
    setActivePopoverNotes(activePopoverNotes === index ? null : index);
  };

  const [cameraPermissionStatus, setCameraPermissionStatus] = useState(true);
  const [micPermissionStatus, setMicPermissionStatus] = useState(true);
  const [cameraPermissionDialog, setCameraPermissionDialog] = useState(false);

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        // Check camera permission
        const cameraPermissionResult = await navigator.permissions.query({
          name: "camera",
        });
        if (cameraPermissionResult.state === "granted") {
          console.log("Camera permission: granted");
        } else if (cameraPermissionResult.state === "prompt") {
          console.log("Camera permission: prompt");
        } else {
          setCameraPermissionStatus(false);

          console.log("Camera permission: denied");
        }

        // Check microphone permission
        const microphonePermissionResult = await navigator.permissions.query({
          name: "microphone",
        });
        if (microphonePermissionResult.state === "granted") {
          console.log("Microphone permission: granted");
        } else if (microphonePermissionResult.state === "prompt") {
          console.log("Microphone permission: prompt");
        } else {
          setMicPermissionStatus(false);
          console.log("Microphone permission: denied");
        }
      } catch (error) {
        console.error("Error checking permissions:", error);
      }
    };

    checkPermissions();
  }, []);

  // Home maintenance functions starts here -----------

  const [myRooms, setMyRooms] = useState([]);
  const [itemListCount, setItemListCount] = useState(0);
  const [homeId, setHomeId] = useState("");
  const [areaId, setAreaId] = useState("");
  const [toggleAddRooms, setToggleAddRooms] = useState(false);
  const [toggleAddItems, setToggleAddItems] = useState(false);
  const [toggleForInventoryModal, setToggleForInventoryModal] = useState(1);
  const [roomTypeName, setRoomTypeName] = useState("");
  const [isRoomTypeNameErr, setIsRoomTypeNameErr] = useState(false);
  const [roomsLoading, setRoomsLoading] = useState(false);

  const [refAreaListNewDesign, setRefAreaListNewDesign] = useState([]);
  const [refAreaId, setRefAreaId] = useState("");


  const [homeAreaProductId, setHomeAreaProductId] = useState("");
  const [maintenancePlanId, setMaintenancePlanId] = useState("");
  const [instruction, setInstruction] = useState("");
  const [isInstructionErr, setIsInstructionErr] = useState(false);
  const [frequency, setFrequency] = useState("");
  const [isFrequencyErr, setIsFrequencyErr] = useState(false);
  const [period, setPeriod] = useState("");
  const [isPeriodErr, setIsPeriodErr] = useState(false);
  const [purchaseLinkHome, setPurchaseLinkHome] = useState("");
  const [maintenancePlanLoading, setMaintenancePlanLoading] = useState(false);

  const frequencyArr = [1, 2, 3, 4, 5]

  const [particularHomeAreaObj, setParticularHomeAreaObj] = useState({});

  const [periodListArr, setPeriodListArr] = useState([]);

  const [isExpandedItem, setIsExpandedItem] = useState(``);
  const [isExpandedForProduct, setIsExpandedForProduct] = useState("");
  const [isExpandedForMaintenancePlan, setIsExpandedForMaintenancePlan] = useState("");
  const [isExpandedForAddMaintenance, setIsExpandedForAddMaintenance] = useState("");

  const [isExpandedForAddRoom, setIsExpandedForAddRoom] = useState("");
  const [isEditForRoomName, setIsEditForRoomName] = useState('');

  const [productTypeArr, setProductTypeArr] = useState([]);
  const [conditionListArr, setConditionListArr] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [categoryName, setCategoryName] = useState("Inspection");
  const [isCategoryIdErr, setIsCategoryIdErr] = useState(false);
  const [inventoryType, setInventoryType] = useState("");
  const [isInventoryTypeErr, setIsInventoryTypeErr] = useState(false);
  const [inventoryTypeId, setInventoryTypeId] = useState("");
  const [inventoryBrand, setInventoryBrand] = useState("");
  const [inventoryModel, setInventoryModel] = useState("");
  const [inventorySerialNumber, setInventorySerialNumber] = useState("");
  const [inventoryCondition, setInventoryCondition] = useState("Not assessed");
  const [inventoryDesc, setInventoryDesc] = useState("");
  const [inventoryImage, setInventoryImage] = useState(null);
  const [attachedImage0, setAttachedImage0] = useState(null);
  const [uploadAttachedImage0, setUploadAttachedImage0] = useState(null);
  const [inventoryLoading, setInventoryLoading] = useState(false);

  const [toggleInspectionTab, setToggleInspectionTab] = useState(1);

  const [toggleCheckUpResultAndMaintenancePlan, setToggleCheckUpResultAndMaintenancePlan] = useState(1);

  const [toggleForDefineRoomList, setToggleForDefineRoomList] = useState(1);


  const [userHomeAreaFlag, setUserHomeAreaFlag] = useState(1);
  const [defineRoomsLoading, setDefineRoomsLoading] = useState(false);

  useEffect(() => {
    if (toggleInspectionTab === 2 && toggleForDefineRoomList === 1) {
      setUserHomeAreaFlag(0)
    } else {
      setUserHomeAreaFlag(1)
    }
  }, [toggleForDefineRoomList, toggleInspectionTab])

  // console.log("particularHomeAreaObj", particularHomeAreaObj);

  // Attachment Upload 1
  const attachedImage0Ref = useRef();

  const handleClickAttachedImage0 = () => {
    attachedImage0Ref.current.click();
  }
  function handleAttachedImage0(e) {
    if (e.target.files) {
      setUploadAttachedImage0(e.target.files[0]);
      setAttachedImage0(URL.createObjectURL(e.target.files[0]))
    }
  }

  function deleteAttachedImage0() {
    setUploadAttachedImage0(null);
    setAttachedImage0(null)
  }

  useEffect(() => {
    localStorage.setItem("inspection_cust_id", callDetailsObj?.ticket_detail?.created_by_chr);
  }, [callDetailsObj])

  const getHomeAreaListonContinue = () => {
    setDefineRoomsLoading(true);
    let details = {
      user_id_ids: callDetailsObj?.ticket_detail?.created_by_chr || localStorage.getItem("inspection_cust_id"),
      user_home_area_list_flag: 1,
    };
    dispatch(getHomeAreaListApi(details, (res) => {
      setDefineRoomsLoading(false);
      setRoomsLoading(false)
      // console.log(res.data);
      setHomeId(res?.user_home?.home_id_ids);
      // setHomeAreaListArr(res.data);
      setRefAreaListNewDesign(res?.ref_area_list_new_design);
      res?.user_home_area_list?.length > 0 && setMyRooms(res?.user_home_area_list)
      setConditionListArr(res?.condition_list)
      setPeriodListArr(res?.period_list)
      setItemListCount(res?.item_list_count)

      setIsEditForRoomName('')

      setToggleForDefineRoomList(2)
      handleClearRoomStates();

      // handleCloseRoomModal();

      // setHomeAreaIdListArr(simplifiedArray(res.data));
    }, (err) => {
      setDefineRoomsLoading(false);
      // console.log(err)
    }))
  }


  const getHomeAreaListFn = () => {

    let details = {
      user_id_ids: callDetailsObj?.ticket_detail?.created_by_chr || localStorage.getItem("inspection_cust_id"),
      user_home_area_list_flag: userHomeAreaFlag,
    };
    dispatch(getHomeAreaListApi(details, (res) => {
      // console.log(res.data);
      setRoomsLoading(false);

      setItemListCount(res?.item_list_count)
      setHomeId(res?.user_home?.home_id_ids);
      // setHomeAreaListArr(res.data);
      res?.user_home_area_list?.length > 0 && setMyRooms(res?.user_home_area_list)
      setConditionListArr(res?.condition_list)
      setPeriodListArr(res?.period_list)
      // setCheckUpCounter(res?.is_checking_item_list_count)
      // setHomeAreaIdListArr(simplifiedArray(res.data));

      setRefAreaListNewDesign(res?.ref_area_list_new_design);

      setIsEditForRoomName('');

      if (Object.keys(particularHomeAreaObj).length > 0) {
        const data = res?.user_home_area_list?.filter((item) => item?.area_id_ids === particularHomeAreaObj?.area_id_ids);
        // console.log("data of area inside if condition", data);
        setParticularHomeAreaObj(data[0]);
      }
    }, (err) => {
      // console.log(err)
      setRoomsLoading(false);
    }))
  }

  useEffect(() => {
    if (Object.keys(particularHomeAreaObj).length > 0) {
      const data = myRooms?.filter((item) => item?.area_id_ids === particularHomeAreaObj?.area_id_ids);
      // console.log("data of area inside if condition", data);
      setParticularHomeAreaObj(data[0]);
    }
  }, [myRooms, particularHomeAreaObj])


  const handleChangeRoomName = (e) => {
    setRoomTypeName(e.target.value);
    setIsRoomTypeNameErr(false);
  };

  const handleBlurCheckRoomName = (e) => {
    if (roomTypeName === "") {
      setIsRoomTypeNameErr(true);
    }
  };

  const handleSubmitRoomOperations = (newRoomName = '', parentAreaId = '') => {
    if (roomTypeName || newRoomName) {
      setRoomsLoading(true)

      let data = new FormData();
      data.append("area_id_ids", areaId);
      data.append("home_id_ids", homeId);
      data.append("home_area_name_chr", roomTypeName || newRoomName);
      data.append("parent_area_id_lng", parentAreaId || refAreaId);

      dispatch(
        addNewHomeAreaApi(data, (res) => {
          // setRoomsLoading(false)
          setResponceMsg(res.data.message)
          setToasterType("success")
          // setToggleForPurchase(1);

          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue.track.send("checkup_list");

          getHomeAreaListFn();
          // handleCloseRoomModal();
          handleClearRoomStates();
          setToggleAddRooms(false);

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);

        }, (err) => {
          setRoomsLoading(false)
          setResponceMsg(err.data.message)
          setToasterType("error")

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        })
      )
    } else {
      setIsRoomTypeNameErr(true);
    }
  }

  const handleAddRoom = (element) => {
    if (roomTypeName || isEditForRoomName) {
      handleSubmitRoomOperations()
    } else {
      handleSubmitRoomOperations(`${element?.ref_display_area_name_chr} #${element?.home_area_count + 1}`, element?.ref_area_id_ids);
    }
  }

  const handleDeleteNewHomeAreaFn = (element) => {
    setRoomsLoading(true)
    let details = {
      home_id_ids: homeId,
      area_id_ids: element?.area_id_ids,
    };
    dispatch(
      deleteNewHomeAreaApi(details, (res) => {
        setResponceMsg(res.data.message);
        setToasterType("success")

        getHomeAreaListFn();

        const [localValue] = [...room.localParticipant.dataTracks.values()];

        localValue.track.send("checkup_list");

        // setHandleToaster(true);
        // setTimeout(() => {
        //     setHandleToaster(false);
        // }, 11000);
      }, (res) => {
        setResponceMsg(res.data.message);
        setToasterType("error");
        setRoomsLoading(false);

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }
      )
    )
  }

  const handleClearRoomStates = () => {
    setRoomTypeName("");
    setIsRoomTypeNameErr(false);
    setAreaId('');
  }

  useEffect(() => {
    handleClearRoomStates();
  }, [toggleAddRooms])

  function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);

    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    let hour = date.getHours();
    const minute = date.getMinutes();

    const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    const amPm = hour < 12 ? "am" : "pm";
    const minuteFormatted = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
  }

  const clearMaintenancePlanStates = () => {
    setInstruction("");
    setFrequency("");
    setPeriod("");
    setPurchaseLinkHome("");
    setIsInstructionErr(false);
    setIsFrequencyErr(false);
    setIsPeriodErr(false);
  }

  const handleChangeInstruction = (e) => {
    setInstruction(e.target.value);
    setIsInstructionErr(false);
  }

  const handleBlurCheckInstrction = () => {
    if (instruction === "") {
      setIsInstructionErr(true);
    }
  }

  const handleChangeFreq = (e) => {
    setFrequency(e.target.value);
    setIsFrequencyErr(false);
  }

  const handleChangePeriod = (e) => {
    setPeriod(e.target.value);
    setIsPeriodErr(false);
  }

  const handleChangePurchaseLink = (e) => {
    setPurchaseLinkHome(e.target.value);
  }

  const addUpdateMaintenancePlanFn = () => {
    if (instruction === "") {
      setIsInstructionErr(true);
    }
    if (frequency === "") {
      setIsFrequencyErr(true);
    }
    if (period === "") {
      setIsPeriodErr(true);
    }

    if (instruction !== "" && frequency !== "" && period !== "") {
      // console.log("addUpdateMaintenancePlanFn")
      // console.log("instruction", instruction)
      // console.log("frequency", frequency)
      // console.log("period", period)
      // console.log("purchase link", purchaseLink)

      setMaintenancePlanLoading(true);

      let data = new FormData();
      data.append("maintenance_plan_id_ids", maintenancePlanId);
      data.append("home_area_product_id_ids", homeAreaProductId);
      data.append("instruction_chr", instruction);
      data.append("frequency_int", frequency);
      data.append("period_int", period);
      data.append("purchase_link", purchaseLinkHome);

      dispatch(
        addUpdateMaintenancePlanApi(data, (res) => {
          setMaintenancePlanLoading(false)
          setResponceMsg(res.data.message)
          setToasterType("success")

          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue.track.send("checkup_list");

          if (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
            var inspectionObj = {
              type: 'inspection',
              message: `${res?.data?.data?.product_name_chr} is beign checking now`,
              productDetails: res?.data?.data,
            }

            const [localValue] = [...room.localParticipant.dataTracks.values()];

            localValue.track.send(JSON.stringify(inspectionObj));
          }

          clearMaintenancePlanStates();
          setIsExpandedForAddMaintenance('');

          getHomeAreaListFn();

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

        }, (err) => {
          setMaintenancePlanLoading(false)
          setResponceMsg(err.data.message)
          setToasterType("error")

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        })
      )

    }
  }

  const handleChangeInventoryType = (e) => {
    setInventoryType(e.target.value);
    setIsInventoryTypeErr(false);
    // console.log(e.target.value, "-----------hewrewr")
  };

  useEffect(() => {
    if (inventoryType !== "") {
      productTypeArr.map((item) => {
        if (item.product_type_name_chr === inventoryType) {
          // console.log(item.product_type_id_ids, 'item.product_type_id_ids')
          // console.log(item.product_type_name_chr, 'item.product_type_name_chr')
          // console.log(item.category_id_lng, 'item.category_id_lng')
          setInventoryTypeId(item.product_type_id_ids);
          setCategoryId(item.category_id_lng);
        }
      })
    }
  }, [inventoryType, toggleForInventoryModal]);

  const handleChangeInventoryBrand = (e) => {
    setInventoryBrand(e.target.value);
  };

  const handleChangeInventoryModel = (e) => {
    setInventoryModel(e.target.value);
  };

  const handleChangeInventorySerialNumber = (e) => {
    setInventorySerialNumber(e.target.value);

  };

  const handleChangeInventoryCondition = (e) => {
    setInventoryCondition(e.target.value);
  };

  // console.log(inventoryCondition, "inventoryCondition")

  const handleChangeInventoryDesc = (e) => {
    setInventoryDesc(e.target.value);
  };

  const handleClearInventoryStates = () => {
    setCategoryId("");
    setCategoryName("Inspection");
    setInventoryType("");
    setIsCategoryIdErr(false);
    setIsInventoryTypeErr(false);
    setInventoryBrand("");
    setInventoryModel("");
    setInventorySerialNumber("");
    setInventoryCondition("Not assessed");
    setInventoryDesc("");
    setInventoryImage(null);
    deleteAttachedImage0();

    setProductTypeArr([]);
  }


  const getAllProductTypeListFn = () => {
    let detail = {
      area_id_ids: areaId,
    }
    dispatch(
      getAllProductTypeListApi(
        detail,
        (res) => {
          // console.log(res.data.data)
          setProductTypeArr(res.data.data)
        },
        (err) => {

        }
      )
    );
  }

  useEffect(() => {
    if (toggleAddItems) {
      getAllProductTypeListFn();
    } else {
      handleClearInventoryStates();
      setToggleForInventoryModal(1);
    }
  }, [toggleAddItems]);

  // const [localValue] = [...room.localParticipant.dataTracks.values()];
  // console.log(localValue, "local track values")

  const addUpdateinventoryItemFn = () => {
    if (inventoryType === "") {
      setIsInventoryTypeErr(true)
    } else {
      setInventoryLoading(true)

      const data = new FormData();
      data.append("home_area_product_id_ids", homeAreaProductId)
      data.append("product_id_ids", inventoryTypeId);
      data.append("product_name_chr", inventoryType);
      data.append("category_id_ids", (categoryId !== "null" && categoryId !== null) ? categoryId : 0);
      data.append("home_id_ids", homeId);
      data.append("area_id_ids", areaId);
      data.append("model_number_chr", inventoryModel || ``);
      data.append("serial_number_chr", inventorySerialNumber || ``);
      data.append("device_brand_chr", inventoryBrand || ``);
      data.append("description_chr", inventoryDesc || ``);
      data.append("condition_chr", inventoryCondition || ``);
      uploadAttachedImage0 != null && data.append("attachment0", uploadAttachedImage0);
      uploadAttachedImage0 != null && data.append("attachment_id_ids0", "");

      dispatch(
        addUpdateInventoryItemApi(data, (res) => {
          setInventoryLoading(false)
          setResponceMsg(res.data.message)
          setToasterType("success")

          // handleCloseInventoryModal();
          setToggleAddItems(false);
          handleClearInventoryStates();

          getHomeAreaListFn();

          handleCloseMobileMoreActionsDrawer();

          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue.track.send("checkup_list");

          if (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
            var inspectionObj = {
              type: 'inspection',
              message: `${res?.data?.data?.product_name_chr} is beign checking now`,
              productDetails: res?.data?.data,
            }

            const [localValue] = [...room.localParticipant.dataTracks.values()];

            localValue.track.send(JSON.stringify(inspectionObj));
          }

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }, (err) => {
          setInventoryLoading(false)
          setResponceMsg(err.data.message)
          setToasterType("error")

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        })
      );
    }
    // handleCloseInventoryModal();
  }

  // Edit and delete of inventory item
  const popoverInventoryActions = (index) => (
    <Popover
      // id="popover-basic"
      id={`popover-basic-${index}`}
      //   className="custom-popover"
      style={{ minWidth: "100px", border: 'none' }}
      onClick={e => e.stopPropagation()}
    >
      <Popover.Body
        className="p-2 popover-body"
        style={{
          //   padding: "5px",
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
          pointerEvents: startStopCheckLoading ? "none" : "auto",
          opacity: startStopCheckLoading ? 0.5 : 1,
        }}
      >
        <div className="d-flex flex-column font-w500 fs-6" style={{}}>
          {/* {permissionArray?.includes("CONTROL REMOTE SCREEN ACTIONS") &&
            <div
              onClick={(e) => {
                // editExpertise(e, expertiseObject);
                e.stopPropagation();
                // setActivePopover(null);
                const value = individualProductObj?.is_checking_ysn ? 0 : 1;
                startStopCheckingItemFn(value);
              }}
              className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
            >
              <span className='me-2'>
                {!startStopCheckLoading ?
                  <i className="bi bi-tools"></i> :
                  <Spinner animation="border" size="sm" variant="primary" />
                }
              </span>
              <span>
                {individualProductObj?.is_checking_ysn ? `Stop checking` : `Start checking`}
              </span>
            </div>
          } */}

          <div
            onClick={(e) => {
              // editExpertise(e, expertiseObject);
              e.stopPropagation();
              updateInventoryItemFn();
              setActivePopover(null);
            }}
            className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
          >
            <span className='me-2'>
              <i className="bi bi-pencil"></i>
            </span>
            <span>Edit</span>
          </div>

          <div
            onClick={(e) => {
              e.stopPropagation();
              // handleOpenInventoryModal(3);
              setInventoryType(individualProductObj?.product_name_chr);
              setHomeAreaProductId(individualProductObj?.home_area_product_id_ids);
              setActivePopover(null);
              setToggleAddItems(true);
              setToggleForInventoryModal(3);
            }}
            className=' cursor-pointer p-2 text-danger overlay-action-btn'
          >
            <span className='me-2'>
              <i className="bi bi-trash"></i>
            </span>
            <span>Delete</span>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );

  const [activePopover, setActivePopover] = useState(null);
  const [individualProductObj, setIndividualProductObj] = useState({});

  // console.log("individualProductObj->", individualProductObj)

  const handleMenuClick = (element, ind) => {
    setIndividualProductObj(element)
    setActivePopover(activePopover === ind ? null : ind)
  }

  const updateInventoryItemFn = () => {
    setHomeAreaProductId(individualProductObj?.home_area_product_id_ids);
    setInventoryTypeId(individualProductObj?.product_id_lng);
    setInventoryType(individualProductObj?.product_name_chr);
    setCategoryId(0);
    setCategoryName(individualProductObj?.category_name_chr);
    // setHomeId(individualProductObj?.home_id_ids);
    setAreaId(individualProductObj?.home_area_id_lng);
    setInventoryModel(individualProductObj?.model_number_chr);
    setInventorySerialNumber(individualProductObj?.serial_number_chr);
    setInventoryBrand(individualProductObj?.device_brand_chr);
    setInventoryDesc(individualProductObj?.description_chr);
    setInventoryCondition(individualProductObj?.condition_chr);
    setInventoryImage(individualProductObj?.image_url);
    deleteAttachedImage0();

    // handleOpenInventoryModal(2);
    setToggleAddItems(true);
    setToggleForInventoryModal(2);
  }

  const deleteInventoryItemFn = () => {
    setInventoryLoading(true);
    let details = {
      home_area_product_id_ids: homeAreaProductId,
    };
    dispatch(
      deleteInventoryItemApi(details, (res) => {
        setResponceMsg(res.data.message);
        setToasterType("success")
        setInventoryLoading(false);

        getHomeAreaListFn();
        setHomeAreaProductId("");

        handleCloseMobileMoreActionsDrawer();

        const [localValue] = [...room.localParticipant.dataTracks.values()];

        localValue.track.send("checkup_list");

        // handleCloseInventoryModal();
        setToggleAddItems(false);
        handleClearInventoryStates();

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }, (res) => {
        setResponceMsg(res.data.message);
        setToasterType("error");
        setInventoryLoading(false);

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }
      )
    )
  }

  const [startStopCheckLoading, setStartStopCheckLoading] = useState(false);
  const startStopCheckingItemFn = (value) => {
    setStartStopCheckLoading(true);
    const data = new FormData();
    data.append("home_area_product_id_ids", individualProductObj?.home_area_product_id_ids);
    data.append("start_stop_checking_flag", value);

    dispatch(
      startStopCheckingItemApi(
        data,
        (res) => {
          setStartStopCheckLoading(false)
          // console.log(res.message)
          setResponceMsg(res.message)
          setToasterType("success")

          getHomeAreaListFn();

          setActivePopover(null);

          const [localValue] = [...room.localParticipant.dataTracks.values()];

          localValue.track.send("checkup_list");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }, (err) => {
          setStartStopCheckLoading(false)
          setResponceMsg(err.data.message)
          setToasterType("error")

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }))
  }

  // Check-up results functions starts here -----------
  const [checkUpTabsToggle, setCheckUpTabsToggle] = useState(4);
  const [pageCheckUp, setPageCheckUp] = React.useState(1);
  const [sortByValueCheckUp, setSortByValueCheckUp] = useState("DESC");
  const [searchValueCheckUp, setSearchValueCheckUp] = useState("");
  const [columnNameCheckUp, setColumnNameCheckUp] = useState("");

  const [checkupResultsArr, setCheckupResultsArr] = useState([]);
  const [checkupResultCompleteObj, setCheckupResultCompleteObj] = useState({});

  const [maintenanceObj, setMaintenanceObj] = useState({});

  const [isExpandedForProductCheckUp, setIsExpandedForProductCheckUp] = useState("");

  const [filtreBoxCheckUp, setFiltreBoxCheckUp] = useState(false);
  const [filtreValueCheckUp, SetFiltreValueCheckUp] = useState(1);
  const [flagCheckUp, setFlagCheckUp] = useState(false);

  const handleCheckUpTabs = (val) => {
    setCheckUpTabsToggle(val)
  }

  const getCheckupReportFn = () => {
    let data = new FormData();
    data.append("user_id_ids", callDetailsObj?.ticket_detail?.created_by_chr || localStorage.getItem("inspection_cust_id"));
    data.append("condition_int", checkUpTabsToggle);
    data.append("pagination_flag", 0);
    // data.append("page_index", pageCheckUp);
    // data.append("page_size", pageSize);
    data.append("sorting_order", sortByValueCheckUp);
    data.append("sorting_column_name", columnNameCheckUp);
    data.append("search_area", searchValueCheckUp);


    dispatch(
      getCheckupReportApi(data, (res) => {
        setCheckupResultCompleteObj(res)
        setCheckupResultsArr(res?.data)
      }, (err) => { })
    );
  };

  const getHomeMaintenancePlansFnCheckUp = () => {
    let data = new FormData();
    data.append("user_id_ids", callDetailsObj?.ticket_detail?.created_by_chr || localStorage.getItem("inspection_cust_id"));
    data.append("pagination_flag", 0);
    // data.append("condition_int", checkUpTabsToggle);
    // data.append("page_index", pageCheckUp);
    // data.append("page_size", pageSize);
    // data.append("sorting_order", sortByValueCheckUp);
    // data.append("sorting_column_name", columnNameCheckUp);
    // data.append("search_area", searchValueCheckUp);
    dispatch(
      getHomeMaintenancePlansApi(data, (res) => {
        setMaintenanceObj(res)
      }, (err) => { })
    );
  };

  useEffect(() => {
    if (toggleInspectionTab === 3 && toggleCheckUpResultAndMaintenancePlan === 1) {
      getCheckupReportFn();
    }
  }, [checkUpTabsToggle, filtreValueCheckUp, toggleInspectionTab, toggleCheckUpResultAndMaintenancePlan]);

  useEffect(() => {
    if (toggleInspectionTab === 3 && toggleCheckUpResultAndMaintenancePlan === 1) {
      getHomeMaintenancePlansFnCheckUp();
    }
  }, [toggleInspectionTab, toggleCheckUpResultAndMaintenancePlan]);



  function handleOpenFiltreBoxCheckUp() {
    setFiltreBoxCheckUp(!filtreBoxCheckUp);
  }

  function handleSetFiltreValueCheckUp(v) {
    SetFiltreValueCheckUp(v);
    const ele = [];
    if (v === 1) {
      setSortByValueCheckUp("DESC");
    } else if (v === 2) {
      setSortByValueCheckUp("ASC");
    }
  }

  const handleSearchCheckUp = (e) => {
    // setPageCheckUp(1)
    setPageCheckUp(1);
    if (searchValueCheckUp.trim().length >= 2) {
      setColumnNameCheckUp("");
    }
    setSearchValueCheckUp(e.target.value);
  };

  useEffect(() => {
    if (searchValueCheckUp.trim().length > 2) {
      setFlagCheckUp(true);
      const timeOutId = setTimeout(getCheckupReportFn, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValueCheckUp.trim().length === 0 || searchValueCheckUp.trim() == "") {
      if (flagCheckUp) {

        getCheckupReportFn();
      }
    }
  }, [searchValueCheckUp]);

  // Check-up results functions ends here -----------


  // Maintenance task functions starts here -----------
  const [maintenanceTabsToggle, setMaintenanceTabsToggle] = useState(4);
  const [pageMaintenanceTask, setPageMaintenanceTask] = React.useState(1);
  const [sortByValueMaintenanceTask, setSortByValueMaintenanceTask] = useState("DESC");
  const [searchValueMaintenanceTask, setSearchValueMaintenanceTask] = useState("");
  const [columnNameMaintenanceTask, setColumnNameMaintenanceTask] = useState("");
  const [maintenanceObjMaintenanceTask, setMaintenanceObjMaintenanceTask] = useState({});
  const [maintenancePlansArr, setMaintenancePlansArr] = useState([]);
  const [isExpandedForMaintenancePlanMaintenanceTask, setIsExpandedForMaintenancePlanMaintenanceTask] = useState("");

  const [filtreBoxMaintenanceTask, setFiltreBoxMaintenanceTask] = useState(false);
  const [filtreValueMaintenanceTask, setFiltreValueMaintenanceTask] = useState(1);
  const [flagMaintenanceTask, setFlagMaintenanceTask] = useState(false);

  const handleMaintenanceTaskTabs = (val) => {
    setMaintenanceTabsToggle(val)
  }

  function handleOpenFiltreBoxMaintenanceTask() {
    setFiltreBoxMaintenanceTask(!filtreBoxMaintenanceTask);
  }

  function handleSetFiltreValueMaintenanceTask(v) {
    setFiltreValueMaintenanceTask(v);
    const ele = [];
    if (v === 1) {
      setSortByValueMaintenanceTask("DESC");
    } else if (v === 2) {
      setSortByValueMaintenanceTask("ASC");
    }
  }

  const handleSearchMaintenanceTask = (e) => {
    // setPageMaintenanceTask(1)
    setPageMaintenanceTask(1);
    if (searchValueMaintenanceTask.trim().length >= 2) {
      setColumnNameMaintenanceTask("");
    }
    setSearchValueMaintenanceTask(e.target.value);
  };

  useEffect(() => {
    if (searchValueMaintenanceTask.trim().length > 2) {
      setFlagMaintenanceTask(true);
      const timeOutId = setTimeout(getHomeMaintenancePlansFn, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValueMaintenanceTask.trim().length === 0 || searchValueMaintenanceTask.trim() == "") {
      if (flagMaintenanceTask) {
        getHomeMaintenancePlansFn();
      }
    }
  }, [searchValueMaintenanceTask]);

  const [allHomeMaintenancePlanCount, setAllHomeMaintenancePlanCount] = useState(0);
  const [secondCount, setSecondCount] = useState(0);
  const [thirdCount, setThirdCount] = useState(0);
  const [fourthCount, setFourthCount] = useState(0);

  const getHomeMaintenancePlansFn = () => {
    let data = new FormData();
    data.append("user_id_ids", callDetailsObj?.ticket_detail?.created_by_chr || localStorage.getItem("inspection_cust_id"));
    maintenanceTabsToggle != 4 && data.append("no_of_days_flag", maintenanceTabsToggle);
    data.append("pagination_flag", 0);
    // data.append("page_index", pageMaintenanceTask);
    // data.append("page_size", pageSize);
    data.append("sorting_order", sortByValueMaintenanceTask);
    data.append("sorting_column_name", columnNameMaintenanceTask);
    data.append("search_area", searchValueMaintenanceTask);

    dispatch(
      getHomeMaintenancePlansApi(data, (res) => {
        setMaintenanceObjMaintenanceTask(res);
        setMaintenancePlansArr(res?.data);
        setPeriodListArrMaintenanceTask(res?.period_list);
        res?.all_home_maintenance_plan_count && setAllHomeMaintenancePlanCount(res?.all_home_maintenance_plan_count);
        res?.home_maintenance_plan_in_30_days_count && setSecondCount(res?.home_maintenance_plan_in_30_days_count);
        res?.home_maintenance_plan_in_60_days_count && setThirdCount(res?.home_maintenance_plan_in_60_days_count);
        res?.home_maintenance_plan_in_90_days_count && setFourthCount(res?.home_maintenance_plan_in_90_days_count);
      }, (err) => { })
    );
  };

  useEffect(() => {
    if (toggleInspectionTab === 3 && toggleCheckUpResultAndMaintenancePlan === 2) {
      getHomeMaintenancePlansFn();
    }
  }, [maintenanceTabsToggle, filtreValueMaintenanceTask, toggleInspectionTab, toggleCheckUpResultAndMaintenancePlan]);

  const [maintenanceModalTriggerMaintenanceTask, setMaintenanceModalTriggerMaintenanceTask] = useState(false);
  const [toggleForMaintenancePlan, setToggleForMaintenancePlan] = useState(1);

  const [periodListArrMaintenanceTask, setPeriodListArrMaintenanceTask] = useState([]);

  const [homeAreaProductIdMaintenanceTask, setHomeAreaProductIdMaintenanceTask] = useState("");
  const [maintenancePlanIdMaintenanceTask, setMaintenancePlanIdMaintenanceTask] = useState("");
  const [instructionMaintenanceTask, setInstructionMaintenanceTask] = useState("");
  const [isInstructionErrMaintenanceTask, setIsInstructionErrMaintenanceTask] = useState(false);
  const [frequencyMaintenanceTask, setFrequencyMaintenanceTask] = useState("");
  const [isFrequencyErrMaintenanceTask, setIsFrequencyErrMaintenanceTask] = useState(false);
  const [periodMaintenanceTask, setPeriodMaintenanceTask] = useState("");
  const [isPeriodErrMaintenanceTask, setIsPeriodErrMaintenanceTask] = useState(false);
  const [purchaseLinkMaintenanceTask, setPurchaseLinkMaintenanceTask] = useState("");
  const [maintenancePlanLoadingMaintenanceTask, setMaintenancePlanLoadingMaintenanceTask] = useState(false);

  const handleOpenMaintenancePlanModalMaintenanceTask = (val = 1) => {
    setMaintenanceModalTriggerMaintenanceTask(true);

    setToggleForMaintenancePlan(val);
  }

  const handleCloseMaintenancePlanModalMaintenanceTask = () => {
    setMaintenanceModalTriggerMaintenanceTask(false);

    clearMaintenancePlanStatesMaintenanceTask();
  }

  const updateMaitenancePlanFnMaintenanceTask = (data) => {
    setHomeAreaProductIdMaintenanceTask(data?.home_area_product_id_lng);
    setMaintenancePlanIdMaintenanceTask(data?.maintenance_plan_id_ids);
    setInstructionMaintenanceTask(data?.instruction_chr);
    setFrequencyMaintenanceTask(data?.frequency_int);
    setPeriodMaintenanceTask(data?.period_int);
    setPurchaseLinkMaintenanceTask(data?.purchase_link);

    handleOpenMaintenancePlanModalMaintenanceTask(1);
  }

  const deletemaintenancePlanFnMaintenanceTask = (data) => {

    setMaintenancePlanLoadingMaintenanceTask(true);
    let details = {
      maintenance_plan_id_ids: maintenancePlanIdMaintenanceTask,
    };
    dispatch(
      deleteMaintenancePlanApi(details, (res) => {
        setResponceMsg(res.data.message);
        setToasterType("success")
        setMaintenancePlanLoadingMaintenanceTask(false);

        getHomeMaintenancePlansFn();
        handleCloseMaintenancePlanModalMaintenanceTask();

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }, (res) => {
        setResponceMsg(res.data.message);
        setToasterType("error");
        setMaintenancePlanLoadingMaintenanceTask(false);

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }
      )
    )
  }

  const clearMaintenancePlanStatesMaintenanceTask = () => {
    setHomeAreaProductIdMaintenanceTask("");
    setMaintenancePlanIdMaintenanceTask("");
    setInstructionMaintenanceTask("");
    setFrequencyMaintenanceTask("");
    setPeriodMaintenanceTask("");
    setPurchaseLinkMaintenanceTask("");
    setIsInstructionErrMaintenanceTask(false);
    setIsFrequencyErrMaintenanceTask(false);
    setIsPeriodErrMaintenanceTask(false);
  }

  const handleChangeInstructionMaintenanceTask = (e) => {
    setInstructionMaintenanceTask(e.target.value);
    setIsInstructionErrMaintenanceTask(false);
  }

  const handleBlurCheckInstrctionMaintenanceTask = () => {
    if (instructionMaintenanceTask === "") {
      setIsInstructionErrMaintenanceTask(true);
    }
  }

  const handleChangeFreqMaintenanceTask = (e) => {
    setFrequencyMaintenanceTask(e.target.value);
    setIsFrequencyErrMaintenanceTask(false);
  }

  const handleChangePeriodMaintenanceTask = (e) => {
    setPeriodMaintenanceTask(e.target.value);
    setIsPeriodErrMaintenanceTask(false);
  }

  const handleChangePurchaseLinkMaintenanceTask = (e) => {
    setPurchaseLinkMaintenanceTask(e.target.value);
  }

  const addUpdateMaintenancePlanFnMaintenanceTask = () => {
    if (instructionMaintenanceTask === "") {
      setIsInstructionErrMaintenanceTask(true);
    }
    if (frequencyMaintenanceTask === "") {
      setIsFrequencyErrMaintenanceTask(true);
    }
    if (periodMaintenanceTask === "") {
      setIsPeriodErrMaintenanceTask(true);
    }

    if (instructionMaintenanceTask !== "" && frequencyMaintenanceTask !== "" && periodMaintenanceTask !== "") {
      // console.log("addUpdateMaintenancePlanFnMaintenanceTask")
      // console.log("instructionMaintenanceTask", instructionMaintenanceTask)
      // console.log("frequencyMaintenanceTask", frequencyMaintenanceTask)
      // console.log("periodMaintenanceTask", periodMaintenanceTask)
      // console.log("purchase link", purchaseLinkMaintenanceTask)

      setMaintenancePlanLoadingMaintenanceTask(true);

      let data = new FormData();
      data.append("maintenance_plan_id_ids", maintenancePlanIdMaintenanceTask);
      data.append("home_area_product_id_ids", homeAreaProductIdMaintenanceTask);
      data.append("instruction_chr", instructionMaintenanceTask);
      data.append("frequency_int", frequencyMaintenanceTask);
      data.append("period_int", periodMaintenanceTask);
      data.append("purchase_link", purchaseLinkMaintenanceTask);

      dispatch(
        addUpdateMaintenancePlanApi(data, (res) => {
          setMaintenancePlanLoadingMaintenanceTask(false)
          setResponceMsg(res.data.message)
          setToasterType("success")

          clearMaintenancePlanStatesMaintenanceTask();

          getHomeMaintenancePlansFn();

          handleCloseMaintenancePlanModalMaintenanceTask();

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

        }, (err) => {
          setMaintenancePlanLoadingMaintenanceTask(false)
          setResponceMsg(err.data.message)
          setToasterType("error")

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        })
      )

    }
  }

  // Maintenance task functions ends here -----------

  // Home maintenance functions ends here -----------


  // Marked as purchased shopping item functions
  const handleMarkPurchaseItem = (element, isPurchaseVal = 1) => {
    setPurchaseLoading(true)
    let data = new FormData();
    data.append("user_id_ids", localStorage.getItem('user_id') || "");
    data.append("item_id_ids", element?.item_id_ids);
    data.append("call_log_id_ids", localStorage.getItem('call_log_id'));
    data.append("ticket_id_ids", localStorage.getItem('ticket_id'));
    data.append("item_name_chr", element?.item_name_chr);
    data.append("quantity_int", element?.quantity_int);
    data.append("estimated_price_float", parseFloat(((element?.estimated_price_float)).toFixed(2)));
    data.append("description_chr", element?.description_chr);
    data.append("purchase_link_chr", element?.purchase_link_chr);
    data.append("is_purchased_ysn", isPurchaseVal);

    dispatch(
      updatePurchaseItem(data, (res) => {
        // setPurchaseLoading(false)
        setResponceMsg(res.data.message)
        setToasterType("success")
        // setToggleForPurchase(1);

        handleClosePurchaseList();

        handleCloseCreatePurchaseItem();

        onLoadData();

        const [localValue] = [...room.localParticipant.dataTracks.values()];

        localValue.track.send("shopping_list");

        // setHandleToaster(true);
        // setTimeout(() => {
        //   setHandleToaster(false);
        // }, 11000);
      }, (err) => {
        setPurchaseLoading(false)
        setResponceMsg(err.data.message)
        setToasterType("error")

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      })
    )
  }

  useEffect(() => {
    // console.log(serviceSummaryMetaData, "serviceSummaryMetaData");
    // console.log(serviceSummaryMetaData?.is_estimations_call, "serviceSummaryMetaData?.is_estimations_call");
    localStorage.setItem("is_estimations_call", JSON.stringify((serviceSummaryMetaData?.is_estimations_call) ? 1 : 0));

  }, [serviceSummaryMetaData]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("is_estimations_call");
    }
  }, [])

  // Get service details 
  const getServiceDetailsFn = (isPartsManualsTrigger = false) => {
    let details = {
      ticket_id_ids: localStorage.getItem("ticket_id"),
    };
    dispatch(
      ticketDetailsApi(details, (res) => {
        // console.log(res);

        setServiceDetailsObj(res?.data);

        if (proCheckInfoModalConfirmTrigger) {
          saveCallDurationForEstimationsCall(res?.data?.remaining_time_in_sec);
        }

        console.log("res?.data?.summary_meta_data", res?.data?.summary_meta_data)

        if (res?.data?.summary_meta_data) {

          // debugger;
          // const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
          // const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

          const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

          let finalObject = {};

          // if(!Object.keys(finalObjectTwo).length > 0) {
          if (typeof (finalObjectTwo) === 'string') {
            finalObject = JSON.parse(finalObjectTwo);
          }

          console.log(finalObject, "finalObject");
          console.log(finalObjectTwo, "finalObjectTwo");

          if (Object.keys(finalObject).length > 0) {

            setServiceSummaryMetaData(finalObject);

            setEstimateCost(finalObject?.estimate_costing?.cost || 0);
            setEstimateDisposal(finalObject?.estimate_costing?.disposal_cost || 0);
            setEstimateLabor(finalObject?.estimate_costing?.labor_cost || 0);
            setEstimatedCostByPro(finalObject?.repair_install_costing?.estimated_cost_by_pro || 0);

            setProDiagnosis(finalObject?.pro_check_info?.pro_diagnosis || "");
            setProEstimatedCostMin(finalObject?.pro_check_info?.pro_estimated_cost_min || '');
            setProEstimatedCostMax(finalObject?.pro_check_info?.pro_estimated_cost_max || '');
            setProRecommendedSolution(finalObject?.pro_check_info?.pro_recommended_solution || 0);
          } else if (Object.keys(finalObjectTwo).length > 0) {
            setServiceSummaryMetaData(finalObjectTwo);

            setEstimateCost(finalObjectTwo?.estimate_costing?.cost || 0);
            setEstimateDisposal(finalObjectTwo?.estimate_costing?.disposal_cost || 0);
            setEstimateLabor(finalObjectTwo?.estimate_costing?.labor_cost || 0);
            setEstimatedCostByPro(finalObjectTwo?.repair_install_costing?.estimated_cost_by_pro || 0);

            setProDiagnosis(finalObjectTwo?.pro_check_info?.pro_diagnosis || "");
            setProEstimatedCostMin(finalObjectTwo?.pro_check_info?.pro_estimated_cost_min || '');
            setProEstimatedCostMax(finalObjectTwo?.pro_check_info?.pro_estimated_cost_max || '');
            setProRecommendedSolution(finalObjectTwo?.pro_check_info?.pro_recommended_solution || 0);
          } else {
            setServiceSummaryMetaData({});
          }

        }

        if (isPartsManualsTrigger) {
          handleShowSourcingInfoOnly(res?.data);
        }

      }, () => {
      })
    );
  };

  useEffect(() => {
    getServiceDetailsFn();
  }, [])


  const [switch3DLoading, setSwitch3DLoading] = useState(false);
  function changeDrawingModeFn() {
    setSwitch3DLoading(true);

    const [localValue] = [
      ...room.localParticipant.dataTracks.values(),
    ];

    localValue?.track.send("end-draw");
    handleClearCanvas()
    if (threeDStatus) {
      const [localValue] = [
        ...room.localParticipant.dataTracks.values(),
      ];

      localValue?.track.send("2D");
      setThreeDModeStatus(!threeDStatus)

    } else {
      const [localValue] = [
        ...room.localParticipant.dataTracks.values(),
      ];

      localValue?.track.send("3D");
      setThreeDModeStatus(!threeDStatus)

    }

    setTimeout(() => {
      setSwitch3DLoading(false);
    }, 2000)
  }


  // Sourcing the device info
  const [sourcingInfoModalTrigger, setSourcingInfoModalTrigger] = useState(false);
  const [productType, setProductType] = useState('');
  const [brandName, setBrandName] = useState('');
  const [modelNumber, setModelNumber] = useState('');
  const [specificPart, setSpecificPart] = useState('');
  const [isProductTypeErr, setIsProductTypeErr] = useState(false);
  const [isBrandNameErr, setIsBrandNameErr] = useState(false);
  const [imgForPartsManuals, setImgForPartsManuals] = useState(null);
  const [partsManualsCropModal, setPartsManualsCropModal] = useState(false);

  const [confirmScanInfoModal, setConfirmScanInfoModal] = useState(false);

  const [confirmProductType, setConfirmProductType] = useState('');
  const [confirmBrandName, setConfirmBrandName] = useState('');
  const [confirmModelNumber, setConfirmModelNumber] = useState('');

  const [confirmProductTypeCheck, setConfirmProductTypeCheck] = useState(false);
  const [confirmBrandNameCheck, setConfirmBrandNameCheck] = useState(false);
  const [confirmModelNumberCheck, setConfirmModelNumberCheck] = useState(false);

  const handleClearConfirmedScanInfo = () => {
    setConfirmProductType('');
    setConfirmBrandName('');
    setConfirmModelNumber('');
  }

  const handleOpenConfirmScanInfoModal = () => {
    setConfirmScanInfoModal(true);
  }

  const handleCloseConfirmScanInfoModal = () => {
    setConfirmScanInfoModal(false);
    handleClearConfirmedScanInfo();
  }

  const handleConfirmScanInfo = () => {
    confirmProductType && setProductType(confirmProductType);
    confirmBrandName && setBrandName(confirmBrandName);
    confirmModelNumber && setModelNumber(confirmModelNumber);
    handleCloseConfirmScanInfoModal();
  }

  useEffect(() => {
    if (productType !== "") {
      setIsProductTypeErr(false);
    }
    if (brandName !== "") {
      setIsBrandNameErr(false);
    }

  }, [productType, brandName])

  const handleProductType = (e) => {
    setIsProductTypeErr(false);
    setProductType(e.target.value);
  };

  const handleProductTypeBlurCheck = () => {
    if (productType === "") {
      setIsProductTypeErr(true);
    }
  };

  const handleBrandName = (e) => {
    setIsBrandNameErr(false);
    setBrandName(e.target.value);
  };

  const handleBrandNameBlurCheck = () => {
    if (brandName === "") {
      setIsBrandNameErr(true);
    }
  };

  const handleModelNumber = (e) => {
    setModelNumber(e.target.value);
  };

  const handleSpecificPart = (e) => {
    setSpecificPart(e.target.value);
  };


  useEffect(() => {
    setProductType(serviceDetailsObj?.product_type_chr ? serviceDetailsObj?.product_type_chr : '');
    setBrandName(serviceDetailsObj?.device_brand_chr ? serviceDetailsObj?.device_brand_chr : '');
    setModelNumber(serviceDetailsObj?.model_number_chr ? serviceDetailsObj?.model_number_chr : "")
  }, [serviceDetailsObj])

  const [sourcingInfoLoading, setSourcingInfoLoading] = useState(false);
  const [sourcingManualsArr, setSourcingManualsArr] = useState([]);
  const [sourcingInfoArr, setSourcingInfoArr] = useState([]);
  const [sourcingShoppingArr, setSourcingShoppingArr] = useState([]);
  const [supportsArr, setSupportsArr] = useState([]);
  const [sourcingInfoTabs, setSourcingInfoTabs] = useState(1);
  const [productManualFlag, setProductManualFlag] = useState(1);
  const [scanPartsManualsLoading, setScanPartsManualsLoading] = useState(false);
  const [scanDeviceLoading, setScanDeviceLoading] = useState(false);
  const [scanDeviceFlag, setScanDeviceFlag] = useState(1);
  const [tabsPartsManuals, setTabsPartsManuals] = useState('');
  const handleSearchSourcingInfo = () => {
    if (productType === "") {
      setIsProductTypeErr(true)
    }
    if (brandName === "") {
      setIsBrandNameErr(true)
    }
    if (productType !== "" && brandName !== "") {
      setSourcingInfoLoading(true);

      // setProductManualFlag(val);

      let formData = new FormData();

      formData.append("product_type_chr", productType);
      formData.append("brand_name_chr", brandName);
      formData.append("model_number_chr", modelNumber);
      formData.append("specific_part_chr", specificPart);
      // formData.append("product_manual_flag", productManualFlag);

      dispatch(
        // sourcingInfoFromDeviceModelApi(
        googleSourcingInfoFromDeviceModelApi(
          formData,
          (res) => {
            // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
            setSourcingInfoLoading(false);
            // console.log(res?.data?.data?.manual, "here");
            updateServiceRequestFn();
            // const isArray = Array.isArray(res?.data?.data?.manual);
            // isArray && (
            //   val == 1 ?
            //     setSourcingInfoArr(res?.data?.data?.manual) :
            //     setSourcingInfoArr(res?.data?.data?.parts)
            // )
            setSourcingManualsArr(res?.data?.data?.manual)
            setSourcingInfoArr(res?.data?.data?.parts)
            setSourcingShoppingArr(res?.data?.data?.shopping);
            setSupportsArr(res?.data?.data?.support);

            if (!tabsPartsManuals) {
              setTabsPartsManuals('1')
            }
          },
          (res) => {
            console.log(res);
            setSourcingInfoLoading(false);

            setResponceMsg(res.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);

            if (!tabsPartsManuals) {
              setTabsPartsManuals('1')
            }
          }
        )
      );
    }
  }
  const handleOpenSourcingInfoModal = () => {
    setSourcingInfoModalTrigger(true);
  };

  const handleCloseSourcingInfoModal = () => {
    setSourcingInfoModalTrigger(false);
  };

  // this function is as per feedback given for updating the manuals real-time
  const handleSourcingInfoFn = (val = 1) => {
    // handleOpenSourcingInfoModal();
    // setProductManualFlag(val)
    if (productType === "") {
      setIsProductTypeErr(true)
    }
    if (brandName === "") {
      setIsBrandNameErr(true)
    }
    if (productType !== "" && brandName !== "") {
      setSourcingInfoLoading(true);

      let formData = new FormData();

      formData.append("product_type_chr", productType);
      formData.append("brand_name_chr", brandName);
      formData.append("model_number_chr", modelNumber);
      formData.append("specific_part_chr", specificPart);
      // formData.append("product_manual_flag", val);

      dispatch(
        // sourcingInfoFromDeviceModelApi(
        googleSourcingInfoFromDeviceModelApi(
          formData,
          (res) => {
            // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
            setSourcingInfoLoading(false);
            updateServiceRequestFn();
            // console.log(res?.data?.data?.manual, "here");
            // const isArray = Array.isArray(res?.data?.data?.manual);
            // isArray && (
            //   val == 1 ?
            //     setSourcingInfoArr(res?.data?.data?.manual) :
            //     setSourcingInfoArr(res?.data?.data?.parts)
            // )
            setSourcingManualsArr(res?.data?.data?.manual)
            setSourcingInfoArr(res?.data?.data?.parts)
            setSourcingShoppingArr(res?.data?.data?.shopping);
            setSupportsArr(res?.data?.data?.support);

            if (!tabsPartsManuals) {
              setTabsPartsManuals('1')
            }
          },
          (res) => {
            console.log(res);
            setSourcingInfoLoading(false);

            setResponceMsg(res.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);

            if (!tabsPartsManuals) {
              setTabsPartsManuals('1')
            }
          }
        )
      );
    }

  };


  const handleShowSourcingInfoOnly = (data) => {
    // handleOpenSourcingInfoModal();
    // setProductManualFlag(val)
    // if (productType === "") {
    //   setIsProductTypeErr(true)
    // }
    // if (brandName === "") {
    //   setIsBrandNameErr(true)
    // }
    // if (productType !== "" && brandName !== "") {
    //   setSourcingInfoLoading(true);

    let formData = new FormData();

    (productType || data?.product_type_chr) && formData.append("product_type_chr", productType || data?.product_type_chr);
    (brandName || data?.device_brand_chr) && formData.append("brand_name_chr", brandName || data?.device_brand_chr);
    (modelNumber || data?.model_number_chr) && formData.append("model_number_chr", modelNumber || data?.model_number_chr);
    formData.append("specific_part_chr", specificPart);
    // formData.append("product_manual_flag", val);

    // formData.append("product_type_chr", data?.product_type_chr);
    // formData.append("brand_name_chr", data?.device_brand_chr);
    // formData.append("model_number_chr", data?.model_number_chr);
    // formData.append("specific_part_chr", specificPart);

    dispatch(
      // sourcingInfoFromDeviceModelApi(
      googleSourcingInfoFromDeviceModelApi(
        formData,
        (res) => {
          // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
          setSourcingInfoLoading(false);
          // setIsPartsManualsTrigger(false);
          // updateServiceRequestFn();
          // console.log(res?.data?.data?.manual, "here");
          // const isArray = Array.isArray(res?.data?.data?.manual);
          // isArray && (
          //   val == 1 ?
          //     setSourcingInfoArr(res?.data?.data?.manual) :
          //     setSourcingInfoArr(res?.data?.data?.parts)
          // )
          setSourcingManualsArr(res?.data?.data?.manual);
          setSourcingInfoArr(res?.data?.data?.parts);
          setSourcingShoppingArr(res?.data?.data?.shopping);
          setSupportsArr(res?.data?.data?.support);

          if (!tabsPartsManuals) {
            setTabsPartsManuals('1')
          }
        },
        (res) => {
          console.log(res);
          setSourcingInfoLoading(false);

          setResponceMsg(res.data.message);
          setToasterType("error");

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);

          if (!tabsPartsManuals) {
            setTabsPartsManuals('1')
          }
        }
      )
    );
    // }

  };


  function updateServiceRequestFn() {

    let formData = new FormData();

    formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    formData.append("product_type_chr", productType);
    modelNumber && formData.append("model_number_chr", modelNumber);
    brandName && formData.append("device_brand_chr", brandName);
    formData.append("time_slot_id", 4)
    formData.append("communication_mode_id", 3);
    dispatch(updateTicketDetail(formData, (res) => {

      setResponceMsg(res.data.message);
      setToasterType("success")

      getServiceDetailsFn();

      const [localValue] = [...room.localParticipant.dataTracks.values()];
      localValue.track.send("parts_manual");

      // setHandleToaster(true);
      // setTimeout(() => {
      //     setHandleToaster(false);
      // }, 11000);

    }, (err) => {

      setResponceMsg(err.data.message);
      setToasterType("error")

      // setHandleToaster(true);
      // setTimeout(() => {
      //     setHandleToaster(false);
      // }, 11000);
    }))
  }

  const handleScanDeviceForParts = () => {
    const video = document.getElementById("LP");
    video.pause();

    setPartsManualsCropModal(true);
  }

  const handleScanDevicePartsManuals = (blob) => {
    let formData = new FormData();

    formData.append("image", blob, "screenshot.png");

    if (scanDeviceFlag == 1) {
      setScanDeviceLoading(true);
      dispatch(
        RecogObj(
          formData,
          (res) => {
            // setOcrResultModal(true);
            // console.log(res.data.data);
            res?.data?.data?.predicted_object_name && !confirmProductTypeCheck && setProductType(res?.data?.data?.predicted_object_name);
            res?.data?.data?.predicted_object_brand && !confirmBrandNameCheck && setBrandName(res?.data?.data?.predicted_object_brand);
            res?.data?.data?.predicted_object_model_number && !confirmModelNumberCheck && setModelNumber(res?.data?.data?.predicted_object_model_number);

            // if (productType === '' && brandName === '' && modelNumber === '') {
            //   res?.data?.data?.predicted_object_name && setProductType(res?.data?.data?.predicted_object_name);
            //   res?.data?.data?.predicted_object_brand && setBrandName(res?.data?.data?.predicted_object_brand);
            //   res?.data?.data?.predicted_object_model_number && setModelNumber(res?.data?.data?.predicted_object_model_number);
            // } else {
            //   res?.data?.data?.predicted_object_name && setConfirmProductType(res?.data?.data?.predicted_object_name);
            //   res?.data?.data?.predicted_object_brand && setConfirmBrandName(res?.data?.data?.predicted_object_brand);
            //   res?.data?.data?.predicted_object_model_number && setConfirmModelNumber(res?.data?.data?.predicted_object_model_number);

            //   if (res?.data?.data?.predicted_object_name || res?.data?.data?.predicted_object_brand || res?.data?.data?.predicted_object_model_number) {
            //     handleOpenConfirmScanInfoModal();
            //   }
            // }

            setScanDeviceLoading(false);
          },
          (err) => {
            setScanDeviceLoading(false);
          }
        )
      );
    } else if (scanDeviceFlag == 2) {
      setScanPartsManualsLoading(true);
      dispatch(
        ocr(
          formData,
          (res) => {
            // setOcrResultModal(true);
            // console.log(res.data.data);

            // res?.data?.data?.predicted_object_type && setProductType(res?.data?.data?.predicted_object_type);
            res?.data?.data?.predicted_object_brand && !confirmBrandNameCheck && setBrandName(res?.data?.data?.predicted_object_brand);
            res?.data?.data?.predicted_object_model_number && !confirmModelNumberCheck && setModelNumber(res?.data?.data?.predicted_object_model_number);

            // if (brandName === '' && modelNumber === '') {
            //   res?.data?.data?.predicted_object_brand && setBrandName(res?.data?.data?.predicted_object_brand);
            //   res?.data?.data?.predicted_object_model_number && setModelNumber(res?.data?.data?.predicted_object_model_number);
            // } else {
            //   res?.data?.data?.predicted_object_brand && setConfirmBrandName(res?.data?.data?.predicted_object_brand);
            //   res?.data?.data?.predicted_object_model_number && setConfirmModelNumber(res?.data?.data?.predicted_object_model_number);
            //   if (res?.data?.data?.predicted_object_brand || res?.data?.data?.predicted_object_model_number) {
            //     handleOpenConfirmScanInfoModal();
            //   }
            // }
            setScanPartsManualsLoading(false);
          },
          (err) => {
            setScanPartsManualsLoading(false);
          }
        )
      );
    }

  };

  // Manage the horizontal scrolling
  const navRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const scrollAmount = 150; // Adjust this value as needed
  const scrollEndMargin = 5; // Allow a margin for end of scroll detection

  const handleScroll = () => {
    if (navRef?.current) {
      setCanScrollLeft(navRef?.current?.scrollLeft > 0);
      setCanScrollRight(
        navRef?.current?.scrollLeft + navRef?.current?.clientWidth < navRef?.current?.scrollWidth - scrollEndMargin
      );
    }
  };

  const scrollLeft = () => {
    navRef?.current?.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  };

  const scrollRight = () => {
    navRef?.current?.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  useEffect(() => {
    handleScroll(); // Check on initial load
    navRef?.current?.addEventListener('scroll', handleScroll);

    if (tabOpen != 3) {
      if (tabOpen != 5 && measuringStatus || mobileTabs != 8 && measuringStatus) {
        const [localValue] = [
          ...room.localParticipant.dataTracks.values(),
        ];

        localValue?.track.send("end_measuring");
      }
    }

    const getManualsFormHeight = () => {
      if (manualsFormHeightRef?.current) {
        setManualsFormHeight(manualsFormHeightRef?.current?.getBoundingClientRect()?.height);
      }
    }
    if (tabOpen == 8) {
      setTimeout(getManualsFormHeight, 0);
    }

    const getShoppingLinkWidth = () => {
      if (shoppingItemLinkWidthRef?.current) {
        setShoppingItemLinkWidth(shoppingItemLinkWidthRef?.current?.getBoundingClientRect()?.width);
      }
    }
    if (tabOpen == 4) {
      setTimeout(getShoppingLinkWidth, 0);
    }

    setDiscussionVal("");
    setToggleForAddPersonalNote(false);

    return () => navRef?.current?.removeEventListener('scroll', handleScroll);

  }, [tabOpen, mobileTabs]);

  // Add personal note
  const [toggleForAddPersonalNote, setToggleForAddPersonalNote] = useState(false);
  const [personalNoteObj, setPersonalNoteObj] = useState({});

  useEffect(() => {
    serviceDetailsObj?.personal_notes && setPersonalNoteObj(serviceDetailsObj?.personal_notes);
  }, [serviceDetailsObj])

  const getPaymentConfigFn = () => {
    let details = {};
    dispatch(
      getPaymentConfigApi(
        details,
        (res) => {
          // console.log(res.data.data)
          // console.log(res?.data?.data)
          setPaymentGatewayFlag(
            res?.data?.data?.purchase?.payment_gateway_flag
          );
          setCallChargeAmount(
            res?.data?.data?.purchase?.call_charge_amount_in_cents_int / 100
          );
          setCallDurationTimeLimit(
            res?.data?.data?.purchase?.call_duration_time_limit_in_sec / 60
          );
          setCallChargeDescription(
            res?.data?.data?.purchase?.call_charge_description_chr
          );
        },
        (res) => {
          // console.log(res.data.data);
        }
      )
    );
  };

  useEffect(() => {
    if (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
      getPaymentConfigFn();
    }
  }, [])

  function saveCallDurationForEstimationsCall(remainingTime = 0) {
    const data = new FormData()
    // data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("user_id_ids", joinCallRes?.remote_user_id || "");


    data.append("call_log_id_ids", joinCallRes?.call_log_id_ids);
    data.append("joinee_name_chr", userName);
    // data.append("call_duration_in_second", ((totalCallTimeRedux / 1000)));

    data.append("call_duration_in_second", (remainingTime || serviceDetailsObj?.remaining_time_in_sec));

    dispatch(saveCallDurationApi(data, (res) => {
      handleResetCounter()
      const [localValue] = [...room.localParticipant.dataTracks.values()];
      localValue.track.send("reset-slot-time");
      // localStorage.setItem("ChargeMe", 0)

      setUpdateTicketSummaryLoading(false);
      setProCheckInfoModalConfirmTrigger(false);
      handleLogout();

      console.log(res)
    }, (err) => {
      // localStorage.setItem("ChargeMe", 0)
      handleLogout()
      alert(err.data.message)
    }))
  }


  // Feature for the image scrolling and zoom, reset, etc

  const [attachImageIndex, setAttachImageIndex] = useState(0);

  const handleImageIndex = (index) => {
    setAttachImageIndex(index);
  }

  const handlePrevAttachImg = () => {
    if (attachImageIndex !== 0) {
      setAttachImageIndex(attachImageIndex - 1)
    }
  }
  const handleNextAttachImg = () => {
    if (attachImageIndex <= serviceDetailsObj?.attachment_data?.length - 1) {
      setAttachImageIndex(attachImageIndex + 1)
    }
  }

  // useEffect(() => {
  //     setAttachImageIndex(0);
  // }, [currentServiceId])


  // Dynamic image height and width
  const imageRef = useRef(null);
  const [imgMaxHeight, setImgMaxHeight] = useState(0);
  const [imgMaxWidth, setImgMaxWidth] = useState(0);

  // useEffect(() => {
  //     if (imageRef.current) {
  //         const height = imageRef?.current?.getBoundingClientRect().height;
  //         const width = imageRef?.current?.getBoundingClientRect().width;
  //         setImgMaxWidth(width);
  //         setImgMaxHeight(height);
  //     }


  //     const resizeObserver = new ResizeObserver(entries => {
  //         for (let entry of entries) {
  //             setImgMaxWidth(entry.contentRect.width);
  //             setImgMaxHeight(entry.contentRect.height);
  //         }
  //     });

  //     if (imageRef.current) {
  //         resizeObserver.observe(imageRef.current);
  //     }

  //     return () => resizeObserver.disconnect();


  // }, [imageRef.current, ]);

  // useEffect(() => {
  //     const resizeObserver = new ResizeObserver(entries => {
  //         for (let entry of entries) {
  //             setImgMaxWidth(entry.contentRect.width);
  //             setImgMaxHeight(entry.contentRect.height);
  //         }
  //     });

  //     if (imageRef.current) {
  //         resizeObserver.observe(imageRef.current);
  //     }

  //     return () => resizeObserver.disconnect();
  // }, [imageRef.current, currentServiceId]);

  const reDirectToTips = () => {
    navigate('/tipsAndTricks')
  }

  // Zoom functionality for the images
  // State to hold the scale value
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  // Function to handle the change in range input
  const handleZoomChange = (event) => {
    setScale(event.target.value);
  };

  // Start dragging
  const handleDragStart = (event) => {
    event.preventDefault();
    setDragging(true);
    // setPosition({
    //     ...position, // Keep the previous position
    //     startX: event.clientX - position.x, // Calculate initial start position
    //     startY: event.clientY - position.y,
    // });
    const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
    const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

    setPosition({
      ...position,
      startX: clientX - position.x,
      startY: clientY - position.y,
    });
  };

  // Handle dragging
  const handleDragging = (event) => {
    if (dragging) {
      // setPosition({
      //     ...position,
      //     x: event.clientX - position.startX,
      //     y: event.clientY - position.startY,
      // });
      const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
      const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

      setPosition({
        ...position,
        x: clientX - position.startX,
        y: clientY - position.startY,
      });
    }
  };

  // Stop dragging
  const handleDragEnd = () => {
    setDragging(false);
  };

  // Reset image
  const handleResetImage = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  }

  useEffect(() => {
    handleResetImage();
    setIsLoadingImg(true);
  }, [attachImageIndex]);

  // Loading effect for the images
  const [isLoadingImg, setIsLoadingImg] = useState(true);

  const handleImageLoaded = () => {
    setIsLoadingImg(false);
  };

  const handleImageError = () => {
    console.error('Failed to load the image.');
    setIsLoadingImg(false);
  };

  // Start for composing video recordings for the estimations call 
  const handleCreateComposeRecording = () => {
    // setCreateComposeRecordingLoading(true);
    const formData = new FormData();
    formData.append("call_log_id", localStorage.getItem("call_log_id"));
    dispatch(
      createComposeRecordingApi(
        formData,
        (res) => {
          // setCreateComposeRecordingLoading(false);
          // setCompositionModalTrigger(false);
          // setCallLogIdForComposition('');
          // setCallRecordingsArr(prevState => []);
          // handleCallIdForRecordings();
        },
        (err) => {
          // setCreateComposeRecordingLoading(false);

          setResponceMsg(err.data.message || "Something went wrong while composing the recording.")
          // setToasterType("error");

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);
        }
      )
    );
  }

  return (
    <>
      <div id="tRoom" style={{ background: "#2B2B2B", position: "relative" }}>
        <div
          className="row video-frame"
          style={{ height: "100dvh", position: "relative" }}>

          {proCheckInfoModalConfirmTrigger && <div style={{ height: '100dvh', width: '100dvw', backgroundColor: 'black', position: 'absolute', top: '0', left: '0', zIndex: '101' }}></div>}
          {/* My control */}
          <div className="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 leftMainContainer">
            <div
              className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 leftMainDiv"
              style={{ background: 'rgb(240, 243, 247)' }}
            >
              <div className=" row d-flex justify-content-center ">
                <div className="col-10  d-flex justify-content-center align-items-center flex-column">
                  <span className="fs-4 ">
                    <IoMdArrowRoundBack
                      className="my-4 pointer"
                      onClick={() => {
                        if (((serviceDetailsObj?.ticket_type_int == 1) || (serviceDetailsObj?.ticket_type_int == 2)) && (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) && (localStorage.getItem("timeUsedInSeconds") != 0)) {
                          if (!proDiagnosis || !proRecommendedSolution) {
                            setProCheckInfoModalTrigger(true);
                          } else {
                            setEndCallPopUp(true);
                          }
                        } else {
                          setEndCallPopUp(true);
                        }
                      }}
                      style={{ width: "18px", height: "18px", color: 'rgba(131, 154, 192, 1)' }}
                    />
                  </span>

                  <span className="fs-7">
                    {" "}
                    <CallDuration
                      joinCallRes={joinCallRes}
                      participants={participants}
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>
                  <ResetTimerDuration ref={callDurationRef} participants={participants}
                    style={{ width: "18px", height: "18px" }} />
                </div>
              </div>

              <div className=" row  " style={{ color: "grey" }}>
                <span className="fs-4 icons-videos-my-control">
                  <i
                    className="bi bi-gear pointer"
                    onClick={() => {
                      setResourceModal(true);
                    }}></i>
                </span>

                {/* My mic control */}
                <span className="fs-4 icons-videos-my-control pointer">
                  {micStatus
                    ? micPermissionStatus && (
                      <BsFillMicFill
                        id="muteAudio"
                        onClick={handleMicStatus}
                        style={{ width: "18px", height: "18px", color: 'rgba(131, 154, 192, 1)' }}
                      />
                    )
                    : micPermissionStatus && (
                      <BsFillMicMuteFill
                        onClick={handleMicOffStatus}
                        style={{
                          width: "18px",
                          height: "18px",
                          color: "red",
                        }}
                      />
                    )}

                  {!micPermissionStatus && (
                    <span
                      className="fs-4 icons-videos-my-control pointer"
                      style={{ position: "relative" }}>
                      <BsFillMicMuteFill
                        onClick={() => {
                          setCameraPermissionDialog(true);
                        }}
                        style={{ width: "18px", height: "18px", color: "red" }}
                      />
                      <FaExclamation
                        onClick={() => {
                          setCameraPermissionDialog(true);
                        }}
                        style={{
                          height: "12px",
                          color: "orange",
                          position: "absolute",
                          left: "9px",
                          top: "0px",
                        }}
                      />
                    </span>
                  )}
                  { }
                </span>
                {/* My video Control */}
                {cameraPermissionStatus ? (
                  <>
                    <span className="fs-4 icons-videos-my-control pointer">
                      {cameraCheckCustomer ? (
                        <>
                          {videoStatus && (
                            <BsFillCameraVideoFill
                              onClick={handleVideoStatus}
                              style={{ width: "18px", height: "18px", color: 'rgba(131, 154, 192, 1)' }}
                            />
                          )}

                          {!videoStatus && (
                            <BsFillCameraVideoOffFill
                              onClick={handleVideoOffStatus}
                              style={{
                                width: "18px",
                                height: "18px",
                                color: "red",
                              }}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {videoStatus && (
                            <BsFillCameraVideoFill
                              style={{
                                color: "#ffbc9be6",
                                cursor: "not-allowed",
                              }}
                            />
                          )}

                          {!videoStatus && (
                            <BsFillCameraVideoOffFill
                              style={{
                                color: "#ffbc9be6",
                                cursor: "not-allowed",
                              }}
                            />
                          )}
                        </>
                      )}
                    </span>

                    <span className="fs-4 icons-videos-my-control pointer">
                      {cameraCheckCustomer ? (
                        <>
                          <MdOutlineFlipCameraIos
                            onClick={toggleFacingMode}
                            style={{ width: "20px", height: "20px", color: 'rgba(131, 154, 192, 1)' }}
                          />
                        </>
                      ) : (
                        <>
                          <MdOutlineFlipCameraIos
                            style={{
                              color: "#ffbc9be6",
                              cursor: "not-allowed",
                              width: "20px",
                              height: "20px",
                            }}
                          />
                        </>
                      )}
                    </span>
                  </>
                ) : (
                  <span
                    className="fs-4 icons-videos-my-control pointer"
                    style={{ position: "relative" }}>
                    <BsFillCameraVideoOffFill
                      onClick={() => {
                        setCameraPermissionDialog(true);
                      }}
                      style={{ width: "18px", height: "18px", color: "red" }}
                    />
                    <FaExclamation
                      onClick={() => {
                        setCameraPermissionDialog(true);
                      }}
                      style={{
                        height: "12px",
                        color: "orange",
                        position: "absolute",
                        right: "9px",
                        top: "0px",
                      }}
                    />
                  </span>
                )}

                <span
                  className="mt-2 mb-2"
                  style={{
                    width: "100%",
                    border: "0.5px solid lightgrey",
                  }}></span>

                {/* Feedback Button */}
                <span
                  className="fs-7 leftMainDivButtons pointer text-black font-w600"
                  onClick={() => {
                    setFeedbackModal(true);
                  }}>
                  {" "}
                  Feedback
                </span>

                {/* End call Button */}
                <span
                  className="fs-7 leftMainDivButtons pointer font-w600"
                  style={{ background: "red" }}
                  onClick={() => {
                    if (((serviceDetailsObj?.ticket_type_int == 1) || (serviceDetailsObj?.ticket_type_int == 2)) && (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) && (localStorage.getItem("timeUsedInSeconds") != 0)) {
                      if (!proDiagnosis || !proRecommendedSolution) {
                        setProCheckInfoModalTrigger(true);
                      } else {
                        setEndCallPopUp(true);
                      }
                    } else {
                      setEndCallPopUp(true);
                    }
                  }}>
                  {" "}
                  End call
                </span>
              </div>
            </div>
            <div
              className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 leftMainDiv"
              style={{ background: "grey" }}></div>
          </div>

          {/*  Video call Section  */}
          <div
            className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 video-set"
            ref={myDivRef}
            id="forSC"
            style={{
              background: "grey",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",

            }}>
            {showMeasureGif &&
              <div style={{ position: 'absolute', zIndex: 999 }}>
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <img className='loader-gif' src={giif} alt='Error Loading' style={{ opacity: '0.6' }} />
                  <span className="fs-4 text-white font-w600 mt-2 text-center">{`Please scan near by area until pointer come`}</span>
                </div>
              </div>
            }

            {zoomCounter > 1 && (
              <div
                onClick={() => setFeedbackModal(true)}
                className="zoom-counter">
                {`${zoomCounter}X`}
              </div>
            )}
            {room && (
              <div className="Lparticipant position-relative" id="lParticipantHeight" >
                {!permissionArray.includes("SCAN TAB") && <BackDropReconnecting

                  show={reconnectingScreen}
                  message={permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") ?
                    "Customer's internet is down" : "Your internet is not stable"
                  }
                />}

                {joinCallRes.is_sender_flag === 1 ? (
                  <>
                    {/* {remoteAvatar ||
                      (participants.length === 0 && (
                        <div
                          style={{
                            width: videoWidth,
                            height: videoHeight,
                            position: "absolute",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "black",
                          }}
                        >
                          {" "}
                          {participants.length != 0 && (
                            <img
                              alt="Error"
                              className="sub-avatar"
                              src={joinCallRes?.local_user_preferred_profile_picture_url}
                              style={{ position: "absolute" }}
                            />
                          )}
                        </div>
                      ))} */}

                    {remoteAvatar && (
                      <div
                        style={{
                          width: videoWidth,
                          height: videoHeight,
                          position: "absolute",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          background: "black",
                        }}>
                        {" "}
                        <img
                          alt="Error"
                          className="sub-video-status"
                          src={joinCallRes?.remote_user_preferred_profile_picture_url}
                          style={{ position: "absolute", borderRadius: "50%" }}
                        />
                      </div>
                    )}
                    <video
                      ref={videoRefRemote}
                      autoPlay={true}
                      id="LP"
                      width={videoWidth}
                      height={videoHeight}
                      style={{
                        opacity: "1",
                        objectFit: "cover",
                        maxWidth: currentWidthOfVideoBox + "px ",
                        maxHeight: currentHeightOfVideoBox + "px ",
                      }}
                    />



                    <audio
                      ref={audioRefRemote}
                      autoPlay={true}
                      id="mediaElement"
                    />
                    <h1 id="scale-visibility">
                      {zoomScale.scale !== 0 ? zoomScale.scale : null}
                    </h1>

                    {drawingArea && (
                      <canvas
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          right: "0",
                          bottom: "0",
                          margin: "auto",
                          cursor: cursorValue,
                        }}
                        id="canvas"></canvas>
                    )}

                    {customerName && (
                      <div
                        className="video-call-customer-name"
                        style={{
                          color: "#f2d0d0",
                          position: "absolute",
                          left: "0",
                          bottom: "0",
                          textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
                        }}>
                        {customerName}
                      </div>
                    )}


                    {videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && (
                      <>
                        <div
                          style={{
                            position: "absolute",
                            left: "50%",
                            bottom: "15px",
                            transform: "translate(-50%, 0)",
                          }}
                        >
                          <PrimaryButton
                            buttonName={"GO LIVE"}
                            className={"blinking-button"}
                            onClick={() => {
                              handleClearCanvas();
                              const [localValue] = [
                                ...room.localParticipant.dataTracks.values(),
                              ];

                              localValue.track.send("stop_ocr");

                            }}
                            style={{
                              width: '115px',
                              fontSize: '12px',
                              border: '2px solid white',
                              background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                              // boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',

                            }}
                          />
                        </div>

                        {/* <div
                          className="video-call-customer-name"
                          style={{
                            color: "#f2d0d0",
                            position: "absolute",
                            left: "50%",
                            bottom: "15px",
                            transform: "translate(-50%, 0)",
                            textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
                          }}>
                          {`RETURN TO LIVE VIDEO`}
                        </div> */}
                      </>
                    )}




                    {!customerDisconnected && !customerName && role != 2 && (
                      <div
                        className="video-call-customer-name"
                        style={{
                          backgroundColor: "white",
                          borderRadius: "15px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: "80",
                          position: "absolute",
                          left: "50%",
                          top: "60%",
                          transform: "translate(-50%, -50%)",
                          fontSize: "13px",
                          color: "black",
                          fontWeight: "700",
                          padding: "16px",
                          border: "5px solid #fc8d30",
                          textAlign: "center",
                        }}>
                        {"Waiting for the customer to join"}
                      </div>
                    )}


                  </>
                ) : (
                  <>
                    {!videoStatus && (
                      <div
                        style={{
                          width: videoWidth,
                          height: videoHeight,
                          position: "absolute",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          background: "black",
                        }}>
                        {" "}
                        <img
                          alt="Error"
                          className="sub-video-status"
                          src={joinCallRes?.local_user_preferred_profile_picture_url}
                          style={{ position: "absolute", borderRadius: "50%" }}
                        />
                      </div>
                    )}
                    <video
                      ref={videoRef}
                      autoPlay={true}
                      id="LP"
                      width={videoWidth}
                      height={videoHeight}
                      style={{
                        opacity: "1",
                        objectFit: "cover",
                        maxWidth: currentWidthOfVideoBox + "px !important",
                        maxHeight: currentHeightOfVideoBox + "px !important",
                      }}
                    />
                    <audio ref={audioRef} autoPlay={true} />

                    {drawingArea && (
                      <canvas
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          right: "0",
                          bottom: "0",
                          margin: "auto",
                          cursor: cursorValue,
                        }}
                        id="canvas"></canvas>
                    )}

                    {/* 
                   
                      {role == 2 && (drawingArea || handleClearDrawForLive) && (
                        <div
                          style={{
                            width: "252px",
                            color: "black",
                            position: "absolute",
                            left: "50%",
                            bottom: "80px",
                            transform: "translate(-50%)",
                            background: "white",
                            padding: "3px 15px",
                            opacity: "0.7",
                            borderRadius: "25px",
                            textAlign: "center",
                          }}>
                          {"Pro has paused your screen to draw"}
                        </div>
                      )}
                      {customerName && (
                        <div
                          className="video-call-customer-name"
                          style={{
                            color: "#f2d0d0",
                            position: "absolute",
                            left: "0",
                            bottom: "0",
                            textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
                          }}>
                          {customerName}
                        </div>
                      )}
                      {!customerDisconnected && !customerName && role != 2 && (
                        <div
                          className="video-call-customer-name"
                          style={{
                            backgroundColor: "white",
                            borderRadius: "15px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: "80",
                            position: "absolute",
                            left: "50%",
                            top: "60%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "13px",
                            color: "black",
                            fontWeight: "700",
                            padding: "16px",
                            border: "5px solid #fc8d30",
                            textAlign: "center",
                          }}>
                          {"Waiting for the customer to join"}
                        </div>
                      )} */}
                  </>
                )}
              </div>
            )}
            <div className="remote-participants">
              <>
                <div
                  className="Rparticipant position-relative"
                  style={{ border: zeroParticipant ? " " : "3px solid #fff" }}
                >
                  {/* {  localAvatar && <Avatar />} */}
                  {joinCallRes.is_sender_flag === 1 ? (
                    <>
                      {!videoStatus && (
                        <div
                          style={{
                            width: "130px",
                            height: "100%",
                            position: "absolute",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "black",
                          }}
                        >
                          {" "}
                          <img
                            alt="Error"
                            className="sub-one-avatar"
                            src={joinCallRes?.local_user_preferred_profile_picture_url}
                            style={{
                              position: "absolute",
                              borderRadius: "50%",
                            }}
                          />

                        </div>
                      )}

                      <video
                        id="testing"
                        ref={videoRef}
                        autoPlay={true}
                        className="remoteParticipant"
                      />
                      <audio ref={audioRef} autoPlay={true} />
                    </>
                  ) : (
                    <>
                      {remoteAvatar && (
                        <div

                          style={{
                            width: "130px",
                            height: "100%",
                            position: "absolute",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "black",
                          }}
                        >
                          {" "}
                          <img
                            alt="Error"
                            className="sub-two-avatar"
                            src={joinCallRes?.remote_user_preferred_profile_picture_url}
                            style={{ position: "absolute", borderRadius: "50%", }}
                          />


                        </div>
                      )}
                      <video
                        ref={videoRefRemote}
                        autoPlay={true}
                        className="remoteParticipant"
                      />
                      <audio ref={audioRefRemote} autoPlay={true} />
                    </>
                  )}

                  {permissionArray.includes("SCAN TAB") && <BackDropReconnecting
                    // show={reconnectingScreen} 
                    show={reconnectingScreen}
                    message={!permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") ?
                      "Pro's internet is down" : "Your internet is not stable"
                    }
                  />}
                </div>
                {!reconnectingScreen && <p
                  style={{
                    color: "white",
                    position: "absolute",
                    left: "24px",
                    bottom: "16px",
                    fontSize: "15px !important",
                    zIndex: "100",
                    textShadow: "0 0 3px #FF0000, 0 0 5px #0000FF",
                    marginBottom: "0px",
                  }}>
                  {professionalName?.split(" ")[0]}
                </p>}
              </>
            </div>
          </div>

          {/* Notes and drawing tool Section */}
          <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 rightMainDiv">
            <BackDropReconnecting
              show={localParticipantReconnecting}
              message={"Your internet is not stable"}
            />

            <div className="row" style={{ borderBottom: "1px solid gray", background: 'rgb(240 243 247)' }}>
              <span className="fs-6 d-flex justify-content-center align-items-baseline py-3 ">
                <span>
                  {" "}
                  {`${customerName?.split(" ")[0]} Customer Controls`}
                </span>{" "}
                {participants.length !== 0 && (
                  <NetworkQualityBar level={networkLevel} />
                )}
              </span>
            </div>

            <div className="row d-flex" style={{ height: "100%" }}>
              <div
                className="col-9"
                style={{
                  borderRight: "1px solid lightgray",
                  display: "flex",
                  flexDirection: "column",
                  background: 'rgb(235, 240, 250)',
                }}
              >
                {/* General Information */}
                {tabOpen == 1 && (
                  <>
                    <div
                      className="row d-flex justify-content-start bg-white"
                      style={{ borderBottom: "1px solid gray" }}>
                      <span
                        className="fs-5 d-flex justify-content-between  py-3 px-4 text-black font-w700"
                        style={{}}
                      >
                        {"General Information"}
                        {/* <LuMoreVertical /> */}
                        <span></span>
                      </span>
                    </div>
                    <div className="row ">
                      <div className="col-12 overflow-auto"
                        style={{ height: "calc(100dvh - 125px)" }}
                      >

                        <div className="bg-white p-3">
                          {/* <div className="row">
                            <span className="fs-7 " style={{ color: "grey" }}>
                              {new Intl.DateTimeFormat("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              }).format(time)}
                              &nbsp;&nbsp; &nbsp;&nbsp;
                              <span
                                style={{ borderRight: "1px solid grey" }}></span>
                              &nbsp;&nbsp; &nbsp;&nbsp; Service request: #
                              {ticketDisplayName}
                            </span>
                          </div> */}
                          <span>Service request: #{serviceDetailsObj?.display_id_int}</span>
                          <div className="row mt-4">
                            {/* <span>
                            <span
                              className="fs-7 px-2 py-1 w-100"
                              style={{
                                color: "grey",
                                background: "white",
                                borderRadius: "20px",
                              }}>
                              Plumbing / Faucet
                            </span>
                          </span> */}
                            <div>
                              {serviceDetailsObj?.category_display_name_chr ?
                                <span
                                  className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                  style={{
                                    background: "rgba(79, 93, 116, 1)",
                                  }}>
                                  {`${serviceDetailsObj?.category_display_name_chr} ${((serviceDetailsObj?.product_type_chr !== "null") && (serviceDetailsObj?.product_type_chr !== null) && (serviceDetailsObj?.product_type_chr !== "")) ? ` / ${serviceDetailsObj?.product_type_chr}` : ''}`}
                                </span> :
                                <span
                                  className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                  style={{
                                    background: 'rgba(199, 212, 234, 1)'
                                  }}>
                                  {`No category`}
                                </span>
                              }
                            </div>

                          </div>

                          <div className="row mt-4">
                            <span>
                              <span
                                className="fs-6 py-1 w-100 text-black font-w700"
                                style={{}}>
                                {serviceDetailsObj?.msg_chr ? serviceDetailsObj?.msg_chr :
                                  serviceDetailsObj?.problem_description_chr
                                    ? serviceDetailsObj?.problem_description_chr
                                    : "Problem description not specified"}
                              </span>
                            </span>
                          </div>


                          {serviceDetailsObj?.attachment_data && (
                            <div className="row mt-4">
                              {serviceDetailsObj?.attachment_data?.map(
                                (data, index) => {
                                  return (
                                    <span
                                      className="rounded-3 shadow border"
                                      style={{
                                        height: "50px",
                                        background: "grey",
                                        width: "40px",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                      }}>
                                      <span className="fs-6 py-1 w-100">
                                        <img
                                          src={data?.url}
                                          className="w-100 h-100 rounded-3 cursor-pointer"
                                          alt=""
                                          onClick={() => {
                                            handleOpenDoc();
                                            setImageAttachURL(data?.url)
                                          }}
                                        />
                                      </span>
                                    </span>
                                  );
                                }
                              )}
                            </div>
                          )}

                          {serviceDetailsObj?.latest_created_call_details?.video_link_new_chr &&
                            <div className="row">
                              <div className="col-12 p-2 border border-light rounded-3">
                                <div className=' mx-0 row p-1 rounded'
                                  style={{
                                    background: 'rgba(244, 248, 255, 1)',
                                    border: '1px solid rgba(199, 212, 234, 1)',
                                  }}
                                >
                                  <div className='col-11 px-0 d-flex  '>

                                    <div className='overflow-hidden p-2  text-nowrap w-100 whitespace-nowrap' style={{ textOverflow: "ellipsis" }}>
                                      <span>
                                        {(serviceDetailsObj?.created_by_chr == process.env.REACT_APP_GUEST_USER_ID_IDS) ?
                                          `${serviceDetailsObj?.latest_created_call_details?.video_link_new_chr}/?guestHomeOwnerId=${serviceDetailsObj?.created_by_chr}` :
                                          `${serviceDetailsObj?.latest_created_call_details?.video_link_new_chr}`}
                                      </span>
                                    </div>
                                  </div>
                                  <div className='col-1 px-0 fs-3 d-flex align-items-center justify-content-end text-black pe-2' style={{}}>
                                    <div className="tooltipCustom ">
                                      <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Copy to clipboard"}</span>
                                      <span
                                        onClick={() => {
                                          navigator.clipboard.writeText(
                                            (serviceDetailsObj?.created_by_chr == process.env.REACT_APP_GUEST_USER_ID_IDS) ?
                                              `${serviceDetailsObj?.latest_created_call_details?.video_link_new_chr}/?guestHomeOwnerId=${serviceDetailsObj?.created_by_chr}` :
                                              `${serviceDetailsObj?.latest_created_call_details?.video_link_new_chr}`
                                          );
                                          copyToClipboard()
                                        }}
                                        className={`cursor-pointer text-hovered`}
                                      >
                                        <MdContentCopy style={{ fontSize: "12px" }} />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className=' mx-0 row mt-1'>
                                  <div className='col-12 px-0'>
                                    <span className="fs-7">
                                      {"You can copy and send a video call link via any messenger you use for communication."}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>

                        <div className="row mx-0 p-3">
                          <div className="col-12 px-0">

                            <div className="row mx-0 mb-2">
                              <div className="col-12 px-0">
                                <span className="font-w600 text-gray">{`General information`}</span>
                              </div>
                            </div>

                            <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                              <div className='col-5'>
                                <span>{`Job started`}</span>
                              </div>
                              <div className='col-7'>
                                <span className='font-w600 text-black'>{`${serviceDetailsObj?.created_date_dtm ? formatUnixTimestamp(serviceDetailsObj?.created_date_dtm) : `-`}`}</span>
                              </div>
                            </div>

                            <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                              <div className='col-5'>
                                <span>{`Last call`}</span>
                              </div>
                              <div className='col-7'>
                                <span className='font-w600 text-black'>{`${serviceDetailsObj?.last_call_dtm ? formatUnixTimestamp(serviceDetailsObj?.last_call_dtm) : `-`}`}</span>
                              </div>
                            </div>

                            <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                              <div className='col-5'>
                                <span>{`Brand`}</span>
                              </div>
                              <div className='col-7'>
                                <span className='font-w600 text-black'>{`${serviceDetailsObj?.device_brand_chr ? serviceDetailsObj?.device_brand_chr : "-"}`}</span>
                              </div>
                            </div>

                            <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                              <div className='col-5'>
                                <span>{`Model`}</span>
                              </div>
                              <div className='col-7'>
                                <span className='font-w600 text-black'>{`${serviceDetailsObj?.model_number_chr ? serviceDetailsObj?.model_number_chr : "-"}`}</span>
                              </div>
                            </div>

                            <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                              <div className='col-5'>
                                <span>{`Serial #`}</span>
                              </div>
                              <div className='col-7'>
                                <span className='font-w600 text-black'>{`${serviceDetailsObj?.serial_number_chr ? serviceDetailsObj?.serial_number_chr : "-"}`}</span>
                              </div>
                            </div>

                            <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                              <div className='col-5'>
                                <span>{`Initiator`}</span>
                              </div>
                              <div className='col-7'>
                                <span className='font-w600 text-black'>{`${serviceDetailsObj?.creator_name_chr ? serviceDetailsObj?.creator_name_chr : "-"}`}</span>
                              </div>
                            </div>

                            <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                              <div className='col-5'>
                                <div className="tooltipCustom">
                                  <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Add note"}</span>
                                  <i className="bi bi-info-circle text-hovered"></i>
                                </div>

                                <span className='ms-2'>{`Personal note`}</span>
                              </div>
                              <div className='col-7'>
                                {(Object?.keys(personalNoteObj)?.length !== 0) ?
                                  <>
                                    <div className='row'>
                                      <div className='col-10 d-flex flex-column'>
                                        {!toggleForAddPersonalNote ?
                                          <span className='font-w600 text-black'>{`${serviceDetailsObj?.personal_notes?.note_chr}`}</span> :
                                          <>
                                            <TextArea
                                              labelName={`Note`}
                                              value={discussionVal}
                                              onChange={discussionOnChange}
                                              onBlur={() => { }}
                                            />

                                            <div
                                              className=''
                                              style={{
                                                pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                                opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                              }}
                                            >
                                              <PrimaryButton
                                                buttonName={`SAVE`}
                                                onClick={() => { handleSaveDiscussion() }}
                                                loadingMessage={"SAVING..."}
                                                isLoading={saveLoading}
                                                style={{
                                                  width: '100%',
                                                  background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                  border: '2px solid rgba(255, 154, 32, 1)',
                                                  boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                }}
                                              />
                                            </div>
                                          </>}

                                      </div>

                                      <div className='col-2 d-flex justify-content-center'>
                                        {!toggleForAddPersonalNote ?
                                          <i
                                            onClick={() => { setToggleForAddPersonalNote(true); setDiscussionVal(serviceDetailsObj?.personal_notes?.note_chr) }}
                                            className='bi bi-pencil cursor-pointer text-black text-hovered'
                                            style={{ fontSize: '12px' }}
                                          ></i> :
                                          <i
                                            className='bi bi-x-lg cursor-pointer text-hovered fs-4'
                                            onClick={() => { setToggleForAddPersonalNote(false) }}
                                          ></i>
                                        }

                                      </div>
                                    </div>
                                  </>
                                  :
                                  <>
                                    {!toggleForAddPersonalNote ?
                                      <div className='col-12 d-flex'>
                                        <div
                                          className='cursor-pointer text-hovered'
                                          onClick={() => { setToggleForAddPersonalNote(true) }}
                                        >
                                          <span className='font-w600'>{`Add note`}</span>
                                          <span className='font-w600' style={{ fontSize: '12px' }}>
                                            <i className="bi bi-pencil ps-2 text-black"></i>
                                          </span>
                                        </div>
                                      </div> :
                                      <div className='row'>
                                        <div className='col-10 d-flex flex-column'>
                                          <TextArea
                                            labelName={`Note`}
                                            value={discussionVal}
                                            onChange={discussionOnChange}
                                            onBlur={() => { }}
                                          />

                                          <div
                                            className=''
                                            style={{
                                              pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                              opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                            }}
                                          >
                                            <PrimaryButton
                                              buttonName={`SAVE`}
                                              onClick={() => { handleSaveDiscussion() }}
                                              loadingMessage={"SAVING..."}
                                              isLoading={saveLoading}
                                              style={{
                                                width: '100%',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                              }}
                                            />
                                          </div>

                                        </div>

                                        <div className='col-2 d-flex justify-content-center'>
                                          <i
                                            onClick={() => { setToggleForAddPersonalNote(false) }}
                                            className='bi bi-x-lg cursor-pointer text-hovered fs-4'
                                          ></i>
                                        </div>
                                      </div>
                                    }
                                  </>
                                }
                              </div>
                            </div>


                            {/* <div className="row mx-0 mb-3 mt-4">
                              <div className="col-12 px-0">
                                <div className="mb-2">
                                  <span className="font-w600 text-gray">{`External resources`}</span>
                                </div>


                                <div
                                  className="d-flex justify-content-between"
                                  title={`${(!serviceDetailsObj?.product_type_chr) ? "Product or brand not found" : ""}`}
                                >
                                  <div
                                    className=" px-2 py-3 rounded-2 shadow-sm d-flex justify-content-center align-items-center font-w600 overlay-action-btn cursor-pointer text-white font-w600"
                                    style={{
                                      width: '49%',
                                      // color: 'rgb(110 137 183)',
                                      background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                      border: '2px solid rgba(255, 154, 32, 1)',
                                      boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                      pointerEvents: (serviceDetailsObj?.product_type_chr) ? 'auto' : 'none',
                                      opacity: (serviceDetailsObj?.product_type_chr) ? '1' : '0.5',
                                    }}
                                    onClick={() => {
                                      handleOpenSourcingInfoModal();
                                      handleSourcingInfoFn(1);
                                    }}
                                  >
                                    <span className="text-center">{`Owners manual`}</span>
                                  </div>

                                  <div
                                    className="px-2 py-3 rounded-2 shadow-sm d-flex justify-content-center align-items-center font-w600 overlay-action-btn cursor-pointer text-white font-w600"
                                    style={{
                                      width: '49%',
                                      // color: 'rgb(110 137 183)',
                                      background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                      border: '2px solid rgba(255, 154, 32, 1)',
                                      boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                      pointerEvents: (serviceDetailsObj?.product_type_chr) ? 'auto' : 'none',
                                      opacity: (serviceDetailsObj?.product_type_chr) ? '1' : '0.5',
                                    }}
                                    onClick={() => {
                                      handleOpenSourcingInfoModal();
                                      handleSourcingInfoFn(0);
                                    }}
                                  >
                                    <span className="text-center">{`Parts and tools`}</span>
                                  </div>
                                </div>
                              </div>
                            </div> */}


                          </div>

                        </div>


                      </div>
                    </div>
                  </>
                )}
                {/* Tab 2 Draw */}
                {tabOpen == 2 && (
                  <>
                    <div
                      className="row d-flex justify-content-start"
                      style={{ flex: "1" }}>
                      <div className="row">
                        <div>
                          <span
                            className=" d-flex justify-content-between align-items-center p-3 text-black bg-white"
                            style={{
                              borderBottom: "1px solid gray",
                            }}>
                            <span className="fs-5 font-w700 ">
                              {"Drawing tool"}
                            </span>
                            {/* <LuMoreVertical /> */}

                            <div
                              className="px-2 py-1 rounded-1 overlay-action-btn cursor-pointer text-black"
                              onClick={handleClearOnly}
                            >
                              <span
                                className="fs-6 font-w500 text-black"
                              >
                                Clear all
                              </span>
                            </div>
                          </span>
                          {!remoteAvatar ? (
                            <div className="row ">
                              <div className="col p-3">
                                <div className="row mt-4">
                                  <span
                                    className="fs-6  font-w600 text-black"
                                    style={{}}>
                                    Select a shape
                                  </span>
                                </div>
                                {process.env.REACT_APP_BASE_URL?.includes('dev') && remotePlatform !== "web" &&
                                  <div className="row mt-4">
                                    <PrimaryButton
                                      isLoading={switch3DLoading}
                                      loadingMessage={threeDStatus ? "Switching to 3D" : "Switching to 2D"}
                                      buttonName={threeDStatus ? "Switch to 2D" : "Switch to 3D"}
                                      onClick={changeDrawingModeFn}
                                    />
                                  </div>
                                }

                                <div className="row mt-2">
                                  <span
                                    className="fs-6 font-w500"
                                    style={{}}>
                                    Choose a shape and then click on the video to highlight an area for the customer
                                  </span>
                                </div>

                                <div className="row mt-4">
                                  {threeDStatus && <span
                                    onClick={handleDrawing}
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawRectangle
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}
                                  >
                                    <FaMapMarkerAlt
                                      className="pointer"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Point`}
                                    </span>
                                  </span>}

                                  {!threeDStatus && <span
                                    onClick={handleDrawing}
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawRectangle
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}
                                  >
                                    <FaRegSquareFull
                                      className="pointer"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Rectangle`}
                                    </span>
                                  </span>}

                                  {!threeDStatus && <span
                                    onClick={handleCircle}
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered "
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawCircle
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}>
                                    <BsCircle
                                      className="pointer"
                                      style={{
                                        // color: drawCircle ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Circle`}
                                    </span>
                                  </span>}

                                  {!threeDStatus && <span
                                    onClick={handleline}
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawLine
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}
                                  >
                                    <BsArrowLeftRight
                                      className="pointer"
                                      style={{
                                        // color: drawLine ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Arrows`}
                                    </span>
                                  </span>}

                                  {!threeDStatus && <span
                                    onClick={handleText}
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawText
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}>
                                    <BiText
                                      className="pointer"
                                      style={{
                                        // color: drawText ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Text`}
                                    </span>
                                  </span>}

                                  {!threeDStatus && <span
                                    onClick={handleLaserLine}
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: laserLine
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}>
                                    <GiLaserburn
                                      className="pointer"
                                      style={{
                                        // color: laserLine ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Laser`}
                                    </span>
                                  </span>}

                                  {!threeDStatus && <span
                                    onClick={handleFreehand}
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: freehand
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}>
                                    <GiLaserburn
                                      className="pointer"
                                      style={{
                                        // color: laserLine ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Free-hand`}
                                    </span>
                                  </span>}
                                </div>

                                {drawText && (
                                  <>
                                    <div className="row mt-3 p-3">
                                      <InputField
                                        labelName={"Text"}
                                        onChange={handleTextChange}
                                        errorOccured={textShapeMessageErr}
                                        errorMeesage={"Please enter text name"}
                                        value={localStorage.getItem("keyText")}
                                      />

                                      <div className="my-2">
                                        <span className="fs-6 font-w600">{`Enter a note and then click on the customers screen to place the note there`}</span>
                                      </div>
                                    </div>
                                  </>
                                )}

                                {/* <div className="row mt-5">
                                  <span
                                    className="fs-6 pointer text-black"
                                    style={{}}
                                    onClick={handleClearOnly}>
                                    Clear all
                                  </span>
                                </div> */}
                              </div>
                            </div>
                          ) : (
                            <div className="row ">
                              <div className="col p-3">
                                <div className="row mt-4">
                                  <span
                                    className="fs-6 text-black">
                                    Remote camera is off, Please ask customer
                                    to turn on camera
                                  </span>
                                </div>

                                <div
                                  className="row mt-4"
                                  style={{ pointerEvents: 'none', opacity: '0.5' }}
                                >
                                  <span
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawRectangle
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}
                                  >
                                    <FaRegSquareFull
                                      className="pointer"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Rectangle`}
                                    </span>
                                  </span>

                                  <span
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered "
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawCircle
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}>
                                    <BsCircle
                                      className="pointer"
                                      style={{
                                        // color: drawCircle ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Circle`}
                                    </span>
                                  </span>

                                  <span
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawLine
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}
                                  >
                                    <BsArrowLeftRight
                                      className="pointer"
                                      style={{
                                        // color: drawLine ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Arrows`}
                                    </span>
                                  </span>

                                  <span
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: drawText
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}>
                                    <BiText
                                      className="pointer"
                                      style={{
                                        // color: drawText ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Text`}
                                    </span>
                                  </span>

                                  <span
                                    className="d-flex justify-content-center align-items-center flex-column bg-white rounded-1 cursor-pointer text-hovered"
                                    style={{
                                      height: "60px",
                                      width: "60px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      // border: " 1px solid rgba(86, 86, 86, 1)",
                                      color: laserLine
                                        ? "orange"
                                        : "rgba(131, 154, 192, 1)",
                                    }}>
                                    <GiLaserburn
                                      className="pointer"
                                      style={{
                                        // color: laserLine ? "orange" : "white",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                    <span className="fs-7 mt-2">
                                      {`Laser`}
                                    </span>
                                  </span>
                                </div>



                                {false &&
                                  <div className="row mt-4">
                                    <span
                                      className="d-flex justify-content-center align-items-center"
                                      style={{
                                        height: "48px",
                                        width: "48px",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        border: " 1px solid rgba(86, 86, 86, 1)",
                                      }}>
                                      <FaRegSquareFull
                                        className="pointer"
                                        style={{
                                          color: "grey",
                                          width: "18px",
                                          height: "18px",
                                        }}
                                      />
                                    </span>

                                    <span
                                      className="d-flex justify-content-center align-items-center"
                                      style={{
                                        height: "48px",
                                        width: "48px",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        border: " 1px solid rgba(86, 86, 86, 1)",
                                      }}>
                                      <BsCircle
                                        className="pointer"
                                        style={{
                                          color: "grey",
                                          width: "18px",
                                          height: "18px",
                                        }}
                                      />
                                    </span>
                                    <span
                                      className="d-flex justify-content-center align-items-center"
                                      style={{
                                        height: "48px",
                                        width: "48px",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        border: " 1px solid rgba(86, 86, 86, 1)",
                                      }}>
                                      <BsArrowLeftRight
                                        className="pointer"
                                        style={{
                                          color: "grey",
                                          width: "18px",
                                          height: "18px",
                                        }}
                                      />
                                    </span>

                                    <span
                                      className="d-flex justify-content-center align-items-center"
                                      style={{
                                        height: "48px",
                                        width: "48px",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        border: " 1px solid rgba(86, 86, 86, 1)",
                                      }}>
                                      <BiText
                                        className="pointer"
                                        style={{
                                          color: "grey",
                                          width: "18px",
                                          height: "18px",
                                        }}
                                      />
                                    </span>

                                    <span
                                      className="d-flex justify-content-center align-items-center"
                                      style={{
                                        height: "48px",
                                        width: "48px",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        border: " 1px solid rgba(86, 86, 86, 1)",
                                      }}>
                                      <GiLaserburn
                                        className="pointer"
                                        style={{
                                          color: "grey",
                                          width: "18px",
                                          height: "18px",
                                        }}
                                      />
                                    </span>
                                  </div>
                                }


                              </div>
                            </div>
                          )}
                        </div>

                        <div className="row d-flex align-items-end">
                          <div className="row">
                            <div className="row p-3">
                              <span
                                className="fs-7 text-black">
                                Customer video stops while drawing
                              </span>
                            </div>
                            {drawingArea && (
                              <>
                                <div
                                  className="col-12 py-3 d-flex justify-content-center align-items-center pointer"
                                  style={{
                                    // background: "#565656",
                                    height: "48px",
                                    color: "white",
                                    width: '100%',
                                    border: 'none',
                                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                  }}
                                  onClick={() => {
                                    setScreenshotModal(true);
                                  }}>
                                  <span
                                    className="fs-6 d-flex justify-content-center align-items-center "
                                    style={{
                                      color: "white",
                                    }}
                                    onClick={() => {
                                      setScreenshotModal(true);
                                    }}
                                  >
                                    {isSavingScreen
                                      ? "SAVING..."
                                      : "SAVE TO NOTES"}
                                  </span>
                                </div>
                                {/* <div
                                  className="col-6 py-3 d-flex justify-content-center align-items-center pointer"
                                  style={{
                                    background: "#1FC758",
                                    height: "48px",
                                    color: "white",
                                  }}
                                  onClick={handleClearCanvas}>
                                  <span
                                    className="fs-6 d-flex justify-content-center align-items-center"
                                    style={{ color: "white" }}>
                                    Go live
                                  </span>
                                </div> */}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* Tab 3 Notes */}
                {tabOpen == 3 && (
                  <>
                    <div
                      className="row d-flex justify-content-start"
                      style={{ flex: "1" }}>
                      <div className="row" style={{ position: "relative" }}>
                        <div>
                          <span
                            className="fs-5 d-flex justify-content-between align-items-center p-3 bg-white text-black font-w700"
                            style={{
                              borderBottom: "1px solid gray",
                            }}
                          >
                            Notes
                            {/* <LuMoreVertical /> */}
                          </span>

                          <div className="row ">
                            <div
                              className="col-12 p-3"
                              style={{
                                height: "calc(100dvh - 150px)",
                                overflow: "auto",
                              }}
                            >
                              {callNoteDetailsArr.length === 0 && (
                                <div className="row mt-4">
                                  {/* <span className="fs-7  ">
                                    No notes added yet
                                  </span> */}

                                  <div className="mb-3 d-flex justify-content-center align-items-center flex-column">
                                    <div className="mb-2">
                                      <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                    </div>
                                    <span>
                                      {`No notes added yet`}
                                    </span>
                                  </div>
                                </div>
                              )}

                              {callNoteDetailsArr?.map((element, index) => (
                                <div
                                  className="mb-3 pb-2"
                                  style={{ borderBottom: "1px solid gray" }}
                                >
                                  <div className="row mx-0">
                                    <div className="col-12 px-0 d-flex justify-content-between">
                                      <div className="d-flex justify-content-center align-items-center">
                                        <div className="pe-3">
                                          <img src={element?.preferred_profile_picture_url} className="rounded-2" style={{ width: "40px", height: "40px" }} alt="" />
                                        </div>

                                        <div className="d-flex flex-column">
                                          <div>
                                            <span className="text-black font-w600">{`${element?.created_by_name}`}</span>
                                          </div>

                                          <div>
                                            <span>
                                              {new Intl.DateTimeFormat("en-US", {
                                                year: "numeric",
                                                month: "short",
                                                day: "numeric",
                                                hour: 'numeric',
                                                minute: 'numeric',
                                                hour12: true
                                              }).format(
                                                element?.created_date_dtm * 1000
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      {localStorage.getItem("user_id") &&
                                        <div>
                                          <OverlayTrigger
                                            key={index}
                                            trigger="click"
                                            placement="bottom"
                                            // overlay={popover}
                                            overlay={popoverNoteActions(index)}
                                            rootClose={true}
                                            show={activePopoverNotes === index}
                                            onToggle={(show) =>
                                              setActivePopoverNotes(
                                                show ? index : null
                                              )
                                            }>
                                            <span
                                              style={{ position: "relative" }}>
                                              <LuMoreVertical
                                                className="pointer"
                                                onClick={() => {
                                                  handleMenuClickNotes(
                                                    element,
                                                    index
                                                  );
                                                }}
                                                style={{ color: "black" }}
                                              />
                                            </span>
                                          </OverlayTrigger>
                                        </div>
                                      }
                                    </div>

                                    <div className="col-12 mt-3">
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: element?.note_chr,
                                        }}
                                      />
                                    </div>

                                    <div className='col-12 mt-2 d-flex overflow-auto'>
                                      {element?.attachment_url?.length > 0 &&
                                        <>
                                          {element?.attachment_url?.map((item, i) => {
                                            return (
                                              <div key={i}>
                                                <img
                                                  className="me-2 mb-2 rounded-3 cursor-pointer border"
                                                  src={item}
                                                  alt=""
                                                  style={{ width: '90px', height: '100px' }}
                                                  onClick={() => {
                                                    handleOpenDoc();
                                                    setImageAttachURL(item);
                                                    element?.note_chr && setNotesMessage(element?.note_chr);
                                                  }}
                                                />
                                              </div>
                                            )
                                          })}
                                        </>
                                      }
                                    </div>

                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div className="row d-flex align-items-end">
                          <div
                            className="row"
                            style={{
                              position: "absolute",
                              background: "rgb(43, 43, 43)",
                            }}>
                            <span
                              className="fs-6 d-flex justify-content-center align-items-center p-3 cursor-pointer text-white font-w600"
                              style={{
                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                borderTop: "1px solid gray",
                              }}
                              onClick={handleAddNotesView}
                            >
                              <>
                                {" "}
                                {"Add note"} &nbsp; &nbsp;{" "}
                                {toggleNoteView ? (
                                  <i class="bi bi-chevron-down"></i>
                                ) : (
                                  <i class="bi bi-chevron-up"></i>
                                )}{" "}
                              </>
                            </span>
                            {toggleNoteView && (
                              <div
                                style={{
                                  maxHeight: "100vh",
                                  overflow: "auto",
                                }}
                                className="bg-white"
                              >
                                <div className="row mt-2 px-3">
                                  {/* <div
                                  className="row mx-0"
                                  style={{ color: "black" }}>
                                  <div className="col-6">
                                    <span
                                      className="fs-6"
                                      style={{ fontWeight: "600" }}>
                                      Add new note
                                    </span>
                                  </div>
                                  <div className="col-6 d-flex justify-content-end">
                                    <span className="fs-7">
                                      <RxCross2
                                        style={{
                                          width: "18px",
                                          height: "18px",
                                        }}
                                        onClick={handleAddNotesView}
                                      />{" "}
                                    </span>
                                  </div>
                                </div> */}
                                  <div className="row mx-0  mt-4">
                                    <TextArea
                                      labelName={txtMessage}
                                      value={discussionVal}
                                      onChange={discussionOnChange}
                                      onBlur={() => { }}
                                    />
                                  </div>
                                </div>

                                {selectedFile?.map((previewFile, index) => {
                                  return (
                                    <div
                                      className="row mx-0  mt-2 py-2 px-3"
                                      style={{
                                        borderTop:
                                          "1px solid rgba(241, 241, 241, 1)",
                                        borderBottom:
                                          "1px solid rgba(241, 241, 241, 1)",
                                      }}>
                                      <div className="col-9">
                                        <span className="fs-7">
                                          <img
                                            alt=""
                                            style={{
                                              width: "50px",
                                              height: "36px",
                                              objectFit: "none",
                                            }}
                                            src={URL.createObjectURL(
                                              previewFile
                                            )}
                                          />
                                        </span>
                                      </div>
                                      <div className="col-3 d-flex justify-content-end align-items-center">
                                        <span className="fs-7">
                                          <MdDeleteOutline
                                            className="cursor-pointer"
                                            onClick={() => deleteUpload(index)}
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              color: "red",
                                            }}
                                          />{" "}
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })}
                                <div className="row mx-0  mt-2 py-2 px-3">
                                  <div className="col-6 d-flex mb-2 align-items-center">
                                    <span
                                      className="fs-6 text-black cursor-pointer text-hovered"
                                      onClick={() => handleAttach()}>
                                      <input
                                        accept="image/*"
                                        type="file"
                                        multiple
                                        style={{ display: "none" }}
                                        ref={hiddenFileInput}
                                        onChange={(e) => {
                                          inputFileTarget(e);
                                        }}
                                      />{" "}
                                      <i className="bi bi-paperclip"></i> Attach
                                      file
                                    </span>
                                  </div>
                                  <div className="col-6 d-flex justify-content-end align-items-center">
                                    {(selectedFile.length > 0 ||
                                      discussionVal !== "") && (
                                        <span
                                          className="fs-7 px-3 py-2 d-flex justify-content-center align-items-center pointer rounded-2 text-white"
                                          style={{
                                            background: "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)'
                                          }}
                                          onClick={
                                            saveLoading
                                              ? null
                                              : handleSaveDiscussion
                                          }>
                                          {saveLoading ? "Saving" : "Submit"}
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {tabOpen == 7 && (
                  <>
                    <div
                      className="row d-flex justify-content-start"
                      style={{ flex: "1" }}
                    >
                      <div className="row" style={{ position: "relative" }}>
                        <div className="">


                          <span
                            className=" d-flex  align-items-center p-3 bg-white justify-content-between"
                            style={{
                              fontWeight: "700",
                              borderBottom: "1px solid gray",
                            }}
                          >
                            <span className="fs-5 text-black">
                              {`Capture Text`}
                            </span>
                            {/* <OverlayTrigger
                              trigger="click"
                              placement="bottom"
                              overlay={popoverShopping}
                              rootClose={true}
                              show={showPopoverShopping}
                              onToggle={(isOpen) =>
                                setShowPopoverShopping(isOpen)
                              }> */}
                            <span
                              className="text-hovered px-2 py-1 overlay-action-btn cursor-pointer rounded"
                              onClick={() => { handleClearOCRSteps() }}
                            >
                              {'Clear all'}
                            </span>
                            {/* </OverlayTrigger> */}
                          </span>


                          <>
                            <div
                              className="row "
                              style={{
                                background: "rgba(235, 240, 250, 1)",
                                // height: "calc(100dvh - 140px)",
                              }}
                            >
                              <div
                                className="col-12 py-3 px-2 "
                                style={{
                                  // maxHeight: "550px",
                                  // minHeight: "450px",
                                  overflow: "auto",
                                  height: "calc(100dvh - 114px)",
                                }}
                              >

                                {/* <div className="row mx-0 mb-2 ">
                                  <div
                                    className="col-12 p-2 bg-white d-flex"
                                  >
                                    <div className="me-2 d-flex justify-content-center">
                                      <div
                                        className="rounded-circle p-1 fs-5 text-black font-w600 d-flex justify-content-center align-items-center"
                                        style={{
                                          border: OCRSteps == 1 ? '1px solid orange' : '1px solid grey',
                                          height: '35px',
                                          width: '35px',
                                          boxShadow: OCRSteps == 1 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : ``,
                                        }}
                                      >
                                        <span>{`1`}</span>
                                      </div>
                                    </div>

                                    <div className="d-flex flex-column">
                                      <span className="font-w600 text-black">
                                        {`Pause a frame with text`}
                                      </span>

                                      <span className="fs-7 font-w500">
                                        {`Pause the video when the brand and model text is most visible for automatic recognition.`}
                                      </span>

                                      <div className="mt-2">
                                        <Button
                                          onClick={() => {
                                            handleStartOCR()
                                          }}
                                          disabled={OCRSteps == 1 ? false : true}
                                          style={{
                                            width: "100%",
                                            background: OCRSteps == 1 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : 'grey',
                                            boxShadow: OCRSteps == 1 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                            border: 'none'
                                          }}

                                        >
                                          {`PAUSE VIDEO`}
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </div> */}

                                <div className="row mx-0 mb-4">
                                  <div className="col-12 px-2">
                                    <span className="text-black font-w500 fs-5">{`Automatically capture any text information so that you don't have to write it down`}</span>
                                  </div>
                                </div>

                                <div className="row mx-0 mb-2 ">
                                  <div
                                    className="col-12 p-2 bg-white d-flex"
                                    onClick={() => { }}
                                  >
                                    <div className="me-2 d-flex justify-content-center">
                                      <div
                                        className="rounded-circle p-1 fs-5 text-black font-w600 d-flex justify-content-center align-items-center"
                                        style={{
                                          border: OCRSteps == 2 ? '1px solid orange' : '1px solid grey',
                                          height: '35px',
                                          width: '35px',
                                          boxShadow: OCRSteps == 2 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                        }}
                                      >
                                        <span>{`1`}</span>
                                      </div>
                                    </div>

                                    <div className="d-flex flex-column">
                                      <span className="font-w600 text-black">
                                        {`Capture the text you need`}
                                      </span>

                                      <span className="fs-7 font-w500">
                                        {`Click Capture Text and then adjust the frame size to only the text you want to capture.`}
                                      </span>

                                      <div className="mt-2">
                                        <Button
                                          disabled={OCRSteps == 2 ? false : true}
                                          onClick={() => {
                                            setOCRSteps(3)
                                            handleOcrSend();
                                          }}
                                          style={{
                                            width: "100%",
                                            background: OCRSteps == 2 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : 'grey',
                                            boxShadow: OCRSteps == 2 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                            border: 'none'
                                          }}
                                        >
                                          {`CAPTURE TEXT`}
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="row mx-0 mb-2 ">
                                  <div
                                    className="col-12 p-2 bg-white d-flex"

                                  >
                                    <div className="me-2 d-flex justify-content-center">
                                      <div
                                        className="rounded-circle p-1 fs-5 text-black font-w600 d-flex justify-content-center align-items-center"
                                        style={{
                                          border: OCRSteps == 3 ? '1px solid orange' : '1px solid grey',
                                          height: '35px',
                                          width: '35px',
                                          boxShadow: OCRSteps == 3 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                        }}
                                      >
                                        <span>{`2`}</span>
                                      </div>
                                    </div>

                                    <div className="d-flex flex-column w-100">
                                      <span className="font-w600 text-black">
                                        {`Save the results`}
                                      </span>

                                      <span className="fs-7 font-w500">
                                        {`Correct the data, if necessary, and save it in the Notes.`}
                                      </span>

                                      <div
                                        className="mt-3"
                                      >
                                        <TextArea
                                          labelName={`Captured text`}
                                          value={OCRText}
                                          onChange={(e) => { setOCRText(e.target.value) }}
                                          rows="6"
                                          onBlur={() => { }}
                                        />
                                      </div>

                                      <div className="mt-2">
                                        <Button
                                          disabled={OCRSteps == 3 ? false : true}
                                          onClick={() => {
                                            setOCRSteps(3)

                                            if (drawingArea) {
                                              handleClearCanvas()

                                            }

                                            const [localValue] = [
                                              ...room.localParticipant.dataTracks.values(),
                                            ];
                                            localValue.track.send("notes_attachment");

                                            localValue.track.send("stop_ocr");
                                            handleSaveNoteFromOcr();
                                            const video = document.getElementById("LP");

                                            if (!video) return;
                                            video.play();
                                          }}
                                          style={{
                                            width: "100%",
                                            background: OCRSteps == 3 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : 'grey',
                                            boxShadow: OCRSteps == 3 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                            border: 'none'
                                          }}
                                        >
                                          {isLoadingActive ? <Spinner size="sm" /> : `SAVE TO NOTES`}
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* Tab 4 Shopping */}
                {tabOpen == 4 && (
                  <>
                    <div
                      className="row d-flex justify-content-start"
                      style={{ flex: "1" }}
                    >
                      <div className="row" style={{ position: "relative" }}>
                        <div>
                          <span
                            className="fs-5 d-flex justify-content-between align-items-center p-3 text-black bg-white font-w700"
                            style={{
                              borderBottom: "1px solid gray",
                            }}
                          >
                            List
                            <OverlayTrigger
                              trigger="click"
                              placement="bottom"
                              overlay={popoverShopping}
                              rootClose={true}
                              show={showPopoverShopping}
                              onToggle={(isOpen) =>
                                setShowPopoverShopping(isOpen)
                              }
                            >
                              <span>
                                <LuMoreVertical className="cursor-pointer" />
                              </span>
                            </OverlayTrigger>
                          </span>

                          <div className="row ">
                            <div
                              className="col p-3"
                              style={{
                                height: "calc(100dvh - 150px)",
                                overflow: "auto",
                              }}
                            >
                              {/* <div className="row mt-4">
                              <span className="fs-7  ">
                                No shopping items added yet
                              </span>
                            </div> */}
                              <div
                                className="row mt-2 pb-2"
                                style={{
                                  borderBottom: "1px solid darkgrey",
                                }}
                              >
                                <div className="col-12 px-0 d-flex align-items-center justify-content-between">
                                  <div>
                                    <span>{`Added : `}</span>
                                    <span className='font-w600 text-black'>{` ${rows.length} items`}</span>
                                  </div>

                                  <div>
                                    <span>{`Total cost : `}</span>
                                    <span className='font-w600 text-black'>
                                      {USDollar.format(
                                        parseFloat(totalCost.toFixed(2))
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>


                              {rows.length > 0 ?
                                <>
                                  {rows?.map((element, index) => {
                                    return (
                                      <div
                                        className="row mt-4 pb-2 border-bottom"
                                        style={{
                                          pointerEvents: purchaseLoading ? 'none' : 'auto',
                                          opacity: purchaseLoading ? '0.5' : '1',
                                        }}
                                      >
                                        <div
                                          className="col-12 p-2 d-flex bg-white-hovered cursor-pointer rounded-2"
                                          onClick={(e) => {
                                            e?.preventDefault();
                                            handleViewPurchaseItemDesktop(element, 5);
                                          }}
                                        >

                                          {/* <div className='pe-3 d-flex justify-content-center'>
                                            <div>
                                              {
                                                <div className='rounded-2 shadow-lg'>
                                                  <div
                                                    className='rounded-2 d-flex justify-content-center align-items-center'
                                                    style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                  >
                                                    <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          </div> */}
                                          <div className="w-100">
                                            <div className="row mx-0">
                                              <div className="col-6 d-flex justify-content-start align-items-center">
                                                <span className="fs-7">
                                                  <span className='pe-2'>{index + 1}.</span>
                                                  <span className="text-black font-w600">{element?.item_name_chr}</span>
                                                </span>
                                              </div>

                                              <div className="col-6 d-flex justify-content-end align-items-center">
                                                <span
                                                  className="fs-7 text-black font-w600"
                                                  style={{}}>
                                                  ({element?.quantity_int}) X{" "}
                                                  {USDollar.format(
                                                    element?.estimated_price_float /
                                                    element?.quantity_int
                                                  )}{" "}
                                                  &nbsp; &nbsp;{" "}
                                                  <OverlayTrigger
                                                    key={index}
                                                    trigger="click"
                                                    placement="bottom"
                                                    // overlay={popover}
                                                    overlay={popoverShoppingActions(
                                                      index
                                                    )}
                                                    rootClose={true}
                                                    show={
                                                      activePopoverShopping === index
                                                    }
                                                    onToggle={(show) =>
                                                      setActivePopoverShopping(
                                                        show ? index : null
                                                      )
                                                    }
                                                  >
                                                    <span style={{}}>
                                                      <LuMoreVertical
                                                        className="cursor-pointer text-black"
                                                        onClick={(e) => {
                                                          e?.preventDefault();
                                                          e.stopPropagation();
                                                          handleMenuClickShopping(
                                                            element,
                                                            index
                                                          );
                                                        }}
                                                      />
                                                    </span>
                                                  </OverlayTrigger>
                                                </span>
                                              </div>
                                            </div>

                                            <div className="row mx-0  mt-2">
                                              <span className="fs-7">
                                                {element?.description_chr}
                                              </span>
                                            </div>

                                            {element?.purchase_link_chr != "" && (
                                              <div className="row mx-0  mt-2" ref={shoppingItemLinkWidthRef}>
                                                <div className="col-12 d-flex justify-content-start align-items-center">
                                                  {urlPattern.test(element?.purchase_link_chr) ?
                                                    <>
                                                      <div className="d-flex align-items-center">
                                                        <span className="text-black font-w600 fs-7 me-2">{`Website: `}</span>
                                                        <a
                                                          className="text-black text-hovered text-decoration-underline"
                                                          href={
                                                            // element?.purchase_link_chr
                                                            element?.purchase_link_chr && !element?.purchase_link_chr.startsWith('http')
                                                              ? `https://${element?.purchase_link_chr}`
                                                              : element?.purchase_link_chr
                                                          }
                                                          target="_blank"
                                                          rel="noreferrer"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                          }}
                                                        >
                                                          <span
                                                            className="fs-7 cursor-pointer text-truncate d-flex"
                                                            // style={{ maxWidth: `calc(${shoppingItemLinkWidth}px - 80px)` }}
                                                            style={{ maxWidth: `180px` }}
                                                          // onClick={() => {
                                                          //   navigator.clipboard.writeText(
                                                          //     `${element?.purchase_link_chr}`
                                                          //   );
                                                          //   copyToClipboard();
                                                          // }}
                                                          >
                                                            {`${element?.purchase_link_chr}`}
                                                            {/* <FaArrowRightLong />{" "} */}
                                                          </span>
                                                        </a>
                                                        <span >{`...`}</span>
                                                      </div>
                                                    </> :
                                                    <div>
                                                      <span className="text-black font-w600 fs-7 me-2">{`Location: `}</span>
                                                      <span
                                                        className="fs-7 text-black"
                                                      >
                                                        {element?.purchase_link_chr}
                                                      </span>
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                            )}

                                            {
                                              <div className="row mx-0  mt-2">
                                                <div className={`col-12 d-flex fs-7 font-w600 `}>
                                                  <div className="d-flex align-items-center justify-content-between w-100">
                                                    <div
                                                      className="me-4 d-flex align-items-center"
                                                      style={{
                                                        pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                        opacity: purchaseLoading ? '0.5' : '1'
                                                      }}
                                                    >
                                                      <span
                                                        className="me-2"
                                                      >
                                                        {purchaseLoading && (element?.item_id_ids === shoppingItemId) ?
                                                          <Spinner animation="border" size="sm" /> :
                                                          <input
                                                            type="checkbox"
                                                            checked={element?.is_purchased_ysn}
                                                            className="form-check-input"
                                                            id="customCheckBox4"
                                                            onChange={(e) => {
                                                              e?.preventDefault();
                                                              e.stopPropagation();

                                                              handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                              setShoppingItemId(element?.item_id_ids)
                                                            }}
                                                            onClick={(e) => {
                                                              e?.preventDefault();
                                                              e.stopPropagation();

                                                              handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                              setShoppingItemId(element?.item_id_ids)
                                                            }}
                                                          />
                                                        }
                                                      </span>
                                                      <span
                                                        className="pt-1 cursor-pointer text-hovered"
                                                        onClick={(e) => {
                                                          e?.preventDefault();
                                                          e?.stopPropagation();

                                                          handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                          setShoppingItemId(element?.item_id_ids)
                                                        }}
                                                      >
                                                        {`Item Acquired`}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            }

                                            <div className="row mx-0  mt-2">
                                              <div className='col-12 px-0 d-flex justify-content-end'>
                                                {element?.is_purchased_ysn ?
                                                  <span className='font-w600 fs-7 text-success'>{`Purchased`}</span> :
                                                  <span className='font-w600 fs-7'>{`Not purchased yet`}</span>
                                                }
                                              </div>
                                            </div>


                                          </div>

                                        </div>

                                      </div>
                                    );
                                  })}
                                </> :
                                <>
                                  <div className="mb-3 mt-4 d-flex justify-content-center align-items-center flex-column">
                                    <div className="mb-2">
                                      <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                    </div>
                                    <span>
                                      {`No items added yet`}
                                    </span>
                                  </div>
                                </>
                              }

                            </div>
                          </div>
                        </div>

                        <div className="row d-flex align-items-end">
                          <div
                            className="row"
                            style={{
                              position: "absolute",
                              background: "white",
                            }}>
                            <span
                              className="fs-6 font-w600 text-white d-flex justify-content-center align-items-center p-3 pointer"
                              style={{
                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                borderTop: "1px solid gray",
                              }}
                              onClick={() => {
                                handleClosePurchaseList();
                                handleAddNotesView();
                                setIsShoppingItemEdit(false);
                              }}>
                              {"Add list item"}&nbsp; &nbsp;{" "}
                              {toggleNoteView ? (
                                <i class="bi bi-chevron-down"></i>
                              ) : (
                                <i class="bi bi-chevron-up"></i>
                              )}{" "}
                            </span>
                            {toggleNoteView && (
                              <div className="px-3 my-2 mt-3">
                                <InputField
                                  labelName={"Item Name"}
                                  placeholderName={"Item Name"}
                                  value={itemName}
                                  onChange={handleItemName}
                                  onBlur={handleItemNameBlurCheck}
                                  errorOccured={itemNameErr}
                                  errorMeesage={"Please add item name"}
                                />
                                <div className="row mx-0 justify-content-between">
                                  <div className="col-md-6 px-0 pe-md-2">
                                    <InputField
                                      labelName={"Quantity"}
                                      placeholderName={"Quantity"}
                                      value={`${quantity}`}
                                      onChange={handleQuantity}
                                      onBlur={() => { }}
                                    />
                                  </div>

                                  <div className="col-md-6 px-0  ps-md-2">
                                    <InputField
                                      labelName={"Item cost ($)"}
                                      placeholderName={"Cost Per Item"}
                                      value={totalEstimatedCost}
                                      onChange={handleTotalEstimatedCost}
                                      onBlur={() => { }}
                                    />
                                  </div>
                                </div>
                                <InputField
                                  labelName={"Website or Location"}
                                  placeholderName={"Website or Location"}
                                  value={purchaseLink}
                                  onChange={handlePurchaseLink}
                                  onBlur={() => { }}
                                />
                                <TextArea
                                  labelName={"Item Description"}
                                  placeholder={"Item Description"}
                                  value={itemDescription}
                                  onChange={handleDescription}
                                  onBlur={() => { }}
                                // onBlur={handleDescriptionBlurCheck}
                                // errorOccured={itemDescriptionErr}
                                // errorMessage={'Please add description'}
                                />

                                {/* <span
                                  className="fs-7 px-3 py-2 d-flex justify-content-center align-items-center pointer mt-1"
                                  style={{
                                    color: "white",
                                    background: "green",
                                    borderRadius: "24px",
                                  }}
                                  onClick={(e) => {
                                    if (!isShoppingItemEdit) {
                                      handleSubmitPurchase(e);
                                    } else {
                                      handleUpdatePurchase(e);
                                    }
                                  }}>
                                  {purchaseLoading ? "Saving" : "Submit"}
                                </span> */}

                                <PrimaryButton
                                  buttonName={"SUBMIT"}
                                  onClick={(e) => {
                                    if (!isShoppingItemEdit) {
                                      handleSubmitPurchase(e);
                                    } else {
                                      handleUpdatePurchase(e);
                                    }
                                  }}
                                  isLoading={purchaseLoading}
                                  loadingMessage={"Loading..."}
                                  style={{
                                    width: '100%',
                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                    border: '2px solid rgba(255, 154, 32, 1)',
                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                  }}
                                />

                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Tab 5 Measuring */}
                {tabOpen == 5 && (
                  <>
                    <div
                      className="row d-flex justify-content-start"
                      style={{ flex: "1" }}>
                      <div className="row">
                        <div>
                          <span
                            className="fs-5 d-flex justify-content-between  p-3 font-w700 text-black bg-white"
                            style={{
                              borderBottom: "1px solid gray",
                            }}
                          >
                            {"Measuring controls"}
                            <div>


                              <span
                                className="text-hovered px-2 py-1 overlay-action-btn cursor-pointer rounded fs-6"
                                onClick={() => {

                                  const [localValue] = [
                                    ...room.localParticipant.dataTracks.values(),
                                  ];

                                  localValue?.track.send("3d_clear");
                                }}
                              >
                                {'Clear all'}
                              </span>
                            </div>
                          </span>

                          <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', height: 'calc(100% - 50px)' }}>
                            <div className="row ">
                              <div className="col p-3">
                                <div className="row mt-4 ">
                                  <PrimaryButton
                                    onClick={() => {
                                      if (!measuringStatus) {
                                        setShowMeasureGif(true)
                                        dispatch(drawActive());
                                        const [localValue] = [
                                          ...room.localParticipant.dataTracks.values(),
                                        ];

                                        localValue?.track.send("start_measuring");
                                      }
                                    }}
                                    style={{
                                      background: !measuringStatus
                                        ? "green"
                                        : "grey",
                                      border: "none",
                                    }}
                                    buttonName={"Start measuring"}
                                  />
                                </div>
                                <div className="row mt-4 ">
                                  <PrimaryButton
                                    onClick={() => {
                                      dispatch(drawActive());
                                      const [localValue] = [
                                        ...room.localParticipant.dataTracks.values(),
                                      ];

                                      localValue?.track.send("add_point");
                                    }}
                                    style={{
                                      background: "black",
                                      border: "none",
                                    }}
                                    buttonName={"Add Point"}
                                  />
                                </div>
                                <div className="row mt-2 ">
                                  <PrimaryButton
                                    onClick={() => {
                                      setMeasuringStatus(false);
                                      dispatch(drawDisable());
                                      const [localValue] = [
                                        ...room.localParticipant.dataTracks.values(),
                                      ];

                                      localValue?.track.send("end_measuring");
                                    }}
                                    style={{ background: "red", border: "none" }}
                                    buttonName={"End measuring"}
                                  />
                                </div>

                              </div>
                            </div>
                            <div className="row d-flex align-items-end">
                              <div className="row">
                                <div className="row p-3">
                                  <span
                                    className="fs-7 text-black">
                                    {/* Customer video stops while drawing */}
                                  </span>
                                </div>

                                <>
                                  <div
                                    className="col-12 py-3 d-flex justify-content-center align-items-center pointer"
                                    style={{
                                      // background: "#565656",
                                      height: "48px",
                                      color: "white",
                                      width: '100%',
                                      border: 'none',
                                      background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                      boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                    }}
                                    onClick={() => {
                                      setScreenshotModal(true);
                                    }}>
                                    <span
                                      className="fs-6 d-flex justify-content-center align-items-center "
                                      style={{
                                        color: "white",
                                      }}
                                      onClick={() => {
                                        setScreenshotModal(true);
                                      }}
                                    >
                                      {isSavingScreen
                                        ? "SAVING... "
                                        : "SAVE TO NOTES"}
                                    </span>
                                  </div>
                                  {/* <div
                                  className="col-6 py-3 d-flex justify-content-center align-items-center pointer"
                                  style={{
                                    background: "#1FC758",
                                    height: "48px",
                                    color: "white",
                                  }}
                                  onClick={handleClearCanvas}>
                                  <span
                                    className="fs-6 d-flex justify-content-center align-items-center"
                                    style={{ color: "white" }}>
                                    Go live
                                  </span>
                                </div> */}
                                </>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Tab 6 Check-in home maintenance */}
                {tabOpen == 6 && (
                  <>
                    <div
                      className="row d-flex justify-content-start"
                      style={{ flex: "1" }}
                    >
                      <div className="row" style={{ position: "relative" }}>
                        <div className="">
                          <span
                            className="fs-5 d-flex  align-items-center p-3 bg-white text-black"
                            style={{
                              fontWeight: "700",
                              borderBottom: "1px solid gray",
                            }}
                          >
                            {toggleInspectionTab === 1 ?
                              <>
                                {`Home Check-Up`}
                              </> :
                              toggleInspectionTab === 2 ?
                                <>
                                  {toggleForDefineRoomList === 1 ?
                                    <>
                                      <span
                                        className="me-2 cursor-pointer text-hovered fs-3"
                                        onClick={() => { setToggleInspectionTab(1) }}
                                      >
                                        <i className="bi bi-arrow-left" />
                                      </span>
                                      <span>
                                        {`Define room list`}
                                      </span>
                                    </> :
                                    toggleForDefineRoomList === 2 ?
                                      <>
                                        {Object.keys(particularHomeAreaObj).length === 0 ?
                                          <>
                                            <span
                                              className="me-2 cursor-pointer text-hovered fs-3"
                                              onClick={() => {
                                                setToggleForDefineRoomList(1);
                                                handleClearRoomStates();
                                              }}
                                            >
                                              <i className="bi bi-arrow-left" />
                                            </span>
                                            <span>
                                              {`Room list`}
                                            </span>
                                          </> :
                                          <>
                                            <span>
                                              {`Check-Up`}
                                            </span>
                                          </>
                                        }
                                      </> :
                                      <></>
                                  }
                                </>
                                :
                                toggleInspectionTab === 3 ?
                                  <>
                                    {toggleCheckUpResultAndMaintenancePlan === 1 ?
                                      <>
                                        <span
                                          className="me-2 cursor-pointer text-hovered fs-3"
                                          onClick={() => { setToggleInspectionTab(1) }}
                                        >
                                          <i className="bi bi-arrow-left" />
                                        </span>
                                        <span>
                                          {`Check-Up results`}
                                        </span>
                                      </> :
                                      toggleCheckUpResultAndMaintenancePlan === 2 ?
                                        <>
                                          <span
                                            className="me-2 cursor-pointer text-hovered fs-3"
                                            onClick={() => { setToggleCheckUpResultAndMaintenancePlan(1) }}
                                          >
                                            <i className="bi bi-arrow-left" />
                                          </span>
                                          <span>
                                            {`Maintenance Tasks`}
                                          </span>
                                        </> :
                                        <></>
                                    }
                                  </> : <></>
                            }

                            {/* <OverlayTrigger
                              trigger="click"
                              placement="bottom"
                              overlay={popoverShopping}
                              rootClose={true}
                              show={showPopoverShopping}
                              onToggle={(isOpen) =>
                                setShowPopoverShopping(isOpen)
                              }> */}
                            <span>
                              {/* <LuMoreVertical className="cursor-pointer" /> */}
                            </span>
                            {/* </OverlayTrigger> */}
                          </span>

                          {toggleInspectionTab === 1 ?
                            <>
                              <div
                                className="row "
                                style={{
                                  background: "rgba(235, 240, 250, 1)",
                                  // height: "calc(100dvh - 140px)",
                                }}
                              >
                                <div
                                  className="col-12 py-3 px-2 "
                                  style={{
                                    // maxHeight: "550px",
                                    // minHeight: "450px",
                                    overflow: "auto",
                                    height: "calc(100dvh - 125px)",
                                  }}
                                >
                                  <div className="row mx-0">
                                    <div className="col-12 px-2 pb-2 border-bottom ">
                                      <span>
                                        {`A check-up helps the Customer maintain their home inventory and avoid costly future repairs`}
                                      </span>
                                    </div>
                                  </div>



                                  <div className="row mx-0 my-3">
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                      <img src={houseImg} alt="logo" style={{ height: '90px', width: '90px' }} />
                                    </div>
                                  </div>

                                  <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                      <span className="font-w700 text-center text-black">
                                        {'What would you like to do now?'}
                                      </span>
                                    </div>
                                  </div>

                                  {itemListCount > 0 &&
                                    <div className="row mx-0 mb-2 ">
                                      <div
                                        className="col-12 p-2 bg-white rounded-2 shadow-lg cursor-pointer d-flex align-items-center"
                                        onClick={() => { setToggleInspectionTab(3) }}
                                      >
                                        <div className="me-2">
                                          <img src={checkUpResultImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                        </div>
                                        <div className="d-flex  flex-column">
                                          <span className="font-w600 text-black">
                                            {`View check-up results`}
                                          </span>

                                          <span className="fs-7 font-w500">
                                            {`You can review your current item conditions at any time`}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                                    <div className="row mx-0 mb-2 ">
                                      <div
                                        className="col-12 p-2 bg-white rounded-2 shadow-lg cursor-pointer d-flex align-items-center"
                                        onClick={() => { setToggleInspectionTab(2) }}
                                      >
                                        <div className="me-2">
                                          <img src={proInspectorImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                        </div>
                                        <div className="d-flex  flex-column">
                                          <span className=" font-w600 text-black">
                                            {`Start Home Check-Up`}
                                          </span>

                                          <span className="fs-7 font-w500">
                                            {`Guide a Customer through each step, collecting info, item condition and recommended maintenance tasks`}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  }

                                  {permissionArray.includes("SCAN TAB") &&
                                    <div className="row mx-0 mb-2 ">
                                      <div
                                        className="col-12 p-3 bg-white rounded-2 shadow-lg cursor-pointer d-flex align-items-center"
                                        onClick={() => { setToggleInspectionTab(2) }}
                                      >
                                        <div className="me-2">
                                          <img src={proInspectorImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                        </div>
                                        <div className="d-flex flex-column">
                                          <span className=" font-w600 text-black">
                                            {`See room list`}
                                          </span>

                                          <span className="fs-7 font-w500">
                                            {`You will go through each room`}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>

                            </> :
                            toggleInspectionTab === 2 ?
                              <div
                                className="row "
                                style={{
                                  background: "rgba(235, 240, 250, 1)",
                                  // height: "calc(100dvh - 140px)",
                                }}
                              >
                                <div
                                  className="col-12 py-3 px-2 "
                                  style={{
                                    // maxHeight: "550px",
                                    // minHeight: "450px",
                                    overflow: "auto",
                                    height: "calc(100dvh - 140px)",
                                  }}
                                >

                                  {toggleForDefineRoomList === 1 ?
                                    <>
                                      <div className="row mx-0">
                                        <div className="col-12 px-0">
                                          <div className="row mx-0">
                                            <div className="col-12 px-0 border-bottom pb-3">
                                              <span>{`Set up which rooms you would like to review`}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="row mx-0">
                                        <div className="col-12 px-0 mt-3" style={{ marginBottom: '30px' }}>
                                          {refAreaListNewDesign.length > 0 ?
                                            <>
                                              {refAreaListNewDesign.map((element, index) => {
                                                return (
                                                  <>
                                                    <div className="row  mx-1 mb-2  rounded-2"
                                                      style={{
                                                        // boxShadow: '0px 0px 3px #a8a4a4',
                                                        opacity: roomsLoading ? '0.5' : '1',
                                                        pointerEvents: roomsLoading ? 'none' : 'auto',
                                                      }}
                                                      key={index}
                                                    >
                                                      <div className="col-12 px-0">
                                                        <div
                                                          className={`d-flex align-items-center justify-content-between w-100 p-2 fs-6 font-w700 text-black cursor-pointer`}
                                                          onClick={() => {
                                                            if (element?.ref_area_id_ids === isExpandedForAddRoom) {
                                                              setIsExpandedForAddRoom('')
                                                            } else {
                                                              setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                            }
                                                            setRefAreaId(element?.ref_area_id_ids);
                                                          }}
                                                        >
                                                          <div className="d-flex align-items-center justify-content-center">
                                                            <div
                                                              className="me-2 rounded d-flex align-items-center justify-content-center border"
                                                              style={{ background: 'rgba(79, 93, 116, 1)', width: '25px', height: '25px' }}
                                                            >
                                                              <img
                                                                src={element?.ref_icon_url}
                                                                alt=""
                                                                className="rounded border"
                                                                style={{ width: "25px", height: "25px", background: 'rgba(79, 93, 116, 1)' }}
                                                              />
                                                            </div>
                                                            <div
                                                              style={{
                                                                color: 'rgba(131, 154, 192, 1)',
                                                                opacity: element?.home_area_count !== 0 ? '1' : '0.7',

                                                              }}
                                                            >
                                                              <span className="fs-7">{`${element?.ref_display_area_name_chr}`}</span>
                                                            </div>
                                                          </div>
                                                          <div className="d-flex align-items-center justify-content-center">
                                                            <div className="me-2">
                                                              <span
                                                                className="text-hovered border-hovered cursor-pointer border rounded p-1"
                                                                style={{
                                                                  pointerEvents: element?.home_area_count == 0 ? 'none' : 'auto',
                                                                  opacity: element?.home_area_count == 0 ? '0.5' : '1',
                                                                }}
                                                                onClick={(e) => {
                                                                  e.stopPropagation()
                                                                  handleDeleteNewHomeAreaFn(element?.home_area_list[element?.home_area_list.length - 1]);
                                                                  setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                                }}
                                                              >
                                                                <i className="bi bi-dash-lg"></i>
                                                              </span>
                                                            </div>
                                                            <div className="me-2 d-flex align-items-center justify-content-center" style={{ width: '15px' }}>
                                                              {`${element?.home_area_count}`}
                                                            </div>
                                                            <div>
                                                              <span
                                                                className="text-hovered border-hovered cursor-pointer border rounded p-1"
                                                                onClick={(e) => {
                                                                  // setRoomTypeName(`${element?.ref_display_area_name_chr} #${element?.home_area_count + 1}`)
                                                                  // setRefAreaId(element?.ref_area_id_ids);
                                                                  e.stopPropagation()
                                                                  handleAddRoom(element)
                                                                  setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                                }}
                                                              >
                                                                <i className="bi bi-plus-lg"></i>
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div
                                                          className="bg-white rounded-2"
                                                          style={{
                                                            boxShadow: '0px 0px 3px #a8a4a4',
                                                          }}
                                                        >
                                                          {element?.ref_area_id_ids === isExpandedForAddRoom &&
                                                            <>
                                                              {element?.home_area_list?.map((item, ind) => {
                                                                return (
                                                                  <>
                                                                    <div
                                                                      className={`row  mx-0 p-2 pt-3 d-flex align-items-baseline ${(ind !== element?.home_area_list?.length - 1) && 'border-bottom'}`}
                                                                      key={ind}
                                                                    >
                                                                      <div className="col-9 px-0 d-flex align-items-center justify-content-center pe-2">
                                                                        <div className="w-100">
                                                                          <InputField
                                                                            labelName={"Room name"}
                                                                            // value={roomTypeName}
                                                                            value={`${item?.area_id_ids !== isEditForRoomName ? item?.area_name_chr : roomTypeName}`}
                                                                            onChange={(e) => { handleChangeRoomName(e) }}
                                                                            onBlur={handleBlurCheckRoomName}
                                                                            errorOccured={isRoomTypeNameErr && item?.area_id_ids == isEditForRoomName}
                                                                            errorMeesage={"Enter valid room name"}
                                                                            disabled={item?.area_id_ids !== isEditForRoomName ? true : false}
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                      <div className="col-3 px-0 d-flex align-items-center justify-content-evenly fs-6 ps-2">
                                                                        {item?.area_id_ids !== isEditForRoomName ?
                                                                          <>
                                                                            <span className="pe-2">
                                                                              <i
                                                                                className="bi bi-pencil-fill text-hovered cursor-pointer"
                                                                                onClick={(e) => {
                                                                                  e.stopPropagation();
                                                                                  setIsEditForRoomName(item?.area_id_ids);
                                                                                  setAreaId(item?.area_id_ids);
                                                                                  setRoomTypeName(item?.area_name_chr);
                                                                                  isRoomTypeNameErr && setIsRoomTypeNameErr(false);
                                                                                }}
                                                                              ></i>
                                                                            </span>

                                                                            <span>
                                                                              <i
                                                                                className="bi bi-trash text-hovered cursor-pointer"

                                                                                onClick={(e) => {
                                                                                  e.stopPropagation();
                                                                                  handleDeleteNewHomeAreaFn(item);
                                                                                }}
                                                                              ></i>
                                                                            </span>
                                                                          </> :
                                                                          <>
                                                                            <span
                                                                              className="px-2 py-1 text-hovered cursor-pointer overlay-action-btn rounded font-w600"
                                                                              onClick={() => {
                                                                                handleAddRoom(item)
                                                                              }}
                                                                            >
                                                                              {`Save`}
                                                                            </span>
                                                                          </>
                                                                        }
                                                                      </div>
                                                                    </div>
                                                                  </>
                                                                )
                                                              })

                                                              }
                                                            </>
                                                          }
                                                        </div>


                                                      </div>
                                                    </div>
                                                  </>
                                                )
                                              })}
                                            </> :
                                            <>
                                              <div className="mt-1 mb-3 d-flex justify-content-center align-items-center flex-column">

                                                <div className="mb-2">
                                                  <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                </div>
                                                <span>
                                                  {`No rooms available`}
                                                </span>
                                              </div>
                                            </>
                                          }
                                        </div>
                                      </div>

                                    </> :
                                    <>
                                      {Object.keys(particularHomeAreaObj).length === 0 ?
                                        <>
                                          {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                                            <div className="row mx-0">
                                              <div className="col-12 px-0">
                                                <div className="row mx-0">
                                                  <div className="col-12 px-0 pb-3">
                                                    <span>{`Guide the Customer to each room, collect information about the inventory items, determine their condition and keep track of maintenance actions.`}</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          }

                                          <div className="row mx-0">
                                            <div className="col-12 px-0">
                                              <div className="row mx-0">
                                                <div className="col-12 px-0 border-bottom border-top px-2 py-3 d-flex align-items-center justify-content-between">
                                                  <div>
                                                    <span className="font-w700 pe-2 text-black">{`${myRooms.length}`}</span>
                                                    <span>{`rooms`}</span>
                                                  </div>

                                                  <div
                                                    className="text-hovered cursor-pointer font-w600"
                                                    onClick={() => {
                                                      setToggleForDefineRoomList(1);
                                                      handleClearRoomStates();
                                                    }}
                                                  >
                                                    <span className="pe-2">{`Define room list`}</span>
                                                    <i className="bi bi-pencil" />
                                                  </div>

                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="row mx-0">
                                            <div className="col-12 px-0 mt-3" style={{ marginBottom: '30px' }}>

                                              {myRooms.length > 0 ?
                                                <>
                                                  {myRooms.map((element, index) => {
                                                    return (
                                                      <>
                                                        <div
                                                          className="row cursor-pointer overlay-action-btn mb-1 py-2 rounded"
                                                          onClick={() => {
                                                            setParticularHomeAreaObj(element);
                                                            setAreaId(element.area_id_ids);
                                                          }}
                                                        >
                                                          <div className={`col-12 d-flex font-w600 `}>
                                                            <div className="d-flex align-items-center justify-content-between w-100">
                                                              <div className="me-2 text-black d-flex align-items-center">
                                                                <span
                                                                  className="me-2 p-2 border rounded bg-dark shadow-lg text-white"
                                                                >
                                                                  <i
                                                                    class="bi bi-cloud-hail-fill"
                                                                    style={{ height: '20px', width: '20px' }}
                                                                  ></i>
                                                                </span>
                                                                <span
                                                                  className="overflow-hidden text-nowrap"
                                                                  style={{ width: '120px', textOverflow: 'ellipsis' }}
                                                                  title={`${element?.display_area_name_chr}`}
                                                                >
                                                                  {`${element?.display_area_name_chr}`}
                                                                </span>
                                                              </div>

                                                              <div className="text-black d-flex align-items-center">
                                                                {element?.item_count ?
                                                                  <span
                                                                    className="px-2 py-1 fs-7 text-white rounded-circle d-flex align-items-center justify-content-center font-w500 me-2 shadow"
                                                                    style={{
                                                                      background: 'rgba(131, 154, 192, 1)',
                                                                    }}
                                                                  >
                                                                    {`${element?.item_count}`}
                                                                  </span> : ''
                                                                }

                                                                <span>
                                                                  {
                                                                    <i class="bi bi-chevron-right ms-2 rounded px-1"></i>
                                                                  }
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    )
                                                  })}
                                                </> :

                                                <div className="row mx-0">
                                                  <div className="col-12">
                                                    <>
                                                      <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                                        <div className="mb-2">
                                                          <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                        </div>
                                                        <span>
                                                          {`No rooms added`}
                                                        </span>
                                                      </div>
                                                    </>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </> :
                                        <>
                                          {
                                            <>
                                              <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                  <div className="row mx-0">
                                                    <div className="col-12 px-0 pb-3">
                                                      <span>{`Add and view each item in every room to collect information about them and check their condition`}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                className="row mb-1 py-2 border-bottom border-top"
                                              >
                                                <div className={`col-12 d-flex font-w600`}>
                                                  <div className="d-flex align-items-center w-100">
                                                    <div
                                                      className="align-items-center cursor-pointer d-flex fs-3 me-4 ms-2 text-black text-hovered"
                                                      onClick={() => {
                                                        setParticularHomeAreaObj({});
                                                        setIsExpandedForProduct('');
                                                        setToggleAddItems(false);
                                                        setHomeAreaProductId("");
                                                        setIndividualProductObj({});
                                                      }}
                                                    >
                                                      <span>
                                                        <i className="bi bi-arrow-left" />
                                                      </span>
                                                    </div>
                                                    <div className="me-2 text-black d-flex align-items-center">
                                                      <span
                                                        className="me-2 p-2 border rounded bg-dark shadow-lg text-white"
                                                      >
                                                        <i
                                                          class="bi bi-cloud-hail-fill"
                                                          style={{ height: '20px', width: '20px' }}
                                                        ></i>
                                                      </span>
                                                      <span
                                                        className="overflow-hidden text-nowrap"
                                                        style={{ width: '120px', textOverflow: 'ellipsis' }}
                                                        title={`${particularHomeAreaObj?.display_area_name_chr}`}
                                                      >
                                                        {`${particularHomeAreaObj?.display_area_name_chr}`}
                                                      </span>
                                                    </div>

                                                  </div>
                                                </div>
                                              </div>

                                              {particularHomeAreaObj?.item_list?.length > 0 ?
                                                <>
                                                  {particularHomeAreaObj?.item_list?.map((item, ind) => {
                                                    return (
                                                      <>
                                                        <div
                                                          className="row border-bottom"
                                                          key={ind}
                                                        >
                                                          <div className="col-12 px-0">
                                                            <div

                                                              className="row cursor-pointer overlay-action-btn py-2 "
                                                              onClick={() => {
                                                                if (item?.home_area_product_id_ids === isExpandedForProduct) {
                                                                  setIsExpandedForProduct('')
                                                                  setHomeAreaProductId("");

                                                                } else {
                                                                  setIsExpandedForProduct(item?.home_area_product_id_ids)

                                                                  if (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                                                    var inspectionObj = {
                                                                      type: 'inspection',
                                                                      message: `${item?.product_name_chr} is beign checking now`,
                                                                      productDetails: item,
                                                                    }

                                                                    const [localValue] = [...room.localParticipant.dataTracks.values()];

                                                                    localValue.track.send(JSON.stringify(inspectionObj));
                                                                  }
                                                                }
                                                              }}
                                                            >
                                                              <div className={`col-12 d-flex font-w600 `}>
                                                                <div className="d-flex align-items-center justify-content-between w-100">
                                                                  <div className="me-2 text-black d-flex align-items-center">
                                                                    <span
                                                                      className="me-2 p-2 rounded bg-white shadow-lg text-black"
                                                                    >
                                                                      <i
                                                                        class="bi bi-cloud-hail-fill"
                                                                        style={{ height: '20px', width: '20px' }}
                                                                      ></i>
                                                                    </span>
                                                                    <div className="d-flex flex-column">
                                                                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && item?.home_area_product_id_ids === isExpandedForProduct ?
                                                                        <span className="text-success font-w600 fs-7">
                                                                          {`Checking now`}
                                                                        </span> : ''
                                                                      }
                                                                      <span
                                                                        className="overflow-hidden text-nowrap"
                                                                        style={{ width: '120px', textOverflow: 'ellipsis' }}
                                                                        title={`${item?.product_name_chr}`}
                                                                      >
                                                                        {`${item?.product_name_chr}`}
                                                                      </span>
                                                                    </div>

                                                                  </div>


                                                                  <div
                                                                    className="text-black fs-4 text-hovered overlay-action-btn rounded-circle d-flex align-items-center justify-content-center cursor-pointer"
                                                                  >
                                                                    <span>
                                                                      <span>
                                                                        <OverlayTrigger
                                                                          key={ind}
                                                                          trigger="click"
                                                                          placement="bottom"
                                                                          // overlay={popover}
                                                                          overlay={popoverInventoryActions(ind)}
                                                                          rootClose={true}
                                                                          show={activePopover === ind}
                                                                          onToggle={(show) => setActivePopover(show ? ind : null)}
                                                                        >
                                                                          <i onClick={(e) => { e.stopPropagation(); handleMenuClick(item, ind) }} class="bi bi-three-dots-vertical px-1"></i>
                                                                        </OverlayTrigger>
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>

                                                            {item?.home_area_product_id_ids === isExpandedForProduct &&
                                                              <div className="row mb-2 bg-white rounded-2 shadow-sm">
                                                                <div className="col-12 p-1 fs-7">
                                                                  <div className="row mx-1 pb-1 pt-2 px-3 d-flex align-items-center">
                                                                    <div className="col-4 pe-2  font-w500">
                                                                      <span>{`Condition`}</span>
                                                                    </div>
                                                                    <div className="col-8 d-flex">
                                                                      <span
                                                                        className="text-white rounded-pill p-1 px-3"
                                                                        style={{
                                                                          background:
                                                                            `${item?.condition_chr === "Good" ? "rgba(45, 204, 99, 1)" :
                                                                              item?.condition_chr === "Ok" ? "rgba(255, 154, 32, 1)" :
                                                                                item?.condition_chr === "Poor" ? "rgba(240, 72, 72, 1)" :
                                                                                  item?.condition_chr === "Not assessed" ? "rgba(131, 154, 192, 1)" : ''}`,
                                                                        }}
                                                                      >
                                                                        {`${item?.condition_chr}`}
                                                                      </span>
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mx-1 py-2 px-3 border-bottom  d-flex align-items-center">
                                                                    <div className="col-4 pe-2  font-w500">
                                                                      <span>{`Updated`}</span>
                                                                    </div>
                                                                    <div className="col-8">
                                                                      <span className="text-black font-w600 p-1 px-2">{`${formatUnixTimestamp(item?.updated_date_dtm)}`}</span>
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                    <div className="col-4 pe-2 font-w500">
                                                                      <span>{`Brand`}</span>
                                                                    </div>
                                                                    <div className="col-8">
                                                                      <span className={`${item?.device_brand_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.device_brand_chr ? item?.device_brand_chr : '-'}`}</span>
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                    <div className="col-4 pe-2 font-w500">
                                                                      <span>{`Model`}</span>
                                                                    </div>
                                                                    <div className="col-8">
                                                                      <span className={`${item?.model_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.model_number_chr ? item?.model_number_chr : '-'}`}</span>
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                    <div className="col-4 pe-2 font-w500">
                                                                      <span>{`Serial number`}</span>
                                                                    </div>
                                                                    <div className="col-8">
                                                                      <span className={`${item?.serial_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.serial_number_chr ? item?.serial_number_chr : '-'}`}</span>
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                    <div className="col-4 pe-2 font-w500">
                                                                      <span>{`Description`}</span>
                                                                    </div>
                                                                    <div className="col-8">
                                                                      <span className={`${item?.description_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.description_chr ? item?.description_chr : '-'}`}</span>
                                                                    </div>
                                                                  </div>

                                                                  {item?.image_url &&
                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                      <div className="col-12">
                                                                        <img
                                                                          src={item?.image_url}
                                                                          alt="Attachment"
                                                                          className="rounded-2 shadow-lg cursor-pointer"
                                                                          onClick={(e) => {
                                                                            handleOpenDoc(); setImageAttachURL(item?.image_url);
                                                                          }}
                                                                          style={{
                                                                            height: '60px',
                                                                            width: '60px',
                                                                            border: '1px solid orange'
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  }

                                                                  {item?.maintenance_plan?.length > 0 &&
                                                                    <div
                                                                      className="row mx-0 py-2 font-w700 d-flex border-top"
                                                                      style={{
                                                                        background: 'rgb(199 212 234 / 30%)',
                                                                        // pointerEvents: 'none',
                                                                        // opacity: '0.5',
                                                                      }}
                                                                    >
                                                                      {item?.maintenance_plan?.map((data, i) => {
                                                                        return (
                                                                          <div
                                                                            className={`bg-white mb-1 ${data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan && 'shadow'} rounded `}
                                                                            style={{ margin: '0' }}
                                                                          >
                                                                            <div
                                                                              className="row mx-1  py-2 px-1 fs-7 d-flex align-items-center"
                                                                            >
                                                                              <div
                                                                                className="row mx-0  cursor-pointer"
                                                                                onClick={() => {
                                                                                  if (data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan) {
                                                                                    setIsExpandedForMaintenancePlan('')
                                                                                  } else {
                                                                                    setIsExpandedForMaintenancePlan(data.maintenance_plan_id_ids)
                                                                                  }
                                                                                }}
                                                                              >
                                                                                <div className="col-4 pe-2 font-w500">
                                                                                  <span>{`Maintenance`}</span>
                                                                                </div>
                                                                                <div className="col-8 d-flex align-items-center justify-content-between">
                                                                                  <span className={`${data?.period_name_chr && 'text-black'} font-w600 p-1 px-2`}>{`${data?.period_name_chr ? `In ${data?.period_name_chr}` : '-'}`}</span>
                                                                                  <span>
                                                                                    {data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan ?
                                                                                      <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i> :
                                                                                      <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i>
                                                                                    }
                                                                                  </span>
                                                                                </div>
                                                                              </div>

                                                                              {data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan &&
                                                                                <>
                                                                                  <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                    <div className="col-4 pe-2 font-w500">
                                                                                      <span>{`Instruction`}</span>
                                                                                    </div>
                                                                                    <div className="col-8">
                                                                                      <span className={`${data?.instruction_chr && 'text-black'} font-w600 p-1 px-2`}>{`${data?.instruction_chr ? `${data?.instruction_chr}` : '-'}`}</span>
                                                                                    </div>
                                                                                  </div>

                                                                                  <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                    <div className="col-4 pe-2 font-w500">
                                                                                      <span>{`Frequency`}</span>
                                                                                    </div>
                                                                                    <div className="col-8">
                                                                                      <span className={`${data?.frequency_int && 'text-black'} font-w600 p-1 px-2`}>{`${data?.frequency_int ? `${data?.frequency_int} times in a ${data?.period_name_chr}` : '-'}`}</span>
                                                                                    </div>
                                                                                  </div>


                                                                                  <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                    <div className="col-4 pe-2 font-w500">
                                                                                      <span>{`Link`}</span>
                                                                                    </div>
                                                                                    <div className="col-8">
                                                                                      {data?.purchase_link ?
                                                                                        <a
                                                                                          className="text-hovered text-gray-800"
                                                                                          href={`${data?.purchase_link}`}
                                                                                          target="_blank"
                                                                                          rel="noreferrer"
                                                                                        >
                                                                                          <span className={`font-w600 p-1 px-2`}>{`Purchase link`} <i className="bi bi-chevron-right me-2"></i> </span>
                                                                                        </a> :
                                                                                        <span className={`font-w600 p-1 px-2`}>{`-`} </span>
                                                                                      }
                                                                                    </div>
                                                                                  </div>

                                                                                </>
                                                                              }

                                                                            </div>
                                                                          </div>
                                                                        )
                                                                      })}
                                                                    </div>
                                                                  }

                                                                  <div
                                                                    className={`row mx-0 py-2 font-w700 d-flex align-items-center border-top ${item?.home_area_product_id_ids !== isExpandedForAddMaintenance && "rounded-bottom"} cursor-pointer text-hovered overlay-action-btn`}
                                                                    style={{
                                                                      background: 'rgb(199 212 234 / 30%)',
                                                                      // pointerEvents: 'none',
                                                                      // opacity: '0.5',
                                                                    }}
                                                                    onClick={() => {
                                                                      if (item?.home_area_product_id_ids === isExpandedForAddMaintenance) {
                                                                        setIsExpandedForAddMaintenance('')
                                                                      } else {
                                                                        setIsExpandedForAddMaintenance(item.home_area_product_id_ids)
                                                                        clearMaintenancePlanStates();
                                                                      }
                                                                      setHomeAreaProductId(item?.home_area_product_id_ids);
                                                                    }}
                                                                  >
                                                                    <div
                                                                      className={`col-12 d-flex ${item?.home_area_product_id_ids === isExpandedForAddMaintenance ? 'justify-content-around' : 'justify-content-center'} align-items-center`}>
                                                                      <div>
                                                                        <span>{`Add maintenance plan`}</span>
                                                                        <span>
                                                                          <i className="bi bi-plus-circle ms-2"></i>
                                                                        </span>
                                                                      </div>

                                                                      {item?.home_area_product_id_ids === isExpandedForAddMaintenance &&
                                                                        <div
                                                                          onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setIsExpandedForAddMaintenance('');
                                                                            setHomeAreaProductId("");
                                                                            clearMaintenancePlanStates();
                                                                          }}
                                                                        >
                                                                          <i className="bi bi-x-lg ms-2"></i>
                                                                        </div>
                                                                      }

                                                                    </div>
                                                                  </div>

                                                                  {item?.home_area_product_id_ids === isExpandedForAddMaintenance &&
                                                                    <div
                                                                      className="row mx-0 py-2 font-w700 d-flex align-items-center  "
                                                                      style={{
                                                                        // background: 'rgb(199 212 234 / 30%)',
                                                                        // pointerEvents: 'none',
                                                                        // opacity: '0.5',
                                                                      }}
                                                                    >
                                                                      <div className="col-12 p-2">
                                                                        <div className="row mx-0">
                                                                          <div className="col-12 px-0">
                                                                            <InputField
                                                                              labelName={"Instruction"}
                                                                              value={instruction}
                                                                              onChange={(e) => { handleChangeInstruction(e) }}
                                                                              onBlur={() => { handleBlurCheckInstrction() }}
                                                                              errorOccured={isInstructionErr}
                                                                              errorMeesage={"Please enter instructions"}
                                                                            />
                                                                          </div>
                                                                        </div>

                                                                        {/* <div className="row mx-0">
                                                                  <div className="col-12 px-0">
                                                                    <span className="font-w600 text-black">{`Every`}</span>
                                                                  </div>
                                                                </div> */}

                                                                        <div className="row mx-0">
                                                                          <div className="col-12 px-0">
                                                                            <div className="row mx-0">
                                                                              <div className="col-5 pe-2">

                                                                                <SelectInputFrequency
                                                                                  labelName={"Times"}
                                                                                  onChange={(e) => handleChangeFreq(e)}
                                                                                  defaultValue={frequency}
                                                                                  options={frequencyArr}
                                                                                  errorOccured={isFrequencyErr}
                                                                                  errorMessage={"Please select frequency"}
                                                                                />

                                                                              </div>
                                                                              <div className="col-7 px-0">
                                                                                <SelectInputPeriod
                                                                                  labelName={"Period"}
                                                                                  onChange={(e) => handleChangePeriod(e)}
                                                                                  defaultValue={period}
                                                                                  options={periodListArr}
                                                                                  errorOccured={isPeriodErr}
                                                                                  errorMessage={"Please select period"}
                                                                                />
                                                                              </div>

                                                                            </div>
                                                                          </div>
                                                                        </div>

                                                                        <div className="row mx-0">
                                                                          <div className="col-12 px-0">
                                                                            <InputField
                                                                              labelName={"Purchase link (optional)"}
                                                                              value={purchaseLinkHome}
                                                                              onChange={(e) => { handleChangePurchaseLink(e) }}
                                                                              onBlur={() => { }}
                                                                              errorOccured={false}
                                                                              errorMeesage={"Please enter purchase link"}
                                                                            />
                                                                          </div>
                                                                        </div>

                                                                        <div className="row mx-0">
                                                                          <div className="col-12 px-0">
                                                                            <PrimaryButton
                                                                              buttonName={"SUBMIT"}
                                                                              onClick={() => { addUpdateMaintenancePlanFn() }}
                                                                              isLoading={maintenancePlanLoading}
                                                                              loadingMessage={"Loading..."}
                                                                              style={{
                                                                                width: '100%',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                              }}
                                                                            />
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  }

                                                                </div>
                                                              </div>
                                                            }

                                                          </div>
                                                        </div>





                                                      </>
                                                    )
                                                  })}
                                                </> :
                                                <div className="row mx-0">
                                                  <div className="col-12">
                                                    <>
                                                      <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                                        <div className="mb-2">
                                                          <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                        </div>
                                                        <span>
                                                          {`No inventory items added yet`}
                                                        </span>
                                                      </div>
                                                    </>
                                                  </div>
                                                </div>
                                              }

                                            </>
                                          }
                                        </>
                                      }
                                    </>
                                  }

                                </div>
                              </div> :
                              toggleInspectionTab === 3 ?
                                <>
                                  {toggleCheckUpResultAndMaintenancePlan === 1 ?
                                    <>
                                      <div
                                        className="row "
                                        style={{
                                          background: "rgba(235, 240, 250, 1)",
                                          // height: "calc(100dvh - 140px)",
                                        }}
                                      >
                                        <div
                                          className="col-12 py-3 px-2 "
                                          style={{
                                            // maxHeight: "550px",
                                            // minHeight: "450px",
                                            overflow: "auto",
                                            height: "calc(100dvh - 130px)",
                                          }}
                                        >
                                          <div className="row mx-0">
                                            <div className="col-12 px-2 pb-2 ">
                                              <span>
                                                {`Review the check-up results to know everything about the current condition of your inventory items and the upcoming maintenance tasks`}
                                              </span>
                                            </div>
                                          </div>

                                          <div className="row mx-0 my-2 ">
                                            <div className='col-12 p-1 bg-white rounded-2 shadow-lg'>
                                              <div className='row mx-0'>
                                                <div className='col-12 p-2 d-flex justify-content-center align-items-center'>
                                                  <span className='fs-7 font-w600'>
                                                    {`Maintenance Tasks`}
                                                  </span>
                                                </div>
                                              </div>

                                              <div className='row mx-0'>
                                                <div
                                                  className='border-3 border-right col-6'
                                                  style={{ borderColor: '#e7e1e1' }}
                                                >
                                                  <div className='row mx-0'>
                                                    <div
                                                      className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                      style={{ background: 'rgba(79, 93, 116, 1)', height: '46px' }}
                                                    >
                                                      <span className='fs-7 font-w600 text-white text-center'>
                                                        {`Total Tasks`}
                                                      </span>
                                                    </div>
                                                  </div>

                                                  <div className='row mx-0'>
                                                    <div
                                                      className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                      style={{}}
                                                    >
                                                      {Object.keys(maintenanceObj).length > 0 ?
                                                        <span className='fs-6 font-w600'>
                                                          {`${maintenanceObj?.total_count || 0}`}
                                                        </span> :
                                                        <Spinner size="md" />
                                                      }
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className='col-6'>
                                                  <div className='row mx-0'>
                                                    <div
                                                      className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                      style={{ background: 'rgba(79, 93, 116, 1)', height: '46px' }}
                                                    >
                                                      <span className='fs-7 font-w600 text-white text-center'>
                                                        {`Tasks in Next 30 days`}
                                                      </span>
                                                    </div>
                                                  </div>

                                                  <div className='row mx-0'>
                                                    <div
                                                      className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                      style={{}}
                                                    >
                                                      {Object.keys(maintenanceObj).length > 0 ?
                                                        <span className='fs-6 font-w600'>
                                                          {`${maintenanceObj?.home_maintenance_plan_in_30_days_count || 0}`}
                                                        </span> :
                                                        <Spinner size="md" />
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>


                                              <div className='row mx-0'>
                                                <div
                                                  onClick={() => { setToggleCheckUpResultAndMaintenancePlan(2) }}
                                                  className='col-12 p-1 d-flex justify-content-center align-items-center text-hovered cursor-pointer overlay-action-btn rounded-bottom'
                                                  style={{ background: 'rgba(244, 248, 255, 1)' }}
                                                >
                                                  <div>
                                                    <span className='fs-7 font-w600'>
                                                      {`View all`}
                                                    </span>
                                                    <span>
                                                      <i className='bi bi-chevron-right ps-2'></i>
                                                    </span>
                                                  </div>

                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className='row mx-0 mb-2'>
                                            <div className='col-12 px-0'>
                                              <span className='fs-7 font-w600'>
                                                {'Items conditions'}
                                              </span>
                                            </div>
                                          </div>

                                          <div className='row mx-0'>
                                            <div className='col-12 px-0'>

                                              <div className='row mx-0'>
                                                <div className='col-12 px-0 d-flex border-bottom overflow-auto'>

                                                  <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(4)}
                                                  >
                                                    <div
                                                      className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white '
                                                      style={{
                                                        background: 'rgba(79, 93, 116, 1)',
                                                        width: '50px'
                                                      }}
                                                    >
                                                      <span>{`All`}</span>
                                                    </div>
                                                    <div
                                                      className='d-flex justify-content-center align-items-center p-1 fs-6 w-100 font-w600'
                                                      style={{
                                                        background: checkUpTabsToggle === 4 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        color: checkUpTabsToggle === 4 ? "black" : '',
                                                      }}
                                                    >
                                                      <span>{checkupResultCompleteObj?.all_items_count || 0}</span>
                                                    </div>

                                                  </div>

                                                  <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(1)}
                                                  >
                                                    <div
                                                      className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                      style={{
                                                        background: 'rgba(45, 204, 99, 1)',
                                                        width: '50px'
                                                      }}
                                                    >
                                                      <span>{`Good`}</span>
                                                    </div>
                                                    <div
                                                      className='d-flex justify-content-center align-items-center p-1 fs-6 w-100 font-w600'
                                                      style={{
                                                        background: checkUpTabsToggle === 1 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        color: checkUpTabsToggle === 1 ? "black" : '',
                                                      }}
                                                    >
                                                      <div>
                                                        <span className='me-2'>
                                                          <IoCheckmarkCircleOutline />
                                                        </span>
                                                        <span>{checkupResultCompleteObj?.good_items_count}</span>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(2)}
                                                  >
                                                    <div
                                                      className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                      style={{
                                                        background: 'rgba(255, 154, 32, 1)',
                                                        width: '50px'
                                                      }}
                                                    >
                                                      <span>{`OK`}</span>
                                                    </div>
                                                    <div
                                                      className='d-flex justify-content-center align-items-center p-1 fs-6 w-100 font-w600'
                                                      style={{
                                                        background: checkUpTabsToggle === 2 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        color: checkUpTabsToggle === 2 ? "black" : '',
                                                      }}
                                                    >
                                                      <div>
                                                        <span className='me-2'>
                                                          <TiSpanner className='rounded-circle border border-2' />
                                                        </span>
                                                        <span>{checkupResultCompleteObj?.ok_items_count}</span>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div
                                                    className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                    onClick={() => handleCheckUpTabs(3)}
                                                  >
                                                    <div
                                                      className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                      style={{
                                                        background: 'rgba(240, 72, 72, 1)',
                                                        width: '50px'
                                                      }}
                                                    >
                                                      <span>{`Poor`}</span>
                                                    </div>
                                                    <div
                                                      className='d-flex justify-content-center align-items-center p-1 fs-6 w-100 font-w600'
                                                      style={{
                                                        background: checkUpTabsToggle === 3 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        color: checkUpTabsToggle === 3 ? "black" : '',
                                                      }}
                                                    >
                                                      <div>
                                                        <span className='me-2'>
                                                          <MdOutlineCancel />
                                                        </span>
                                                        <span>{checkupResultCompleteObj?.poor_items_count}</span>
                                                      </div>
                                                    </div>
                                                  </div>

                                                </div>
                                              </div>

                                              <div
                                                className="row  px-2 "
                                                style={{
                                                  backgroundColor: "rgba(251, 252, 255, 1)",
                                                }}
                                              >

                                                <div
                                                  className="row mx-0 my-1 align-items-center "
                                                  style={{ minHeight: "40px" }}
                                                >
                                                  <div className="col-12">
                                                    <div className="row">
                                                      <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                                                        <span className="fs-5 p-2 d-flex align-items-center">
                                                          <LuArrowUpDown
                                                            className="cursor-pointer"
                                                            style={{ marginRight: "4px", color: "black" }}
                                                            onClick={handleOpenFiltreBoxCheckUp}
                                                          />
                                                          <span
                                                            className="fs-7  cursor-pointer"
                                                            style={{ position: "relative" }}
                                                            onClick={handleOpenFiltreBoxCheckUp}
                                                          >
                                                            {/* {filtreValueCheckUp == 1 && "Date: Newset first"}
                                                                    {filtreValueCheckUp == 2 && "Date: Oldest first"} */}

                                                            &nbsp;
                                                            {/* {filtreBoxCheckUp ? <IoIosArrowUp /> : <IoIosArrowDown />} */}
                                                            <span
                                                              className={`${filtreBoxCheckUp ? "" : "d-none"} p-1`}
                                                              style={{
                                                                position: "absolute",
                                                                top: "26px",
                                                                width: "170px",
                                                                zIndex: 1,
                                                                border: "1px solid lightgray",
                                                                background: "white",
                                                                left: "-22px",
                                                                boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                              }}>
                                                              <div className="row">
                                                                <div
                                                                  className={`${filtreValueCheckUp == 1 ? "dt" : ""
                                                                    } d-flex justify-content-start m-1 pointer `}
                                                                  onClick={() => {
                                                                    handleSetFiltreValueCheckUp(1);
                                                                  }}>
                                                                  <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                    {filtreValueCheckUp == 1 && <i className="bi bi-check-lg"></i>}
                                                                  </div>
                                                                  Date: Newest first
                                                                </div>
                                                                <div
                                                                  className={`${filtreValueCheckUp == 2 ? "dt" : ""
                                                                    } d-flex justify-content-start m-1 pointer`}
                                                                  onClick={() => {
                                                                    handleSetFiltreValueCheckUp(2);
                                                                  }}>
                                                                  <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                    {filtreValueCheckUp == 2 && <i className="bi bi-check-lg"></i>}
                                                                  </div>
                                                                  Date: Oldest first
                                                                </div>

                                                              </div>
                                                            </span>
                                                          </span>
                                                        </span>

                                                        <span
                                                          className="fs-6 p-2 d-flex align-items-center"
                                                          style={{
                                                            border: "1px solid lightgray",
                                                            borderRadius: "6px",
                                                          }}>
                                                          <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                                          <input
                                                            placeholder="Search"
                                                            style={{ border: "0px", width: "100%" }}
                                                            onChange={handleSearchCheckUp}
                                                            value={searchValueCheckUp}
                                                          />
                                                        </span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>


                                              <div className='row mx-0 mb-3'>
                                                <div className='col-12 px-0'>
                                                  {checkupResultsArr.length > 0 ?
                                                    <>
                                                      {checkupResultsArr?.map((item, ind) => {
                                                        return (
                                                          <>
                                                            <div
                                                              key={ind}
                                                              className="row mx-0 "
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                              }}
                                                              style={{ cursor: 'default', }}
                                                            >
                                                              <div
                                                                className="col-12 px-3 border-top"
                                                                style={{
                                                                  background: 'rgb(199 212 234 / 30%)',
                                                                }}
                                                              >
                                                                <div
                                                                  className="d-flex align-items-center justify-content-between w-100 py-3 font-w600 cursor-pointer text-black text-hovered"
                                                                  onClick={() => {
                                                                    if (item?.home_area_product_id_ids === isExpandedForProductCheckUp) {
                                                                      setIsExpandedForProductCheckUp('')
                                                                    } else {
                                                                      setIsExpandedForProductCheckUp(item?.home_area_product_id_ids)
                                                                    }
                                                                  }}
                                                                >
                                                                  <div className="me-4 d-flex">
                                                                    <div className='me-3 position-relative'>
                                                                      <div className='position-absolute'
                                                                        style={{
                                                                          top: '-15px',
                                                                          right: '-5px',
                                                                        }}
                                                                      >
                                                                        {
                                                                          item?.condition_chr === "Good" ?
                                                                            <IoCheckmarkCircleOutline
                                                                              style={{ height: '18px', width: '18px', color: 'rgba(45, 204, 99, 1)' }}
                                                                              className='bg-white rounded-circle shadow'
                                                                            /> :
                                                                            item?.condition_chr === "Ok" ?
                                                                              <TiSpanner
                                                                                style={{ height: '18px', width: '18px', color: 'rgba(255, 154, 32, 1)', border: '1px solid rgba(255, 154, 32, 1)' }}
                                                                                className='bg-white rounded-circle shadow'
                                                                              /> :
                                                                              item?.condition_chr === "Poor" ?
                                                                                <MdOutlineCancel
                                                                                  style={{ height: '18px', width: '18px', color: 'rgba(240, 72, 72, 1)' }}
                                                                                  className='bg-white rounded-circle shadow'
                                                                                /> : ''
                                                                        }
                                                                      </div>
                                                                      <span
                                                                        className=" p-2 rounded bg-white shadow-lg text-black"
                                                                      >
                                                                        <i
                                                                          class="bi bi-cloud-hail-fill"
                                                                          style={{ height: '20px', width: '20px' }}
                                                                        ></i>
                                                                      </span>
                                                                    </div>

                                                                    <span>{`${item?.product_name_chr}`}</span>
                                                                  </div>

                                                                  <div
                                                                    className="text-black fs-4 d-flex align-items-center justify-content-center cursor-pointer"
                                                                  >
                                                                    <span>
                                                                      <span>
                                                                        <span>
                                                                          {item.home_area_product_id_ids === isExpandedForProductCheckUp ?
                                                                            <i class="bi bi-chevron-up ms-2 border rounded px-1 text-hovered overlay-action-btn"></i> :
                                                                            <i class="bi bi-chevron-down ms-2 border rounded px-1 text-hovered overlay-action-btn"></i>
                                                                          }
                                                                        </span>
                                                                      </span>
                                                                    </span>
                                                                  </div>
                                                                </div>

                                                                {item?.home_area_product_id_ids === isExpandedForProductCheckUp &&
                                                                  <div
                                                                    className="row mb-2 bg-white rounded-2 shadow-sm fs-7"
                                                                    style={{}}
                                                                  >
                                                                    <div className="col-12 p-1">
                                                                      <div className="row mx-1 pb-1 pt-2 px-3 d-flex align-items-center">
                                                                        <div className="col-4 pe-2  font-w500">
                                                                          <span>{`Condition`}</span>
                                                                        </div>
                                                                        <div className="col-8 d-flex px-2">
                                                                          <span
                                                                            className="text-white rounded-pill p-1 px-3"
                                                                            style={{
                                                                              background:
                                                                                `${item?.condition_chr === "Good" ? "rgba(45, 204, 99, 1)" :
                                                                                  item?.condition_chr === "Ok" ? "rgba(255, 154, 32, 1)" :
                                                                                    item?.condition_chr === "Poor" ? "rgba(240, 72, 72, 1)" :
                                                                                      item?.condition_chr === "Not assessed" ? "rgba(131, 154, 192, 1)" : ''}`,
                                                                            }}
                                                                          >
                                                                            {`${item?.condition_chr}`}
                                                                          </span>
                                                                        </div>
                                                                      </div>

                                                                      <div className="row mx-1 py-2 px-3 border-bottom  d-flex align-items-center">
                                                                        <div className="col-4 pe-2  font-w500">
                                                                          <span>{`Updated`}</span>
                                                                        </div>
                                                                        <div className="col-8">
                                                                          <span className="text-black font-w600 p-1 px-2">{`${formatUnixTimestamp(item?.updated_date_dtm)}`}</span>
                                                                        </div>
                                                                      </div>

                                                                      <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                        <div className="col-4 pe-2 font-w500">
                                                                          <span>{`Brand`}</span>
                                                                        </div>
                                                                        <div className="col-8">
                                                                          <span className={`${item?.device_brand_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.device_brand_chr ? item?.device_brand_chr : '-'}`}</span>
                                                                        </div>
                                                                      </div>

                                                                      <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                        <div className="col-4 pe-2 font-w500">
                                                                          <span>{`Model`}</span>
                                                                        </div>
                                                                        <div className="col-8">
                                                                          <span className={`${item?.model_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.model_number_chr ? item?.model_number_chr : '-'}`}</span>
                                                                        </div>
                                                                      </div>

                                                                      <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                        <div className="col-4 pe-2 font-w500">
                                                                          <span>{`Serial number`}</span>
                                                                        </div>
                                                                        <div className="col-8">
                                                                          <span className={`${item?.serial_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.serial_number_chr ? item?.serial_number_chr : '-'}`}</span>
                                                                        </div>
                                                                      </div>

                                                                      <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                        <div className="col-4 pe-2 font-w500">
                                                                          <span>{`Description`}</span>
                                                                        </div>
                                                                        <div className="col-8">
                                                                          <span className={`${item?.description_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.description_chr ? item?.description_chr : '-'}`}</span>
                                                                        </div>
                                                                      </div>

                                                                      {item?.image_url &&
                                                                        <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                          <div className="col-12">
                                                                            <img
                                                                              src={item?.image_url}
                                                                              alt="Attachment"
                                                                              className="rounded-2 shadow-lg cursor-pointer"
                                                                              onClick={(e) => {
                                                                                handleOpenDoc(); setImageAttachURL(item?.image_url);
                                                                              }}
                                                                              style={{
                                                                                height: '40px',
                                                                                width: '40px',
                                                                                border: '1px solid orange'
                                                                              }}
                                                                            />
                                                                          </div>
                                                                        </div>
                                                                      }

                                                                    </div>
                                                                  </div>
                                                                }
                                                              </div>
                                                            </div>
                                                          </>
                                                        )
                                                      })}
                                                    </> :
                                                    <>
                                                      <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                                        <div className="mb-2">
                                                          <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                        </div>
                                                        <span>
                                                          {`No items found`}
                                                        </span>
                                                      </div>
                                                    </>
                                                  }
                                                </div>
                                              </div>

                                            </div>
                                          </div>


                                        </div>
                                      </div>
                                    </> :
                                    toggleCheckUpResultAndMaintenancePlan === 2 ?
                                      <>
                                        <div
                                          className="row "
                                          style={{
                                            background: "rgba(235, 240, 250, 1)",
                                            // height: "calc(100dvh - 140px)",
                                          }}
                                        >
                                          <div
                                            className="col-12 py-3 px-2 "
                                            style={{
                                              // maxHeight: "550px",
                                              // minHeight: "450px",
                                              overflow: "auto",
                                              height: "calc(100dvh - 135px)",
                                            }}
                                          >
                                            <div className="row mx-0">
                                              <div className="col-12 px-2 pb-2 ">
                                                <span>
                                                  {`The maintenance tasks are intended to help you extend the life and safety of the inventory items in your home`}
                                                </span>
                                              </div>
                                            </div>

                                            <div className='row mx-0'>
                                              <div className='col-12 px-0'>

                                                <div className='row mx-0'>
                                                  <div className='col-12 px-0 d-flex border-bottom overflow-auto'>

                                                    <div
                                                      className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                      onClick={() => handleMaintenanceTaskTabs(4)}
                                                    >
                                                      <div
                                                        className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white '
                                                        style={{
                                                          background: maintenanceTabsToggle === 4 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                          width: '50px'
                                                        }}
                                                      >
                                                        <span className="text-truncate" style={{ fontSize: '8px' }}>{`All`}</span>
                                                      </div>
                                                      <div
                                                        className={`d-flex justify-content-center align-items-center p-1 fs-6 w-100 ${maintenanceTabsToggle === 4 ? "font-w700 text-black" : "font-w600"}`}
                                                        style={{
                                                          background: maintenanceTabsToggle === 4 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                      >
                                                        {/* <span>{maintenanceObjMaintenanceTask?.total_count}</span> */}
                                                        <span>{allHomeMaintenancePlanCount}</span>
                                                      </div>

                                                    </div>

                                                    <div
                                                      className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                      onClick={() => handleMaintenanceTaskTabs(1)}
                                                    >
                                                      <div
                                                        className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                        style={{
                                                          background: maintenanceTabsToggle === 1 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                          width: '50px'
                                                        }}
                                                      >
                                                        <span className="text-truncate" style={{ fontSize: '8px' }}>{`In 30 Days`}</span>
                                                      </div>
                                                      <div
                                                        className={`d-flex justify-content-center align-items-center p-1 fs-6 w-100 ${maintenanceTabsToggle === 1 ? "font-w700 text-black" : "font-w600"}`}
                                                        style={{
                                                          background: maintenanceTabsToggle === 1 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                      >
                                                        <div>
                                                          {/* <span>{maintenanceObjMaintenanceTask?.home_maintenance_plan_in_30_days_count}</span> */}
                                                          <span>{secondCount}</span>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                      onClick={() => handleMaintenanceTaskTabs(2)}
                                                    >
                                                      <div
                                                        className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                        style={{
                                                          background: maintenanceTabsToggle === 2 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                          width: '50px'
                                                        }}
                                                      >
                                                        <span className="text-truncate" style={{ fontSize: '8px' }}>{`In 60 Days`}</span>
                                                      </div>
                                                      <div
                                                        className={`d-flex justify-content-center align-items-center p-1 fs-6 w-100 ${maintenanceTabsToggle === 2 ? "font-w700 text-black" : "font-w600"}`}
                                                        style={{
                                                          background: maintenanceTabsToggle === 2 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                      >
                                                        <div>
                                                          {/* <span>{maintenanceObjMaintenanceTask?.home_maintenance_plan_in_60_days_count}</span> */}
                                                          <span>{thirdCount}</span>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                      onClick={() => handleMaintenanceTaskTabs(3)}
                                                    >
                                                      <div
                                                        className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                        style={{
                                                          background: maintenanceTabsToggle === 3 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                          width: '50px'
                                                        }}
                                                      >
                                                        <span className="text-truncate" style={{ fontSize: '8px' }}>{`In 90 Days`}</span>
                                                      </div>
                                                      <div
                                                        className={`d-flex justify-content-center align-items-center p-1 fs-6 w-100 ${maintenanceTabsToggle === 3 ? "font-w700 text-black" : "font-w600"}`}
                                                        style={{
                                                          background: maintenanceTabsToggle === 3 ? "white" : 'rgba(244, 248, 255, 1)',
                                                        }}
                                                      >
                                                        <div>
                                                          {/* <span>{maintenanceObjMaintenanceTask?.home_maintenance_plan_in_90_days_count}</span> */}
                                                          <span>{fourthCount}</span>
                                                        </div>
                                                      </div>
                                                    </div>

                                                  </div>
                                                </div>

                                                <div
                                                  className="row  px-2 "
                                                  style={{
                                                    backgroundColor: "rgba(251, 252, 255, 1)",
                                                  }}
                                                >

                                                  <div
                                                    className="row mx-0 my-1 align-items-center "
                                                    style={{ minHeight: "40px" }}
                                                  >
                                                    <div className="col-12">
                                                      <div className="row">
                                                        <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                                                          <span className="fs-5 p-2 d-flex align-items-center">
                                                            <LuArrowUpDown
                                                              className="cursor-pointer"
                                                              style={{ marginRight: "4px", color: "black" }}
                                                              onClick={handleOpenFiltreBoxMaintenanceTask}
                                                            />
                                                            <span
                                                              className="fs-7  cursor-pointer"
                                                              style={{ position: "relative" }}
                                                              onClick={handleOpenFiltreBoxMaintenanceTask}>
                                                              {/* {filtreValueMaintenanceTask == 1 && "Date: Newset first"}
                                                              {filtreValueMaintenanceTask == 2 && "Date: Oldest first"} */}

                                                              &nbsp;
                                                              {/* {filtreBoxMaintenanceTask ? <IoIosArrowUp /> : <IoIosArrowDown />} */}
                                                              <span
                                                                className={`${filtreBoxMaintenanceTask ? "" : "d-none"} p-1`}
                                                                style={{
                                                                  position: "absolute",
                                                                  top: "26px",
                                                                  width: "170px",
                                                                  zIndex: 1,
                                                                  border: "1px solid lightgray",
                                                                  background: "white",
                                                                  left: "-22px",
                                                                  boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                                }}>
                                                                <div className="row">
                                                                  <div
                                                                    className={`${filtreValueMaintenanceTask == 1 ? "dt" : ""
                                                                      } d-flex justify-content-start m-1 pointer `}
                                                                    onClick={() => {
                                                                      handleSetFiltreValueMaintenanceTask(1);
                                                                    }}>
                                                                    <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                      {filtreValueMaintenanceTask == 1 && <i className="bi bi-check-lg"></i>}
                                                                    </div>
                                                                    Date: Newest first
                                                                  </div>
                                                                  <div
                                                                    className={`${filtreValueMaintenanceTask == 2 ? "dt" : ""
                                                                      } d-flex justify-content-start m-1 pointer`}
                                                                    onClick={() => {
                                                                      handleSetFiltreValueMaintenanceTask(2);
                                                                    }}>
                                                                    <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                      {filtreValueMaintenanceTask == 2 && <i className="bi bi-check-lg"></i>}
                                                                    </div>
                                                                    Date: Oldest first
                                                                  </div>

                                                                </div>
                                                              </span>
                                                            </span>
                                                          </span>

                                                          <span
                                                            className="fs-6 p-2 d-flex align-items-center"
                                                            style={{
                                                              border: "1px solid lightgray",
                                                              borderRadius: "6px",
                                                            }}>
                                                            <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                                            <input
                                                              placeholder="Search"
                                                              style={{ border: "0px", width: "100%" }}
                                                              onChange={handleSearchMaintenanceTask}
                                                              value={searchValueMaintenanceTask}
                                                            />
                                                          </span>
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>


                                                <div className='row mx-0 mb-3'>
                                                  <div className='col-12 px-0'>
                                                    {maintenancePlansArr.length > 0 ?
                                                      <>
                                                        {maintenancePlansArr?.map((item, ind) => {
                                                          return (
                                                            <>
                                                              <div
                                                                key={ind}
                                                                className="row mx-0 fs-7"
                                                                onClick={(e) => {
                                                                  e.stopPropagation();
                                                                }}
                                                                style={{ cursor: 'default' }}
                                                              >
                                                                <div
                                                                  className="col-12 px-3 border-top"
                                                                  style={{
                                                                    background: 'rgb(199 212 234 / 30%)',
                                                                  }}
                                                                >
                                                                  <div
                                                                    className="d-flex align-items-center justify-content-between w-100 py-3 font-w600  text-black text-hovered"
                                                                  // onClick={() => {
                                                                  //     if (item?.home_area_product_id_ids === isExpandedForProduct) {
                                                                  //         setIsExpandedForProduct('')
                                                                  //     } else {
                                                                  //         setIsExpandedForProduct(item?.home_area_product_id_ids)
                                                                  //     }
                                                                  // }}
                                                                  >
                                                                    <div className="me-4 d-flex">
                                                                      <div className='me-3 position-relative'>
                                                                        <div className='position-absolute'
                                                                          style={{
                                                                            top: '-15px',
                                                                            right: '-5px',
                                                                          }}
                                                                        >
                                                                          {
                                                                            item?.condition_chr === "Good" ?
                                                                              <IoCheckmarkCircleOutline
                                                                                style={{ height: '18px', width: '18px', color: 'rgba(45, 204, 99, 1)' }}
                                                                                className='bg-white rounded-circle shadow'
                                                                              /> :
                                                                              item?.condition_chr === "Ok" ?
                                                                                <TiSpanner
                                                                                  style={{ height: '18px', width: '18px', color: 'rgba(255, 154, 32, 1)', border: '1px solid rgba(255, 154, 32, 1)' }}
                                                                                  className='bg-white rounded-circle shadow'
                                                                                /> :
                                                                                item?.condition_chr === "Poor" ?
                                                                                  <MdOutlineCancel
                                                                                    style={{ height: '18px', width: '18px', color: 'rgba(240, 72, 72, 1)' }}
                                                                                    className='bg-white rounded-circle shadow'
                                                                                  /> : ''
                                                                          }
                                                                        </div>
                                                                        <span
                                                                          className=" p-2 rounded bg-white shadow-lg text-black"
                                                                        >
                                                                          <i
                                                                            class="bi bi-cloud-hail-fill"
                                                                            style={{ height: '20px', width: '20px' }}
                                                                          ></i>
                                                                        </span>
                                                                      </div>

                                                                      <span>{`${item?.product_name_chr}`}</span>
                                                                    </div>

                                                                    <div
                                                                      className="text-black fs-4 d-flex align-items-center justify-content-center"
                                                                    >
                                                                      <span>
                                                                        <span>
                                                                          <span>
                                                                            <i class="bi bi-chevron-right ms-2  px-1"></i>
                                                                          </span>
                                                                        </span>
                                                                      </span>
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mb-2 bg-white rounded-2 shadow-sm">
                                                                    <div className="col-12 p-1">

                                                                      <div
                                                                        className={`bg-white mb-1  rounded `}
                                                                        style={{ margin: '0' }}
                                                                      >
                                                                        <div
                                                                          className="row mx-1  py-2 px-3 d-flex"
                                                                        >
                                                                          <div
                                                                            className="row mx-0  cursor-pointer"
                                                                            onClick={() => {
                                                                              if (item?.maintenance_plan_id_ids === isExpandedForMaintenancePlanMaintenanceTask) {
                                                                                setIsExpandedForMaintenancePlanMaintenanceTask('')
                                                                              } else {
                                                                                setIsExpandedForMaintenancePlanMaintenanceTask(item.maintenance_plan_id_ids)
                                                                              }
                                                                            }}
                                                                          >
                                                                            <div className="col-4 pe-2 font-w500">
                                                                              <span>{`Maintenance`}</span>
                                                                            </div>
                                                                            <div className="col-8 d-flex align-items-center justify-content-between ps-3">
                                                                              <span className={`${item?.instruction_chr && 'text-black'} font-w600 `}>{`${item?.instruction_chr ? `${item?.instruction_chr}` : '-'}`}</span>

                                                                              <span>
                                                                                {item?.maintenance_plan_id_ids === isExpandedForMaintenancePlanMaintenanceTask ?
                                                                                  <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i> :
                                                                                  <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i>
                                                                                }
                                                                              </span>
                                                                            </div>
                                                                          </div>

                                                                          {item?.maintenance_plan_id_ids === isExpandedForMaintenancePlanMaintenanceTask &&
                                                                            <>
                                                                              <div className="row mx-1 py-2  d-flex ">
                                                                                <div className="col-4 pe-2 font-w500">
                                                                                  <span>{`When`}</span>
                                                                                </div>
                                                                                <div className="col-8 ps-3">
                                                                                  <span className={`${item?.period_name_chr && 'text-black'} font-w600  `}>{`${item?.period_name_chr ? `In ${item?.period_name_chr}` : '-'}`}</span>
                                                                                </div>
                                                                              </div>

                                                                              <div className="row mx-1 py-2  d-flex ">
                                                                                <div className="col-4 pe-2 font-w500">
                                                                                  <span>{`Frequency`}</span>
                                                                                </div>
                                                                                <div className="col-8 ps-3">
                                                                                  <span className={`${item?.frequency_int && 'text-black'} font-w600 `}>{`${item?.frequency_int ? `${item?.frequency_int} times in a ${item?.period_name_chr}` : '-'}`}</span>
                                                                                </div>
                                                                              </div>


                                                                              <div className="row mx-1 py-2  d-flex ">
                                                                                <div className="col-4 pe-2 font-w500">
                                                                                  <span>{`Link`}</span>
                                                                                </div>
                                                                                <div className="col-8 ps-3">
                                                                                  {item?.purchase_link ?
                                                                                    <a
                                                                                      className="text-hovered text-gray-800"
                                                                                      href={`${item?.purchase_link}`}
                                                                                      target="_blank"
                                                                                      rel="noreferrer"
                                                                                    >
                                                                                      <span className={`font-w600`}>{`Purchase link`} <i className="bi bi-chevron-right me-2"></i> </span>
                                                                                    </a> :
                                                                                    <span className={`font-w600`}>{`-`} </span>
                                                                                  }
                                                                                </div>
                                                                              </div>

                                                                              <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                <div className="col-12">
                                                                                  <div className="d-flex align-items-center justify-content-between">
                                                                                    <div className="mx-2"></div>
                                                                                    <div className="mx-2 d-flex align-items-center fs-4">

                                                                                      <div className="me-2">
                                                                                        <div className="tooltipCustom">
                                                                                          <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                          <span
                                                                                            className="cursor-pointer overlay-action-btn px-2 py-1 rounded-2 text-gray-800 text-hovered"
                                                                                            onClick={() => {
                                                                                              updateMaitenancePlanFnMaintenanceTask(item);
                                                                                            }}
                                                                                          >
                                                                                            <i className="bi bi-pencil"></i>
                                                                                          </span>
                                                                                        </div>
                                                                                      </div>

                                                                                      <div className="me-2">
                                                                                        <div className="tooltipCustom">
                                                                                          <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete"}</span>
                                                                                          <span
                                                                                            className="cursor-pointer overlay-action-btn px-2 py-1 rounded-2 text-gray-800 text-hovered"
                                                                                            onClick={() => {
                                                                                              handleOpenMaintenancePlanModalMaintenanceTask(2);
                                                                                              setMaintenancePlanIdMaintenanceTask(item?.maintenance_plan_id_ids);
                                                                                              setInstructionMaintenanceTask(item?.instruction_chr);
                                                                                            }}
                                                                                          >
                                                                                            <i className="bi bi-trash"></i>
                                                                                          </span>
                                                                                        </div>
                                                                                      </div>
                                                                                    </div>
                                                                                  </div>

                                                                                </div>
                                                                              </div>



                                                                            </>
                                                                          }

                                                                        </div>
                                                                      </div>



                                                                      {item?.image_url && false &&
                                                                        <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                          <div className="col-12">
                                                                            <img
                                                                              src={item?.image_url}
                                                                              alt="Attachment"
                                                                              className="rounded-2 shadow-lg cursor-pointer"
                                                                              onClick={(e) => {
                                                                                handleOpenDoc(); setImageAttachURL(item?.image_url);
                                                                              }}
                                                                              style={{
                                                                                height: '60px',
                                                                                width: '60px',
                                                                                border: '1px solid orange'
                                                                              }}
                                                                            />
                                                                          </div>
                                                                        </div>
                                                                      }
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mx-0 mb-1">
                                                                    <div className="col-12 px-0 font-w600">
                                                                      {item?.is_completed_ysn ?
                                                                        <span className="text-success">{`Task completed`}</span> :
                                                                        <span>{`Task not completed yet`}</span>
                                                                      }
                                                                    </div>
                                                                  </div>

                                                                  {/* {
                                                                    <div
                                                                      className="row  px-0"
                                                                    // onClick={() => handleCheckboxChange(element)}
                                                                    >
                                                                      <div
                                                                        className={`row pb-2`}
                                                                      >
                                                                        <div className={`col-12 d-flex fs-6 font-w600 `}>
                                                                          <div className="d-flex align-items-center justify-content-between w-100">
                                                                            <div
                                                                              className="me-4 d-flex align-items-center"
                                                                              style={{
                                                                                pointerEvents: updateMaintenancePlanStatusLoading ? 'none' : 'auto',
                                                                                opacity: updateMaintenancePlanStatusLoading ? '0.5' : '1'
                                                                              }}
                                                                            >
                                                                              <span
                                                                                className="me-2"
                                                                              >
                                                                                {updateMaintenancePlanStatusLoading && (item?.maintenance_plan_id_ids === maintenancePlanIdMaintenanceTask) ?
                                                                                  <Spinner animation="border" size="sm" /> :
                                                                                  <input
                                                                                    type="checkbox"
                                                                                    checked={item?.is_completed_ysn}
                                                                                    className="form-check-input"
                                                                                    id="customCheckBox4"
                                                                                    onChange={(e) => {
                                                                                      updateMaintenancePlanStatusFn(item);
                                                                                      setMaintenancePlanIdMaintenanceTask(item?.maintenance_plan_id_ids)
                                                                                    }}
                                                                                    onClick={() => { updateMaintenancePlanStatusFn(item); setMaintenancePlanIdMaintenanceTask(item?.maintenance_plan_id_ids) }}
                                                                                  />
                                                                                }
                                                                              </span>
                                                                              <span
                                                                                className="pt-1 cursor-pointer text-hovered"
                                                                                onClick={() => {
                                                                                  updateMaintenancePlanStatusFn(item);
                                                                                  setMaintenancePlanIdMaintenanceTask(item?.maintenance_plan_id_ids)
                                                                                }}
                                                                              >
                                                                                {`Task Completed`}
                                                                              </span>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>} */}
                                                                </div>
                                                              </div>
                                                            </>
                                                          )
                                                        })}
                                                      </> :
                                                      <>
                                                        <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                                          <div className="mb-2">
                                                            <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                          </div>
                                                          <span>
                                                            {`No items found`}
                                                          </span>
                                                        </div>
                                                      </>
                                                    }
                                                  </div>
                                                </div>

                                              </div>
                                            </div>


                                          </div>
                                        </div>
                                      </> : <></>
                                  }

                                </> :
                                <></>
                          }
                        </div>


                        {toggleInspectionTab === 2 &&
                          <div className="row d-flex align-items-end">

                            {toggleForDefineRoomList === 1 ?
                              <>
                                <div
                                  className="row"
                                  style={{
                                    position: "absolute",
                                    background: "white",
                                    boxShadow: "rgba(0, 0, 0, 0.31) 0px -6px 10px -2px",
                                  }}
                                >
                                  <div className="row mx-0 ">
                                    <div className="col-12 p-3">
                                      <PrimaryButton
                                        buttonName={"CONTINUE"}
                                        onClick={() => {
                                          // setToggleForDefineRoomList(2)
                                          // handleClearRoomStates();
                                          getHomeAreaListonContinue();
                                        }}
                                        isLoading={defineRoomsLoading}
                                        loadingMessage={"CONTINUING..."}
                                        style={{
                                          width: '100%',
                                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                          border: '2px solid rgba(255, 154, 32, 1)',
                                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                        }}
                                      />
                                    </div>
                                  </div>

                                </div>
                              </> :
                              <>
                                {Object.keys(particularHomeAreaObj).length === 0 ?
                                  <>

                                    <div
                                      className="row"
                                      style={{
                                        position: "absolute",
                                        background: "white",
                                        // boxShadow: "rgba(0, 0, 0, 0.31) 0px -6px 10px -2px",
                                      }}
                                    >

                                      {false && <>
                                        <span
                                          className="fs-6 font-w700 border-top mb-2 d-flex justify-content-center align-items-center p-3 pointer position-relative"
                                          onClick={() => {
                                            setToggleAddRooms(!toggleAddRooms);
                                          }}
                                        >
                                          {"Add room"}&nbsp; &nbsp;{" "}
                                          {toggleAddRooms ? (
                                            <i className="bi bi-chevron-down"></i>
                                          ) : (
                                            <i className="bi bi-chevron-up"></i>
                                          )}{" "}

                                          {toggleAddRooms &&
                                            <span
                                              className="position-absolute fs-4"
                                              style={{ right: "15px" }}
                                            >
                                              <i
                                                className="bi bi-x-lg ms-2 cursor-pointer text-hovered"
                                                onClick={(e) => { e.stopPropagation(); setToggleAddRooms(!toggleAddRooms) }}
                                              ></i>
                                            </span>
                                          }
                                        </span>

                                        {toggleAddRooms && (
                                          <div className="px-3 mb-2">
                                            <InputField
                                              labelName={"Room name"}
                                              value={roomTypeName}
                                              onChange={(e) => { handleChangeRoomName(e) }}
                                              onBlur={handleBlurCheckRoomName}
                                              errorOccured={isRoomTypeNameErr}
                                              errorMeesage={"Enter valid room name"}
                                            />

                                            <div className="row mx-0 ">
                                              <div className="col-12 px-0">
                                                <PrimaryButton
                                                  buttonName={"SUBMIT"}
                                                  onClick={() => handleSubmitRoomOperations()}
                                                  isLoading={roomsLoading}
                                                  loadingMessage={"Loading..."}
                                                  style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                  }}
                                                />
                                              </div>
                                            </div>

                                          </div>
                                        )}
                                      </>}

                                    </div>
                                  </> :
                                  <>
                                    <div
                                      className="row"
                                      style={{
                                        position: "absolute",
                                        background: "white",
                                        zIndex: 1011,
                                        boxShadow: "rgba(0, 0, 0, 0.31) 0px -6px 10px -2px",
                                      }}
                                    >
                                      <span
                                        className="fs-6 font-w700 border-top mb-2 d-flex justify-content-center align-items-center p-3 pointer position-relative"
                                        onClick={() => {
                                          setToggleAddItems(!toggleAddItems);
                                        }}
                                      >
                                        {toggleForInventoryModal === 1 ? `Add item` :
                                          toggleForInventoryModal === 2 ? `Edit ${inventoryType}` :
                                            toggleForInventoryModal === 3 ? `Delete inventory item` : ``
                                        }&nbsp; &nbsp;{" "}

                                        {toggleAddItems ? (
                                          <i className="bi bi-chevron-down"></i>
                                        ) : (
                                          <i className="bi bi-chevron-up"></i>
                                        )}{" "}

                                        {toggleAddItems &&
                                          <span
                                            className="position-absolute fs-4"
                                            style={{ right: "15px" }}
                                          >
                                            <i
                                              className="bi bi-x-lg ms-2 cursor-pointer text-hovered"
                                              onClick={(e) => { e.stopPropagation(); setToggleAddItems(!toggleAddItems) }}
                                            ></i>
                                          </span>
                                        }
                                      </span>

                                      <div className="px-3 mb-2">
                                        {toggleAddItems && (
                                          <>
                                            {(toggleForInventoryModal === 1 || toggleForInventoryModal === 2) &&
                                              <div>
                                                {toggleForInventoryModal === 1 &&
                                                  <div className="row mx-0">
                                                    <div className="col-12 px-0">
                                                      <SelectInputProductTypes
                                                        labelName={"Inventory type"}
                                                        onChange={(e) => handleChangeInventoryType(e)}
                                                        defaultValue={inventoryType}
                                                        options={productTypeArr}
                                                        errorOccured={isInventoryTypeErr}
                                                        errorMessage={"Please select inventory type"}
                                                      // isForProdId={true}
                                                      />
                                                    </div>
                                                  </div>
                                                }

                                                <div className="row mx-0 fs-6 mb-2">
                                                  <div className="col-12 font-w600 mb-2">
                                                    <span>{`Condition `}</span>
                                                  </div>

                                                  <div className="col-12">
                                                    <div className="d-flex flex-wrap pb-1 w-100 justify-content-start">
                                                      {conditionListArr.map((item, index) => {
                                                        return (
                                                          <>
                                                            {item?.condition_id_ids !== 0 &&
                                                              <span
                                                                key={index}
                                                                className="font-w500 me-2 px-3 py-1 rounded-pill text-white cursor-pointer fs-7 mb-1"
                                                                onClick={() => { setInventoryCondition(item?.condition_name_chr) }}
                                                                style={{
                                                                  background:
                                                                    (inventoryCondition === "Good" && item?.condition_name_chr === "Good") ? "rgba(45, 204, 99, 1)" :
                                                                      (inventoryCondition === "Ok" && item?.condition_name_chr === "Ok") ? "rgba(255, 154, 32, 1)" :
                                                                        (inventoryCondition === "Poor" && item?.condition_name_chr === "Poor") ? "rgba(240, 72, 72, 1)" : `rgba(131, 154, 192, 1)`,
                                                                  boxShadow:
                                                                    (inventoryCondition === "Good" && item?.condition_name_chr === "Good") ? '1px 1px 2px 0px grey' :
                                                                      (inventoryCondition === "Ok" && item?.condition_name_chr === "Ok") ? '1px 1px 2px 0px grey' :
                                                                        (inventoryCondition === "Poor" && item?.condition_name_chr === "Poor") ? '1px 1px 2px 0px grey' : `0px 0px 2px 0px grey`,
                                                                }}
                                                              >
                                                                {`${item?.condition_name_chr}`}
                                                              </span>
                                                            }
                                                          </>
                                                        )
                                                      })}
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="row mx-0">
                                                  <div className="col-12 px-0">
                                                    <InputField
                                                      labelName={"Brand"}
                                                      value={inventoryBrand}
                                                      onChange={(e) => { handleChangeInventoryBrand(e) }}
                                                      onBlur={(e) => { }}
                                                    />
                                                  </div>
                                                </div>

                                                <div className="row mx-0">
                                                  <div className="col-12">
                                                    <InputField
                                                      labelName={"Model"}
                                                      value={inventoryModel}
                                                      onChange={(e) => { handleChangeInventoryModel(e) }}
                                                      onBlur={(e) => { }}
                                                    />
                                                  </div>
                                                </div>

                                                <div className="row mx-0">
                                                  <div className="col-12">
                                                    <InputField
                                                      labelName={"Serial number"}
                                                      value={inventorySerialNumber}
                                                      onChange={(e) => { handleChangeInventorySerialNumber(e) }}
                                                      onBlur={(e) => { }}
                                                    />
                                                  </div>
                                                </div>

                                                {/* <div className="row mx-0">
                                              <div className="col-12 px-0">
                                                <SelectInputCondition
                                                  labelName={"Condition"}
                                                  onChange={(e) => handleChangeInventoryCondition(e)}
                                                  defaultValue={inventoryCondition}
                                                  options={conditionListArr}
                                                  errorOccured={false}
                                                  errorMessage={"Please select device condition"}
                                                />
                                              </div>
                                            </div> */}



                                                <div className="row mx-0">
                                                  <div className="col-12 px-0">
                                                    <TextArea
                                                      labelName={"Description (optional)"}
                                                      value={inventoryDesc}
                                                      rows={3}
                                                      onChange={(e) => { handleChangeInventoryDesc(e) }}
                                                      onBlur={(e) => { }}
                                                    />
                                                  </div>
                                                </div>

                                                <div className="row mx-0 ">
                                                  <div className="col-sm-6 pe-sm-2 mb-2 d-flex align-items-center">
                                                    {permissionArray.includes("SCAN TAB") &&
                                                      <div
                                                        className="text-hovered fs-5 cursor-pointer d-flex align-items-center font-w600"
                                                        onClick={handleClickAttachedImage0}
                                                      >
                                                        <span className="me-2">
                                                          <i className="bi bi-paperclip"></i>
                                                        </span>
                                                        <span>
                                                          {`Attach file`}
                                                        </span>
                                                        <input ref={attachedImage0Ref} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage0(e) }} />
                                                      </div>
                                                    }
                                                  </div>

                                                  <div className="col-sm-6 ps-sm-2 mb-2">
                                                    <PrimaryButton
                                                      buttonName={"SUBMIT"}
                                                      onClick={(e) => { addUpdateinventoryItemFn() }}
                                                      isLoading={inventoryLoading}
                                                      loadingMessage={"Loading..."}
                                                      style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                      }}
                                                    />
                                                  </div>
                                                </div>

                                                {attachedImage0 &&
                                                  <div className="row mx-0 mt-2">
                                                    <div className="col-12 px-0 d-flex">
                                                      <div className="position-relative">
                                                        <i
                                                          onClick={deleteAttachedImage0}
                                                          className="bi bi-x-circle position-absolute cursor-pointer fs-3 text-orange bg-white rounded-circle"
                                                          style={{
                                                            top: '-10px',
                                                            right: '-10px',
                                                          }}
                                                        ></i>
                                                        <img
                                                          src={attachedImage0}
                                                          className="rounded-2 shadow-lg border border-danger"
                                                          alt="Attachement"
                                                          style={{
                                                            height: '50px',
                                                            width: '50px',
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                }
                                              </div>
                                            }


                                            {(toggleForInventoryModal === 3) &&
                                              <>
                                                <div className="row mx-0 mb-3">
                                                  <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                                                    <span>
                                                      {(toggleForInventoryModal === 3) && `Are you sure you want to delete ${inventoryType} from this room?`}
                                                    </span>
                                                  </div>
                                                </div>

                                                <div className="row mx-0">

                                                  <div className="col-12 mb-2">
                                                    <PrimaryButton
                                                      buttonName={"YES, DELETE IT"}
                                                      onClick={(e) => { deleteInventoryItemFn() }}
                                                      isLoading={inventoryLoading}
                                                      loadingMessage={"Loading..."}
                                                      style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                        border: '1px solid rgba(240, 72, 72, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                              </>
                                            }
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                }
                              </>
                            }

                          </div>
                        }

                      </div>
                    </div>
                  </>
                )}

                {/* Tab 7 OCR capture text */}

                {/* Parts and Manuals New*/}
                {tabOpen == 8 && (
                  <>
                    <div
                      className="row d-flex justify-content-start"
                      style={{ flex: "1" }}
                    >
                      <div className="row" style={{ position: "relative" }}>
                        <div>
                          <span
                            className="fs-5 d-flex justify-content-between align-items-center p-3 text-black bg-white font-w700"
                            style={{
                              borderBottom: "1px solid gray",
                            }}
                          >
                            {"Parts and Manuals"}
                          </span>

                          <div className="row position-relative">
                            {tabsPartsManuals &&
                              <div
                                className="position-absolute"
                                style={{
                                  top: '0',
                                  left: '0',
                                  bottom: '0',
                                  right: '0',
                                  background: '#00000091',
                                  zIndex: '9',
                                }}
                                onClick={() => { setTabsPartsManuals('') }}
                              ></div>}
                            <div
                              className="col-12"
                              style={{
                                height: "calc(100dvh - 150px)",
                                overflow: "auto",
                              }}
                            >
                              <div className="bg-white p-3" ref={manualsFormHeightRef}>

                                <div className="row mx-0 mb-4">
                                  <div className="col-12 px-0">
                                    <span className="text-black font-w500 fs-5">{`To source owners manuals and parts, enter this info or scan the customers info-plate`}</span>
                                  </div>
                                </div>

                                <div className="row mx-0">
                                  <div className="col-12 px-0 d-flex flex-column align-items-center justify-content-end">
                                    <span className="text-black text-center font-w500 fs-7 align-self-end">{`Click if`}</span>
                                    <span className="text-black text-center font-w500 fs-7 align-self-end">{`Correct`}</span>
                                  </div>
                                </div>
                                {/* {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                                  participants.length > 0 &&
                                  <div className="row mx-0 pb-4"  >
                                    <div className="col-12 px-0 mb-2">
                                      <span>{`Scan device or enter in information manually`}</span>
                                    </div>

                                    <div className="col-12"
                                      style={{
                                        pointerEvents: scanPartsManualsLoading || scanDeviceLoading ? "none" : "auto",
                                        opacity: scanPartsManualsLoading || scanDeviceLoading ? 0.5 : 1,
                                      }}
                                    >
                                      <span
                                        className="px-3 py-2 rounded-3 bg-light text-black font-w600 cursor-pointer overlay-action-btn me-2"
                                        onClick={() => { handleScanDeviceForParts(); setScanDeviceFlag(1); }}
                                      >
                                        {!scanDeviceLoading ? <span>{`Scan device`}</span> :
                                          <Spinner size="sm" />}
                                      </span>

                                      <span
                                        className="px-3 py-2 rounded-3 bg-light text-black font-w600 cursor-pointer overlay-action-btn me-2"
                                        onClick={() => { handleScanDeviceForParts(); setScanDeviceFlag(2); }}
                                      >
                                        {!scanPartsManualsLoading ? <span>{`Scan model`}</span> :
                                          <Spinner size="sm" />}
                                      </span>
                                    </div>

                                  </div>
                                } */}

                                <div
                                  style={{
                                    // pointerEvents: (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") || permissionArray.includes("SCAN TAB")) ? "auto" : "none",
                                    // opacity: (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") || permissionArray.includes("SCAN TAB")) ? 1 : 0.6,
                                  }}
                                >

                                  <div className="row mx-0">
                                    <div className="col-12 px-0 d-flex">
                                      <div
                                        className="me-2 mb-3"
                                        style={{
                                          pointerEvents: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? "none" : "auto",
                                          opacity: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? 0.5 : 1,
                                        }}
                                      >
                                        <div className="tooltipCustom h-100 bg-light">
                                          {/* <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content', zIndex: 10 }}>{"Scan"}</span> */}
                                          <div
                                            className="align-items-center d-flex justify-content-center rounded-1 overlay-action-btn cursor-pointer h-100"
                                            onClick={() => {
                                              handleScanDeviceForParts();
                                              setScanDeviceFlag(1);
                                            }}
                                            style={{
                                              // height: "41px",
                                              width: "50px",
                                              border: "1px solid rgb(179 179 179 / 64%)",
                                            }}>

                                            <span className="d-flex justify-content-center text-center">
                                              {/* <i className="bi bi-camera"></i> */}
                                              {scanDeviceLoading ? <Spinner size="sm" /> :
                                                // <RiQrScan2Line />
                                                <div className="font-w600 text-black" style={{ fontSize: "10px" }}>
                                                  <div>{`Scan`}</div>
                                                  <div>{`Image`}</div>
                                                </div>
                                              }
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="w-100">
                                        <div className="d-flex">
                                          <div
                                            className="w-100"
                                            style={{ pointerEvents: confirmProductTypeCheck ? "none" : "auto", }}
                                          >
                                            <InputField
                                              labelName={"Device type"}
                                              placeholderName={"Device type eg: Refrigerator, faucet, etc"}
                                              value={productType}
                                              onChange={(e) => { !confirmProductTypeCheck && handleProductType(e) }}
                                              onBlur={handleProductTypeBlurCheck}
                                              errorOccured={isProductTypeErr}
                                              errorMeesage={"Please add device type"}
                                              isRequired={true}
                                              autoActivated={true}
                                              isPlaceholder={true}
                                            />
                                          </div>

                                          <div
                                            className="ms-2 mb-3"
                                            style={{
                                              // pointerEvents: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? "none" : "auto",
                                              // opacity: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? 0.5 : 1,
                                            }}
                                          >
                                            <div className="tooltipCustom">
                                              <span className="tooltiptextCustom " style={{ width: '52px !important', zIndex: 110 }}>
                                                <div>{"Click to confirm"}</div>
                                                <div>{"information"}</div>
                                              </span>
                                              <div
                                                className="align-items-center d-flex fs-3 justify-content-center rounded-1 overlay-action-btn cursor-pointer"
                                                onClick={() => {
                                                  // handleScanDeviceForParts();
                                                  // setScanDeviceFlag(1);
                                                  setConfirmProductTypeCheck(!confirmProductTypeCheck)
                                                }}
                                                style={{
                                                  height: "41px",
                                                  width: "30px",
                                                  // border: "1px solid rgb(179 179 179 / 64%)",
                                                }}
                                              >

                                                {/* <span className="d-flex">
                                                  {scanDeviceLoading ? <Spinner size="sm" /> :
                                                    <RiQrScan2Line />}
                                                </span> */}
                                                <span className="d-flex check-lg checkbox-success">
                                                  <input
                                                    type="checkbox"
                                                    checked={confirmProductTypeCheck}
                                                    className="form-check-input mt-0 rounded-circle"
                                                    id="customCheckBox4"
                                                    onChange={(e) => {
                                                      setConfirmProductTypeCheck(e.target.checked)
                                                    }}
                                                    onClick={() => { setConfirmProductTypeCheck(!confirmProductTypeCheck) }}
                                                  />
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="d-flex">
                                          <div
                                            className="w-100"
                                            style={{ pointerEvents: confirmBrandNameCheck ? "none" : "auto", }}
                                          >
                                            <InputField
                                              labelName={"Brand"}
                                              placeholderName={"Make or Brand"}
                                              value={brandName}
                                              onChange={(e) => { !confirmBrandNameCheck && handleBrandName(e) }}
                                              onBlur={handleBrandNameBlurCheck}
                                              errorOccured={isBrandNameErr}
                                              errorMeesage={"Please add brand name"}
                                              isRequired={true}
                                            />
                                          </div>

                                          <div
                                            className="ms-2 mb-3"
                                            style={{
                                              // pointerEvents: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? "none" : "auto",
                                              // opacity: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? 0.5 : 1,
                                            }}
                                          >
                                            <div className="tooltipCustom">
                                              <span className="tooltiptextCustom " style={{ width: '52px !important', zIndex: 110 }}>
                                                <div>{"Click to confirm"}</div>
                                                <div>{"information"}</div>
                                              </span>
                                              <div
                                                className="align-items-center d-flex fs-3 justify-content-center rounded-1 overlay-action-btn cursor-pointer"
                                                onClick={() => {
                                                  // handleScanDeviceForParts();
                                                  // setScanDeviceFlag(1);
                                                  setConfirmBrandNameCheck(!confirmBrandNameCheck)
                                                }}
                                                style={{
                                                  height: "41px",
                                                  width: "30px",
                                                  // border: "1px solid rgb(179 179 179 / 64%)",
                                                }}
                                              >

                                                {/* <span className="d-flex">
                                                  {scanDeviceLoading ? <Spinner size="sm" /> :
                                                    <RiQrScan2Line />}
                                                </span> */}
                                                <span className="d-flex check-lg checkbox-success">
                                                  <input
                                                    type="checkbox"
                                                    checked={confirmBrandNameCheck}
                                                    className="form-check-input mt-0 rounded-circle"
                                                    id="customCheckBox4"
                                                    onChange={(e) => {
                                                      setConfirmBrandNameCheck(e.target.checked)
                                                    }}
                                                    onClick={() => { setConfirmBrandNameCheck(!confirmBrandNameCheck) }}
                                                  />
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="d-flex">
                                          <div
                                            className="w-100"
                                            style={{ pointerEvents: confirmModelNumberCheck ? "none" : "auto", }}
                                          >
                                            <InputField
                                              labelName={"Model"}
                                              placeholderName={"Model number"}
                                              value={modelNumber}
                                              onChange={(e) => { !confirmModelNumberCheck && handleModelNumber(e) }}
                                              onBlur={() => { }}
                                              errorOccured={false}
                                              errorMeesage={"Please add brand name"}
                                            />
                                          </div>

                                          <div
                                            className="ms-2 mb-3"
                                            style={{
                                              // pointerEvents: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? "none" : "auto",
                                              // opacity: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? 0.5 : 1,
                                            }}
                                          >
                                            <div className="tooltipCustom">
                                              <span className="tooltiptextCustom " style={{ width: '52px !important', zIndex: 110 }}>
                                                <div>{"Click to confirm"}</div>
                                                <div>{"information"}</div>
                                              </span>
                                              <div
                                                className="align-items-center d-flex fs-3 justify-content-center rounded-1 overlay-action-btn cursor-pointer"
                                                onClick={() => {
                                                  // handleScanDeviceForParts();
                                                  // setScanDeviceFlag(1);
                                                  setConfirmModelNumberCheck(!confirmModelNumberCheck)
                                                }}
                                                style={{
                                                  height: "41px",
                                                  width: "30px",
                                                  // border: "1px solid rgb(179 179 179 / 64%)",
                                                }}
                                              >

                                                {/* <span className="d-flex">
                                                  {scanDeviceLoading ? <Spinner size="sm" /> :
                                                    <RiQrScan2Line />}
                                                </span> */}
                                                <span className="d-flex check-lg checkbox-success">
                                                  <input
                                                    type="checkbox"
                                                    checked={confirmModelNumberCheck}
                                                    className="form-check-input mt-0 rounded-circle"
                                                    id="customCheckBox4"
                                                    onChange={(e) => {
                                                      setConfirmModelNumberCheck(e.target.checked)
                                                    }}
                                                    onClick={() => { setConfirmModelNumberCheck(!confirmModelNumberCheck) }}
                                                  />
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="row mx-0">
                                  <div
                                    className="col-12 px-0"
                                  >
                                    <InputField
                                      labelName={"Specific part"}
                                      placeholderName={"Specific part"}
                                      value={specificPart}
                                      onChange={(e) => { handleSpecificPart(e) }}
                                      onBlur={() => { }}
                                      errorOccured={false}
                                      errorMeesage={"Please add specific part"}
                                    />
                                  </div>
                                </div>

                                <div className="row mx-0 pb-2">
                                  <div
                                    className="col-12 px-0"
                                    style={{
                                      pointerEvents: scanPartsManualsLoading || scanDeviceLoading || sourcingInfoLoading ? "none" : "auto",
                                      opacity: scanPartsManualsLoading || scanDeviceLoading || sourcingInfoLoading ? 0.5 : 1,
                                    }}
                                  >
                                    {/* {(permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") || permissionArray.includes("SCAN TAB")) && */}
                                    <span
                                      className="px-3 py-2 rounded-3 bg-light text-black d-flex align-items-center justify-content-center font-w600 cursor-pointer overlay-action-btn"
                                      onClick={() => { handleSearchSourcingInfo() }}
                                    >
                                      {sourcingInfoLoading ?
                                        <>
                                          <Spinner size="sm" className="me-2" />  {` Searching...`}
                                        </> :
                                        <> {`Search results`}</>}
                                    </span>
                                    {/* } */}
                                  </div>
                                </div>

                              </div>

                              {!tabsPartsManuals &&
                                <div className="row mx-0">
                                  <div className="col-12 px-0">
                                    <div className="d-flex justify-content-center align-items-center my-5 text-center">
                                      <span className="text-black my-5">{`Select an Option Below`}</span>
                                    </div>
                                  </div>
                                </div>
                              }

                            </div>
                          </div>
                        </div>

                        <div className="row d-flex align-items-end">
                          <div
                            className="row"
                            style={{
                              position: "absolute",
                              background: "white",
                              zIndex: '10',
                              boxShadow: '-6px 1px 8px gray',
                            }}
                          >
                            <div className="col-12" style={{}}>
                              <Accordion
                                // defaultActiveKey={tabsPartsManuals}
                                activeKey={tabsPartsManuals}
                              >
                                <Accordion.Item eventKey="1" className="mb-0">
                                  <h2 className="accordion-header">
                                    <Accordion.Button className="border-0 p-0 d-block">
                                      <div
                                        className={`m-1 border fs-6 font-w600 ${tabsPartsManuals === "1" ? "text-white" : "text-black"} overlay-action-btn d-flex justify-content-between align-items-center p-3 cursor-pointer`}
                                        style={{
                                          background: tabsPartsManuals === "1" ? 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)' : 'rgb(202 198 198 / 88%)',
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                                            handleSourcingInfoFn()
                                          }
                                          if (tabsPartsManuals == "1") {
                                            setTabsPartsManuals("");
                                          } else {
                                            setTabsPartsManuals("1");
                                          }
                                        }}
                                      >
                                        {"Owner's manual"}{" "}
                                        {tabsPartsManuals == "1" ? (
                                          <i class="bi bi-chevron-down"></i>
                                        ) : (
                                          <i class="bi bi-chevron-up"></i>
                                        )}{" "}
                                      </div>
                                    </Accordion.Button>
                                  </h2>
                                  <Accordion.Body className="p-0">
                                    {tabsPartsManuals == "1" &&
                                      <div className="p-1 px-2 overflow-auto"
                                        style={{
                                          // maxHeight: `calc(100dvh - ${manualsFormHeight + 300}px)` 
                                          maxHeight: `60dvh`
                                        }}
                                      >
                                        {sourcingInfoLoading ? <div>
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                        </div> :
                                          <>
                                            {sourcingManualsArr?.length > 0 ?
                                              <>
                                                {sourcingManualsArr?.map((item, index) => {
                                                  return (
                                                    <>
                                                      <a target="_blank" href={item?.url} rel="noreferrer">
                                                        <div className="mx-0 row mb-2">
                                                          <div
                                                            className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                            style={{
                                                              background: "rgba(244, 248, 255, 1)",
                                                              border: "1px solid rgba(199, 212, 234, 1)",
                                                            }}
                                                          >
                                                            <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                              <div className="d-flex">
                                                                <div
                                                                  className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                  style={{ width: "30px", height: "30px" }}
                                                                >
                                                                  <img
                                                                    src={item?.image}
                                                                    style={{ width: "30px", height: "30px" }}
                                                                    className="rounded-3"
                                                                    alt=""
                                                                  />
                                                                </div>

                                                                {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                <div className="d-flex flex-column">
                                                                  <span className="fs-6 text-black">
                                                                    {`${item?.name}`}
                                                                  </span>
                                                                  <span className="fs-7">
                                                                    {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                  </span>
                                                                </div>

                                                              </div>

                                                              <div>
                                                                <i className="bi bi-chevron-right" />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </a>
                                                    </>
                                                  )
                                                })}
                                              </> :
                                              <>
                                                <div>
                                                  <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                    <div className="mb-2">
                                                      <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                    </div>
                                                    <span>
                                                      {`No record found`}
                                                    </span>
                                                  </div>
                                                </div>
                                              </>
                                            }
                                          </>}
                                      </div>
                                    }
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2" className="mb-0">
                                  <h2 className="accordion-header">
                                    <Accordion.Button className="border-0 p-0 d-block">
                                      <div
                                        className={`m-1 border fs-6 font-w600 ${tabsPartsManuals === "2" ? "text-white" : "text-black"} overlay-action-btn d-flex justify-content-between align-items-center p-3 cursor-pointer`}
                                        style={{
                                          background: tabsPartsManuals === "2" ? 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)' : 'rgb(202 198 198 / 88%)',
                                        }}
                                        onClick={() => {
                                          if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                                            handleSourcingInfoFn()
                                          }
                                          if (tabsPartsManuals == '2') {
                                            setTabsPartsManuals('');
                                          } else {
                                            setTabsPartsManuals('2');
                                          }
                                        }}
                                      >
                                        {"Parts"}{" "}
                                        {tabsPartsManuals == '2' ? (
                                          <i class="bi bi-chevron-down"></i>
                                        ) : (
                                          <i class="bi bi-chevron-up"></i>
                                        )}{" "}
                                      </div>
                                    </Accordion.Button>
                                  </h2>
                                  <Accordion.Body className="p-0">
                                    {tabsPartsManuals == '2' &&
                                      <div className="p-1 px-2 overflow-auto"
                                        style={{
                                          // maxHeight: `calc(100dvh - ${manualsFormHeight + 300}px)` 
                                          maxHeight: `60dvh`
                                        }}
                                      >
                                        {sourcingInfoLoading ? <div>
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                        </div> :
                                          <>
                                            {productType !== "" && brandName !== "" &&
                                              <div className="row mx-0 mb-3">
                                                <div className="col-12 px-0">

                                                  <div className="row mx-0">
                                                    <div className="col-12 px-0 d-flex">
                                                      <div
                                                        onClick={() => {
                                                          setSourcingInfoTabs(1)
                                                        }}
                                                        className={`${sourcingInfoTabs === 1 ? "text-white font-w600 bg-black" : "text-black bg-light overlay-action-btn cursor-pointer"} align-items-center d-flex justify-content-center me-2 rounded p-2 `}
                                                        style={{ minWidth: '50px' }}
                                                      >
                                                        <span>{`All`}</span>
                                                      </div>

                                                      <div
                                                        onClick={() => {
                                                          setSourcingInfoTabs(2)
                                                        }}
                                                        className={`${sourcingInfoTabs === 2 ? "text-white font-w600 bg-black" : "text-black bg-light overlay-action-btn cursor-pointer"} align-items-center d-flex justify-content-center me-2 rounded p-2 `}
                                                        style={{ minWidth: '50px' }}
                                                      >
                                                        <span>{`Supports`}</span>
                                                      </div>
                                                    </div>
                                                  </div>

                                                </div>
                                              </div>
                                            }

                                            <>
                                              {sourcingInfoTabs == 1 ?
                                                <>
                                                  {sourcingInfoArr?.length > 0 ?
                                                    <>
                                                      {sourcingInfoArr?.map((item, index) => {
                                                        return (
                                                          <>
                                                            <a target="_blank" href={item?.url} rel="noreferrer">
                                                              <div className="mx-0 row mb-2">
                                                                <div
                                                                  className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                  style={{
                                                                    background: "rgba(244, 248, 255, 1)",
                                                                    border: "1px solid rgba(199, 212, 234, 1)",
                                                                  }}
                                                                >
                                                                  <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                    <div className="d-flex">
                                                                      <div
                                                                        className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                        style={{ width: "30px", height: "30px" }}
                                                                      >
                                                                        <img
                                                                          src={item?.image}
                                                                          style={{ width: "30px", height: "30px" }}
                                                                          className="rounded-3"
                                                                          alt=""
                                                                        />
                                                                      </div>

                                                                      {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                      <div className="d-flex flex-column">
                                                                        <span className="fs-6 text-black">
                                                                          {`${item?.name}`}
                                                                        </span>
                                                                        <span className="fs-7">
                                                                          {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                        </span>
                                                                      </div>

                                                                    </div>

                                                                    <div>
                                                                      <i className="bi bi-chevron-right" />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </a>
                                                          </>
                                                        )
                                                      })}
                                                    </> :
                                                    <>
                                                      <div>
                                                        <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                          <div className="mb-2">
                                                            <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                          </div>
                                                          <span>
                                                            {`No record found`}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </>
                                                  }
                                                </> :
                                                sourcingInfoTabs == 2 ?
                                                  <>
                                                    {supportsArr?.length > 0 ?
                                                      <>
                                                        {supportsArr?.map((item, index) => {
                                                          return (
                                                            <>
                                                              <a target="_blank" href={item?.url} rel="noreferrer">
                                                                <div className="mx-0 row mb-2">
                                                                  <div
                                                                    className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                    style={{
                                                                      background: "rgba(244, 248, 255, 1)",
                                                                      border: "1px solid rgba(199, 212, 234, 1)",
                                                                    }}
                                                                  >
                                                                    <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                      <div className="d-flex">
                                                                        <div
                                                                          className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                          style={{ width: "30px", height: "30px" }}
                                                                        >
                                                                          <img
                                                                            src={item?.image}
                                                                            style={{ width: "30px", height: "30px" }}
                                                                            className="rounded-3"
                                                                            alt=""
                                                                          />
                                                                        </div>

                                                                        {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                        <div className="d-flex flex-column">
                                                                          <span className="fs-6 text-black">
                                                                            {`${item?.name}`}
                                                                          </span>
                                                                          <span className="fs-7">
                                                                            {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                          </span>
                                                                        </div>

                                                                      </div>

                                                                      <div>
                                                                        <i className="bi bi-chevron-right" />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </a>
                                                            </>
                                                          )
                                                        })}
                                                      </> :
                                                      <>
                                                        <div>
                                                          <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                            <div className="mb-2">
                                                              <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                            </div>
                                                            <span>
                                                              {`No record found`}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </>
                                                    }
                                                  </> : <></>
                                              }
                                            </>
                                          </>}
                                      </div>
                                    }
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="3" className="mb-0">
                                  <h2 className="accordion-header">
                                    <Accordion.Button className="border-0 p-0 d-block">
                                      <div
                                        className={`m-1 border fs-6 font-w600 ${tabsPartsManuals === "3" ? "text-white" : "text-black"} overlay-action-btn d-flex justify-content-between align-items-center p-3 cursor-pointer`}
                                        style={{
                                          background: tabsPartsManuals === "3" ? 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)' : 'rgb(202 198 198 / 88%)',
                                        }}
                                        onClick={() => {
                                          if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                                            handleSourcingInfoFn()
                                          }
                                          if (tabsPartsManuals == "3") {
                                            setTabsPartsManuals('');
                                          } else {
                                            setTabsPartsManuals("3");
                                          }
                                        }}
                                      >
                                        {"Replacement"}{" "}
                                        {tabsPartsManuals == "3" ? (
                                          <i class="bi bi-chevron-down"></i>
                                        ) : (
                                          <i class="bi bi-chevron-up"></i>
                                        )}{" "}
                                      </div>
                                    </Accordion.Button>
                                  </h2>
                                  <Accordion.Body className="p-0">
                                    {tabsPartsManuals == "3" &&
                                      <div className="p-1 px-2 overflow-auto"
                                        style={{
                                          // maxHeight: `calc(100dvh - ${manualsFormHeight + 300}px)`
                                          maxHeight: `60dvh`
                                        }}
                                      >
                                        {sourcingInfoLoading ? <div>
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                        </div> :
                                          <>
                                            {sourcingShoppingArr?.length > 0 ?
                                              <>
                                                {sourcingShoppingArr?.map((item, index) => {
                                                  return (
                                                    <>
                                                      <a target="_blank" href={item?.url} rel="noreferrer">
                                                        <div className="mx-0 row mb-2">
                                                          <div
                                                            className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                            style={{
                                                              background: "rgba(244, 248, 255, 1)",
                                                              border: "1px solid rgba(199, 212, 234, 1)",
                                                            }}
                                                          >
                                                            <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                              <div className="d-flex">
                                                                <div
                                                                  className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                  style={{ width: "30px", height: "30px" }}
                                                                >
                                                                  <img
                                                                    src={item?.image}
                                                                    style={{ width: "30px", height: "30px" }}
                                                                    className="rounded-3"
                                                                    alt=""
                                                                  />
                                                                </div>

                                                                {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                <div className="d-flex flex-column">
                                                                  <span className="fs-6 text-black">
                                                                    {`${item?.name}`}
                                                                  </span>
                                                                  <span className="fs-7">
                                                                    {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                  </span>
                                                                </div>

                                                              </div>

                                                              <div>
                                                                <i className="bi bi-chevron-right" />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </a>
                                                    </>
                                                  )
                                                })}
                                              </> :
                                              <>
                                                <div>
                                                  <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                    <div className="mb-2">
                                                      <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                    </div>
                                                    <span>
                                                      {`No record found`}
                                                    </span>
                                                  </div>
                                                </div>
                                              </>
                                            }
                                          </>}
                                      </div>
                                    }
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* Estimates and repair and install */}
                {tabOpen == 9 && (
                  <>
                    <div
                      className="row d-flex justify-content-start bg-white"
                      style={{ borderBottom: "1px solid gray" }}>
                      <span
                        className="fs-5 d-flex justify-content-between  py-3 px-4 text-black font-w700"
                        style={{}}>
                        {/* {"Estimates"} */}
                        {serviceDetailsObj?.ticket_type_int == 1 ?
                          <>{"Estimate"}</> :
                          serviceDetailsObj?.ticket_type_int == 2 ?
                            <>{"Repair and Install"}</> : <>{"Service Summary"}</>
                        }
                        {/* <LuMoreVertical /> */}
                        <span></span>
                      </span>
                    </div>
                    <div className="row ">
                      <div className="col-12 overflow-auto"
                        style={{ height: "calc(100dvh - 125px)" }}
                      >

                        <div className="bg-white p-3">

                          <div className="row">
                            <span>
                              <span
                                className="fs-6 py-1 w-100 text-black "
                                style={{}}>
                                {(serviceDetailsObj?.ticket_type_int == 1) ?
                                  <>
                                    <span className="font-w600">{`Summary : `} </span><br />
                                    {
                                      // serviceSummaryMetaData?.recognized_estimation_summary ?
                                      //   serviceSummaryMetaData?.recognized_estimation_summary
                                      serviceSummaryMetaData?.recognized_image_summary ?
                                        serviceSummaryMetaData?.recognized_image_summary
                                          .split(/\\n|\n/)
                                          .map((line, idx) => {
                                            // Match serial number, bold label, and rest
                                            const match = line.match(/^(\d+)\.\s*\*\*(.+?)\*\*(.*)$/);
                                            if (match) {
                                              const number = match[1];
                                              const label = match[2];
                                              const value = match[3]?.trim();
                                              return (
                                                <div key={idx}>
                                                  <span>{number}. </span>
                                                  <strong>{label}</strong>
                                                  {value ? ` ${value}` : ""}
                                                </div>
                                              );
                                            }
                                            // Try to match only bold label
                                            const boldMatch = line.match(/\*\*(.+?)\*\*/);
                                            if (boldMatch) {
                                              const label = boldMatch[1];
                                              const value = line.split(/\*\*(.+?)\*\*/)[1]?.trim() || "";
                                              return (
                                                <div key={idx}>
                                                  <strong>{label}</strong>
                                                  {value ? ` ${value}` : ""}
                                                </div>
                                              );
                                            }
                                            // Otherwise, render normally
                                            return <div key={idx} style={{ maxHeight: '150px', overflowY: 'auto' }}>{line}</div>;
                                          })
                                        // formatEstimatesRepairStrings(serviceSummaryMetaData?.recognized_estimation_summary)

                                        : "Unable to provide summary."}
                                  </> :
                                  (serviceDetailsObj?.ticket_type_int == 2) ?
                                    <>
                                      <span className="font-w600">{`Repair and Install summary : `} </span> <br />
                                      {serviceSummaryMetaData?.recognized_repair_and_install_summary ?
                                        serviceSummaryMetaData?.recognized_repair_and_install_summary
                                          .split(/\\n|\n/)
                                          .map((line, idx) => {
                                            // Match serial number, bold label, and rest
                                            const match = line.match(/^(\d+)\.\s*\*\*(.+?)\*\*(.*)$/);
                                            if (match) {
                                              const number = match[1];
                                              const label = match[2];
                                              const value = match[3]?.trim();
                                              return (
                                                <div key={idx}>
                                                  <span>{number}. </span>
                                                  <strong>{label}</strong>
                                                  {value ? ` ${value}` : ""}
                                                </div>
                                              );
                                            }
                                            // Try to match only bold label
                                            const boldMatch = line.match(/\*\*(.+?)\*\*/);
                                            if (boldMatch) {
                                              const label = boldMatch[1];
                                              const value = line.split(/\*\*(.+?)\*\*/)[1]?.trim() || "";
                                              return (
                                                <div key={idx}>
                                                  <strong>{label}</strong>
                                                  {value ? ` ${value}` : ""}
                                                </div>
                                              );
                                            }
                                            // Otherwise, render normally
                                            return <div key={idx}>{line}</div>;
                                          })
                                        : "Description not specified"}
                                    </> :
                                    <>
                                      <span className="fs-6 py-1 w-100 text-black font-w700">
                                        <span className="font-w600">{`Service summary : `}</span> <br />
                                        {serviceSummaryMetaData?.recognized_image_summary ?
                                          serviceSummaryMetaData?.recognized_image_summary
                                            .split(/\\n|\n/)
                                            .map((line, idx) => {
                                              // Match serial number, bold label, and rest
                                              const match = line.match(/^(\d+)\.\s*\*\*(.+?)\*\*(.*)$/);
                                              if (match) {
                                                const number = match[1];
                                                const label = match[2];
                                                const value = match[3]?.trim();
                                                return (
                                                  <div key={idx}>
                                                    <span>{number}. </span>
                                                    <strong>{label}</strong>
                                                    {value ? ` ${value}` : ""}
                                                  </div>
                                                );
                                              }
                                              // Try to match only bold label
                                              const boldMatch = line.match(/\*\*(.+?)\*\*/);
                                              if (boldMatch) {
                                                const label = boldMatch[1];
                                                const value = line.split(/\*\*(.+?)\*\*/)[1]?.trim() || "";
                                                return (
                                                  <div key={idx}>
                                                    <strong>{label}</strong>
                                                    {value ? ` ${value}` : ""}
                                                  </div>
                                                );
                                              }
                                              // Otherwise, render normally
                                              return <div key={idx}>{line}</div>;
                                            })
                                          : "No summary available"}
                                      </span>
                                    </>}

                                {/* {`Service summary : `}
                                {serviceSummaryMetaData?.recognized_image_summary ?
                                  serviceSummaryMetaData?.recognized_image_summary
                                  : "No summary available"} */}

                              </span>
                            </span>
                          </div>


                          {serviceDetailsObj?.attachment_data && (
                            <div className="row mt-4">
                              {serviceDetailsObj?.attachment_data?.map(
                                (data, index) => {
                                  return (
                                    <span
                                      className="rounded-3 shadow border"
                                      style={{
                                        height: "50px",
                                        background: "grey",
                                        width: "40px",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                      }}>
                                      <span className="fs-6 py-1 w-100">
                                        <img
                                          src={data?.url}
                                          className="w-100 h-100 rounded-3 cursor-pointer"
                                          alt=""
                                          onClick={() => {
                                            handleOpenDoc();
                                            setImageAttachURL(data?.url)
                                          }}
                                        />
                                      </span>
                                    </span>
                                  );
                                }
                              )}
                            </div>
                          )}

                          <form
                            onSubmit={(e) => {
                              if ((serviceDetailsObj?.ticket_type_int == 1) || (serviceDetailsObj?.ticket_type_int == 2)) {
                                handleUpdateTicketSummary(e)
                              }
                            }
                            } className="mt-1"
                          >

                            {(serviceDetailsObj?.ticket_type_int == 1) && false && <>

                              <div className="row mx-0 ">
                                <div
                                  className="col-12 px-0"
                                >
                                  <InputField
                                    labelName={"Cost ($)"}
                                    placeholderName={"Cost ($)"}
                                    value={`${estimateCost}`}
                                    onChange={(e) => { handleEstimateCost(e) }}
                                    onBlur={() => { }}
                                    errorOccured={false}
                                    errorMeesage={"Please add Cost"}
                                  />
                                </div>
                              </div>

                              <div className="row mx-0">
                                <div
                                  className="col-12 px-0"
                                >
                                  <InputField
                                    labelName={"Disposal ($)"}
                                    placeholderName={"Disposal ($)"}
                                    value={`${estimateDisposal}`}
                                    onChange={(e) => { handleEstimateDisposal(e) }}
                                    onBlur={() => { }}
                                    errorOccured={false}
                                    errorMeesage={"Please add Disposal"}
                                  />
                                </div>
                              </div>

                              <div className="row mx-0">
                                <div
                                  className="col-12 px-0"
                                >
                                  <InputField
                                    labelName={"Labor ($)"}
                                    placeholderName={"Labor ($)"}
                                    value={`${estimateLabor}`}
                                    onChange={(e) => { handleEstimateLabor(e) }}
                                    onBlur={() => { }}
                                    errorOccured={false}
                                    errorMeesage={"Please add Labor"}
                                  />
                                </div>
                              </div>

                            </>}


                            {(serviceDetailsObj?.ticket_type_int == 2) && false &&
                              <div className="row mx-0">
                                <div
                                  className="col-12 px-0"
                                >
                                  <InputField
                                    labelName={"Total cost for Repair and Install ($)"}
                                    placeholderName={"Total estimate ($)"}
                                    value={`${estimatedCostByPro}`}
                                    onChange={(e) => { handleEstimatedCostByPro(e) }}
                                    onBlur={() => { }}
                                    errorOccured={false}
                                    errorMeesage={"Please add Labor"}
                                  />
                                </div>
                              </div>
                            }

                            {(serviceDetailsObj?.ticket_type_int == 1) && false && <>
                              <div className="row mx-0 ">
                                <div className="col-12 px-0 bg-black" style={{ height: '2px' }}></div>
                                <div className="col-12 px-0 pt-3 d-flex align-items-center justify-content-between">
                                  <span>{`Total Range : `}</span>
                                  <span className='text-black font-w600'>
                                    {
                                      USDollar.format(
                                        parseFloat((Number(estimateCost) + Number(estimateDisposal) + Number(estimateLabor)).toFixed(2))
                                      )
                                    }
                                  </span>
                                </div>
                              </div>
                            </>}

                            <div className="row mx-0">
                              <div className="row">
                                <div className="col-12 px-0">
                                  <TextArea
                                    labelName={"Diagnosis *"}
                                    placeholderName={"Diagnosis"}
                                    value={`${proDiagnosis}`}
                                    onChange={(e) => { handleProDiagnosis(e) }}
                                    onBlur={() => { }}
                                    errorOccured={proDiagnosisErr}
                                    errorMessage={"Please add Diagnosis"}
                                    isRequired={true}
                                    rows={3}
                                  />
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12 px-0 mb-2">
                                  <span className="fs-5 text-black font-w500">{`Estimated Cost Range`}</span>
                                </div>

                                <div className="row">
                                  <div className="col-6 px-0 pe-2">
                                    <InputField
                                      labelName={"Low ($)"}
                                      placeholderName={"Low ($)"}
                                      value={`${proEstimatedCostMin}`}
                                      onChange={(e) => { handleProEstimatedCostMin(e) }}
                                      onBlur={() => { }}
                                      errorOccured={false}
                                      errorMeesage={"Please add Labor"}
                                    />
                                  </div>
                                  <div className="col-6 px-0 ps-2">
                                    <InputField
                                      labelName={"High ($)"}
                                      placeholderName={"High ($)"}
                                      value={`${proEstimatedCostMax}`}
                                      onChange={(e) => { handleProEstimatedCostMax(e) }}
                                      onBlur={() => { }}
                                      errorOccured={false}
                                      errorMeesage={"Please add Labor"}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12 px-0 mb-3">
                                  <span className="fs-5 text-black font-w500">{`Solution recommendation`}</span>
                                </div>

                                <div className="row">
                                  <div
                                    className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                    onClick={() => {
                                      setProRecommendedSolution(1);
                                    }}
                                    style={{
                                      border: proRecommendedSolution == 1 ? "2px solid orange" : "2px solid lightgray",
                                      background: proRecommendedSolution == 1 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                      color: proRecommendedSolution == 1 ? "white" : "black",
                                    }}
                                  >
                                    <span className="fs-5 font-w600 text-center">{`DIY with Chilll Toolbox`}</span>
                                    <span className="fs-6 text-center">{`Free`}</span>
                                  </div>

                                  <div
                                    className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                    onClick={() => {
                                      setProRecommendedSolution(2);
                                    }}
                                    style={{
                                      border: proRecommendedSolution == 2 ? "2px solid orange" : "2px solid lightgray",
                                      background: proRecommendedSolution == 2 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                      color: proRecommendedSolution == 2 ? "white" : "black",
                                    }}

                                  >
                                    <span className="fs-5 font-w600 text-center">{`DIY with Remote Pro`}</span>
                                    <span className="fs-6 text-center">
                                      {`${USDollar.format(
                                        parseFloat(callChargeAmount?.toFixed(2))
                                      )} for ${callDurationTimeLimit} minutes`}
                                    </span>
                                  </div>

                                  <div
                                    className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                    onClick={() => {
                                      setProRecommendedSolution(3);
                                    }}
                                    style={{
                                      border: proRecommendedSolution == 3 ? "2px solid orange" : "2px solid lightgray",
                                      background: proRecommendedSolution == 3 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                      color: proRecommendedSolution == 3 ? "white" : "black",
                                    }}
                                  >
                                    <span className="fs-5 font-w600 text-center">{`Get Local Pro`}</span>
                                    <span className="fs-6 text-center">{`Free matching on your terms`}</span>
                                  </div>
                                </div>

                                {proRecommendedSolutionErr &&
                                  <div>
                                    <span className="text-danger font-w500 fs-12">{`Please select one of the above options`}</span>
                                  </div>
                                }
                              </div>



                            </div>

                            {((serviceDetailsObj?.ticket_type_int == 1) || (serviceDetailsObj?.ticket_type_int == 2)) &&
                              <div className="row mx-0 pb-2 pt-3">
                                <div
                                  className="col-12 px-0"
                                  style={{
                                    pointerEvents: updateTicketSummaryLoading ? "none" : "auto",
                                    opacity: updateTicketSummaryLoading ? 0.5 : 1,
                                  }}
                                >

                                  <span
                                    className="p-3 fs-5 rounded-3 bg-light text-white d-flex align-items-center justify-content-center font-w600 cursor-pointer overlay-action-btn"
                                    onClick={(e) => { handleUpdateTicketSummary(e) }}
                                    type="submit"
                                    style={{
                                      background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',

                                    }}
                                  >
                                    {updateTicketSummaryLoading ?
                                      <>
                                        <Spinner size="sm" className="me-2" />  {`Saving...`}
                                      </> :
                                      <> {`Save`}</>}
                                  </span>

                                </div>
                              </div>
                            }

                          </form>

                        </div>




                      </div>
                    </div>
                  </>
                )}
              </div>

              <div
                className="col-3 px-2 py-3"
                style={{
                  background: "rgb(240 243 247)",
                }}
              >
                {/* tab 1 info */}
                <div
                  className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered"
                  style={{
                    color: tabOpen == 1 ? "orange" : "rgba(131, 154, 192, 1)",
                  }}
                  onClick={() => {
                    handleTab(1);

                    if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                      handleClearCanvas();
                    }
                  }}
                >
                  <span className="fs-6 pointer ">
                    <FaCircleInfo />
                  </span>
                  <span
                    className="fs-7 pointer">
                    Info
                  </span>
                </div>

                {/* Estimates, Repair and Installs */}
                {((serviceDetailsObj?.ticket_type_int == 1) || (serviceDetailsObj?.ticket_type_int == 2)) && (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) && false &&
                  <div
                    className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered text-center"
                    style={{
                      color: tabOpen == 9 ? "orange" : "rgba(131, 154, 192, 1)",
                    }}
                    onClick={() => {
                      handleTab(9);
                      if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                        handleClearCanvas();
                      }
                    }}
                  >
                    <span className="fs-6 pointer ">
                      <PiToolboxBold />
                    </span>
                    <span
                      className="fs-7 pointer"
                    >
                      {(serviceDetailsObj?.ticket_type_int == 1) ?
                        <>{"Estimate"}</> :
                        (serviceDetailsObj?.ticket_type_int == 2) ?
                          <>{"Repair and Install"}</> : <>{"Service Summary"}</>
                      }
                    </span>
                  </div>
                }


                {/* tab Parts and Manuals */}
                <div
                  className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered text-center"
                  style={{
                    color: tabOpen == 8 ? "orange" : "rgba(131, 154, 192, 1)",
                  }}
                  onClick={() => {
                    handleTab(8);
                    if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                      handleSourcingInfoFn()
                    }

                    if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                      handleClearCanvas();
                    }
                  }}
                >
                  <span className="fs-6 pointer ">
                    <HiMiniWrenchScrewdriver />
                  </span>
                  <span
                    className="fs-7 pointer"
                  >
                    {`Parts and `}
                  </span>
                  <span className="fs-7 pointer">{`Manuals`}</span>
                </div>

                {/* tab -2 Draw */}
                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered"
                      style={{
                        color:
                          tabOpen == 2 ? "orange" : "rgba(131, 154, 192, 1)",
                      }}
                      onClick={() => {
                        // handleStaticDrawing()
                        if (drawingArea) {
                          dispatch(drawDisable());

                        }

                        const [localValue] = [
                          ...room?.localParticipant?.dataTracks.values(),
                        ];

                        localValue?.track?.send("end_measuring");

                        setMeasuringStatus(false);
                        handleTab(2);
                        // handleDrawing()
                      }}
                    >
                      <span
                        className="fs-6 pointer"
                      // onClick={() => {
                      //   handleStaticDrawing()
                      //   // if (drawingArea && tabOpen != 2) {
                      //   //   dispatch(drawDisable());

                      //   // }

                      //   const [localValue] = [
                      //     ...room?.localParticipant?.dataTracks.values(),
                      //   ];

                      //   localValue?.track?.send("end_measuring");

                      //   setMeasuringStatus(false);
                      //   handleTab(2);
                      //   handleDrawing()
                      // }}
                      >
                        <MdDraw />
                      </span>
                      <span
                        className="fs-7 pointer"
                      // onClick={() => {

                      //   handleStaticDrawing()
                      //   const [localValue] = [
                      //     ...room?.localParticipant?.dataTracks.values(),
                      //   ];

                      //   localValue?.track?.send("end_measuring");

                      //   setMeasuringStatus(false);
                      //   handleTab(2);
                      //   handleDrawing()

                      // }}
                      >
                        Draw
                      </span>
                    </div>
                  )}
                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered position-relative"
                      style={{
                        color:
                          tabOpen == 5 ? "orange" : "rgba(131, 154, 192, 1)",
                      }}
                      onClick={() => {

                        if (remotePlatform == "web" || remotePlatform == "IOS") {
                          setUsePhoneMessaegAlert(true);
                          setUsePhoneModalMessage("Measure");
                        } else {
                          handleClearCanvas();
                          handleTab(5);
                        }
                      }}
                    >
                      {(remotePlatform == "web" || remotePlatform == "IOS") &&
                        <span
                          className="text-white position-absolute d-flex justify-content-center align-items-center rounded-3"
                          style={{
                            background: 'rgb(251, 188, 4)',
                            top: '-4px',
                            right: '27px',
                            fontSize: '9px',
                            width: '12px',
                            height: '12px',
                            color: 'white !important',
                          }}
                        >
                          <FaExclamation />
                        </span>
                      }
                      <span
                        className="fs-6 pointer "
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      // onClick={() => {
                      //   if (!usePhoneApp) {
                      //     handleClearCanvas();
                      //     handleTab(5);
                      //   } else {
                      //     setUsePhoneMessaegAlert(true);
                      //   }
                      // }}
                      >
                        <TbRulerMeasure />
                      </span>
                      <span
                        className="fs-7 pointer"
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      // onClick={() => {
                      //   if (!usePhoneApp) {
                      //     handleClearCanvas();
                      //     handleTab(5);
                      //   } else {
                      //     setUsePhoneMessaegAlert(true);
                      //   }
                      // }}
                      >
                        Measure
                      </span>
                    </div>
                  )}
                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && participants.length > 0 && (
                  <div
                    className="d-flex justify-content-center align-items-center flex-column my-2  overlay-action-btn cursor-pointer rounded-3 text-hovered"
                    style={{
                      color: tabOpen == 7 ? "orange" : "rgba(131, 154, 192, 1)",
                    }}
                    onClick={() => {
                      // handleOcrSend()
                      handleTab(7);
                      handleStartOCR()

                      if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                        handleClearCanvas();
                      }
                    }}
                  >
                    <span className="fs-6 pointer ">
                      <IoIosQrScanner
                      // onClick={() => {
                      //   // handleOcrSend()
                      //   handleTab(7);
                      // }}
                      />
                    </span>
                    <span
                      className="fs-7 pointer text-center"
                    // onClick={() => {
                    //   // handleOcrSend()
                    //   handleTab(7);
                    // }}
                    >
                      Capture Text
                    </span>
                  </div>
                )}

                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 &&
                  tabOpen != 2 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered"
                      style={{
                        color: "rgba(131, 154, 192, 1)",
                      }}
                      onClick={() => {
                        handleLaserLineAlone();
                      }}
                    >
                      <span className="fs-6 pointer ">
                        <GiLaserburn
                          style={{
                            color: laserLine ? "orange" : "rgba(131, 154, 192, 1)",
                          }}
                        // onClick={() => {
                        //   handleLaserLineAlone();
                        // }}
                        />
                      </span>
                      <span
                        className="fs-7 pointer text-center"
                      // onClick={() => {
                      //   handleLaserLineAlone();
                      // }}
                      >
                        Laser
                      </span>
                    </div>
                  )}
                <div
                  className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered"
                  style={{
                    color: "rgba(131, 154, 192, 1)",
                  }}
                  onClick={() => {
                    setScreenshotModal(true);

                    if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                      handleClearCanvas();
                    }
                  }}
                >
                  <span className="fs-6 pointer ">
                    <IoIosFootball
                    // onClick={() => {
                    //   setScreenshotModal(true);
                    // }}
                    />
                  </span>
                  <span
                    className="fs-7 pointer text-center"
                  // onClick={() => {
                  //   setScreenshotModal(true);
                  // }}
                  >
                    Screenshot
                  </span>
                </div>


                {/* tab -3 Notes */}
                <div
                  className="d-flex justify-content-center align-items-center flex-column my-2  overlay-action-btn cursor-pointer rounded-3 text-hovered"
                  style={{
                    color: tabOpen == 3 ? "orange" : "rgba(131, 154, 192, 1)",
                    position: "relative",
                  }}
                  onClick={() => {
                    handleTab(3);
                    callNoteData();
                    setNotesCounter(0);

                    if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                      handleClearCanvas();
                    }
                  }}
                >
                  <span className="fs-6 pointer ">
                    <CgNotes
                    // onClick={() => {
                    //   handleTab(3);
                    //   callNoteData();
                    //   setNotesCounter(0);
                    // }}
                    />
                    {notesCounter > 0 && (
                      <span
                        className="fs-5"
                        style={{
                          width: "10px",
                          height: "10px",
                          background: "red",
                          position: "absolute",
                          borderRadius: "100%",
                        }}></span>
                    )}
                  </span>
                  <span
                    className="fs-7 pointer"
                  // onClick={() => {
                  //   handleTab(3);
                  //   callNoteData();
                  //   setNotesCounter(0);
                  // }}
                  >
                    Notes
                  </span>
                </div>
                {/* tab -4 Shoping */}
                <div
                  className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered "
                  style={{
                    color: tabOpen == 4 ? "orange" : "rgba(131, 154, 192, 1)",
                    position: "relative",
                  }}
                  onClick={() => {
                    handleTab(4);
                    onLoadData();
                    setShoppingListCounter(0);

                    if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                      handleClearCanvas();
                    }
                  }}
                >
                  <span className="fs-6 pointer ">
                    <MdChecklistRtl
                    // onClick={() => {
                    //   handleTab(4);
                    //   onLoadData();
                    //   setShoppingListCounter(0);
                    // }}
                    />

                    {shoppingListCounter > 0 && (
                      <span
                        className="fs-5"
                        style={{
                          width: "10px",
                          height: "10px",
                          background: "red",
                          position: "absolute",
                          borderRadius: "100%",
                        }}></span>
                    )}
                  </span>
                  <span
                    className="fs-7 pointer"
                  // onClick={() => {
                  //   handleTab(4);
                  //   onLoadData();
                  //   setShoppingListCounter(0);
                  // }}
                  >
                    List
                  </span>
                </div>

                {/* tab - 6 Check-In */}
                {callDetailsObj?.ticket_detail?.category_name_chr === "Inspection" &&
                  // participants.length > 0 &&
                  <div
                    className="d-flex justify-content-center align-items-center flex-column my-2  overlay-action-btn cursor-pointer rounded-3 text-hovered "
                    style={{
                      color: tabOpen == 6 ? "orange" : "rgba(131, 154, 192, 1)",
                      position: "relative",
                    }}
                    onClick={() => {
                      handleTab(6);
                      getHomeAreaListFn();
                      setCheckUpCounter(0);

                      if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                        handleClearCanvas();
                      }
                    }}
                  >
                    <span className="fs-6 pointer ">
                      <IoBagCheck
                      // onClick={() => {
                      //   handleTab(6);
                      //   getHomeAreaListFn();
                      //   setCheckUpCounter(0);
                      // }}
                      />

                      {
                        checkUpCounter > 0 && (
                          <span
                            className="fs-5"
                            style={{
                              width: "10px",
                              height: "10px",
                              background: "red",
                              position: "absolute",
                              borderRadius: "100%",
                            }}></span>
                          // <div
                          //   className="align-items-center d-flex justify-content-center position-absolute px-2 rounded-circle text-white"
                          //   style={{
                          //     background: "rgba(131, 154, 192, 1)",
                          //     top: '-4px',
                          //     right: '12px',
                          //   }}
                          // >
                          //   <span
                          //     className="fs-7"
                          //   >
                          //     {checkUpCounter}
                          //   </span>
                          // </div>
                        )
                      }
                    </span>
                    <span
                      className="fs-7 pointer"
                    // onClick={() => {
                    //   handleTab(6);
                    //   getHomeAreaListFn();
                    //   setCheckUpCounter(0);
                    // }}
                    >
                      Check-up
                    </span>
                  </div>
                }
                <div className="bg-black my-3" style={{ height: '2px' }}></div>

                {/* tab -5 Mute unmoute */}
                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2   overlay-action-btn cursor-pointer rounded-3 text-hovered "
                      style={{
                        color: "rgba(131, 154, 192, 1)",
                      }}
                      onClick={() => {
                        if (!participantMicStatus) {
                          handleMute();
                        } else {
                          handleUnmute();
                        }
                      }}
                    >
                      <span className="fs-6 pointer ">
                        {!participantMicStatus && (
                          <BsFillMicMuteFill
                            id="muteAudio"
                          // onClick={handleMute}
                          />
                        )}
                        {participantMicStatus && (
                          <BsFillMicFill
                            id="muteAudio"
                          // onClick={handleUnmute}
                          />
                        )}
                      </span>
                      <span className="fs-7 pointer"
                      //  onClick={handleMute}
                      >
                        {!participantMicStatus ? "Mute" : "Unmute"}
                      </span>
                    </div>
                  )}

                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered "
                      style={{
                        color: "rgba(131, 154, 192, 1)",
                        cursor: !drawingArea ? "pointer" : "not-allowed"
                      }}
                      onClick={

                        () => { !drawingArea && handleAnotherFlipCamera() }

                      }
                    >
                      <span className="fs-6  ">
                        <MdOutlineFlipCameraIos
                        // onClick={

                        //   () => { !drawingArea && handleAnotherFlipCamera() }

                        // }
                        />
                      </span>
                      <span
                        className="fs-7  text-center"
                      // onClick={
                      //   () => {
                      //     !drawingArea && handleAnotherFlipCamera()
                      //   }
                      // }
                      >
                        Camera
                      </span>
                    </div>
                  )}
                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered position-relative"
                      style={{
                        color: "rgba(131, 154, 192, 1)",
                      }}
                      onClick={() => {

                        if (remotePlatform == "web") {
                          setUsePhoneMessaegAlert(true);
                          setUsePhoneModalMessage("Flash");
                        } else {
                          // handleClearCanvas();
                          // handleMobileTabs(8);
                          // handleOpenMobileBottomDrawer();
                          handleFlashOn();
                        }
                      }}
                    >
                      {usePhoneApp &&
                        <span
                          className="text-white position-absolute d-flex justify-content-center align-items-center rounded-3"
                          style={{
                            background: 'rgb(251, 188, 4)',
                            top: '-4px',
                            right: '27px',
                            fontSize: '9px',
                            width: '12px',
                            height: '12px',
                            color: 'white !important',
                          }}
                        >
                          <FaExclamation />
                        </span>
                      }
                      <span className="fs-6 pointer ">
                        <MdOutlineFlashlightOff
                          style={{
                            opacity: usePhoneApp ? '0.7' : '1',
                          }}
                        // onClick={() => {
                        //   if (!usePhoneApp) {
                        //     handleFlashOn()
                        //   } else {
                        //     setUsePhoneMessaegAlert(true);
                        //   }
                        // }}
                        />
                      </span>
                      <span
                        className="fs-7 pointer text-center"
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      // onClick={() => {
                      //   if (!usePhoneApp) {
                      //     handleFlashOn()
                      //   } else {
                      //     setUsePhoneMessaegAlert(true);
                      //   }
                      // }}
                      >
                        Flash
                      </span>
                    </div>
                  )}



                {/* {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 "
                      style={{
                        color: "rgba(131, 154, 192, 1)",
                      }}
                    >
                      <span>
                        <FaPlus
                          className="fs-6 pointer text-hovered "
                          onClick={() => {
                            if (!usePhoneApp) {
                              zoomIn();
                            } else {
                              setUsePhoneMessaegAlert(true);
                              setUsePhoneModalMessage("Zoom");
                            }

                          }}
                        />
                        <MdOutlineResetTv
                          className="fs-6 pointer text-hovered "
                          style={{ marginLeft: "1px", marginRight: "1px" }}
                          onClick={() => {
                            if (!usePhoneApp) {
                              zoomReset();
                            } else {
                              setUsePhoneMessaegAlert(true);
                              setUsePhoneModalMessage("Zoom");
                            }

                          }}
                        />
                        <FaMinus
                          className="fs-6 pointer text-hovered "
                          onClick={() => {
                            if (!usePhoneApp) {
                              zoomOut();
                            } else {
                              setUsePhoneMessaegAlert(true);
                              setUsePhoneModalMessage("Zoom");
                            }
                          }}
                        />
                      </span>

                      <span className="fs-7 pointer text-center">Zoom</span>
                    </div>
                  )} */}

                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered position-relative"
                      style={{
                        color: "rgba(131, 154, 192, 1)",

                      }}
                      onClick={() => {
                        if (!usePhoneApp) {
                          zoomIn();
                        } else {
                          setUsePhoneMessaegAlert(true);
                          setUsePhoneModalMessage("Zoom");
                        }

                      }}
                    >
                      {usePhoneApp &&
                        <span
                          className="text-white position-absolute d-flex justify-content-center align-items-center rounded-3"
                          style={{
                            background: 'rgb(251, 188, 4)',
                            top: '-4px',
                            right: '27px',
                            fontSize: '9px',
                            width: '12px',
                            height: '12px',
                            color: 'white !important',
                          }}
                        >
                          <FaExclamation />
                        </span>
                      }
                      <span
                        className="fs-6 pointer "
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      >
                        <BsZoomIn />
                      </span>
                      <span
                        className="fs-7 pointer text-center"
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      >
                        Zoom-in
                      </span>
                    </div>
                  )}

                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered position-relative"
                      style={{
                        color: "rgba(131, 154, 192, 1)",
                      }}
                      onClick={() => {
                        if (!usePhoneApp) {
                          zoomReset();
                        } else {
                          setUsePhoneMessaegAlert(true);
                          setUsePhoneModalMessage("Zoom");
                        }
                      }}
                    >
                      {usePhoneApp &&
                        <span
                          className="text-white position-absolute d-flex justify-content-center align-items-center rounded-3"
                          style={{
                            background: 'rgb(251, 188, 4)',
                            top: '-4px',
                            right: '27px',
                            fontSize: '9px',
                            width: '12px',
                            height: '12px',
                            color: 'white !important',
                          }}
                        >
                          <FaExclamation />
                        </span>
                      }
                      <span
                        className="fs-6 pointer "
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      >
                        <TbZoomCancel />
                      </span>
                      <span
                        className="fs-7 pointer text-center"
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      >
                        Reset
                      </span>
                    </div>
                  )}

                {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                  participants.length > 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center flex-column my-2 overlay-action-btn cursor-pointer rounded-3 text-hovered position-relative"
                      style={{
                        color: "rgba(131, 154, 192, 1)",
                      }}
                      onClick={() => {
                        if (!usePhoneApp) {
                          zoomOut();
                        } else {
                          setUsePhoneMessaegAlert(true);
                          setUsePhoneModalMessage("Zoom");
                        }
                      }}
                    >
                      {usePhoneApp &&
                        <span
                          className="text-white position-absolute d-flex justify-content-center align-items-center rounded-3"
                          style={{
                            background: 'rgb(251, 188, 4)',
                            top: '-4px',
                            right: '27px',
                            fontSize: '9px',
                            width: '12px',
                            height: '12px',
                            color: 'white !important',
                          }}
                        >
                          <FaExclamation />
                        </span>
                      }
                      <span
                        className="fs-6 pointer "
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      >
                        <BsZoomOut />
                      </span>
                      <span
                        className="fs-7 pointer text-center"
                        style={{
                          opacity: usePhoneApp ? '0.7' : '1',
                        }}
                      >
                        Zoom-out
                      </span>
                    </div>
                  )}


              </div>
            </div>
          </div>

          {/* New UI design for mobile view start here */}

          {/* Mobile View top call duration here */}
          <div
            className="position-absolute video-call-mobile-view-timer"
            style={{ top: "75px", left: "10px" }}>
            <div className="d-flex" style={{}}>
              <CallDuration participants={participants} joinCallRes={joinCallRes} />
            </div>
          </div>
          <BackDropReconnecting show={localParticipantReconnecting} message={"Your internet is not stable"} />
          {/* Mobile View top container starts here */}
          <div
            className="row position-absolute mx-0 video-call-mobile-view-top-container"
            style={{
              top: 0,
              background: 'rgba(0, 0, 0, 0.11)',
            }}
          >
            <div className="col-12 px-0">
              <div
                className={`row mx-0 pt-3 ${!permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")
                  ? "pb-3"
                  : ""
                  }`}>
                <div className="col-2 ps-2 pe-2 d-flex align-items-center">
                  {/* <span className="fs-4 cursor-pointer">
                    <IoMdArrowRoundBack
                      className=""
                      onClick={() => {
                        setEndCallPopUp(true);
                      }}
                      style={{ width: "18px", height: "18px", color: "rgb(131, 154, 192)" }}
                    />
                  </span> */}

                  {/* Call End */}
                  <div className="d-flex align-items-center">
                    {/* <span
                      className="font-w600 py-1 px-3 text-white cursor-pointer"
                      style={{ background: "red", }}
                      onClick={() => {
                        setEndCallPopUp(true);
                      }}>
                      End
                    </span> */}

                    <div className="position-relative">
                      <div
                        className={`align-items-center d-flex flex-column justify-content-center p-2`}

                        onClick={() => {
                          setEndCallPopUp(true);
                        }}
                      >
                        <span
                          className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                          style={{
                            width: "40px",
                            height: "40px",
                            background: "rgb(0 0 0 / 27%)",
                            color: "white",
                          }}
                        >
                          <IoChevronBackSharp
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>

                      </div>
                    </div>
                  </div>

                </div>



                <div className="col-10 px-2 d-flex align-items-center justify-content-end">
                  <div className="d-flex">
                    {/* Feedback control */}

                    <span
                      className="fs-4 icons-videos-my-control me-3"
                      style={{ color: "rgb(131, 154, 192)" }}
                    >
                      <i
                        className="bi bi-gear pointer"
                        style={{ width: "22px", height: "22px" }}
                        onClick={() => {
                          setResourceModal(true);
                        }}></i>
                    </span>

                    <div
                      className="me-3 d-flex align-items-center"
                      style={{ color: "rgb(131, 154, 192)" }}
                    >
                      <span className="">
                        <PiCircleDashedFill
                          style={{ width: "22px", height: "22px" }}
                          onClick={() => {
                            setScreenshotModal(true);
                          }}
                        />
                      </span>
                    </div>

                    {permissionArray.includes(
                      "CONTROL REMOTE SCREEN ACTIONS"
                    ) && (
                        <>
                          {/* My mic control */}
                          <div
                            className="me-3 d-flex align-items-center "
                            style={{ color: "rgb(131, 154, 192)" }}
                          >
                            <span className="">
                              {micStatus ? (
                                <BsFillMicFill
                                  id="muteAudio"
                                  onClick={handleMicStatus}
                                  style={{ width: "19px", height: "19px" }}
                                />
                              ) : (
                                <span>
                                  <BsFillMicMuteFill
                                    onClick={handleMicOffStatus}
                                    style={{
                                      width: "19px",
                                      height: "19px",
                                      color: "red",
                                    }}
                                  />
                                </span>
                              )}
                            </span>
                          </div>

                          {/* My video Control */}
                          <div
                            className="me-3 d-flex align-items-center"
                            style={{ color: "rgb(131, 154, 192)" }}
                          >
                            <span className="">
                              {cameraCheckCustomer ? (
                                <>
                                  {videoStatus && (
                                    <BsFillCameraVideoFill
                                      onClick={handleVideoStatus}
                                      style={{ width: "25px", height: "25px" }}
                                    />
                                  )}

                                  {!videoStatus && (
                                    <BsFillCameraVideoOffFill
                                      onClick={handleVideoOffStatus}
                                      style={{
                                        width: "25px",
                                        height: "25px",
                                        color: "red",
                                      }}
                                    />
                                  )}
                                </>
                              ) : (
                                <>
                                  {videoStatus && (
                                    <BsFillCameraVideoFill
                                      style={{
                                        color: "#ffbc9be6",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  )}

                                  {!videoStatus && (
                                    <BsFillCameraVideoOffFill
                                      style={{
                                        color: "#ffbc9be6",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  )}
                                </>
                              )}
                            </span>
                          </div>

                          {/* Swicth camera */}
                          <div
                            className="me-3 d-flex align-items-center"
                            style={{ color: "rgb(131, 154, 192)" }}
                          >
                            <span className="">
                              {cameraCheckCustomer ? (
                                <>
                                  <MdOutlineFlipCameraIos
                                    onClick={toggleFacingMode}
                                    style={{ width: "25px", height: "25px" }}
                                  />
                                </>
                              ) : (
                                <>
                                  <MdOutlineFlipCameraIos
                                    style={{
                                      color: "#ffbc9be6",
                                      cursor: "not-allowed",
                                      width: "25px",
                                      height: "25px",
                                    }}
                                  />
                                </>
                              )}
                            </span>
                          </div>
                        </>
                      )}


                  </div>
                </div>
              </div>

              {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && (
                <div className="row mx-0">
                  <div className="col-12 p-1 d-flex justify-content-center align-items-center ">
                    <span style={{ color: "#717171" }}>{"My Controlls"}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Mobile View top container ends here */}

          {/* Mobile View bottom container starts here */}
          <div
            className="row position-absolute mx-0 video-call-mobile-view-bottom-container rounded-top"
            style={{
              bottom: 0,
              zIndex: "110",
              // background: 'rgb(235, 240, 250)'
            }}
          >
            <div className="col-12 position-relative">
              {/* Bottom mobile view drawer for info, notes, and purchase list */}

              <div
                className={`row mx-0 mobile-view-drawer-custom ${mobileBottomDrawer ? "open" : ""} bg-white rounded-top w-100 position-absolute`}
                style={{ bottom: '0' }}
              >
                <div className="col-12 px-0">
                  {/* General Info */}
                  {mobileTabs == 1 && (
                    <>
                      <div className="row mx-0">
                        <div className="col-12">

                          <div
                            className="row mx-0 border-bottom p-3 rounded-top"
                            style={{ background: 'rgb(235, 240, 250)' }}
                          >
                            <div className="align-items-center col-12 d-flex font-w600 fs-3 justify-content-between px-0 text-black">
                              <div className=" d-flex align-items-center">
                                <span
                                  onClick={() => {
                                    handleCloseMobileBottomDrawer();
                                    setMobileTabs();
                                  }}
                                  className="cursor-pointer">
                                  <MdClose />
                                </span>
                              </div>

                              <div className="d-flex align-items-center">
                                <span>{"General Information"}</span>
                              </div>

                              <div>{/* More option */}</div>
                            </div>
                          </div>

                          <div className="overflow-auto" style={{ maxHeight: '70dvh' }}>
                            <div className="p-3 bg-white">
                              <div className="row mx-0">
                                <div className="col-12 px-0 d-flex">
                                  {/* <div className="align-items-center border-end d-flex font-w700 pe-4">
                                  <span>
                                    {new Intl.DateTimeFormat("en-US", {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                    }).format(time)}
                                  </span>
                                </div> */}

                                  <div className="align-items-center d-flex font-w400">
                                    <span>
                                      {`Service request: #${serviceDetailsObj?.display_id_int}`}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="row mx-0 pt-2">
                                <div className="col-12 px-0">
                                  {/* <span className="bg-white px-3 py-1 rounded-pill text-black fs-7">
                                {callDetailsObj?.ticket_detail
                                  ?.product_type_chr == ""
                                  ? "NA"
                                  : callDetailsObj?.ticket_detail
                                    ?.product_type_chr}
                              </span> */}

                                  {serviceDetailsObj?.category_display_name_chr ?
                                    <span
                                      className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                      style={{
                                        background: "rgba(79, 93, 116, 1)",
                                      }}>
                                      {`${serviceDetailsObj?.category_display_name_chr} ${((serviceDetailsObj?.product_type_chr !== "null") && (serviceDetailsObj?.product_type_chr !== null) && (serviceDetailsObj?.product_type_chr !== "")) ? ` / ${serviceDetailsObj?.product_type_chr}` : ''}`}
                                    </span> :
                                    <span
                                      className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                      style={{
                                        background: 'rgba(199, 212, 234, 1)'
                                      }}>
                                      {`No category`}
                                    </span>
                                  }
                                </div>
                              </div>

                              <div className="row mx-0 pt-2">
                                <div className="col-12 px-0">
                                  <span className="text-black font-w600 fs-4">
                                    {serviceDetailsObj?.msg_chr ? serviceDetailsObj?.msg_chr :
                                      serviceDetailsObj?.problem_description_chr
                                        ? serviceDetailsObj?.problem_description_chr
                                        : "Problem description not specified"}
                                  </span>
                                </div>
                              </div>

                              {serviceDetailsObj?.attachment_data && (
                                <div className="row mt-2">
                                  {serviceDetailsObj?.attachment_data?.map(
                                    (data, index) => {
                                      return (
                                        <span
                                          className="rounded-3 shadow border"
                                          style={{
                                            height: "50px",
                                            background: "grey",
                                            width: "40px",
                                            marginRight: "10px",
                                            marginBottom: "10px",
                                          }}>
                                          <span className="fs-6 py-1 w-100">
                                            <img
                                              src={data?.url}
                                              className="w-100 h-100 rounded-3 cursor-pointer"
                                              alt=""
                                              onClick={() => {
                                                handleOpenDoc();
                                                setImageAttachURL(data?.url)
                                              }}
                                            />
                                          </span>
                                        </span>
                                      );
                                    }
                                  )}
                                </div>
                              )}

                              {serviceDetailsObj?.latest_created_call_details?.video_link_new_chr &&
                                <div className="row">
                                  <div className="col-12 p-2 border border-light rounded-3">
                                    <div className=' mx-0 row p-1 rounded'
                                      style={{
                                        background: 'rgba(244, 248, 255, 1)',
                                        border: '1px solid rgba(199, 212, 234, 1)',
                                      }}
                                    >
                                      <div className='col-11 px-0 d-flex  '>

                                        <div className='overflow-hidden p-2  text-nowrap w-100 whitespace-nowrap' style={{ textOverflow: "ellipsis" }}>
                                          <span>
                                            {serviceDetailsObj?.latest_created_call_details?.video_link_new_chr}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-1 px-0 fs-3 d-flex align-items-center justify-content-end text-black pe-2' style={{}}>
                                        <div className="tooltipCustom ">
                                          <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Copy to clipboard"}</span>
                                          <span
                                            onClick={() => {
                                              navigator.clipboard.writeText(
                                                `${serviceDetailsObj?.latest_created_call_details?.video_link_new_chr}`
                                              );
                                              copyToClipboard()
                                            }}
                                            className={`cursor-pointer text-hovered`}
                                          >
                                            <MdContentCopy style={{ fontSize: "12px" }} />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className=' mx-0 row mt-1'>
                                      <div className='col-12 px-0'>
                                        <span className="fs-7">
                                          {"You can copy and send a video call link via any messenger you use for communication."}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>

                            <div className="row mx-0 p-3">
                              <div className="col-12 px-0">

                                <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                                  <div className='col-5'>
                                    <span>{`Job started`}</span>
                                  </div>
                                  <div className='col-7'>
                                    <span className='font-w600 text-black'>{`${serviceDetailsObj?.created_date_dtm ? formatUnixTimestamp(serviceDetailsObj?.created_date_dtm) : `-`}`}</span>
                                  </div>
                                </div>

                                <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                                  <div className='col-5'>
                                    <span>{`Last call`}</span>
                                  </div>
                                  <div className='col-7'>
                                    <span className='font-w600 text-black'>{`${serviceDetailsObj?.last_call_dtm ? formatUnixTimestamp(serviceDetailsObj?.last_call_dtm) : `-`}`}</span>
                                  </div>
                                </div>

                                <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                                  <div className='col-5'>
                                    <span>{`Brand`}</span>
                                  </div>
                                  <div className='col-7'>
                                    <span className='font-w600 text-black'>{`${serviceDetailsObj?.device_brand_chr ? serviceDetailsObj?.device_brand_chr : "-"}`}</span>
                                  </div>
                                </div>

                                <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                                  <div className='col-5'>
                                    <span>{`Model`}</span>
                                  </div>
                                  <div className='col-7'>
                                    <span className='font-w600 text-black'>{`${serviceDetailsObj?.model_number_chr ? serviceDetailsObj?.model_number_chr : "-"}`}</span>
                                  </div>
                                </div>

                                <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                                  <div className='col-5'>
                                    <span>{`Serial #`}</span>
                                  </div>
                                  <div className='col-7'>
                                    <span className='font-w600 text-black'>{`${serviceDetailsObj?.serial_number_chr ? serviceDetailsObj?.serial_number_chr : "-"}`}</span>
                                  </div>
                                </div>

                                <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                                  <div className='col-5'>
                                    <span>{`Initiator`}</span>
                                  </div>
                                  <div className='col-7'>
                                    <span className='font-w600 text-black'>{`${serviceDetailsObj?.creator_name_chr ? serviceDetailsObj?.creator_name_chr : "-"}`}</span>
                                  </div>
                                </div>

                                <div className='bg-white border border-light mb-1 mx-0 px-3 py-2 rounded-3 row shadow'>
                                  <div className='col-5'>
                                    <div className="tooltipCustom">
                                      <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Add note"}</span>
                                      <i className="bi bi-info-circle text-hovered"></i>
                                    </div>

                                    <span className='ms-2'>{`Personal note`}</span>
                                  </div>
                                  <div className='col-7'>
                                    {(Object?.keys(personalNoteObj)?.length !== 0) ?
                                      <>
                                        <div className='row'>
                                          <div className='col-10 d-flex flex-column'>
                                            {!toggleForAddPersonalNote ?
                                              <span className='font-w600 text-black'>{`${serviceDetailsObj?.personal_notes?.note_chr}`}</span> :
                                              <>
                                                <TextArea
                                                  labelName={`Note`}
                                                  value={discussionVal}
                                                  onChange={discussionOnChange}
                                                  onBlur={() => { }}
                                                />

                                                <div
                                                  className=''
                                                  style={{
                                                    pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                                    opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                                  }}
                                                >
                                                  <PrimaryButton
                                                    buttonName={`SAVE`}
                                                    onClick={() => { handleSaveDiscussion() }}
                                                    loadingMessage={"SAVING..."}
                                                    isLoading={saveLoading}
                                                    style={{
                                                      width: '100%',
                                                      background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                      border: '2px solid rgba(255, 154, 32, 1)',
                                                      boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    }}
                                                  />
                                                </div>
                                              </>}

                                          </div>

                                          <div className='col-2 d-flex justify-content-center'>
                                            {!toggleForAddPersonalNote ?
                                              <i
                                                onClick={() => { setToggleForAddPersonalNote(true); setDiscussionVal(serviceDetailsObj?.personal_notes?.note_chr) }}
                                                className='bi bi-pencil cursor-pointer text-black text-hovered'
                                                style={{ fontSize: '12px' }}
                                              ></i> :
                                              <i
                                                className='bi bi-x-lg cursor-pointer text-hovered fs-4'
                                                onClick={() => { setToggleForAddPersonalNote(false) }}
                                              ></i>
                                            }

                                          </div>
                                        </div>
                                      </>
                                      :
                                      <>
                                        {!toggleForAddPersonalNote ?
                                          <div className='col-12 d-flex'>
                                            <div
                                              className='cursor-pointer text-hovered'
                                              onClick={() => { setToggleForAddPersonalNote(true) }}
                                            >
                                              <span className='font-w600'>{`Add note`}</span>
                                              <span className='font-w600' style={{ fontSize: '12px' }}>
                                                <i className="bi bi-pencil ps-2 text-black"></i>
                                              </span>
                                            </div>
                                          </div> :

                                          <div className='row'>
                                            <div className='col-10 d-flex flex-column'>
                                              <TextArea
                                                labelName={`Note`}
                                                value={discussionVal}
                                                onChange={discussionOnChange}
                                                onBlur={() => { }}
                                              />

                                              <div
                                                className=''
                                                style={{
                                                  pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                                  opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                                }}
                                              >
                                                <PrimaryButton
                                                  buttonName={`SAVE`}
                                                  onClick={() => { handleSaveDiscussion() }}
                                                  loadingMessage={"SAVING..."}
                                                  isLoading={saveLoading}
                                                  style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                  }}
                                                />
                                              </div>

                                            </div>

                                            <div className='col-2 d-flex justify-content-center'>
                                              <i
                                                onClick={() => { setToggleForAddPersonalNote(false) }}
                                                className='bi bi-x-lg cursor-pointer text-hovered fs-4'
                                              ></i>
                                            </div>
                                          </div>
                                        }
                                      </>
                                    }
                                  </div>
                                </div>


                                {/* <div className="row mx-0 mb-3 mt-4">
                                  <div className="col-12 px-0">
                                    <div className="mb-2">
                                      <span className="font-w600 text-gray">{`External resources`}</span>
                                    </div>

                                    <div
                                      className="d-flex justify-content-between"
                                      title={`${(!serviceDetailsObj?.product_type_chr) ? "Product or brand not found" : ""}`}
                                    >
                                      <div
                                        className=" px-2 py-3 rounded-2 shadow-sm d-flex justify-content-center align-items-center font-w600 overlay-action-btn cursor-pointer text-white font-w600"
                                        style={{
                                          width: '49%',
                                          // color: 'rgb(110 137 183)',
                                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                          border: '2px solid rgba(255, 154, 32, 1)',
                                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                          pointerEvents: (serviceDetailsObj?.product_type_chr) ? 'auto' : 'none',
                                          opacity: (serviceDetailsObj?.product_type_chr) ? '1' : '0.5',
                                        }}
                                        onClick={() => {
                                          // handleOpenSourcingInfoModal();
                                          handleSourcingInfoFn(1);
                                          handleOpenMobileMoreActionsDrawer();
                                          handleMobileMoreActionsTabs(4);
                                        }}
                                      >
                                        <span className="text-center">{`Owners manual`}</span>
                                      </div>

                                      <div
                                        className=" px-2 py-3 rounded-2 shadow-sm d-flex justify-content-center align-items-center font-w600 overlay-action-btn cursor-pointer text-white font-w600"
                                        style={{
                                          width: '49%',
                                          // color: 'rgb(110 137 183)',
                                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                          border: '2px solid rgba(255, 154, 32, 1)',
                                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                          pointerEvents: (serviceDetailsObj?.product_type_chr) ? 'auto' : 'none',
                                          opacity: (serviceDetailsObj?.product_type_chr) ? '1' : '0.5',
                                        }}
                                        onClick={() => {
                                          // handleOpenSourcingInfoModal();
                                          handleSourcingInfoFn(0);
                                          handleOpenMobileMoreActionsDrawer();
                                          handleMobileMoreActionsTabs(4);
                                        }}
                                      >
                                        <span className="text-center">{`Parts and tools`}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div> */}

                              </div>

                            </div>
                          </div>

                        </div>
                      </div>
                    </>
                  )}

                  {/* Notes */}
                  {mobileTabs == 3 && (
                    <>
                      <div className="row mx-0">
                        <div className="col-12">
                          <div className="row mx-0 border-bottom p-3 rounded-top"
                            style={{ background: 'rgb(235, 240, 250)' }}
                          >
                            <div className="align-items-center col-12 d-flex font-w600 fs-3 justify-content-between px-0 text-black">
                              <div className=" d-flex align-items-center">
                                <span
                                  onClick={() => {
                                    handleCloseMobileBottomDrawer();
                                    setMobileTabs();
                                  }}
                                  className="cursor-pointer">
                                  <MdClose />
                                </span>
                              </div>

                              <div className="d-flex align-items-center">
                                <span>{`Notes`}</span>
                              </div>

                              <div>
                                <span
                                  onClick={() => {
                                    handleOpenMobileMoreActionsDrawer();
                                    handleMobileMoreActionsTabs(1);
                                  }}>
                                  <LuMoreVertical style={{ color: "black" }} />
                                </span>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row mx-0 pt-2 overflow-auto"
                            style={{ maxHeight: "60dvh", minHeight: '45dvh' }}
                          >
                            <div className="col-12 px-0">
                              {callNoteDetailsArr?.length > 0 ? (
                                <>
                                  {callNoteDetailsArr?.map((element, index) => (
                                    <div
                                      className={`row mx-0 py-2 p-3 ${index < callNoteDetailsArr.length - 1 && "border-bottom"}`}
                                    >
                                      {/* new notes */}
                                      <div className="col-12 px-0 d-flex justify-content-between">
                                        <div className="d-flex justify-content-center align-items-center">
                                          <div className="pe-3">
                                            <img src={element?.preferred_profile_picture_url} className="rounded-2" style={{ width: "40px", height: "40px" }} alt="" />
                                          </div>

                                          <div className="d-flex flex-column">
                                            <div>
                                              <span className="text-black font-w600">{`${element?.created_by_name}`}</span>
                                            </div>

                                            <div>
                                              <span>
                                                {new Intl.DateTimeFormat("en-US", {
                                                  year: "numeric",
                                                  month: "short",
                                                  day: "numeric",
                                                  hour: 'numeric',
                                                  minute: 'numeric',
                                                  hour12: true
                                                }).format(
                                                  element?.created_date_dtm * 1000
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </div>

                                        {localStorage.getItem("user_id") &&
                                          <div>
                                            <span
                                              onClick={() => {
                                                handleMenuClickNoteMobile(
                                                  element,
                                                  index
                                                );
                                              }}
                                              className="pe-2 text-black font-w600">
                                              <LuMoreVertical />
                                            </span>
                                          </div>
                                        }
                                      </div>

                                      <div className="col-12 mt-3">
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: element?.note_chr,
                                          }}
                                        />
                                      </div>

                                      <div className='col-12 mt-2 d-flex overflow-auto'>
                                        {element?.attachment_url?.length > 0 &&
                                          <>
                                            {element?.attachment_url?.map((item, i) => {
                                              return (
                                                <div key={i}>
                                                  <img
                                                    className="me-2 mb-2 rounded-3 cursor-pointer border"
                                                    src={item}
                                                    alt=""
                                                    style={{ width: '90px', height: '100px' }}
                                                    onClick={() => {
                                                      handleOpenDoc();
                                                      setImageAttachURL(item);
                                                      setNotesMessage(element?.note_chr)
                                                    }}
                                                  />
                                                </div>
                                              )
                                            })}
                                          </>
                                        }
                                      </div>


                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div className="row my-4">
                                  {/* <span className="fs-7  ">
                                  No notes added yet
                                </span> */}

                                  <div className="mb-3 d-flex justify-content-center align-items-center flex-column">
                                    <div className="mb-2">
                                      <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                    </div>
                                    <span>
                                      {`No notes added yet`}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row mx-0 pb-2 p-3 border-bottom position-relative bg-white"
                            style={{
                              boxShadow: "rgba(0, 0, 0, 0.31) 0px -6px 10px -2px",
                            }}
                            onClick={() => {
                              handleOpenMobileMoreActionsDrawer();
                              handleMobileMoreActionsTabs(1);
                              setMobileNotesTabs(3);
                            }}
                          >
                            <div
                              className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-center px-0"
                              style={{ color: 'rgba(131, 154, 192, 1)' }}
                            >
                              <div className="d-flex align-items-center">
                                <span>{`Add note`}</span>

                                <span>
                                  <i className="bi bi-chevron-up ms-2" />
                                </span>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                    </>
                  )}

                  {/* Shopping List */}
                  {mobileTabs == 4 && (
                    <>
                      <div className="row mx-0">
                        <div className="col-12">
                          <div className="row mx-0 border-bottom p-3 rounded-top"
                            style={{ background: 'rgb(235, 240, 250)' }}
                          >
                            <div className="align-items-center col-12 d-flex font-w600 fs-3 justify-content-between px-0 text-black">
                              <div className=" d-flex align-items-center">
                                <span
                                  onClick={() => {
                                    handleCloseMobileBottomDrawer();
                                    setMobileTabs();
                                  }}
                                  className="cursor-pointer">
                                  <MdClose />
                                </span>
                              </div>

                              <div className="d-flex align-items-center">
                                <span>{`List`}</span>
                              </div>

                              <div>
                                <span
                                  onClick={() => {
                                    handleOpenMobileMoreActionsDrawer();
                                    handleMobileMoreActionsTabs(2);
                                  }}>
                                  <LuMoreVertical style={{ color: "black" }} />
                                </span>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row py-2 border-bottom px-3 bg-white"
                          >
                            <div className="col-12 px-0 d-flex align-items-center justify-content-between">
                              <div>
                                <span>{`Added : `}</span>
                                <span className='font-w600 text-black'>{` ${rows.length} items`}</span>
                              </div>

                              <div>
                                <span>{`Total cost : `}</span>
                                <span className='font-w600 text-black'>
                                  {USDollar.format(
                                    parseFloat(totalCost.toFixed(2))
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row mx-0 pt-2 overflow-auto"
                            style={{ maxHeight: "60dvh", minHeight: '45dvh' }}
                          >

                            <div className="col-12 px-0">
                              {rows?.length > 0 ? (
                                <>
                                  {rows?.map((element, index) => (
                                    <div
                                      className={`row mx-0  p-3 ${index < rows.length - 1 ? "border-bottom" : ""}`}
                                      style={{
                                        pointerEvents: purchaseLoading ? 'none' : 'auto',
                                        opacity: purchaseLoading ? '0.5' : '1',
                                      }}
                                      onClick={(e) => {
                                        e?.preventDefault();
                                        handleViewPurchaseItem(element);
                                        setMobileMoreActionsTabs(2);
                                        handleOpenMobileMoreActionsDrawer();
                                        setMobileShoppingListTabs(7);
                                      }}
                                    >

                                      {/* New flow purchase */}
                                      <div className="col-12 px-0 d-flex">

                                        {/* <div className='pe-3 d-flex justify-content-center'>
                                          <div>
                                            {
                                              <div className='rounded-2 shadow-lg'>
                                                <div
                                                  className='rounded-2 d-flex justify-content-center align-items-center'
                                                  style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                >
                                                  <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                        </div> */}
                                        <div className="w-100">
                                          <div className="row mx-0">
                                            <div className="col-6 d-flex justify-content-start align-items-center">
                                              <span className="fs-7">
                                                <span className='pe-2'>{index + 1}.</span>
                                                <span className="text-black font-w600">{element?.item_name_chr}</span>
                                              </span>
                                            </div>

                                            <div className="col-6 d-flex justify-content-end align-items-center">
                                              <span
                                                className="fs-7 text-black font-w600"
                                                style={{}}>
                                                ({element?.quantity_int}) X{" "}
                                                {USDollar.format(
                                                  element?.estimated_price_float /
                                                  element?.quantity_int
                                                )}{" "}
                                                &nbsp; &nbsp;{" "}



                                                <span
                                                  onClick={(e) => {
                                                    e?.stopPropagation();
                                                    handleMenuClickShoppingMobile(
                                                      element,
                                                      index
                                                    );
                                                  }}
                                                  className="pe-2 text-black font-w600">
                                                  <LuMoreVertical />
                                                </span>

                                              </span>
                                            </div>
                                          </div>

                                          <div className="row mx-0  mt-2">
                                            <span className="fs-7">
                                              {element?.description_chr}
                                            </span>
                                          </div>

                                          {element?.purchase_link_chr != "" && (
                                            <div className="row mx-0  mt-2">
                                              <div className="col-12 d-flex justify-content-start align-items-center">
                                                {urlPattern.test(element?.purchase_link_chr) ?
                                                  <>
                                                    <div className="d-flex align-items-center">

                                                      <span className="text-black font-w600 fs-7 me-2">{`Website: `}</span>
                                                      <a
                                                        className="text-black font-w600 text-hovered"
                                                        href={
                                                          // element?.purchase_link_chr
                                                          element?.purchase_link_chr && !element?.purchase_link_chr.startsWith('http')
                                                            ? `https://${element?.purchase_link_chr}`
                                                            : element?.purchase_link_chr
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                        }}
                                                      >
                                                        <span
                                                          className="fs-7 pointer cursor-pointer text-truncate d-flex"
                                                          style={{ maxWidth: '200px' }}
                                                        // onClick={() => {
                                                        //   navigator.clipboard.writeText(
                                                        //     `${element?.purchase_link_chr}`
                                                        //   );
                                                        //   copyToClipboard();
                                                        // }}
                                                        >
                                                          {`${element?.purchase_link_chr}`}
                                                          {/* <FaArrowRightLong />{" "} */}
                                                        </span>
                                                      </a>
                                                      <span >{`...`}</span>
                                                    </div>
                                                  </> :
                                                  <div>
                                                    <span className="text-black font-w600 fs-7 me-2">{`Location: `}</span>
                                                    <span
                                                      className="fs-7 text-black"
                                                    >
                                                      {element?.purchase_link_chr}
                                                    </span>
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                          )}

                                          {
                                            <div className="row mx-0  mt-2">
                                              <div className={`col-12 d-flex fs-7 font-w600 `}>
                                                <div className="d-flex align-items-center justify-content-between w-100">
                                                  <div
                                                    className="me-4 d-flex align-items-center"
                                                    style={{
                                                      pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                      opacity: purchaseLoading ? '0.5' : '1'
                                                    }}
                                                  >
                                                    <span
                                                      className="me-2"
                                                    >
                                                      {purchaseLoading && (element?.item_id_ids === shoppingItemId) ?
                                                        <Spinner animation="border" size="sm" /> :
                                                        <input
                                                          type="checkbox"
                                                          checked={element?.is_purchased_ysn}
                                                          className="form-check-input"
                                                          id="customCheckBox4"
                                                          onChange={(e) => {
                                                            e.stopPropagation();
                                                            handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                            setShoppingItemId(element?.item_id_ids)
                                                          }}
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                            setShoppingItemId(element?.item_id_ids)
                                                          }}
                                                        />
                                                      }
                                                    </span>
                                                    <span
                                                      className="pt-1 cursor-pointer text-hovered"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                        setShoppingItemId(element?.item_id_ids)
                                                      }}
                                                    >
                                                      {`Item Acquired`}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          }

                                          <div className="row mx-0  mt-2">
                                            <div className='col-12 px-0 d-flex justify-content-end'>
                                              {element?.is_purchased_ysn ?
                                                <span className='font-w600 fs-7 text-success'>{`Purchased`}</span> :
                                                <span className='font-w600 fs-7'>{`Not purchased yet`}</span>
                                              }
                                            </div>
                                          </div>


                                        </div>

                                      </div>


                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div className="row my-4">
                                  {/* <span className="fs-7  ">
                                  No notes added yet
                                </span> */}

                                  <div className="mb-3 d-flex justify-content-center align-items-center flex-column">
                                    <div className="mb-2">
                                      <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                    </div>
                                    <span>
                                      {`No items added yet`}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="row mx-0 pb-2 p-3 border-bottom position-relative bg-white"
                            style={{
                              boxShadow: "rgba(0, 0, 0, 0.31) 0px -6px 10px -2px",
                            }}
                            onClick={() => {
                              handleOpenMobileMoreActionsDrawer();
                              handleMobileMoreActionsTabs(2);
                              setMobileShoppingListTabs(3);
                            }}
                          >
                            <div
                              className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-center px-0"
                              style={{ color: 'rgba(131, 154, 192, 1)' }}
                            >
                              <div className="d-flex align-items-center">
                                <span>{`Add list item`}</span>

                                <span>
                                  <i className="bi bi-chevron-up ms-2" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Check-up */}
                  {mobileTabs == 5 && (
                    <>
                      <div className="row mx-0">
                        <div className="col-12  bg-white rounded-top">
                          <div className="row mx-0 p-3 border-bottom">
                            <div className="align-items-center col-12 d-flex font-w600 fs-3 justify-content-between px-0 text-black">
                              <div className=" d-flex align-items-center">
                                <span
                                  onClick={() => {
                                    handleCloseMobileBottomDrawer();
                                    setMobileTabs();
                                  }}
                                  className="cursor-pointer">
                                  <MdClose />
                                </span>
                              </div>

                              <div className="d-flex align-items-center">
                                <span>{`Home Check-Up`}</span>
                              </div>

                              <div>
                                <span
                                  onClick={() => {
                                    // handleOpenMobileMoreActionsDrawer();
                                    // handleMobileMoreActionsTabs(2);
                                  }}
                                >
                                  {/* <LuMoreVertical style={{ color: "" }} /> */}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row mx-0 pt-2 overflow-auto mb-1"
                            style={{
                              maxHeight: "60dvh",
                              background: "rgba(235, 240, 250, 1)",
                            }}
                          >

                            <div className="col-12 px-0">

                              {/* Title box inspection */}
                              <div
                                className="row mb-1 py-2 border-bottom"
                              >
                                <div className={`col-12 d-flex font-w600`}>
                                  <div className="d-flex align-items-center w-100 px-3 text-black">
                                    {/* <div
                                      className="align-items-center cursor-pointer d-flex fs-3 me-4 ms-2 text-black text-hovered"
                                      onClick={() => {
                                        
                                      }}
                                    >
                                      <span>
                                        <i className="bi bi-arrow-left" />
                                      </span>
                                    </div>
                                    <div className="me-2 text-black d-flex align-items-center">
                                      <span
                                        className="overflow-hidden text-nowrap"
                                        style={{ width: '120px', textOverflow: 'ellipsis' }}
                                      >
                                        {`Title`}
                                      </span>
                                    </div> */}

                                    {toggleInspectionTab === 1 ?
                                      <>
                                        {`Home Check-Up`}
                                      </> :
                                      toggleInspectionTab === 2 ?
                                        <>
                                          {toggleForDefineRoomList === 1 ?
                                            <>
                                              <span
                                                className="me-2 cursor-pointer text-hovered fs-3"
                                                onClick={() => { setToggleInspectionTab(1) }}
                                              >
                                                <i className="bi bi-arrow-left" />
                                              </span>
                                              <span>
                                                {`Define room list`}
                                              </span>
                                            </> :
                                            toggleForDefineRoomList === 2 ?
                                              <>
                                                {Object.keys(particularHomeAreaObj).length === 0 ?
                                                  <>
                                                    <span
                                                      className="me-2 cursor-pointer text-hovered fs-3"
                                                      onClick={() => {
                                                        setToggleForDefineRoomList(1);
                                                        handleClearRoomStates();
                                                      }}
                                                    >
                                                      <i className="bi bi-arrow-left" />
                                                    </span>
                                                    <span>
                                                      {`Room list`}
                                                    </span>
                                                  </> :
                                                  <>
                                                    <span>
                                                      {`Check-Up`}
                                                    </span>
                                                  </>
                                                }
                                              </> :
                                              <></>
                                          }
                                        </>
                                        :
                                        toggleInspectionTab === 3 ?
                                          <>
                                            {toggleCheckUpResultAndMaintenancePlan === 1 ?
                                              <>
                                                <span
                                                  className="me-2 cursor-pointer text-hovered fs-3"
                                                  onClick={() => { setToggleInspectionTab(1) }}
                                                >
                                                  <i className="bi bi-arrow-left" />
                                                </span>
                                                <span>
                                                  {`Check-Up results`}
                                                </span>
                                              </> :
                                              toggleCheckUpResultAndMaintenancePlan === 2 ?
                                                <>
                                                  <span
                                                    className="me-2 cursor-pointer text-hovered fs-3"
                                                    onClick={() => { setToggleCheckUpResultAndMaintenancePlan(1) }}
                                                  >
                                                    <i className="bi bi-arrow-left" />
                                                  </span>
                                                  <span>
                                                    {`Maintenance Tasks`}
                                                  </span>
                                                </> :
                                                <></>
                                            }
                                          </> : <></>
                                    }

                                  </div>
                                </div>
                              </div>

                              {toggleInspectionTab === 1 ?
                                <>
                                  <div
                                    className="col-12 py-3 px-2 "
                                    style={{
                                      // maxHeight: "550px",
                                      // minHeight: "450px",
                                      // overflow: "auto",
                                      // height: "calc(100dvh - 106px)",
                                    }}
                                  >
                                    <div className="row mx-0">
                                      <div className="col-12 px-2 pb-2 border-bottom ">
                                        <span>
                                          {`A check-up helps the Customer maintain their home inventory and avoid costly future repairs`}
                                        </span>
                                      </div>
                                    </div>



                                    <div className="row mx-0 my-3">
                                      <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                        <img src={houseImg} alt="logo" style={{ height: '90px', width: '90px' }} />
                                      </div>
                                    </div>

                                    <div className="row mx-0 mb-3">
                                      <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                        <span className="font-w700 text-center text-black">
                                          {'What would you like to do now?'}
                                        </span>
                                      </div>
                                    </div>

                                    {itemListCount > 0 &&
                                      <div className="row mx-0 mb-2 ">
                                        <div
                                          className="col-12 p-2 bg-white rounded-2 shadow-lg cursor-pointer d-flex align-items-center"
                                          onClick={() => { setToggleInspectionTab(3) }}
                                        >
                                          <div className="me-2">
                                            <img src={checkUpResultImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                          </div>
                                          <div className="d-flex  flex-column">
                                            <span className="font-w600 text-black">
                                              {`View check-up results`}
                                            </span>

                                            <span className="fs-7 font-w500">
                                              {`You can review your current item conditions at any time`}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    }

                                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                                      <div className="row mx-0 mb-2 ">
                                        <div
                                          className="col-12 p-2 bg-white rounded-2 shadow-lg cursor-pointer d-flex align-items-center"
                                          onClick={() => { setToggleInspectionTab(2) }}
                                        >
                                          <div className="me-2">
                                            <img src={proInspectorImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                          </div>
                                          <div className="d-flex  flex-column">
                                            <span className=" font-w600 text-black">
                                              {`Start Home Check-Up`}
                                            </span>

                                            <span className="fs-7 font-w500">
                                              {`Guide a Customer through each step, collecting info, item condition and recommended maintenance tasks`}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    }

                                    {permissionArray.includes("SCAN TAB") &&
                                      <div className="row mx-0 mb-2 ">
                                        <div
                                          className="col-12 p-3 bg-white rounded-2 shadow-lg cursor-pointer d-flex align-items-center"
                                          onClick={() => { setToggleInspectionTab(2) }}
                                        >
                                          <div className="me-2">
                                            <img src={proInspectorImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                          </div>
                                          <div className="d-flex flex-column">
                                            <span className=" font-w600 text-black">
                                              {`See room list`}
                                            </span>

                                            <span className="fs-7 font-w500">
                                              {`You will go through each room`}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </> :
                                toggleInspectionTab === 2 ?
                                  <>
                                    {toggleForDefineRoomList === 1 ?
                                      <>
                                        <div className="row mx-0">
                                          <div className="col-12 px-0">
                                            <div className="row mx-0">
                                              <div className="col-12 border-bottom p-2">
                                                <span>{`Set up which rooms you would like to review`}</span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row mx-0">
                                          <div className="col-12 px-0 mt-3" style={{ marginBottom: '30px' }}>
                                            {refAreaListNewDesign.length > 0 ?
                                              <>
                                                {refAreaListNewDesign.map((element, index) => {
                                                  return (
                                                    <>
                                                      <div className="row  mx-1 mb-2  rounded-2"
                                                        style={{
                                                          // boxShadow: '0px 0px 3px #a8a4a4',
                                                          opacity: roomsLoading ? '0.5' : '1',
                                                          pointerEvents: roomsLoading ? 'none' : 'auto',
                                                        }}
                                                        key={index}
                                                      >
                                                        <div className="col-12 px-0">
                                                          <div
                                                            className={`d-flex align-items-center justify-content-between w-100 p-2 fs-6 font-w700 text-black cursor-pointer`}
                                                            onClick={() => {
                                                              if (element?.ref_area_id_ids === isExpandedForAddRoom) {
                                                                setIsExpandedForAddRoom('')
                                                              } else {
                                                                setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                              }
                                                              setRefAreaId(element?.ref_area_id_ids);
                                                            }}
                                                          >
                                                            <div className="d-flex align-items-center justify-content-center">
                                                              <div
                                                                className="me-2 rounded d-flex align-items-center justify-content-center border"
                                                                style={{ background: 'rgba(79, 93, 116, 1)', width: '25px', height: '25px' }}
                                                              >
                                                                <img
                                                                  src={element?.ref_icon_url}
                                                                  alt=""
                                                                  className="rounded border"
                                                                  style={{ width: "25px", height: "25px", background: 'rgba(79, 93, 116, 1)' }}
                                                                />
                                                              </div>
                                                              <div
                                                                style={{
                                                                  color: 'rgba(131, 154, 192, 1)',
                                                                  opacity: element?.home_area_count !== 0 ? '1' : '0.7',

                                                                }}
                                                              >
                                                                <span className="fs-7">{`${element?.ref_display_area_name_chr}`}</span>
                                                              </div>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                              <div className="me-2">
                                                                <span
                                                                  className="text-hovered border-hovered cursor-pointer border rounded p-1"
                                                                  style={{
                                                                    pointerEvents: element?.home_area_count == 0 ? 'none' : 'auto',
                                                                    opacity: element?.home_area_count == 0 ? '0.5' : '1',
                                                                  }}
                                                                  onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    handleDeleteNewHomeAreaFn(element?.home_area_list[element?.home_area_list.length - 1]);
                                                                    setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                                  }}
                                                                >
                                                                  <i className="bi bi-dash-lg"></i>
                                                                </span>
                                                              </div>
                                                              <div className="me-2 d-flex align-items-center justify-content-center" style={{ width: '15px' }}>
                                                                {`${element?.home_area_count}`}
                                                              </div>
                                                              <div>
                                                                <span
                                                                  className="text-hovered border-hovered cursor-pointer border rounded p-1"
                                                                  onClick={(e) => {
                                                                    // setRoomTypeName(`${element?.ref_display_area_name_chr} #${element?.home_area_count + 1}`)
                                                                    // setRefAreaId(element?.ref_area_id_ids);
                                                                    e.stopPropagation()
                                                                    handleAddRoom(element)
                                                                    setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                                  }}
                                                                >
                                                                  <i className="bi bi-plus-lg"></i>
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div
                                                            className="bg-white rounded-2"
                                                            style={{
                                                              boxShadow: '0px 0px 3px #a8a4a4',
                                                            }}
                                                          >
                                                            {element?.ref_area_id_ids === isExpandedForAddRoom &&
                                                              <>
                                                                {element?.home_area_list?.map((item, ind) => {
                                                                  return (
                                                                    <>
                                                                      <div
                                                                        className={`row  mx-0 p-2 pt-3 d-flex align-items-baseline ${(ind !== element?.home_area_list?.length - 1) && 'border-bottom'}`}
                                                                        key={ind}
                                                                      >
                                                                        <div className="col-9 px-0 d-flex align-items-center justify-content-center pe-2">
                                                                          <div className="w-100">
                                                                            <InputField
                                                                              labelName={"Room name"}
                                                                              // value={roomTypeName}
                                                                              value={`${item?.area_id_ids !== isEditForRoomName ? item?.area_name_chr : roomTypeName}`}
                                                                              onChange={(e) => { handleChangeRoomName(e) }}
                                                                              onBlur={handleBlurCheckRoomName}
                                                                              errorOccured={isRoomTypeNameErr && item?.area_id_ids == isEditForRoomName}
                                                                              errorMeesage={"Enter valid room name"}
                                                                              disabled={item?.area_id_ids !== isEditForRoomName ? true : false}
                                                                            />
                                                                          </div>
                                                                        </div>
                                                                        <div className="col-3 px-0 d-flex align-items-center justify-content-evenly fs-6 ps-2">
                                                                          {item?.area_id_ids !== isEditForRoomName ?
                                                                            <>
                                                                              <span className="pe-2">
                                                                                <i
                                                                                  className="bi bi-pencil-fill text-hovered cursor-pointer"
                                                                                  onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setIsEditForRoomName(item?.area_id_ids);
                                                                                    setAreaId(item?.area_id_ids);
                                                                                    setRoomTypeName(item?.area_name_chr);
                                                                                    isRoomTypeNameErr && setIsRoomTypeNameErr(false);
                                                                                  }}
                                                                                ></i>
                                                                              </span>

                                                                              <span>
                                                                                <i
                                                                                  className="bi bi-trash text-hovered cursor-pointer"

                                                                                  onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleDeleteNewHomeAreaFn(item);
                                                                                  }}
                                                                                ></i>
                                                                              </span>
                                                                            </> :
                                                                            <>
                                                                              <span
                                                                                className="px-2 py-1 text-hovered cursor-pointer overlay-action-btn rounded font-w600"
                                                                                onClick={() => {
                                                                                  handleAddRoom(item)
                                                                                }}
                                                                              >
                                                                                {`Save`}
                                                                              </span>
                                                                            </>
                                                                          }
                                                                        </div>
                                                                      </div>
                                                                    </>
                                                                  )
                                                                })

                                                                }
                                                              </>
                                                            }
                                                          </div>


                                                        </div>
                                                      </div>
                                                    </>
                                                  )
                                                })}
                                              </> :
                                              <>
                                                <div className="mt-1 mb-3 d-flex justify-content-center align-items-center flex-column">

                                                  <div className="mb-2">
                                                    <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                  </div>
                                                  <span>
                                                    {`No rooms available`}
                                                  </span>
                                                </div>
                                              </>
                                            }
                                          </div>
                                        </div>

                                      </> :
                                      <>
                                        {Object.keys(particularHomeAreaObj).length === 0 ?
                                          <>
                                            {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                                              <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                  <div className="row mx-0">
                                                    <div className="col-12 p-2">
                                                      <span>{`Guide the Customer to each room, collect information about the inventory items, determine their condition and keep track of maintenance actions.`}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            }

                                            <div className="row mx-0">
                                              <div className="col-12 px-0">
                                                <div className="row mx-0">
                                                  <div className={`col-12 px-0 border-bottom ${permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && 'border-top'} px-2 py-3 d-flex align-items-center justify-content-between`}>
                                                    <div>
                                                      <span className="font-w700 pe-2 text-black">{`${myRooms.length}`}</span>
                                                      <span>{`rooms`}</span>
                                                    </div>

                                                    <div
                                                      className="text-hovered cursor-pointer font-w600"
                                                      onClick={() => {
                                                        setToggleForDefineRoomList(1);
                                                        handleClearRoomStates();
                                                      }}
                                                    >
                                                      <span className="pe-2">{`Define room list`}</span>
                                                      <i className="bi bi-pencil" />
                                                    </div>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            {myRooms.length > 0 ?
                                              <>
                                                {myRooms.map((element, index) => {
                                                  return (
                                                    <>
                                                      <div
                                                        className="row cursor-pointer overlay-action-btn mb-1 py-2 rounded mx-3"
                                                        onClick={() => {
                                                          setParticularHomeAreaObj(element);
                                                          setAreaId(element.area_id_ids);
                                                        }}
                                                      >
                                                        <div className={`col-12 d-flex font-w600 `}>
                                                          <div className="d-flex align-items-center justify-content-between w-100">
                                                            <div className="me-2 text-black d-flex align-items-center">
                                                              <span
                                                                className="me-2 p-2 border rounded bg-dark shadow-lg text-white"
                                                              >
                                                                <i
                                                                  class="bi bi-cloud-hail-fill"
                                                                  style={{ height: '20px', width: '20px' }}
                                                                ></i>
                                                              </span>
                                                              <span
                                                                className="overflow-hidden text-nowrap"
                                                                style={{ width: '120px', textOverflow: 'ellipsis' }}
                                                                title={`${element?.display_area_name_chr}`}
                                                              >
                                                                {`${element?.display_area_name_chr}`}
                                                              </span>
                                                            </div>

                                                            <div className="text-black d-flex align-items-center">
                                                              {element?.item_count ?
                                                                <span
                                                                  className="px-2 py-1 fs-7 text-white rounded-circle d-flex align-items-center justify-content-center font-w500 me-2 shadow"
                                                                  style={{
                                                                    background: 'rgba(131, 154, 192, 1)',
                                                                  }}
                                                                >
                                                                  {`${element?.item_count}`}
                                                                </span> : ''
                                                              }

                                                              <span>
                                                                {
                                                                  <i class="bi bi-chevron-right ms-2 rounded px-1"></i>
                                                                }
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )
                                                })}
                                              </> :

                                              <div className="row mx-0">
                                                <div className="col-12">
                                                  <>
                                                    <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                      <div className="mb-2">
                                                        <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                      </div>
                                                      <span>
                                                        {`No rooms added`}
                                                      </span>
                                                    </div>
                                                  </>
                                                </div>
                                              </div>
                                            }
                                          </> :
                                          <>
                                            {
                                              <>
                                                <div
                                                  className="row mb-1 py-2 border-bottom"
                                                >
                                                  <div className={`col-12 d-flex font-w600`}>
                                                    <div className="d-flex align-items-center w-100">
                                                      <div
                                                        className="align-items-center cursor-pointer d-flex fs-3 me-4 ms-2 text-black text-hovered"
                                                        onClick={() => {
                                                          setParticularHomeAreaObj({});
                                                          setIsExpandedForProduct('');
                                                          setToggleAddItems(false);
                                                          setHomeAreaProductId("");
                                                          setIndividualProductObj({});
                                                        }}
                                                      >
                                                        <span>
                                                          <i className="bi bi-arrow-left" />
                                                        </span>
                                                      </div>
                                                      <div className="me-2 text-black d-flex align-items-center">
                                                        <span
                                                          className="me-2 p-2 border rounded bg-dark shadow-lg text-white"
                                                        >
                                                          <i
                                                            class="bi bi-cloud-hail-fill"
                                                            style={{ height: '20px', width: '20px' }}
                                                          ></i>
                                                        </span>
                                                        <span
                                                          className="overflow-hidden text-nowrap"
                                                          style={{ width: '120px', textOverflow: 'ellipsis' }}
                                                          title={`${particularHomeAreaObj?.display_area_name_chr}`}
                                                        >
                                                          {`${particularHomeAreaObj?.display_area_name_chr}`}
                                                        </span>
                                                      </div>

                                                    </div>
                                                  </div>
                                                </div>

                                                {particularHomeAreaObj?.item_list?.length > 0 ?
                                                  <>
                                                    {particularHomeAreaObj?.item_list?.map((item, ind) => {
                                                      return (
                                                        <>
                                                          <div
                                                            className="row border-bottom px-3"
                                                            key={ind}
                                                          >
                                                            <div className="col-12 px-0">
                                                              <div

                                                                className="row cursor-pointer  py-2 "
                                                                onClick={() => {
                                                                  if (item?.home_area_product_id_ids === isExpandedForProduct) {
                                                                    setIsExpandedForProduct('')
                                                                    setHomeAreaProductId("");
                                                                  } else {
                                                                    setIsExpandedForProduct(item?.home_area_product_id_ids)

                                                                    if (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                                                      var inspectionObj = {
                                                                        type: 'inspection',
                                                                        message: `${item?.product_name_chr} is beign checking now`,
                                                                        productDetails: item,
                                                                      }

                                                                      const [localValue] = [...room.localParticipant.dataTracks.values()];

                                                                      localValue.track.send(JSON.stringify(inspectionObj));
                                                                    }
                                                                  }
                                                                }}
                                                              >
                                                                <div className={`col-12 d-flex font-w600 `}>
                                                                  <div className="d-flex align-items-center justify-content-between w-100">
                                                                    <div className="me-2 text-black d-flex align-items-center">
                                                                      <span
                                                                        className="me-2 p-2 rounded bg-white shadow-lg text-black"
                                                                      >
                                                                        <i
                                                                          class="bi bi-cloud-hail-fill"
                                                                          style={{ height: '20px', width: '20px' }}
                                                                        ></i>
                                                                      </span>
                                                                      <div className="d-flex flex-column">
                                                                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") && item?.home_area_product_id_ids === isExpandedForProduct ?
                                                                          <span className="text-success font-w600 fs-7">
                                                                            {`Checking now`}
                                                                          </span> : ''
                                                                        }
                                                                        <span
                                                                          className="overflow-hidden text-nowrap"
                                                                          style={{ width: '120px', textOverflow: 'ellipsis' }}
                                                                          title={`${item?.product_name_chr}`}
                                                                        >
                                                                          {`${item?.product_name_chr}`}
                                                                        </span>
                                                                      </div>

                                                                    </div>


                                                                    <div
                                                                      className="text-black fs-4 text-hovered overlay-action-btn rounded-circle d-flex align-items-center justify-content-center cursor-pointer"
                                                                    >
                                                                      <span>
                                                                        <span>
                                                                          {/* <OverlayTrigger
                                                                  key={ind}
                                                                  trigger="click"
                                                                  placement="bottom"
                                                                  // overlay={popover}
                                                                  overlay={popoverInventoryActions(ind)}
                                                                  rootClose={true}
                                                                  show={activePopover === ind}
                                                                  onToggle={(show) => setActivePopover(show ? ind : null)}
                                                                > */}
                                                                          <i onClick={(e) => { e.stopPropagation(); handleMenuClickCheckUpMobile(item, ind) }} class="bi bi-three-dots-vertical px-1"></i>
                                                                          {/* </OverlayTrigger> */}
                                                                        </span>
                                                                      </span>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>

                                                              {item?.home_area_product_id_ids === isExpandedForProduct &&
                                                                <div className="row mb-2 bg-white rounded-2 shadow-sm">
                                                                  <div className="col-12 p-1 fs-7">
                                                                    <div className="row mx-1 pb-1 pt-2 px-3 d-flex align-items-center">
                                                                      <div className="col-4 pe-2  font-w500">
                                                                        <span>{`Condition`}</span>
                                                                      </div>
                                                                      <div className="col-8 d-flex">
                                                                        <span
                                                                          className="text-white rounded-pill p-1 px-3"
                                                                          style={{
                                                                            background:
                                                                              `${item?.condition_chr === "Good" ? "rgba(45, 204, 99, 1)" :
                                                                                item?.condition_chr === "Ok" ? "rgba(255, 154, 32, 1)" :
                                                                                  item?.condition_chr === "Poor" ? "rgba(240, 72, 72, 1)" :
                                                                                    item?.condition_chr === "Not assessed" ? "rgba(131, 154, 192, 1)" : ''}`,
                                                                          }}
                                                                        >
                                                                          {`${item?.condition_chr}`}
                                                                        </span>
                                                                      </div>
                                                                    </div>

                                                                    <div className="row mx-1 py-2 px-3 border-bottom  d-flex align-items-center">
                                                                      <div className="col-4 pe-2  font-w500">
                                                                        <span>{`Updated`}</span>
                                                                      </div>
                                                                      <div className="col-8">
                                                                        <span className="text-black font-w600 p-1 px-2">{`${formatUnixTimestamp(item?.updated_date_dtm)}`}</span>
                                                                      </div>
                                                                    </div>

                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                      <div className="col-4 pe-2 font-w500">
                                                                        <span>{`Brand`}</span>
                                                                      </div>
                                                                      <div className="col-8">
                                                                        <span className={`${item?.device_brand_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.device_brand_chr ? item?.device_brand_chr : '-'}`}</span>
                                                                      </div>
                                                                    </div>

                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                      <div className="col-4 pe-2 font-w500">
                                                                        <span>{`Model`}</span>
                                                                      </div>
                                                                      <div className="col-8">
                                                                        <span className={`${item?.model_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.model_number_chr ? item?.model_number_chr : '-'}`}</span>
                                                                      </div>
                                                                    </div>

                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                      <div className="col-4 pe-2 font-w500">
                                                                        <span>{`Serial number`}</span>
                                                                      </div>
                                                                      <div className="col-8">
                                                                        <span className={`${item?.serial_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.serial_number_chr ? item?.serial_number_chr : '-'}`}</span>
                                                                      </div>
                                                                    </div>

                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                      <div className="col-4 pe-2 font-w500">
                                                                        <span>{`Description`}</span>
                                                                      </div>
                                                                      <div className="col-8">
                                                                        <span className={`${item?.description_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.description_chr ? item?.description_chr : '-'}`}</span>
                                                                      </div>
                                                                    </div>

                                                                    {item?.image_url &&
                                                                      <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                        <div className="col-12">
                                                                          <img
                                                                            src={item?.image_url}
                                                                            alt="Attachment"
                                                                            className="rounded-2 shadow-lg cursor-pointer"
                                                                            onClick={(e) => {
                                                                              handleOpenDoc(); setImageAttachURL(item?.image_url);
                                                                            }}
                                                                            style={{
                                                                              height: '60px',
                                                                              width: '60px',
                                                                              border: '1px solid orange'
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                    }

                                                                    {item?.maintenance_plan?.length > 0 &&
                                                                      <div
                                                                        className="row mx-0 py-2 font-w700 d-flex border-top"
                                                                        style={{
                                                                          background: 'rgb(199 212 234 / 30%)',
                                                                          // pointerEvents: 'none',
                                                                          // opacity: '0.5',
                                                                        }}
                                                                      >
                                                                        {item?.maintenance_plan?.map((data, i) => {
                                                                          return (
                                                                            <div
                                                                              className={`bg-white mb-1 ${data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan && 'shadow'} rounded `}
                                                                              style={{ margin: '0' }}
                                                                            >
                                                                              <div
                                                                                className="row mx-1  py-2 px-1 fs-7 d-flex align-items-center"
                                                                              >
                                                                                <div
                                                                                  className="row mx-0  cursor-pointer"
                                                                                  onClick={() => {
                                                                                    if (data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan) {
                                                                                      setIsExpandedForMaintenancePlan('')
                                                                                    } else {
                                                                                      setIsExpandedForMaintenancePlan(data.maintenance_plan_id_ids)
                                                                                    }
                                                                                  }}
                                                                                >
                                                                                  <div className="col-4 pe-2 font-w500">
                                                                                    <span>{`Maintenance`}</span>
                                                                                  </div>
                                                                                  <div className="col-8 d-flex align-items-center justify-content-between">
                                                                                    <span className={`${data?.period_name_chr && 'text-black'} font-w600 p-1 px-2`}>{`${data?.period_name_chr ? `In ${data?.period_name_chr}` : '-'}`}</span>
                                                                                    <span>
                                                                                      {data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan ?
                                                                                        <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i> :
                                                                                        <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i>
                                                                                      }
                                                                                    </span>
                                                                                  </div>
                                                                                </div>

                                                                                {data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan &&
                                                                                  <>
                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                      <div className="col-4 pe-2 font-w500">
                                                                                        <span>{`Instruction`}</span>
                                                                                      </div>
                                                                                      <div className="col-8">
                                                                                        <span className={`${data?.instruction_chr && 'text-black'} font-w600 p-1 px-2`}>{`${data?.instruction_chr ? `${data?.instruction_chr}` : '-'}`}</span>
                                                                                      </div>
                                                                                    </div>

                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                      <div className="col-4 pe-2 font-w500">
                                                                                        <span>{`Frequency`}</span>
                                                                                      </div>
                                                                                      <div className="col-8">
                                                                                        <span className={`${data?.frequency_int && 'text-black'} font-w600 p-1 px-2`}>{`${data?.frequency_int ? `${data?.frequency_int} times in a ${data?.period_name_chr}` : '-'}`}</span>
                                                                                      </div>
                                                                                    </div>


                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                      <div className="col-4 pe-2 font-w500">
                                                                                        <span>{`Link`}</span>
                                                                                      </div>
                                                                                      <div className="col-8">
                                                                                        {data?.purchase_link ?
                                                                                          <a
                                                                                            className="text-hovered text-gray-800"
                                                                                            href={`${data?.purchase_link}`}
                                                                                            target="_blank"
                                                                                            rel="noreferrer"
                                                                                          >
                                                                                            <span className={`font-w600 p-1 px-2`}>{`Purchase link`} <i className="bi bi-chevron-right me-2"></i> </span>
                                                                                          </a> :
                                                                                          <span className={`font-w600 p-1 px-2`}>{`-`} </span>
                                                                                        }
                                                                                      </div>
                                                                                    </div>

                                                                                  </>
                                                                                }

                                                                              </div>
                                                                            </div>
                                                                          )
                                                                        })}
                                                                      </div>
                                                                    }

                                                                    <div
                                                                      className={`row mx-0 py-2 font-w700 d-flex align-items-center border-top ${item?.home_area_product_id_ids !== isExpandedForAddMaintenance && "rounded-bottom"} cursor-pointer text-hovered overlay-action-btn`}
                                                                      style={{
                                                                        background: 'rgb(199 212 234 / 30%)',
                                                                        // pointerEvents: 'none',
                                                                        // opacity: '0.5',
                                                                      }}
                                                                      onClick={() => {
                                                                        if (item?.home_area_product_id_ids === isExpandedForAddMaintenance) {
                                                                          setIsExpandedForAddMaintenance('')
                                                                        } else {
                                                                          setIsExpandedForAddMaintenance(item.home_area_product_id_ids)
                                                                          clearMaintenancePlanStates();
                                                                        }
                                                                        setHomeAreaProductId(item?.home_area_product_id_ids);
                                                                      }}
                                                                    >
                                                                      <div
                                                                        className={`col-12 d-flex ${item?.home_area_product_id_ids === isExpandedForAddMaintenance ? 'justify-content-around' : 'justify-content-center'} align-items-center`}>
                                                                        <div>
                                                                          <span>{`Add maintenance plan`}</span>
                                                                          <span>
                                                                            <i className="bi bi-plus-circle ms-2"></i>
                                                                          </span>
                                                                        </div>

                                                                        {item?.home_area_product_id_ids === isExpandedForAddMaintenance &&
                                                                          <div
                                                                            onClick={(e) => {
                                                                              e.stopPropagation();
                                                                              setIsExpandedForAddMaintenance('');
                                                                              setHomeAreaProductId("");
                                                                              clearMaintenancePlanStates();
                                                                            }}
                                                                          >
                                                                            <i className="bi bi-x-lg ms-2"></i>
                                                                          </div>
                                                                        }

                                                                      </div>
                                                                    </div>

                                                                    {item?.home_area_product_id_ids === isExpandedForAddMaintenance &&
                                                                      <div
                                                                        className="row mx-0 py-2 font-w700 d-flex align-items-center  "
                                                                        style={{
                                                                          // background: 'rgb(199 212 234 / 30%)',
                                                                          // pointerEvents: 'none',
                                                                          // opacity: '0.5',
                                                                        }}
                                                                      >
                                                                        <div className="col-12 p-2">
                                                                          <div className="row mx-0">
                                                                            <div className="col-12 px-0">
                                                                              <InputField
                                                                                labelName={"Instruction"}
                                                                                value={instruction}
                                                                                onChange={(e) => { handleChangeInstruction(e) }}
                                                                                onBlur={() => { handleBlurCheckInstrction() }}
                                                                                errorOccured={isInstructionErr}
                                                                                errorMeesage={"Please enter instructions"}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          {/* <div className="row mx-0">
                                                                  <div className="col-12 px-0">
                                                                    <span className="font-w600 text-black">{`Every`}</span>
                                                                  </div>
                                                                </div> */}

                                                                          <div className="row mx-0">
                                                                            <div className="col-12 px-0">
                                                                              <div className="row mx-0">
                                                                                <div className="col-5 pe-2">

                                                                                  <SelectInputFrequency
                                                                                    labelName={"Times"}
                                                                                    onChange={(e) => handleChangeFreq(e)}
                                                                                    defaultValue={frequency}
                                                                                    options={frequencyArr}
                                                                                    errorOccured={isFrequencyErr}
                                                                                    errorMessage={"Please select frequency"}
                                                                                  />

                                                                                </div>
                                                                                <div className="col-7 px-0">
                                                                                  <SelectInputPeriod
                                                                                    labelName={"Period"}
                                                                                    onChange={(e) => handleChangePeriod(e)}
                                                                                    defaultValue={period}
                                                                                    options={periodListArr}
                                                                                    errorOccured={isPeriodErr}
                                                                                    errorMessage={"Please select period"}
                                                                                  />
                                                                                </div>

                                                                              </div>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row mx-0">
                                                                            <div className="col-12 px-0">
                                                                              <InputField
                                                                                labelName={"Purchase link (optional)"}
                                                                                value={purchaseLinkHome}
                                                                                onChange={(e) => { handleChangePurchaseLink(e) }}
                                                                                onBlur={() => { }}
                                                                                errorOccured={false}
                                                                                errorMeesage={"Please enter purchase link"}
                                                                              />
                                                                            </div>
                                                                          </div>

                                                                          <div className="row mx-0">
                                                                            <div className="col-12 px-0">
                                                                              <PrimaryButton
                                                                                buttonName={"SUBMIT"}
                                                                                onClick={() => { addUpdateMaintenancePlanFn() }}
                                                                                isLoading={maintenancePlanLoading}
                                                                                loadingMessage={"Loading..."}
                                                                                style={{
                                                                                  width: '100%',
                                                                                  background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                  border: '2px solid rgba(255, 154, 32, 1)',
                                                                                  boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                }}
                                                                              />
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    }

                                                                  </div>
                                                                </div>
                                                              }

                                                            </div>
                                                          </div>
                                                        </>
                                                      )
                                                    })}
                                                  </> :
                                                  <div className="row mx-0">
                                                    <div className="col-12">
                                                      <>
                                                        <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                          <div className="mb-2">
                                                            <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                          </div>
                                                          <span>
                                                            {`No inventory items added yet`}
                                                          </span>
                                                        </div>
                                                      </>
                                                    </div>
                                                  </div>
                                                }
                                              </>
                                            }
                                          </>
                                        }
                                      </>
                                    }
                                  </> :
                                  toggleInspectionTab === 3 ?
                                    <>
                                      {toggleCheckUpResultAndMaintenancePlan === 1 ?
                                        <>
                                          <div
                                            className="row "
                                            style={{
                                              background: "rgba(235, 240, 250, 1)",
                                              // height: "calc(100dvh - 140px)",
                                            }}
                                          >
                                            <div
                                              className="col-12 py-3 px-2 "
                                              style={{
                                                // maxHeight: "550px",
                                                // minHeight: "450px",
                                                //  overflow: "auto",
                                                //  height: "calc(100dvh - 115px)",
                                              }}
                                            >
                                              <div className="row mx-0">
                                                <div className="col-12 px-2 pb-2 ">
                                                  <span>
                                                    {`Review the check-up results to know everything about the current condition of your inventory items and the upcoming maintenance tasks`}
                                                  </span>
                                                </div>
                                              </div>

                                              <div className="row mx-0 my-2 ">
                                                <div className='col-12 p-1 bg-white rounded-2 shadow-lg'>
                                                  <div className='row mx-0'>
                                                    <div className='col-12 p-2 d-flex justify-content-center align-items-center'>
                                                      <span className='fs-7 font-w600'>
                                                        {`Maintenance Tasks`}
                                                      </span>
                                                    </div>
                                                  </div>

                                                  <div className='row mx-0'>
                                                    <div
                                                      className='border-3 border-right col-6'
                                                      style={{ borderColor: '#e7e1e1' }}
                                                    >
                                                      <div className='row mx-0'>
                                                        <div
                                                          className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                          style={{ background: 'rgba(79, 93, 116, 1)', height: '46px' }}
                                                        >
                                                          <span className='fs-7 font-w600 text-white text-center'>
                                                            {`Total Tasks`}
                                                          </span>
                                                        </div>
                                                      </div>

                                                      <div className='row mx-0'>
                                                        <div
                                                          className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                          style={{}}
                                                        >
                                                          {Object.keys(maintenanceObj).length > 0 ?
                                                            <span className='fs-6 font-w600'>
                                                              {`${maintenanceObj?.total_count || 0}`}
                                                            </span> :
                                                            <Spinner size="md" />
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className='col-6'>
                                                      <div className='row mx-0'>
                                                        <div
                                                          className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                          style={{ background: 'rgba(79, 93, 116, 1)', height: '46px' }}
                                                        >
                                                          <span className='fs-7 font-w600 text-white text-center'>
                                                            {`Tasks in Next 30 days`}
                                                          </span>
                                                        </div>
                                                      </div>

                                                      <div className='row mx-0'>
                                                        <div
                                                          className='col-12 p-2 d-flex justify-content-center align-items-center'
                                                          style={{}}
                                                        >
                                                          {Object.keys(maintenanceObj).length > 0 ?
                                                            <span className='fs-6 font-w600'>
                                                              {`${maintenanceObj?.home_maintenance_plan_in_30_days_count || 0}`}
                                                            </span> :
                                                            <Spinner size="md" />
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>


                                                  <div className='row mx-0'>
                                                    <div
                                                      onClick={() => { setToggleCheckUpResultAndMaintenancePlan(2) }}
                                                      className='col-12 p-1 d-flex justify-content-center align-items-center text-hovered cursor-pointer overlay-action-btn rounded-bottom'
                                                      style={{ background: 'rgba(244, 248, 255, 1)' }}
                                                    >
                                                      <div>
                                                        <span className='fs-7 font-w600'>
                                                          {`View all`}
                                                        </span>
                                                        <span>
                                                          <i className='bi bi-chevron-right ps-2'></i>
                                                        </span>
                                                      </div>

                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className='row mx-0 mb-2'>
                                                <div className='col-12 px-0'>
                                                  <span className='fs-7 font-w600'>
                                                    {'Items conditions'}
                                                  </span>
                                                </div>
                                              </div>

                                              <div className='row mx-0'>
                                                <div className='col-12 px-0'>

                                                  <div className='row mx-0'>
                                                    <div className='col-12 px-0 d-flex border-bottom overflow-auto'>

                                                      <div
                                                        className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                        onClick={() => handleCheckUpTabs(4)}
                                                      >
                                                        <div
                                                          className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white '
                                                          style={{
                                                            background: 'rgba(79, 93, 116, 1)',
                                                            width: '50px'
                                                          }}
                                                        >
                                                          <span>{`All`}</span>
                                                        </div>
                                                        <div
                                                          className='d-flex justify-content-center align-items-center p-1 fs-6 w-100 font-w600'
                                                          style={{
                                                            background: checkUpTabsToggle === 4 ? "white" : 'rgba(244, 248, 255, 1)',
                                                            color: checkUpTabsToggle === 4 ? "black" : '',
                                                          }}
                                                        >
                                                          <span>{checkupResultCompleteObj?.all_items_count || 0}</span>
                                                        </div>

                                                      </div>

                                                      <div
                                                        className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                        onClick={() => handleCheckUpTabs(1)}
                                                      >
                                                        <div
                                                          className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                          style={{
                                                            background: 'rgba(45, 204, 99, 1)',
                                                            width: '50px'
                                                          }}
                                                        >
                                                          <span>{`Good`}</span>
                                                        </div>
                                                        <div
                                                          className='d-flex justify-content-center align-items-center p-1 fs-6 w-100 font-w600'
                                                          style={{
                                                            background: checkUpTabsToggle === 1 ? "white" : 'rgba(244, 248, 255, 1)',
                                                            color: checkUpTabsToggle === 1 ? "black" : '',
                                                          }}
                                                        >
                                                          <div>
                                                            <span className='me-2'>
                                                              <IoCheckmarkCircleOutline />
                                                            </span>
                                                            <span>{checkupResultCompleteObj?.good_items_count}</span>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div
                                                        className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                        onClick={() => handleCheckUpTabs(2)}
                                                      >
                                                        <div
                                                          className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                          style={{
                                                            background: 'rgba(255, 154, 32, 1)',
                                                            width: '50px'
                                                          }}
                                                        >
                                                          <span>{`OK`}</span>
                                                        </div>
                                                        <div
                                                          className='d-flex justify-content-center align-items-center p-1 fs-6 w-100 font-w600'
                                                          style={{
                                                            background: checkUpTabsToggle === 2 ? "white" : 'rgba(244, 248, 255, 1)',
                                                            color: checkUpTabsToggle === 2 ? "black" : '',
                                                          }}
                                                        >
                                                          <div>
                                                            <span className='me-2'>
                                                              <TiSpanner className='rounded-circle border border-2' />
                                                            </span>
                                                            <span>{checkupResultCompleteObj?.ok_items_count}</span>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div
                                                        className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                        onClick={() => handleCheckUpTabs(3)}
                                                      >
                                                        <div
                                                          className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                          style={{
                                                            background: 'rgba(240, 72, 72, 1)',
                                                            width: '50px'
                                                          }}
                                                        >
                                                          <span>{`Poor`}</span>
                                                        </div>
                                                        <div
                                                          className='d-flex justify-content-center align-items-center p-1 fs-6 w-100 font-w600'
                                                          style={{
                                                            background: checkUpTabsToggle === 3 ? "white" : 'rgba(244, 248, 255, 1)',
                                                            color: checkUpTabsToggle === 3 ? "black" : '',
                                                          }}
                                                        >
                                                          <div>
                                                            <span className='me-2'>
                                                              <MdOutlineCancel />
                                                            </span>
                                                            <span>{checkupResultCompleteObj?.poor_items_count}</span>
                                                          </div>
                                                        </div>
                                                      </div>

                                                    </div>
                                                  </div>

                                                  <div
                                                    className="row  px-2 "
                                                    style={{
                                                      backgroundColor: "rgba(251, 252, 255, 1)",
                                                    }}
                                                  >

                                                    <div
                                                      className="row mx-0 my-1 align-items-center "
                                                      style={{ minHeight: "40px" }}
                                                    >
                                                      <div className="col-12">
                                                        <div className="row">
                                                          <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                                                            <span className="fs-5 p-2 d-flex align-items-center">
                                                              <LuArrowUpDown
                                                                className="cursor-pointer"
                                                                style={{ marginRight: "4px", color: "black" }}
                                                                onClick={handleOpenFiltreBoxCheckUp}
                                                              />
                                                              <span
                                                                className="fs-7  cursor-pointer"
                                                                style={{ position: "relative" }}
                                                                onClick={handleOpenFiltreBoxCheckUp}
                                                              >
                                                                {/* {filtreValueCheckUp == 1 && "Date: Newset first"}
                                                                       {filtreValueCheckUp == 2 && "Date: Oldest first"} */}

                                                                &nbsp;
                                                                {/* {filtreBoxCheckUp ? <IoIosArrowUp /> : <IoIosArrowDown />} */}
                                                                <span
                                                                  className={`${filtreBoxCheckUp ? "" : "d-none"} p-1`}
                                                                  style={{
                                                                    position: "absolute",
                                                                    top: "26px",
                                                                    width: "170px",
                                                                    zIndex: 1,
                                                                    border: "1px solid lightgray",
                                                                    background: "white",
                                                                    left: "-22px",
                                                                    boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                                  }}>
                                                                  <div className="row">
                                                                    <div
                                                                      className={`${filtreValueCheckUp == 1 ? "dt" : ""
                                                                        } d-flex justify-content-start m-1 pointer `}
                                                                      onClick={() => {
                                                                        handleSetFiltreValueCheckUp(1);
                                                                      }}>
                                                                      <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                        {filtreValueCheckUp == 1 && <i className="bi bi-check-lg"></i>}
                                                                      </div>
                                                                      Date: Newest first
                                                                    </div>
                                                                    <div
                                                                      className={`${filtreValueCheckUp == 2 ? "dt" : ""
                                                                        } d-flex justify-content-start m-1 pointer`}
                                                                      onClick={() => {
                                                                        handleSetFiltreValueCheckUp(2);
                                                                      }}>
                                                                      <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                        {filtreValueCheckUp == 2 && <i className="bi bi-check-lg"></i>}
                                                                      </div>
                                                                      Date: Oldest first
                                                                    </div>

                                                                  </div>
                                                                </span>
                                                              </span>
                                                            </span>

                                                            <span
                                                              className="fs-6 p-2 d-flex align-items-center"
                                                              style={{
                                                                border: "1px solid lightgray",
                                                                borderRadius: "6px",
                                                              }}>
                                                              <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                                              <input
                                                                placeholder="Search"
                                                                style={{ border: "0px", width: "100%" }}
                                                                onChange={handleSearchCheckUp}
                                                                value={searchValueCheckUp}
                                                              />
                                                            </span>
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>


                                                  <div className='row mx-0 mb-3'>
                                                    <div className='col-12 px-0'>
                                                      {checkupResultsArr.length > 0 ?
                                                        <>
                                                          {checkupResultsArr?.map((item, ind) => {
                                                            return (
                                                              <>
                                                                <div
                                                                  key={ind}
                                                                  className="row mx-0 "
                                                                  onClick={(e) => {
                                                                    e.stopPropagation();
                                                                  }}
                                                                  style={{ cursor: 'default', }}
                                                                >
                                                                  <div
                                                                    className="col-12 px-3 border-top"
                                                                    style={{
                                                                      background: 'rgb(199 212 234 / 30%)',
                                                                    }}
                                                                  >
                                                                    <div
                                                                      className="d-flex align-items-center justify-content-between w-100 py-3 font-w600 cursor-pointer text-black text-hovered"
                                                                      onClick={() => {
                                                                        if (item?.home_area_product_id_ids === isExpandedForProductCheckUp) {
                                                                          setIsExpandedForProductCheckUp('')
                                                                        } else {
                                                                          setIsExpandedForProductCheckUp(item?.home_area_product_id_ids)
                                                                        }
                                                                      }}
                                                                    >
                                                                      <div className="me-4 d-flex">
                                                                        <div className='me-3 position-relative'>
                                                                          <div className='position-absolute'
                                                                            style={{
                                                                              top: '-15px',
                                                                              right: '-5px',
                                                                            }}
                                                                          >
                                                                            {
                                                                              item?.condition_chr === "Good" ?
                                                                                <IoCheckmarkCircleOutline
                                                                                  style={{ height: '18px', width: '18px', color: 'rgba(45, 204, 99, 1)' }}
                                                                                  className='bg-white rounded-circle shadow'
                                                                                /> :
                                                                                item?.condition_chr === "Ok" ?
                                                                                  <TiSpanner
                                                                                    style={{ height: '18px', width: '18px', color: 'rgba(255, 154, 32, 1)', border: '1px solid rgba(255, 154, 32, 1)' }}
                                                                                    className='bg-white rounded-circle shadow'
                                                                                  /> :
                                                                                  item?.condition_chr === "Poor" ?
                                                                                    <MdOutlineCancel
                                                                                      style={{ height: '18px', width: '18px', color: 'rgba(240, 72, 72, 1)' }}
                                                                                      className='bg-white rounded-circle shadow'
                                                                                    /> : ''
                                                                            }
                                                                          </div>
                                                                          <span
                                                                            className=" p-2 rounded bg-white shadow-lg text-black"
                                                                          >
                                                                            <i
                                                                              class="bi bi-cloud-hail-fill"
                                                                              style={{ height: '20px', width: '20px' }}
                                                                            ></i>
                                                                          </span>
                                                                        </div>

                                                                        <span>{`${item?.product_name_chr}`}</span>
                                                                      </div>

                                                                      <div
                                                                        className="text-black fs-4 d-flex align-items-center justify-content-center cursor-pointer"
                                                                      >
                                                                        <span>
                                                                          <span>
                                                                            <span>
                                                                              {item.home_area_product_id_ids === isExpandedForProductCheckUp ?
                                                                                <i class="bi bi-chevron-up ms-2 border rounded px-1 text-hovered overlay-action-btn"></i> :
                                                                                <i class="bi bi-chevron-down ms-2 border rounded px-1 text-hovered overlay-action-btn"></i>
                                                                              }
                                                                            </span>
                                                                          </span>
                                                                        </span>
                                                                      </div>
                                                                    </div>

                                                                    {item?.home_area_product_id_ids === isExpandedForProductCheckUp &&
                                                                      <div
                                                                        className="row mb-2 bg-white rounded-2 shadow-sm fs-7"
                                                                        style={{}}
                                                                      >
                                                                        <div className="col-12 p-1">
                                                                          <div className="row mx-1 pb-1 pt-2 px-3 d-flex align-items-center">
                                                                            <div className="col-4 pe-2  font-w500">
                                                                              <span>{`Condition`}</span>
                                                                            </div>
                                                                            <div className="col-8 d-flex px-2">
                                                                              <span
                                                                                className="text-white rounded-pill p-1 px-3"
                                                                                style={{
                                                                                  background:
                                                                                    `${item?.condition_chr === "Good" ? "rgba(45, 204, 99, 1)" :
                                                                                      item?.condition_chr === "Ok" ? "rgba(255, 154, 32, 1)" :
                                                                                        item?.condition_chr === "Poor" ? "rgba(240, 72, 72, 1)" :
                                                                                          item?.condition_chr === "Not assessed" ? "rgba(131, 154, 192, 1)" : ''}`,
                                                                                }}
                                                                              >
                                                                                {`${item?.condition_chr}`}
                                                                              </span>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row mx-1 py-2 px-3 border-bottom  d-flex align-items-center">
                                                                            <div className="col-4 pe-2  font-w500">
                                                                              <span>{`Updated`}</span>
                                                                            </div>
                                                                            <div className="col-8">
                                                                              <span className="text-black font-w600 p-1 px-2">{`${formatUnixTimestamp(item?.updated_date_dtm)}`}</span>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                            <div className="col-4 pe-2 font-w500">
                                                                              <span>{`Brand`}</span>
                                                                            </div>
                                                                            <div className="col-8">
                                                                              <span className={`${item?.device_brand_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.device_brand_chr ? item?.device_brand_chr : '-'}`}</span>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                            <div className="col-4 pe-2 font-w500">
                                                                              <span>{`Model`}</span>
                                                                            </div>
                                                                            <div className="col-8">
                                                                              <span className={`${item?.model_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.model_number_chr ? item?.model_number_chr : '-'}`}</span>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                            <div className="col-4 pe-2 font-w500">
                                                                              <span>{`Serial number`}</span>
                                                                            </div>
                                                                            <div className="col-8">
                                                                              <span className={`${item?.serial_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.serial_number_chr ? item?.serial_number_chr : '-'}`}</span>
                                                                            </div>
                                                                          </div>

                                                                          <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                            <div className="col-4 pe-2 font-w500">
                                                                              <span>{`Description`}</span>
                                                                            </div>
                                                                            <div className="col-8">
                                                                              <span className={`${item?.description_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.description_chr ? item?.description_chr : '-'}`}</span>
                                                                            </div>
                                                                          </div>

                                                                          {item?.image_url &&
                                                                            <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                              <div className="col-12">
                                                                                <img
                                                                                  src={item?.image_url}
                                                                                  alt="Attachment"
                                                                                  className="rounded-2 shadow-lg cursor-pointer"
                                                                                  onClick={(e) => {
                                                                                    handleOpenDoc(); setImageAttachURL(item?.image_url);
                                                                                  }}
                                                                                  style={{
                                                                                    height: '40px',
                                                                                    width: '40px',
                                                                                    border: '1px solid orange'
                                                                                  }}
                                                                                />
                                                                              </div>
                                                                            </div>
                                                                          }

                                                                        </div>
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                </div>
                                                              </>
                                                            )
                                                          })}
                                                        </> :
                                                        <>
                                                          <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                                            <div className="mb-2">
                                                              <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                            </div>
                                                            <span>
                                                              {`No items found`}
                                                            </span>
                                                          </div>
                                                        </>
                                                      }
                                                    </div>
                                                  </div>

                                                </div>
                                              </div>


                                            </div>
                                          </div>
                                        </> :
                                        toggleCheckUpResultAndMaintenancePlan === 2 ?
                                          <>
                                            <div
                                              className="row "
                                              style={{
                                                background: "rgba(235, 240, 250, 1)",
                                                // height: "calc(100dvh - 140px)",
                                              }}
                                            >
                                              <div
                                                className="col-12 py-3 px-2 "
                                                style={{
                                                  // maxHeight: "550px",
                                                  // minHeight: "450px",
                                                  //  overflow: "auto",
                                                  //  height: "calc(100dvh - 115px)",
                                                }}
                                              >
                                                <div className="row mx-0">
                                                  <div className="col-12 px-2 pb-2 ">
                                                    <span>
                                                      {`The maintenance tasks are intended to help you extend the life and safety of the inventory items in your home`}
                                                    </span>
                                                  </div>
                                                </div>

                                                <div className='row mx-0'>
                                                  <div className='col-12 px-0'>

                                                    <div className='row mx-0'>
                                                      <div className='col-12 px-0 d-flex border-bottom overflow-auto'>

                                                        <div
                                                          className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                          onClick={() => handleMaintenanceTaskTabs(4)}
                                                        >
                                                          <div
                                                            className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white '
                                                            style={{
                                                              background: maintenanceTabsToggle === 4 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                              width: '50px'
                                                            }}
                                                          >
                                                            <span className="text-truncate" style={{ fontSize: '8px' }}>{`All`}</span>
                                                          </div>
                                                          <div
                                                            className={`d-flex justify-content-center align-items-center p-1 fs-6 w-100 ${maintenanceTabsToggle === 4 ? "font-w700 text-black" : "font-w600"}`}
                                                            style={{
                                                              background: maintenanceTabsToggle === 4 ? "white" : 'rgba(244, 248, 255, 1)',
                                                            }}
                                                          >
                                                            {/* <span>{maintenanceObjMaintenanceTask?.total_count}</span> */}
                                                            <span>{allHomeMaintenancePlanCount}</span>
                                                          </div>

                                                        </div>

                                                        <div
                                                          className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                          onClick={() => handleMaintenanceTaskTabs(1)}
                                                        >
                                                          <div
                                                            className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                            style={{
                                                              background: maintenanceTabsToggle === 1 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                              width: '50px'
                                                            }}
                                                          >
                                                            <span className="text-truncate" style={{ fontSize: '8px' }}>{`In 30 Days`}</span>
                                                          </div>
                                                          <div
                                                            className={`d-flex justify-content-center align-items-center p-1 fs-6 w-100 ${maintenanceTabsToggle === 1 ? "font-w700 text-black" : "font-w600"}`}
                                                            style={{
                                                              background: maintenanceTabsToggle === 1 ? "white" : 'rgba(244, 248, 255, 1)',
                                                            }}
                                                          >
                                                            <div>
                                                              {/* <span>{maintenanceObjMaintenanceTask?.home_maintenance_plan_in_30_days_count}</span> */}
                                                              <span>{secondCount}</span>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div
                                                          className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                          onClick={() => handleMaintenanceTaskTabs(2)}
                                                        >
                                                          <div
                                                            className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                            style={{
                                                              background: maintenanceTabsToggle === 2 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                              width: '50px'
                                                            }}
                                                          >
                                                            <span className="text-truncate" style={{ fontSize: '8px' }}>{`In 60 Days`}</span>
                                                          </div>
                                                          <div
                                                            className={`d-flex justify-content-center align-items-center p-1 fs-6 w-100 ${maintenanceTabsToggle === 2 ? "font-w700 text-black" : "font-w600"}`}
                                                            style={{
                                                              background: maintenanceTabsToggle === 2 ? "white" : 'rgba(244, 248, 255, 1)',
                                                            }}
                                                          >
                                                            <div>
                                                              {/* <span>{maintenanceObjMaintenanceTask?.home_maintenance_plan_in_60_days_count}</span> */}
                                                              <span>{thirdCount}</span>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div
                                                          className='d-flex justify-content-center align-items-center rounded-top flex-column border border-bottom-0 cursor-pointer overlay-action-btn'
                                                          onClick={() => handleMaintenanceTaskTabs(3)}
                                                        >
                                                          <div
                                                            className='d-flex justify-content-center align-items-center p-1 fs-7 rounded-top text-white'
                                                            style={{
                                                              background: maintenanceTabsToggle === 3 ? "rgba(79, 93, 116, 1)" : 'rgba(131, 154, 192, 1)',
                                                              width: '50px'
                                                            }}
                                                          >
                                                            <span className="text-truncate" style={{ fontSize: '8px' }}>{`In 90 Days`}</span>
                                                          </div>
                                                          <div
                                                            className={`d-flex justify-content-center align-items-center p-1 fs-6 w-100 ${maintenanceTabsToggle === 3 ? "font-w700 text-black" : "font-w600"}`}
                                                            style={{
                                                              background: maintenanceTabsToggle === 3 ? "white" : 'rgba(244, 248, 255, 1)',
                                                            }}
                                                          >
                                                            <div>
                                                              {/* <span>{maintenanceObjMaintenanceTask?.home_maintenance_plan_in_90_days_count}</span> */}
                                                              <span>{fourthCount}</span>
                                                            </div>
                                                          </div>
                                                        </div>

                                                      </div>
                                                    </div>

                                                    <div
                                                      className="row  px-2 "
                                                      style={{
                                                        backgroundColor: "rgba(251, 252, 255, 1)",
                                                      }}
                                                    >

                                                      <div
                                                        className="row mx-0 my-1 align-items-center "
                                                        style={{ minHeight: "40px" }}
                                                      >
                                                        <div className="col-12">
                                                          <div className="row">
                                                            <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                                                              <span className="fs-5 p-2 d-flex align-items-center">
                                                                <LuArrowUpDown
                                                                  className="cursor-pointer"
                                                                  style={{ marginRight: "4px", color: "black" }}
                                                                  onClick={handleOpenFiltreBoxMaintenanceTask}
                                                                />
                                                                <span
                                                                  className="fs-7  cursor-pointer"
                                                                  style={{ position: "relative" }}
                                                                  onClick={handleOpenFiltreBoxMaintenanceTask}>
                                                                  {/* {filtreValueMaintenanceTask == 1 && "Date: Newset first"}
                                                                 {filtreValueMaintenanceTask == 2 && "Date: Oldest first"} */}

                                                                  &nbsp;
                                                                  {/* {filtreBoxMaintenanceTask ? <IoIosArrowUp /> : <IoIosArrowDown />} */}
                                                                  <span
                                                                    className={`${filtreBoxMaintenanceTask ? "" : "d-none"} p-1`}
                                                                    style={{
                                                                      position: "absolute",
                                                                      top: "26px",
                                                                      width: "170px",
                                                                      zIndex: 1,
                                                                      border: "1px solid lightgray",
                                                                      background: "white",
                                                                      left: "-22px",
                                                                      boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                                    }}
                                                                  >
                                                                    <div className="row">
                                                                      <div
                                                                        className={`${filtreValueMaintenanceTask == 1 ? "dt" : ""
                                                                          } d-flex justify-content-start m-1 pointer `}
                                                                        onClick={() => {
                                                                          handleSetFiltreValueMaintenanceTask(1);
                                                                        }}>
                                                                        <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                          {filtreValueMaintenanceTask == 1 && <i className="bi bi-check-lg"></i>}
                                                                        </div>
                                                                        Date: Newest first
                                                                      </div>
                                                                      <div
                                                                        className={`${filtreValueMaintenanceTask == 2 ? "dt" : ""
                                                                          } d-flex justify-content-start m-1 pointer`}
                                                                        onClick={() => {
                                                                          handleSetFiltreValueMaintenanceTask(2);
                                                                        }}>
                                                                        <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                          {filtreValueMaintenanceTask == 2 && <i className="bi bi-check-lg"></i>}
                                                                        </div>
                                                                        Date: Oldest first
                                                                      </div>

                                                                    </div>
                                                                  </span>
                                                                </span>
                                                              </span>

                                                              <span
                                                                className="fs-6 p-2 d-flex align-items-center"
                                                                style={{
                                                                  border: "1px solid lightgray",
                                                                  borderRadius: "6px",
                                                                }}>
                                                                <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                                                <input
                                                                  placeholder="Search"
                                                                  style={{ border: "0px", width: "100%" }}
                                                                  onChange={handleSearchMaintenanceTask}
                                                                  value={searchValueMaintenanceTask}
                                                                />
                                                              </span>
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>


                                                    <div className='row mx-0 mb-3'>
                                                      <div className='col-12 px-0'>
                                                        {maintenancePlansArr.length > 0 ?
                                                          <>
                                                            {maintenancePlansArr?.map((item, ind) => {
                                                              return (
                                                                <>
                                                                  <div
                                                                    key={ind}
                                                                    className="row mx-0 fs-7"
                                                                    onClick={(e) => {
                                                                      e.stopPropagation();
                                                                    }}
                                                                    style={{ cursor: 'default' }}
                                                                  >
                                                                    <div
                                                                      className="col-12 px-3 border-top"
                                                                      style={{
                                                                        background: 'rgb(199 212 234 / 30%)',
                                                                      }}
                                                                    >
                                                                      <div
                                                                        className="d-flex align-items-center justify-content-between w-100 py-3 font-w600  text-black text-hovered"
                                                                      // onClick={() => {
                                                                      //     if (item?.home_area_product_id_ids === isExpandedForProduct) {
                                                                      //         setIsExpandedForProduct('')
                                                                      //     } else {
                                                                      //         setIsExpandedForProduct(item?.home_area_product_id_ids)
                                                                      //     }
                                                                      // }}
                                                                      >
                                                                        <div className="me-4 d-flex">
                                                                          <div className='me-3 position-relative'>
                                                                            <div className='position-absolute'
                                                                              style={{
                                                                                top: '-15px',
                                                                                right: '-5px',
                                                                              }}
                                                                            >
                                                                              {
                                                                                item?.condition_chr === "Good" ?
                                                                                  <IoCheckmarkCircleOutline
                                                                                    style={{ height: '18px', width: '18px', color: 'rgba(45, 204, 99, 1)' }}
                                                                                    className='bg-white rounded-circle shadow'
                                                                                  /> :
                                                                                  item?.condition_chr === "Ok" ?
                                                                                    <TiSpanner
                                                                                      style={{ height: '18px', width: '18px', color: 'rgba(255, 154, 32, 1)', border: '1px solid rgba(255, 154, 32, 1)' }}
                                                                                      className='bg-white rounded-circle shadow'
                                                                                    /> :
                                                                                    item?.condition_chr === "Poor" ?
                                                                                      <MdOutlineCancel
                                                                                        style={{ height: '18px', width: '18px', color: 'rgba(240, 72, 72, 1)' }}
                                                                                        className='bg-white rounded-circle shadow'
                                                                                      /> : ''
                                                                              }
                                                                            </div>
                                                                            <span
                                                                              className=" p-2 rounded bg-white shadow-lg text-black"
                                                                            >
                                                                              <i
                                                                                class="bi bi-cloud-hail-fill"
                                                                                style={{ height: '20px', width: '20px' }}
                                                                              ></i>
                                                                            </span>
                                                                          </div>

                                                                          <span>{`${item?.product_name_chr}`}</span>
                                                                        </div>

                                                                        <div
                                                                          className="text-black fs-4 d-flex align-items-center justify-content-center"
                                                                        >
                                                                          <span>
                                                                            <span>
                                                                              <span>
                                                                                <i class="bi bi-chevron-right ms-2  px-1"></i>
                                                                              </span>
                                                                            </span>
                                                                          </span>
                                                                        </div>
                                                                      </div>

                                                                      <div className="row mb-2 bg-white rounded-2 shadow-sm">
                                                                        <div className="col-12 p-1">

                                                                          <div
                                                                            className={`bg-white mb-1  rounded `}
                                                                            style={{ margin: '0' }}
                                                                          >
                                                                            <div
                                                                              className="row mx-1  py-2 px-3 d-flex"
                                                                            >
                                                                              <div
                                                                                className="row mx-0  cursor-pointer"
                                                                                onClick={() => {
                                                                                  if (item?.maintenance_plan_id_ids === isExpandedForMaintenancePlanMaintenanceTask) {
                                                                                    setIsExpandedForMaintenancePlanMaintenanceTask('')
                                                                                  } else {
                                                                                    setIsExpandedForMaintenancePlanMaintenanceTask(item.maintenance_plan_id_ids)
                                                                                  }
                                                                                }}
                                                                              >
                                                                                <div className="col-4 pe-2 font-w500">
                                                                                  <span>{`Maintenance`}</span>
                                                                                </div>
                                                                                <div className="col-8 d-flex align-items-center justify-content-between ps-3">
                                                                                  <span className={`${item?.instruction_chr && 'text-black'} font-w600 `}>{`${item?.instruction_chr ? `${item?.instruction_chr}` : '-'}`}</span>

                                                                                  <span>
                                                                                    {item?.maintenance_plan_id_ids === isExpandedForMaintenancePlanMaintenanceTask ?
                                                                                      <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i> :
                                                                                      <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i>
                                                                                    }
                                                                                  </span>
                                                                                </div>
                                                                              </div>

                                                                              {item?.maintenance_plan_id_ids === isExpandedForMaintenancePlanMaintenanceTask &&
                                                                                <>
                                                                                  <div className="row mx-1 py-2  d-flex ">
                                                                                    <div className="col-4 pe-2 font-w500">
                                                                                      <span>{`When`}</span>
                                                                                    </div>
                                                                                    <div className="col-8 ps-3">
                                                                                      <span className={`${item?.period_name_chr && 'text-black'} font-w600  `}>{`${item?.period_name_chr ? `In ${item?.period_name_chr}` : '-'}`}</span>
                                                                                    </div>
                                                                                  </div>

                                                                                  <div className="row mx-1 py-2  d-flex ">
                                                                                    <div className="col-4 pe-2 font-w500">
                                                                                      <span>{`Frequency`}</span>
                                                                                    </div>
                                                                                    <div className="col-8 ps-3">
                                                                                      <span className={`${item?.frequency_int && 'text-black'} font-w600 `}>{`${item?.frequency_int ? `${item?.frequency_int} times in a ${item?.period_name_chr}` : '-'}`}</span>
                                                                                    </div>
                                                                                  </div>


                                                                                  <div className="row mx-1 py-2  d-flex ">
                                                                                    <div className="col-4 pe-2 font-w500">
                                                                                      <span>{`Link`}</span>
                                                                                    </div>
                                                                                    <div className="col-8 ps-3">
                                                                                      {item?.purchase_link ?
                                                                                        <a
                                                                                          className="text-hovered text-gray-800"
                                                                                          href={`${item?.purchase_link}`}
                                                                                          target="_blank"
                                                                                          rel="noreferrer"
                                                                                        >
                                                                                          <span className={`font-w600`}>{`Purchase link`} <i className="bi bi-chevron-right me-2"></i> </span>
                                                                                        </a> :
                                                                                        <span className={`font-w600`}>{`-`} </span>
                                                                                      }
                                                                                    </div>
                                                                                  </div>

                                                                                  <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                    <div className="col-12">
                                                                                      <div className="d-flex align-items-center justify-content-between">
                                                                                        <div className="mx-2"></div>
                                                                                        <div className="mx-2 d-flex align-items-center fs-4">

                                                                                          <div className="me-2">
                                                                                            <div className="tooltipCustom">
                                                                                              <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                              <span
                                                                                                className="cursor-pointer overlay-action-btn px-2 py-1 rounded-2 text-gray-800 text-hovered"
                                                                                                onClick={() => {
                                                                                                  updateMaitenancePlanFnMaintenanceTask(item);
                                                                                                }}
                                                                                              >
                                                                                                <i className="bi bi-pencil"></i>
                                                                                              </span>
                                                                                            </div>
                                                                                          </div>

                                                                                          <div className="me-2">
                                                                                            <div className="tooltipCustom">
                                                                                              <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete"}</span>
                                                                                              <span
                                                                                                className="cursor-pointer overlay-action-btn px-2 py-1 rounded-2 text-gray-800 text-hovered"
                                                                                                onClick={() => {
                                                                                                  handleOpenMaintenancePlanModalMaintenanceTask(2);
                                                                                                  setMaintenancePlanIdMaintenanceTask(item?.maintenance_plan_id_ids);
                                                                                                  setInstructionMaintenanceTask(item?.instruction_chr);
                                                                                                }}
                                                                                              >
                                                                                                <i className="bi bi-trash"></i>
                                                                                              </span>
                                                                                            </div>
                                                                                          </div>
                                                                                        </div>
                                                                                      </div>

                                                                                    </div>
                                                                                  </div>



                                                                                </>
                                                                              }

                                                                            </div>
                                                                          </div>



                                                                          {item?.image_url && false &&
                                                                            <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                              <div className="col-12">
                                                                                <img
                                                                                  src={item?.image_url}
                                                                                  alt="Attachment"
                                                                                  className="rounded-2 shadow-lg cursor-pointer"
                                                                                  onClick={(e) => {
                                                                                    handleOpenDoc(); setImageAttachURL(item?.image_url);
                                                                                  }}
                                                                                  style={{
                                                                                    height: '60px',
                                                                                    width: '60px',
                                                                                    border: '1px solid orange'
                                                                                  }}
                                                                                />
                                                                              </div>
                                                                            </div>
                                                                          }
                                                                        </div>
                                                                      </div>

                                                                      <div className="row mx-0 mb-1">
                                                                        <div className="col-12 px-0 font-w600">
                                                                          {item?.is_completed_ysn ?
                                                                            <span className="text-success">{`Task completed`}</span> :
                                                                            <span>{`Task not completed yet`}</span>
                                                                          }
                                                                        </div>
                                                                      </div>

                                                                      {/* {
                                                                       <div
                                                                         className="row  px-0"
                                                                       // onClick={() => handleCheckboxChange(element)}
                                                                       >
                                                                         <div
                                                                           className={`row pb-2`}
                                                                         >
                                                                           <div className={`col-12 d-flex fs-6 font-w600 `}>
                                                                             <div className="d-flex align-items-center justify-content-between w-100">
                                                                               <div
                                                                                 className="me-4 d-flex align-items-center"
                                                                                 style={{
                                                                                   pointerEvents: updateMaintenancePlanStatusLoading ? 'none' : 'auto',
                                                                                   opacity: updateMaintenancePlanStatusLoading ? '0.5' : '1'
                                                                                 }}
                                                                               >
                                                                                 <span
                                                                                   className="me-2"
                                                                                 >
                                                                                   {updateMaintenancePlanStatusLoading && (item?.maintenance_plan_id_ids === maintenancePlanIdMaintenanceTask) ?
                                                                                     <Spinner animation="border" size="sm" /> :
                                                                                     <input
                                                                                       type="checkbox"
                                                                                       checked={item?.is_completed_ysn}
                                                                                       className="form-check-input"
                                                                                       id="customCheckBox4"
                                                                                       onChange={(e) => {
                                                                                         updateMaintenancePlanStatusFn(item);
                                                                                         setMaintenancePlanIdMaintenanceTask(item?.maintenance_plan_id_ids)
                                                                                       }}
                                                                                       onClick={() => { updateMaintenancePlanStatusFn(item); setMaintenancePlanIdMaintenanceTask(item?.maintenance_plan_id_ids) }}
                                                                                     />
                                                                                   }
                                                                                 </span>
                                                                                 <span
                                                                                   className="pt-1 cursor-pointer text-hovered"
                                                                                   onClick={() => {
                                                                                     updateMaintenancePlanStatusFn(item);
                                                                                     setMaintenancePlanIdMaintenanceTask(item?.maintenance_plan_id_ids)
                                                                                   }}
                                                                                 >
                                                                                   {`Task Completed`}
                                                                                 </span>
                                                                               </div>
                                                                             </div>
                                                                           </div>
                                                                         </div>
                                                                       </div>} */}
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              )
                                                            })}
                                                          </> :
                                                          <>
                                                            <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                                              <div className="mb-2">
                                                                <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                              </div>
                                                              <span>
                                                                {`No items found`}
                                                              </span>
                                                            </div>
                                                          </>
                                                        }
                                                      </div>
                                                    </div>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </> : <></>
                                      }
                                    </>
                                    : <></>
                              }
                            </div>
                          </div>

                          {toggleInspectionTab === 2 &&
                            <>
                              {toggleForDefineRoomList === 1 ?
                                <>
                                  <div className="row mx-0 pb-2 p-3 border-bottom position-relative"
                                    style={{
                                      boxShadow: "rgba(0, 0, 0, 0.31) 0px -6px 10px -2px",
                                    }}
                                  >
                                    <div className="align-items-center col-12 d-flex font-w600 justify-content-center px-0 text-black w-100">

                                      <PrimaryButton
                                        buttonName={"CONTINUE"}
                                        onClick={() => {
                                          // setToggleForDefineRoomList(2)
                                          // handleClearRoomStates();
                                          getHomeAreaListonContinue();
                                        }}
                                        isLoading={defineRoomsLoading}
                                        loadingMessage={"CONTINUING..."}
                                        style={{
                                          width: '100%',
                                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                          border: '2px solid rgba(255, 154, 32, 1)',
                                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                        }}
                                      />

                                    </div>
                                  </div>
                                </> :
                                <>
                                  {Object.keys(particularHomeAreaObj).length > 0 &&
                                    <>
                                      <div className="row mx-0 pb-2 p-3 border-bottom position-relative"
                                        style={{
                                          boxShadow: "rgba(0, 0, 0, 0.31) 0px -6px 10px -2px",
                                        }}
                                        onClick={() => {
                                          handleOpenMobileMoreActionsDrawer();
                                          handleMobileMoreActionsTabs(3);
                                          setMobileCheckUpTabs(2);
                                          getAllProductTypeListFn();
                                        }}
                                      >
                                        <div className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-center px-0 text-black">

                                          <div className="d-flex align-items-center">
                                            <span>{`Add item`}</span>

                                            <span>
                                              <i className="bi bi-chevron-up ms-2" />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  }
                                </>
                              }
                            </>
                          }

                        </div>
                      </div>
                    </>
                  )}

                  {/* OCR new for mobile */}
                  {mobileTabs == 6 && (
                    <>
                      <div className="row mx-0">
                        <div className="col-12  bg-white rounded-top">
                          <div className="row mx-0 p-3 border-bottom">
                            <div className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-between px-0 ">
                              <div className=" d-flex align-items-center">
                                <span
                                  onClick={() => {
                                    handleCloseMobileBottomDrawer();
                                    setMobileTabs();
                                    handleClearOCRSteps()
                                  }}
                                  className="cursor-pointer text-black">
                                  <MdClose />
                                </span>
                              </div>

                              <div className="d-flex align-items-center text-black">
                                <span>{`Capture Text`}</span>
                              </div>

                              <div>
                                {/* <span
                                  onClick={() => {
                                    // handleOpenMobileMoreActionsDrawer();
                                    // handleMobileMoreActionsTabs(2);
                                  }}
                                >
                                  <LuMoreVertical style={{ color: "" }} />
                                </span> */}

                                <span
                                  className="text-hovered px-2 py-1 overlay-action-btn cursor-pointer rounded fs-6"
                                  onClick={() => { handleClearOCRSteps() }}
                                >
                                  {'Clear all'}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row mx-0 pt-2 overflow-auto mb-1"
                            style={{
                              maxHeight: "50dvh",
                              background: "rgba(235, 240, 250, 1)",
                            }}
                          >
                            <div className="col-12 p-3">
                              {/* <div className="row mx-0 mb-2 ">
                                <div
                                  className="col-12 p-2 bg-white d-flex"
                                >
                                  <div className="me-2 d-flex justify-content-center">
                                    <div
                                      className="rounded-circle p-1 fs-5 text-black font-w600 d-flex justify-content-center align-items-center"
                                      style={{
                                        border: OCRSteps == 1 ? '1px solid orange' : '1px solid grey',
                                        height: '35px',
                                        width: '35px',
                                        boxShadow: OCRSteps == 1 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : ``,
                                      }}
                                    >
                                      <span>{`1`}</span>
                                    </div>
                                  </div>

                                  <div className="d-flex flex-column">
                                    <span className="font-w600 text-black">
                                      {`Pause a frame with text`}
                                    </span>

                                    <span className="fs-7 font-w500">
                                      {`Pause the video when the brand and model text is most visible for automatic recognition.`}
                                    </span>

                                    <div className="mt-2">
                                      <Button
                                        onClick={() => {
                                          handleStartOCR()
                                        }}
                                        disabled={OCRSteps == 1 ? false : true}
                                        style={{
                                          width: "100%",
                                          background: OCRSteps == 1 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : 'grey',
                                          boxShadow: OCRSteps == 1 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                          border: 'none'
                                        }}

                                      >
                                        {`PAUSE VIDEO`}
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div> */}

                              <div className="row mx-0 mb-2 ">
                                <div
                                  className="col-12 p-2 bg-white d-flex"
                                  onClick={() => { }}
                                >
                                  <div className="me-2 d-flex justify-content-center">
                                    <div
                                      className="rounded-circle p-1 fs-5 text-black font-w600 d-flex justify-content-center align-items-center"
                                      style={{
                                        border: OCRSteps == 2 ? '1px solid orange' : '1px solid grey',
                                        height: '35px',
                                        width: '35px',
                                        boxShadow: OCRSteps == 2 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                      }}
                                    >
                                      <span>{`1`}</span>
                                    </div>
                                  </div>

                                  <div className="d-flex flex-column">
                                    <span className="font-w600 text-black">
                                      {`Capture the text you need`}
                                    </span>

                                    <span className="fs-7 font-w500">
                                      {`Adjust the frame size, and then click the “Capture Text” button to automatically recognize the text.`}
                                    </span>

                                    <div className="mt-2">
                                      <Button
                                        disabled={OCRSteps == 2 ? false : true}
                                        onClick={() => {
                                          setOCRSteps(3)
                                          handleOcrSend();
                                        }}
                                        style={{
                                          width: "100%",
                                          background: OCRSteps == 2 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : 'grey',
                                          boxShadow: OCRSteps == 2 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                          border: 'none'
                                        }}
                                      >
                                        {`CAPTURE TEXT`}
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row mx-0 mb-2 ">
                                <div
                                  className="col-12 p-2 bg-white d-flex"

                                >
                                  <div className="me-2 d-flex justify-content-center">
                                    <div
                                      className="rounded-circle p-1 fs-5 text-black font-w600 d-flex justify-content-center align-items-center"
                                      style={{
                                        border: OCRSteps == 3 ? '1px solid orange' : '1px solid grey',
                                        height: '35px',
                                        width: '35px',
                                        boxShadow: OCRSteps == 3 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                      }}
                                    >
                                      <span>{`2`}</span>
                                    </div>
                                  </div>

                                  <div className="d-flex flex-column w-100">
                                    <span className="font-w600 text-black">
                                      {`Save the results`}
                                    </span>

                                    <span className="fs-7 font-w500">
                                      {`Correct the data, if necessary, and save it in the Notes.`}
                                    </span>

                                    <div
                                      className="mt-3"
                                    >
                                      <TextArea
                                        labelName={`Captured text`}
                                        value={OCRText}
                                        onChange={(e) => { setOCRText(e.target.value) }}
                                        rows="6"
                                        onBlur={() => { }}
                                      />
                                    </div>

                                    <div className="mt-2">
                                      <Button
                                        disabled={OCRSteps == 3 ? false : true}
                                        onClick={() => {
                                          setOCRSteps(3)
                                          if (!drawingArea) {
                                            const video = document.getElementById("LP");

                                            if (!video) return;
                                            video.play();
                                          }
                                          const [localValue] = [
                                            ...room.localParticipant.dataTracks.values(),
                                          ];
                                          localValue.track.send("notes_attachment");

                                          localValue.track.send("stop_ocr");

                                          handleSaveNoteFromOcr();
                                        }}
                                        style={{
                                          width: "100%",
                                          background: OCRSteps == 3 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : 'grey',
                                          boxShadow: OCRSteps == 3 ? "0px 6px 12px 0px rgba(255, 154, 32, 0.24)" : '',
                                          border: 'none'
                                        }}
                                      >
                                        {isLoadingActive ? <Spinner size="sm" /> : `SAVE TEXT TO NOTES`}
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>



                        </div>
                      </div>
                    </>
                  )}

                  {/* Parts and Manuals */}
                  {mobileTabs == 7 && (
                    <>
                      <div className="row mx-0">
                        <div className="col-12">
                          <div className="row mx-0 border-bottom p-3 rounded-top"
                            style={{ background: 'rgb(235, 240, 250)' }}
                          >
                            <div className="align-items-center col-12 d-flex font-w600 fs-3 justify-content-between px-0 text-black">
                              <div className=" d-flex align-items-center">
                                <span
                                  onClick={() => {
                                    handleCloseMobileBottomDrawer();
                                    setMobileTabs();
                                  }}
                                  className="cursor-pointer">
                                  <MdClose />
                                </span>
                              </div>

                              <div className="d-flex align-items-center">
                                <span>{`Parts and Manuals`}</span>
                              </div>

                              <div>
                                {/* <span
                                  onClick={() => {
                                    handleOpenMobileMoreActionsDrawer();
                                    handleMobileMoreActionsTabs(2);
                                  }}>
                                  <LuMoreVertical style={{ color: "black" }} />
                                </span> */}
                              </div>
                            </div>
                          </div>

                          <div className="overflow-auto" style={{ maxHeight: '80dvh' }}>
                            <div
                              className="row py-1 px-3 bg-white"
                            >

                              <div className="bg-white">

                                {/* {(permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") || permissionArray.includes("SCAN TAB")) && */}
                                <div className="row mx-0 pb-3">
                                  <div className="col-12 px-0">
                                    <span>{`To source info, enter information manually.`}</span>
                                  </div>
                                </div>
                                {/* } */}

                                <div className="row mx-0">
                                  <div className="col-12 px-0 d-flex flex-column align-items-center justify-content-end">
                                    <span className="text-black text-center font-w500 fs-7 align-self-end">{`Click if`}</span>
                                    <span className="text-black text-center font-w500 fs-7 align-self-end">{`Correct`}</span>
                                  </div>
                                </div>

                                {/* {(permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") || permissionArray.includes("SCAN TAB")) && */}
                                <div
                                  style={{
                                    // pointerEvents: (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") || permissionArray.includes("SCAN TAB")) ? "auto" : "none",
                                    // opacity: (permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") || permissionArray.includes("SCAN TAB")) ? 1 : 0.6,
                                  }}
                                >
                                  <div className="row mx-0 pb-2">
                                    <div className="col-12 px-0 d-flex">
                                      <div
                                        className="w-100"
                                        style={{ pointerEvents: confirmProductTypeCheck ? "none" : "auto", }}
                                      >
                                        <InputField
                                          labelName={"Device type"}
                                          placeholderName={"Device type eg: Refrigerator, faucet, etc"}
                                          value={productType}
                                          onChange={(e) => { !confirmProductTypeCheck && handleProductType(e) }}
                                          onBlur={handleProductTypeBlurCheck}
                                          errorOccured={isProductTypeErr}
                                          errorMeesage={"Please add device type"}
                                          isRequired={true}
                                          autoActivated={true}
                                          isPlaceholder={true}
                                        />
                                      </div>

                                      <div
                                        className="ms-2 mb-3"
                                        style={{
                                          // pointerEvents: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? "none" : "auto",
                                          // opacity: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? 0.5 : 1,
                                        }}
                                      >
                                        <div className="tooltipCustom">
                                          <span className="tooltiptextCustom " style={{ width: '52px !important', zIndex: 110 }}>
                                            <div>{"Click to confirm"}</div>
                                            <div>{"information"}</div>
                                          </span>
                                          <div
                                            className="align-items-center d-flex fs-3 justify-content-center rounded-1 overlay-action-btn cursor-pointer"
                                            onClick={() => {
                                              // handleScanDeviceForParts();
                                              // setScanDeviceFlag(1);
                                              setConfirmProductTypeCheck(!confirmProductTypeCheck)
                                            }}
                                            style={{
                                              height: "41px",
                                              width: "30px",
                                              // border: "1px solid rgb(179 179 179 / 64%)",
                                            }}
                                          >

                                            {/* <span className="d-flex">
                                        {scanDeviceLoading ? <Spinner size="sm" /> :
                                          <RiQrScan2Line />}
                                      </span> */}
                                            <span className="d-flex check-lg checkbox-success">
                                              <input
                                                type="checkbox"
                                                checked={confirmProductTypeCheck}
                                                className="form-check-input mt-0 rounded-circle"
                                                id="customCheckBox4"
                                                onChange={(e) => {
                                                  setConfirmProductTypeCheck(e.target.checked)
                                                }}
                                                onClick={() => { setConfirmProductTypeCheck(!confirmProductTypeCheck) }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      {/* <div className="ms-2 mt-1">
                                      <OverlayTrigger placement="top" overlay={partsAndManualsInfo}>
                                        <span className="fs-3 cursor-pointer">
                                          <i className="bi bi-info-circle "></i>
                                        </span>
                                      </OverlayTrigger>
                                    </div> */}
                                    </div>

                                    <div className="col-12 px-0 d-flex">
                                      <div
                                        className="w-100"
                                        style={{ pointerEvents: confirmBrandNameCheck ? "none" : "auto", }}
                                      >
                                        <InputField
                                          labelName={"Brand"}
                                          placeholderName={"Make or Brand"}
                                          value={brandName}
                                          onChange={(e) => { !confirmBrandNameCheck && handleBrandName(e) }}
                                          onBlur={handleBrandNameBlurCheck}
                                          errorOccured={isBrandNameErr}
                                          errorMeesage={"Please add brand name"}
                                          isRequired={true}
                                        />
                                      </div>

                                      <div
                                        className="ms-2 mb-3"
                                        style={{
                                          // pointerEvents: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? "none" : "auto",
                                          // opacity: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? 0.5 : 1,
                                        }}
                                      >
                                        <div className="tooltipCustom">
                                          <span className="tooltiptextCustom " style={{ width: '52px !important', zIndex: 110 }}>
                                            <div>{"Click to confirm"}</div>
                                            <div>{"information"}</div>
                                          </span>
                                          <div
                                            className="align-items-center d-flex fs-3 justify-content-center rounded-1 overlay-action-btn cursor-pointer"
                                            onClick={() => {
                                              // handleScanDeviceForParts();
                                              // setScanDeviceFlag(1);
                                              setConfirmBrandNameCheck(!confirmBrandNameCheck)
                                            }}
                                            style={{
                                              height: "41px",
                                              width: "30px",
                                              // border: "1px solid rgb(179 179 179 / 64%)",
                                            }}
                                          >

                                            {/* <span className="d-flex">
                                        {scanDeviceLoading ? <Spinner size="sm" /> :
                                          <RiQrScan2Line />}
                                      </span> */}
                                            <span className="d-flex check-lg checkbox-success">
                                              <input
                                                type="checkbox"
                                                checked={confirmBrandNameCheck}
                                                className="form-check-input mt-0 rounded-circle"
                                                id="customCheckBox4"
                                                onChange={(e) => {
                                                  setConfirmBrandNameCheck(e.target.checked)
                                                }}
                                                onClick={() => { setConfirmBrandNameCheck(!confirmBrandNameCheck) }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      {/* <div className="ms-2 mt-1">
                                      <OverlayTrigger placement="top" overlay={partsAndManualsInfo}>
                                        <span className="fs-3 cursor-pointer">
                                          <i className="bi bi-info-circle "></i>
                                        </span>
                                      </OverlayTrigger>
                                    </div> */}
                                    </div>

                                    <div className="col-12 px-0 d-flex">
                                      <div
                                        className="w-100"
                                        style={{ pointerEvents: confirmModelNumberCheck ? "none" : "auto", }}
                                      >
                                        <InputField
                                          labelName={"Model"}
                                          placeholderName={"Model number"}
                                          value={modelNumber}
                                          onChange={(e) => { !confirmModelNumberCheck && handleModelNumber(e) }}
                                          onBlur={() => { }}
                                          errorOccured={false}
                                          errorMeesage={"Please add brand name"}
                                        />
                                      </div>

                                      <div
                                        className="ms-2 mb-3"
                                        style={{
                                          // pointerEvents: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? "none" : "auto",
                                          // opacity: scanPartsManualsLoading || scanDeviceLoading || remoteAvatar || participants.length == 0 ? 0.5 : 1,
                                        }}
                                      >
                                        <div className="tooltipCustom">
                                          <span className="tooltiptextCustom " style={{ width: '52px !important', zIndex: 110 }}>
                                            <div>{"Click to confirm"}</div>
                                            <div>{"information"}</div>
                                          </span>
                                          <div
                                            className="align-items-center d-flex fs-3 justify-content-center rounded-1 overlay-action-btn cursor-pointer"
                                            onClick={() => {
                                              // handleScanDeviceForParts();
                                              // setScanDeviceFlag(1);
                                              setConfirmModelNumberCheck(!confirmModelNumberCheck)
                                            }}
                                            style={{
                                              height: "41px",
                                              width: "30px",
                                              // border: "1px solid rgb(179 179 179 / 64%)",
                                            }}
                                          >

                                            {/* <span className="d-flex">
                                        {scanDeviceLoading ? <Spinner size="sm" /> :
                                          <RiQrScan2Line />}
                                      </span> */}
                                            <span className="d-flex check-lg checkbox-success">
                                              <input
                                                type="checkbox"
                                                checked={confirmModelNumberCheck}
                                                className="form-check-input mt-0 rounded-circle"
                                                id="customCheckBox4"
                                                onChange={(e) => {
                                                  setConfirmModelNumberCheck(e.target.checked)
                                                }}
                                                onClick={() => { setConfirmModelNumberCheck(!confirmModelNumberCheck) }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      {/* <div className="ms-2 mt-1">
                                      <OverlayTrigger placement="top" overlay={partsAndManualsInfo}>
                                        <span className="fs-3 cursor-pointer">
                                          <i className="bi bi-info-circle "></i>
                                        </span>
                                      </OverlayTrigger>
                                    </div> */}
                                    </div>
                                  </div>



                                  <div className="row mx-0 pb-2">
                                    {/* <div className="col-6 px-0 pe-2">
                                      <InputField
                                        labelName={"Brand"}
                                        placeholderName={"Make or Brand"}
                                        value={brandName}
                                        onChange={handleBrandName}
                                        onBlur={handleBrandNameBlurCheck}
                                        errorOccured={isBrandNameErr}
                                        errorMeesage={"Please add Make or Brand name"}
                                        isRequired={true}
                                      />
                                    </div> */}

                                    {/* <div className="col-6 px-0 ps-2">
                                      <InputField
                                        labelName={"Model"}
                                        placeholderName={"Model number"}
                                        value={modelNumber}
                                        onChange={handleModelNumber}
                                        onBlur={() => { }}
                                        errorOccured={false}
                                        errorMeesage={"Please add brand name"}
                                      />
                                    </div> */}

                                    <div className="row mx-0">
                                      <div
                                        className="col-12 px-0"
                                      >
                                        <InputField
                                          labelName={"Specific part"}
                                          placeholderName={"Specific part"}
                                          value={specificPart}
                                          onChange={(e) => { handleSpecificPart(e) }}
                                          onBlur={() => { }}
                                          errorOccured={false}
                                          errorMeesage={"Please add specific part"}
                                        />
                                      </div>
                                    </div>

                                  </div>
                                </div>
                                {/* } */}

                                <div className="row mx-0 pb-2">
                                  <div
                                    className="col-12 px-0"
                                    style={{
                                      pointerEvents: scanPartsManualsLoading || scanDeviceLoading || sourcingInfoLoading ? "none" : "auto",
                                      opacity: scanPartsManualsLoading || scanDeviceLoading || sourcingInfoLoading ? 0.5 : 1,
                                    }}
                                  >
                                    {/* {(permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") || permissionArray.includes("SCAN TAB")) && */}
                                    <span
                                      className="px-3 py-2 rounded-3 bg-light text-black font-w600 cursor-pointer overlay-action-btn"
                                      onClick={() => { handleSearchSourcingInfo(1) }}
                                    >
                                      {sourcingInfoLoading ?
                                        <>
                                          <Spinner size="sm" className="me-2" />  {` Searching...`}
                                        </> :
                                        <> {`Search results`}</>}
                                    </span>
                                    {/* } */}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row mx-0 bg-white">
                              <div className="col-12 px-0 position-relative">
                                {/* Left Scroll Button */}
                                {canScrollLeft && (
                                  <span
                                    className="scroll-btn-left position-absolute cursor-pointer text-hovere text-white shadow d-flex align-items-center justify-content-center"
                                    style={{
                                      left: 0,
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      zIndex: '1',
                                      height: '35px',
                                      width: '26px',
                                      borderRadius: '0 50% 50% 0',
                                      background: 'gray'
                                    }}
                                    onClick={(e) => {
                                      e?.stopPropagation();
                                      scrollLeft()
                                    }}
                                  >
                                    <FaChevronLeft />
                                  </span>
                                )}

                                {/* Right Scroll Button */}
                                {canScrollRight && (
                                  <span
                                    className="scroll-btn-right position-absolute cursor-pointer text-hovered text-white shadow d-flex align-items-center justify-content-center"
                                    style={{
                                      right: 0,
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      zIndex: '1',
                                      height: '35px',
                                      width: '26px',
                                      borderRadius: '50% 0 0 50%',
                                      background: 'gray'
                                    }}
                                    onClick={(e) => {
                                      e?.stopPropagation();
                                      scrollRight()
                                    }}
                                  >
                                    <FaChevronRight />
                                  </span>
                                )}


                                {/* Navigations */}
                                <div
                                  ref={navRef}
                                  className='border-bottom overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                                  style={{ scrollBehavior: 'smooth', display: 'flex' }}
                                >
                                  <div className='col-12 d-flex px-0 fs-5 font-w500'>
                                    <div
                                      onClick={() => {
                                        // handleSourcingInfoFn(1);
                                        setTabsPartsManuals('1');
                                      }}
                                      className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative`}
                                      style={{}}
                                    >
                                      <div
                                        className={`${tabsPartsManuals === '1' ? "text-black" : "text-grey"} ${tabsPartsManuals === '1' && "fw-bold"} d-flex align-items-center justify-content-center flex-column`}
                                      >
                                        <span className={``}>{`Owner's`}</span>
                                        <span className={``}>{`manual`}</span>
                                      </div>
                                      {/* <span className={`${tabsPartsManuals === 1 ? "text-black" : "text-grey"} ${tabsPartsManuals === 1 && "fw-bold"}`} >{"Owners manual"}</span> */}
                                      {tabsPartsManuals === '1' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}

                                    </div>

                                    <div
                                      onClick={() => {
                                        // handleSourcingInfoFn(0);
                                        setTabsPartsManuals('2');
                                      }}
                                      className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                      style={{}}
                                    >
                                      <div
                                        className={`${tabsPartsManuals === '2' ? "text-black" : "text-grey"} ${tabsPartsManuals === '2' && "fw-bold"} d-flex align-items-center justify-content-center flex-column`}
                                      >
                                        <span className={``}>{`Parts`}</span>
                                      </div>
                                      {/* <span className={`${tabsPartsManuals === 2 ? "text-black" : "text-grey"} ${tabsPartsManuals === 2 && "fw-bold"}`}>{`Parts and tools`}</span> */}
                                      {tabsPartsManuals === '2' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                    </div>

                                    <div
                                      onClick={() => {
                                        // handleSourcingInfoFn(0);
                                        setTabsPartsManuals('3');
                                      }}
                                      className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                      style={{}}
                                    >
                                      <span className={`${tabsPartsManuals === '3' ? "text-black" : "text-grey"} ${tabsPartsManuals === '3' && "fw-bold"} align-self-center`}>{`Replacements`}</span>
                                      {tabsPartsManuals === '3' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="row mx-0 overflow-auto"
                              style={{ maxHeight: "38dvh" }}
                            >
                              <div className="col-12 p-2">

                                {tabsPartsManuals == '2' && productType !== "" && brandName !== "" &&
                                  <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0">

                                      <div className="row mx-0">
                                        <div className="col-12 px-0 d-flex">
                                          <div
                                            onClick={() => {
                                              setSourcingInfoTabs(1)
                                            }}
                                            className={`${sourcingInfoTabs === 1 ? "text-white font-w600 bg-black" : "text-black bg-light overlay-action-btn cursor-pointer"} align-items-center d-flex justify-content-center me-2 rounded p-2 `}
                                            style={{ minWidth: '50px' }}
                                          >
                                            <span>{`All`}</span>
                                          </div>

                                          <div
                                            onClick={() => {
                                              setSourcingInfoTabs(2)
                                            }}
                                            className={`${sourcingInfoTabs === 2 ? "text-white font-w600 bg-black" : "text-black bg-light overlay-action-btn cursor-pointer"} align-items-center d-flex justify-content-center me-2 rounded p-2 `}
                                            style={{ minWidth: '50px' }}
                                          >
                                            <span>{`Supports`}</span>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                }

                                <div className="row mx-0 mt-3 pb-2">
                                  <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">

                                    <div className="w-100">
                                      {sourcingInfoLoading ? <div>
                                        <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                        <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                        <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                        <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                      </div> :
                                        <>
                                          {tabsPartsManuals == '1' ?
                                            <>
                                              {sourcingManualsArr?.length > 0 ?
                                                <>
                                                  {sourcingManualsArr?.map((item, index) => {
                                                    return (
                                                      <>
                                                        <a target="_blank" href={item?.url} rel="noreferrer">
                                                          <div className="mx-0 row mb-2">
                                                            <div
                                                              className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                              style={{
                                                                background: "rgba(244, 248, 255, 1)",
                                                                border: "1px solid rgba(199, 212, 234, 1)",
                                                              }}
                                                            >
                                                              <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                <div className="d-flex">
                                                                  <div
                                                                    className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                    style={{ width: "30px", height: "30px" }}
                                                                  >
                                                                    <img
                                                                      src={item?.image}
                                                                      style={{ width: "30px", height: "30px" }}
                                                                      className="rounded-3"
                                                                      alt=""
                                                                    />
                                                                  </div>

                                                                  {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                  <div className="d-flex flex-column">
                                                                    <span className="fs-6 text-black">
                                                                      {`${item?.name}`}
                                                                    </span>
                                                                    <span className="fs-7">
                                                                      {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                    </span>
                                                                  </div>

                                                                </div>

                                                                <div>
                                                                  <i className="bi bi-chevron-right" />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </a>
                                                      </>
                                                    )
                                                  })}
                                                </> :
                                                <>
                                                  <div>
                                                    <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                      <div className="mb-2">
                                                        <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                      </div>
                                                      <span>
                                                        {`No record found`}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </>
                                              }
                                            </> :
                                            tabsPartsManuals == '2' ?
                                              <>
                                                {sourcingInfoTabs == 1 ?
                                                  <>
                                                    {sourcingInfoArr?.length > 0 ?
                                                      <>
                                                        {sourcingInfoArr?.map((item, index) => {
                                                          return (
                                                            <>
                                                              <a target="_blank" href={item?.url} rel="noreferrer">
                                                                <div className="mx-0 row mb-2">
                                                                  <div
                                                                    className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                    style={{
                                                                      background: "rgba(244, 248, 255, 1)",
                                                                      border: "1px solid rgba(199, 212, 234, 1)",
                                                                    }}
                                                                  >
                                                                    <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                      <div className="d-flex">
                                                                        <div
                                                                          className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                          style={{ width: "30px", height: "30px" }}
                                                                        >
                                                                          <img
                                                                            src={item?.image}
                                                                            style={{ width: "30px", height: "30px" }}
                                                                            className="rounded-3"
                                                                            alt=""
                                                                          />
                                                                        </div>

                                                                        {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                        <div className="d-flex flex-column">
                                                                          <span className="fs-6 text-black">
                                                                            {`${item?.name}`}
                                                                          </span>
                                                                          <span className="fs-7">
                                                                            {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                          </span>
                                                                        </div>

                                                                      </div>

                                                                      <div>
                                                                        <i className="bi bi-chevron-right" />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </a>
                                                            </>
                                                          )
                                                        })}
                                                      </> :
                                                      <>
                                                        <div>
                                                          <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                            <div className="mb-2">
                                                              <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                            </div>
                                                            <span>
                                                              {`No record found`}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </>
                                                    }
                                                  </> :
                                                  sourcingInfoTabs == 2 ?
                                                    <>
                                                      {supportsArr?.length > 0 ?
                                                        <>
                                                          {supportsArr?.map((item, index) => {
                                                            return (
                                                              <>
                                                                <a target="_blank" href={item?.url} rel="noreferrer">
                                                                  <div className="mx-0 row mb-2">
                                                                    <div
                                                                      className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                      style={{
                                                                        background: "rgba(244, 248, 255, 1)",
                                                                        border: "1px solid rgba(199, 212, 234, 1)",
                                                                      }}
                                                                    >
                                                                      <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                        <div className="d-flex">
                                                                          <div
                                                                            className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                            style={{ width: "30px", height: "30px" }}
                                                                          >
                                                                            <img
                                                                              src={item?.image}
                                                                              style={{ width: "30px", height: "30px" }}
                                                                              className="rounded-3"
                                                                              alt=""
                                                                            />
                                                                          </div>

                                                                          {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                          <div className="d-flex flex-column">
                                                                            <span className="fs-6 text-black">
                                                                              {`${item?.name}`}
                                                                            </span>
                                                                            <span className="fs-7">
                                                                              {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                            </span>
                                                                          </div>

                                                                        </div>

                                                                        <div>
                                                                          <i className="bi bi-chevron-right" />
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </a>
                                                              </>
                                                            )
                                                          })}
                                                        </> :
                                                        <>
                                                          <div>
                                                            <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                              <div className="mb-2">
                                                                <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                              </div>
                                                              <span>
                                                                {`No record found`}
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </>
                                                      }
                                                    </> : <></>
                                                }
                                              </> :
                                              tabsPartsManuals == '3' ?
                                                <>
                                                  {sourcingShoppingArr?.length > 0 ?
                                                    <>
                                                      {sourcingShoppingArr?.map((item, index) => {
                                                        return (
                                                          <>
                                                            <a target="_blank" href={item?.url} rel="noreferrer">
                                                              <div className="mx-0 row mb-2">
                                                                <div
                                                                  className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                  style={{
                                                                    background: "rgba(244, 248, 255, 1)",
                                                                    border: "1px solid rgba(199, 212, 234, 1)",
                                                                  }}
                                                                >
                                                                  <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                    <div className="d-flex">
                                                                      <div
                                                                        className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                        style={{ width: "30px", height: "30px" }}
                                                                      >
                                                                        <img
                                                                          src={item?.image}
                                                                          style={{ width: "30px", height: "30px" }}
                                                                          className="rounded-3"
                                                                          alt=""
                                                                        />
                                                                      </div>

                                                                      {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                      <div className="d-flex flex-column">
                                                                        <span className="fs-6 text-black">
                                                                          {`${item?.name}`}
                                                                        </span>
                                                                        <span className="fs-7">
                                                                          {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                        </span>
                                                                      </div>

                                                                    </div>

                                                                    <div>
                                                                      <i className="bi bi-chevron-right" />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </a>
                                                          </>
                                                        )
                                                      })}
                                                    </> :
                                                    <>
                                                      <div>
                                                        <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                          <div className="mb-2">
                                                            <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                          </div>
                                                          <span>
                                                            {`No record found`}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </>
                                                  }
                                                </>
                                                : <></>
                                          }


                                        </>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Measure for mobile */}
                  {mobileTabs == 8 && (
                    <>
                      <div className="row mx-0">
                        <div className="col-12  bg-white rounded-top">
                          <div className="row mx-0 p-3 border-bottom">
                            <div className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-between px-0 ">
                              <div className=" d-flex align-items-center">
                                <span
                                  onClick={() => {
                                    handleCloseMobileBottomDrawer();
                                    setMobileTabs();
                                    const [localValue] = [
                                      ...room.localParticipant.dataTracks.values(),
                                    ];

                                    localValue?.track.send("3d_clear");
                                  }}
                                  className="cursor-pointer text-black">
                                  <MdClose />
                                </span>
                              </div>

                              <div className="d-flex align-items-center text-black">
                                <span>{`Measuring controls`}</span>
                              </div>

                              <div>
                                {/* <span
                                  onClick={() => {
                                    // handleOpenMobileMoreActionsDrawer();
                                    // handleMobileMoreActionsTabs(2);
                                  }}
                                >
                                  <LuMoreVertical style={{ color: "" }} />
                                </span> */}

                                <span
                                  className="text-hovered px-2 py-1 overlay-action-btn cursor-pointer rounded fs-6"
                                  onClick={() => {
                                    const [localValue] = [
                                      ...room.localParticipant.dataTracks.values(),
                                    ];

                                    localValue?.track.send("3d_clear");
                                  }}
                                >
                                  {'Clear all'}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div
                            className="row mx-0 pt-2 overflow-auto mb-1"
                            style={{
                              maxHeight: "50dvh",
                              background: "rgba(235, 240, 250, 1)",
                            }}
                          >
                            <div className="col-12 p-3">

                              <div className="row mt-4 ">
                                <PrimaryButton
                                  onClick={() => {
                                    setShowMeasureGif(true)
                                    dispatch(drawActive());
                                    const [localValue] = [
                                      ...room.localParticipant.dataTracks.values(),
                                    ];

                                    localValue?.track.send("start_measuring");
                                  }}
                                  style={{
                                    background: measuringStatus
                                      ? "green"
                                      : "grey",
                                    border: "none",
                                  }}
                                  buttonName={"Start measuring"}
                                />
                              </div>
                              <div className="row mt-4 ">
                                <PrimaryButton
                                  onClick={() => {
                                    dispatch(drawActive());
                                    const [localValue] = [
                                      ...room.localParticipant.dataTracks.values(),
                                    ];

                                    localValue?.track.send("add_point");
                                  }}
                                  style={{
                                    background: "black",
                                    border: "none",
                                  }}
                                  buttonName={"Add Point"}
                                />
                              </div>
                              <div className="row mt-2 ">
                                <PrimaryButton
                                  onClick={() => {
                                    setShowMeasureGif(false)
                                    setMeasuringStatus(false);
                                    dispatch(drawDisable());
                                    const [localValue] = [
                                      ...room.localParticipant.dataTracks.values(),
                                    ];

                                    localValue?.track.send("end_measuring");
                                  }}
                                  style={{ background: "red", border: "none" }}
                                  buttonName={"End measuring"}
                                />
                              </div>


                            </div>
                          </div>



                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Instruction for customer to wait for the Pro estimations report */}
              {/* Currently converted this in modal form */}
              {!mobileTabs && permissionArray.includes("SCAN TAB")
                && (serviceDetailsObj?.ticket_type_int == 1) &&
                isProGivingEstimationsReport && false &&
                <>
                  <div className="row mx-0 border-bottom">
                    <div className="col-12 px-0 d-flex align-items-center py-2 px-3 bg-white">
                      <span
                        className="me-3 cursor-pointer"
                        onClick={() => setIsProGivingEstimationsReport(false)}
                      >
                        <i className='bi bi-x-lg' style={{ height: '20px', width: '20px' }}></i>
                      </span>
                      <span className="text-primary font-w600">
                        {`Please wait while a Pro giving you estimations report Or you can leave a call`}
                      </span>
                    </div>
                  </div>
                </>
              }

              {/* Inspection object if received from pro */}
              {!mobileTabs &&
                callDetailsObj?.ticket_detail?.category_name_chr === "Inspection" &&
                permissionArray.includes("SCAN TAB") &&
                <>
                  {Object.keys(inspectionItemReceived).length > 0 ?
                    <>
                      {toggleForInspectionItemReceived ?
                        <>
                          <div
                            className="row cursor-pointer  py-2 px-2 bg-white"
                            onClick={() => setToggleForInspectionItemReceived(false)}
                          >
                            <div className={`col-12 d-flex font-w600 `}>
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <div className="me-2 text-black d-flex align-items-center">
                                  <span
                                    className="me-2 p-2 rounded bg-dark shadow-lg text-black"
                                  >
                                    <i
                                      class="bi bi-cloud-hail-fill"
                                      style={{ height: '20px', width: '20px' }}
                                    ></i>
                                  </span>
                                  <div className="d-flex flex-column">
                                    {true ?
                                      <span className="text-success font-w600 fs-7">
                                        {`Checking now`}
                                      </span> : ''
                                    }
                                    <span
                                      className="overflow-hidden text-nowrap"
                                      style={{ width: '280px', textOverflow: 'ellipsis' }}
                                      title={`${inspectionItemReceived?.productDetails?.area_name_chr} : ${inspectionItemReceived?.productDetails?.product_name_chr}`}
                                    >
                                      {`${inspectionItemReceived?.productDetails?.area_name_chr} : ${inspectionItemReceived?.productDetails?.product_name_chr}`}
                                    </span>
                                  </div>

                                </div>


                                <div
                                  className="text-black fs-4 text-hovered overlay-action-btn rounded-circle d-flex align-items-center justify-content-center cursor-pointer"
                                >
                                  <span>
                                    <span>

                                      <i
                                        onClick={(e) => { }}
                                        className="bi bi-chevron-right p-1 px-2 rounded border "
                                      ></i>

                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </> :
                        <>
                          <div className="row mx-0">
                            <div className="col-12  bg-white">
                              <div className="row mx-0 pb-2 p-3 border-bottom">
                                <div className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-between px-0 text-black">
                                  <div className=" d-flex align-items-center">
                                    <span
                                      onClick={() => setToggleForInspectionItemReceived(true)}
                                      className="cursor-pointer"
                                    >
                                      <MdClose />
                                    </span>
                                  </div>

                                  <div className="d-flex align-items-center">
                                    <span>{`Check-Up result`}</span>
                                  </div>

                                  <div>
                                    <span
                                      onClick={() => {
                                        // handleOpenMobileMoreActionsDrawer();
                                        // handleMobileMoreActionsTabs(2);
                                      }}
                                    >
                                      {/* <LuMoreVertical style={{ color: "" }} /> */}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="row mb-1 py-2 border-bottom"
                              >
                                <div className={`col-12 d-flex font-w600`}>
                                  <div className="d-flex align-items-center w-100">

                                    <div className="mx-2 text-black d-flex align-items-center">
                                      <span
                                        className="me-2 p-2 border rounded bg-dark shadow-lg text-white"
                                      >
                                        <i
                                          class="bi bi-cloud-hail-fill"
                                          style={{ height: '20px', width: '20px' }}
                                        ></i>
                                      </span>
                                      <span
                                        className="overflow-hidden text-nowrap"
                                        style={{ width: '120px', textOverflow: 'ellipsis' }}
                                        title={`${inspectionItemReceived?.productDetails?.area_name_chr}`}
                                      >
                                        {`${inspectionItemReceived?.productDetails?.area_name_chr}`}
                                      </span>
                                    </div>

                                  </div>
                                </div>
                              </div>

                              <div
                                className="row mx-0 pt-2 overflow-auto mb-1"
                                style={{
                                  maxHeight: "60dvh",
                                  background: "rgba(235, 240, 250, 1)",
                                }}
                              >
                                <div className="col-12 px-0">

                                  <>
                                    {
                                      <>
                                        <>
                                          <div
                                            className="row border-bottom px-3"

                                          >
                                            <div className="col-12 px-0">
                                              <div
                                                className="row cursor-pointer  py-2 "
                                              >
                                                <div className={`col-12 d-flex font-w600 `}>
                                                  <div className="d-flex align-items-center justify-content-between w-100">
                                                    <div className="me-2 text-black d-flex align-items-center">
                                                      <span
                                                        className="me-2 p-2 rounded bg-white shadow-lg text-black"
                                                      >
                                                        <i
                                                          class="bi bi-cloud-hail-fill"
                                                          style={{ height: '20px', width: '20px' }}
                                                        ></i>
                                                      </span>
                                                      <div className="d-flex flex-column">
                                                        {true ?
                                                          <span className="text-success font-w600 fs-7">
                                                            {`Checking now`}
                                                          </span> : ''
                                                        }
                                                        <span
                                                          className="overflow-hidden text-nowrap"
                                                          style={{ width: '120px', textOverflow: 'ellipsis' }}
                                                          title={`${inspectionItemReceived?.productDetails?.product_name_chr}`}
                                                        >
                                                          {`${inspectionItemReceived?.productDetails?.product_name_chr}`}
                                                        </span>
                                                      </div>

                                                    </div>


                                                    <div
                                                      className="text-black fs-4 text-hovered overlay-action-btn rounded-circle d-flex align-items-center justify-content-center cursor-pointer"
                                                    >
                                                      <span>
                                                        <span>
                                                          {/* <OverlayTrigger
                                                                  key={ind}
                                                                  trigger="click"
                                                                  placement="bottom"
                                                                  // overlay={popover}
                                                                  overlay={popoverInventoryActions(ind)}
                                                                  rootClose={true}
                                                                  show={activePopover === ind}
                                                                  onToggle={(show) => setActivePopover(show ? ind : null)}
                                                                > */}
                                                          {/* <i onClick={(e) => { e.stopPropagation(); }} class="bi bi-three-dots-vertical px-1"></i> */}
                                                          {/* </OverlayTrigger> */}
                                                        </span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>


                                              <div className="row mb-2 bg-white rounded-2 shadow-sm">
                                                <div className="col-12 p-1 fs-7">
                                                  <div className="row mx-1 pb-1 pt-2 px-3 d-flex align-items-center">
                                                    <div className="col-4 pe-2  font-w500">
                                                      <span>{`Condition`}</span>
                                                    </div>
                                                    <div className="col-8 d-flex">
                                                      <span
                                                        className="text-white rounded-pill p-1 px-3"
                                                        style={{
                                                          background:
                                                            `${inspectionItemReceived?.productDetails?.condition_chr === "Good" ? "rgba(45, 204, 99, 1)" :
                                                              inspectionItemReceived?.productDetails?.condition_chr === "Ok" ? "rgba(255, 154, 32, 1)" :
                                                                inspectionItemReceived?.productDetails?.condition_chr === "Poor" ? "rgba(240, 72, 72, 1)" :
                                                                  inspectionItemReceived?.productDetails?.condition_chr === "Not assessed" ? "rgba(131, 154, 192, 1)" : ''}`,
                                                        }}
                                                      >
                                                        {`${inspectionItemReceived?.productDetails?.condition_chr}`}
                                                      </span>
                                                    </div>
                                                  </div>

                                                  <div className="row mx-1 py-2 px-3 border-bottom  d-flex align-items-center">
                                                    <div className="col-4 pe-2  font-w500">
                                                      <span>{`Updated`}</span>
                                                    </div>
                                                    <div className="col-8">
                                                      <span className="text-black font-w600 p-1 px-2">{`${formatUnixTimestamp(inspectionItemReceived?.productDetails?.updated_date_dtm)}`}</span>
                                                    </div>
                                                  </div>

                                                  <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                    <div className="col-4 pe-2 font-w500">
                                                      <span>{`Brand`}</span>
                                                    </div>
                                                    <div className="col-8">
                                                      <span className={`${inspectionItemReceived?.productDetails?.device_brand_chr && 'text-black'} font-w600 p-1 px-2`}>{`${inspectionItemReceived?.productDetails?.device_brand_chr ? inspectionItemReceived?.productDetails?.device_brand_chr : '-'}`}</span>
                                                    </div>
                                                  </div>

                                                  <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                    <div className="col-4 pe-2 font-w500">
                                                      <span>{`Model`}</span>
                                                    </div>
                                                    <div className="col-8">
                                                      <span className={`${inspectionItemReceived?.productDetails?.model_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${inspectionItemReceived?.productDetails?.model_number_chr ? inspectionItemReceived?.productDetails?.model_number_chr : '-'}`}</span>
                                                    </div>
                                                  </div>

                                                  <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                    <div className="col-4 pe-2 font-w500">
                                                      <span>{`Serial number`}</span>
                                                    </div>
                                                    <div className="col-8">
                                                      <span className={`${inspectionItemReceived?.productDetails?.serial_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${inspectionItemReceived?.productDetails?.serial_number_chr ? inspectionItemReceived?.productDetails?.serial_number_chr : '-'}`}</span>
                                                    </div>
                                                  </div>

                                                  <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                    <div className="col-4 pe-2 font-w500">
                                                      <span>{`Description`}</span>
                                                    </div>
                                                    <div className="col-8">
                                                      <span className={`${inspectionItemReceived?.productDetails?.description_chr && 'text-black'} font-w600 p-1 px-2`}>{`${inspectionItemReceived?.productDetails?.description_chr ? inspectionItemReceived?.productDetails?.description_chr : '-'}`}</span>
                                                    </div>
                                                  </div>

                                                  {inspectionItemReceived?.productDetails?.image_url &&
                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                      <div className="col-12">
                                                        <img
                                                          src={inspectionItemReceived?.productDetails?.image_url}
                                                          alt="Attachment"
                                                          className="rounded-2 shadow-lg cursor-pointer"
                                                          onClick={(e) => {
                                                            handleOpenDoc(); setImageAttachURL(inspectionItemReceived?.productDetails?.image_url);
                                                          }}
                                                          style={{
                                                            height: '60px',
                                                            width: '60px',
                                                            border: '1px solid orange'
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  }

                                                  {inspectionItemReceived?.productDetails?.maintenance_plan?.length > 0 &&
                                                    <div
                                                      className="row mx-0 py-2 font-w700 d-flex border-top"
                                                      style={{
                                                        background: 'rgb(199 212 234 / 30%)',
                                                        // pointerEvents: 'none',
                                                        // opacity: '0.5',
                                                      }}
                                                    >
                                                      {inspectionItemReceived?.productDetails?.maintenance_plan?.map((data, i) => {
                                                        return (
                                                          <div
                                                            className={`bg-white mb-1 ${data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan && 'shadow'} rounded `}
                                                            style={{ margin: '0' }}
                                                          >
                                                            <div
                                                              className="row mx-1  py-2 px-1 fs-7 d-flex align-items-center"
                                                            >
                                                              <div
                                                                className="row mx-0  cursor-pointer"
                                                                onClick={() => {
                                                                  if (data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan) {
                                                                    setIsExpandedForMaintenancePlan('')
                                                                  } else {
                                                                    setIsExpandedForMaintenancePlan(data.maintenance_plan_id_ids)
                                                                  }
                                                                }}
                                                              >
                                                                <div className="col-4 pe-2 font-w500">
                                                                  <span>{`Maintenance`}</span>
                                                                </div>
                                                                <div className="col-8 d-flex align-items-center justify-content-between">
                                                                  <span className={`${data?.period_name_chr && 'text-black'} font-w600 p-1 px-2`}>{`${data?.period_name_chr ? `In ${data?.period_name_chr}` : '-'}`}</span>
                                                                  <span>
                                                                    {data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan ?
                                                                      <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i> :
                                                                      <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i>
                                                                    }
                                                                  </span>
                                                                </div>
                                                              </div>

                                                              {data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan &&
                                                                <>
                                                                  <div className="row mx-1 py-2  d-flex align-items-center">
                                                                    <div className="col-4 pe-2 font-w500">
                                                                      <span>{`Instruction`}</span>
                                                                    </div>
                                                                    <div className="col-8">
                                                                      <span className={`${data?.instruction_chr && 'text-black'} font-w600 p-1 px-2`}>{`${data?.instruction_chr ? `${data?.instruction_chr}` : '-'}`}</span>
                                                                    </div>
                                                                  </div>

                                                                  <div className="row mx-1 py-2  d-flex align-items-center">
                                                                    <div className="col-4 pe-2 font-w500">
                                                                      <span>{`Frequency`}</span>
                                                                    </div>
                                                                    <div className="col-8">
                                                                      <span className={`${data?.frequency_int && 'text-black'} font-w600 p-1 px-2`}>{`${data?.frequency_int ? `${data?.frequency_int} times in a ${data?.period_name_chr}` : '-'}`}</span>
                                                                    </div>
                                                                  </div>


                                                                  <div className="row mx-1 py-2  d-flex align-items-center">
                                                                    <div className="col-4 pe-2 font-w500">
                                                                      <span>{`Link`}</span>
                                                                    </div>
                                                                    <div className="col-8">
                                                                      {data?.purchase_link ?
                                                                        <a
                                                                          className="text-hovered text-gray-800"
                                                                          href={`${data?.purchase_link}`}
                                                                          target="_blank"
                                                                          rel="noreferrer"
                                                                        >
                                                                          <span className={`font-w600 p-1 px-2`}>{`Purchase link`} <i className="bi bi-chevron-right me-2"></i> </span>
                                                                        </a> :
                                                                        <span className={`font-w600 p-1 px-2`}>{`-`} </span>
                                                                      }
                                                                    </div>
                                                                  </div>

                                                                </>
                                                              }

                                                            </div>
                                                          </div>
                                                        )
                                                      })}
                                                    </div>
                                                  }

                                                </div>
                                              </div>


                                            </div>
                                          </div>
                                        </>
                                      </>
                                    }
                                  </>



                                </div>
                              </div>



                            </div>
                          </div>
                        </>
                      }
                    </> :
                    <>
                      <div className="row mx-0">
                        <div className="col-12 px-0 d-flex justify-content-center align-items-center py-2 px-3 bg-white">
                          <span className="text-center text-primary font-w600">
                            {`Please wait for the Pro’s instructions to start a Home Check-Up`}
                          </span>
                        </div>
                      </div>
                    </>
                  }
                </>
              }

              {/* Bottom mobile view drawing instructions */}
              {mobileTabs == 2 && toggleDrawingInstructionMobile && (
                <div className="row mx-0 bg-white">
                  <div className="col-2 d-flex justify-content-center p-2">
                    <span
                      onClick={() => {
                        setToggleDrawingInstructionMobile(false);
                      }}>
                      <MdClose />
                    </span>
                  </div>
                  <div className="col-10 fs-7 p-2 text-black">
                    <span>
                      {
                        "Select a shape and drag over the specific area of the video to highlight it for the customer"
                      }
                    </span>
                  </div>
                </div>
              )}

              {/* Bottom mobile view download and go live options */}
              {mobileTabs == 2 && drawingArea && (
                <div className="row mx-0 bg-black">
                  <div
                    onClick={() => {
                      setScreenshotModal(true);
                    }}
                    className="col-6 px-1 d-flex align-items-center justify-content-center py-2 font-w600 text-white"
                    style={{ background: "#565656" }}>
                    <span>{"Download screen"}</span>
                  </div>

                  <div
                    onClick={() => {
                      handleClearCanvas();
                      setMobileTabs();
                    }}
                    className="col-6 px-1 d-flex align-items-center justify-content-center py-2 font-w600 text-white"
                    style={{ background: "#1FC758" }}>
                    <span>{"Go live"}</span>
                  </div>
                </div>
              )}

              {/* Bottom mobile view drawing tools  */}
              {mobileTabs == 2 && (
                <div className="row mx-0 bg-black">
                  <div className="col-9 d-flex align-items-center ps-3">
                    <div
                      className="d-flex align-items-center justify-content-center p-3 me-2 cursor-pointer"
                      onClick={handleDrawing}>
                      <FaRegSquareFull
                        className="pointer"
                        style={{
                          color: drawRectangle ? "orange" : "white",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </div>

                    <div
                      className="d-flex align-items-center justify-content-center p-3 me-2 cursor-pointer"
                      onClick={handleCircle}>
                      <BsCircle
                        className="pointer"
                        style={{
                          color: drawCircle ? "orange" : "white",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </div>

                    <div
                      className="d-flex align-items-center justify-content-center p-3 me-2 cursor-pointer"
                      onClick={handleline}>
                      <BsArrowLeftRight
                        className="pointer"
                        style={{
                          color: drawLine ? "orange" : "white",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </div>

                    <div
                      className="d-flex align-items-center justify-content-center p-3 me-2 cursor-pointer"
                      onClick={handleTextMobile}>
                      <BiText
                        className="pointer"
                        style={{
                          color: drawText ? "orange" : "white",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </div>

                    <div
                      className="d-flex align-items-center justify-content-center p-3 me-2 cursor-pointer"
                      onClick={handleLaserLine}>
                      <GiLaserburn
                        className="pointer"
                        style={{
                          color: laserLine ? "orange" : "white",
                          width: "20px",
                          height: "20px",
                        }}
                        onClick={handleLaserLine}
                      />
                    </div>
                  </div>

                  <div className="col-3 d-flex align-items-center justify-content-end">
                    <div
                      className="d-flex align-items-center justify-content-center p-3 text-white cursor-pointer font-w600"
                      onClick={handleClearOnly}>
                      <span>{"Clear"}</span>
                    </div>
                  </div>
                </div>
              )}

              {/* Bottom Navbar New design for customer */}
              {(permissionArray.includes("SCAN TAB") || !localStorage.getItem("user_id") || localStorage.getItem("guest_user_id")) &&
                <>
                  {/* Sub menu on More actions */}
                  {mobileTabs == 9 &&
                    <div
                      className="row mx-0 mb-2"
                      style={{}}
                    >
                      <div className="col-12 px-0 overflow-auto d-flex justify-content-end">


                        <div
                          className=' p-1 px-3 mx-2 d-flex overflow-auto'
                          style={{
                            background: 'rgba(0, 0, 0, 0.5)',
                            borderTopLeftRadius: '30px',
                            borderTopRightRadius: '30px',
                            borderBottomLeftRadius: '30px',
                          }}
                        >

                          {/* Nav - Sub Menu 1 info */}
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2`}

                              onClick={() => {
                                if (mobileTabs == 1) {
                                  handleMobileTabs(null);
                                } else {
                                  handleMobileTabs(1);
                                  handleOpenMobileBottomDrawer();
                                  if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                    handleClearCanvas();
                                  }
                                }
                              }}
                            >
                              <span
                                className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  background: mobileTabs == 1 ? "white" : "rgb(0 0 0 / 27%)",
                                  color: mobileTabs == 1 ? "black" : "white",
                                }}
                              >
                                <FaCircleInfo
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1 text-white">Info</span>
                            </div>
                          </div>

                          {/* Nav - Sub Menu 3 Notes */}
                          {/* Shopping list moved to menu section */}
                          {false && <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2`}

                              onClick={() => {
                                if (mobileTabs == 3) {
                                  handleMobileTabs(null);
                                } else {
                                  handleMobileTabs(3);
                                  callNoteData();
                                  setNotesCounter(0);
                                  handleOpenMobileBottomDrawer();
                                  if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                    handleClearCanvas();
                                  }
                                }
                              }}
                            >
                              <span
                                className="d-flex align-items-center justify-content-center p-2 rounded-circle position-relative"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  background: mobileTabs == 3 ? "white" : "rgb(0 0 0 / 27%)",
                                  color: mobileTabs == 3 ? "black" : "white",
                                }}
                              >
                                <CgNotes
                                  style={{ width: "20px", height: "20px" }}
                                />
                                {notesCounter > 0 && (
                                  <span
                                    className="fs-5"
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      background: "red",
                                      position: "absolute",
                                      borderRadius: "100%",
                                      top: 0,
                                      right: 0,
                                    }}></span>
                                )}
                              </span>
                              <span className="fs-7 mt-1 text-white">Notes</span>
                            </div>
                          </div>}

                          {/* Nav - Sub Menu 4 Shoping  */}
                          {/* List moved to menu section */}
                          {false && <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2`}
                              onClick={() => {
                                if (mobileTabs == 4) {
                                  handleMobileTabs(null);
                                } else {
                                  handleMobileTabs(4);
                                  onLoadData();
                                  setShoppingListCounter(0);
                                  handleOpenMobileBottomDrawer();
                                  if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                    handleClearCanvas();
                                  }
                                }
                              }}
                            >
                              <span
                                className="d-flex align-items-center justify-content-center p-2 rounded-circle position-relative"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  background: mobileTabs == 4 ? "white" : "rgb(0 0 0 / 27%)",
                                  color: mobileTabs == 4 ? "black" : "white",
                                }}
                              >
                                <MdChecklistRtl
                                  style={{ width: "20px", height: "20px" }}
                                />
                                {shoppingListCounter > 0 && (
                                  <span
                                    className="fs-5"
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      background: "red",
                                      position: "absolute",
                                      borderRadius: "100%",
                                      top: 0,
                                      right: 0,
                                    }}></span>
                                )}
                              </span>
                              <span className="fs-7 mt-1 text-white">List</span>
                            </div>
                          </div>}

                          {/* Nav - Sub Menu 7 Parts and Manuals  */}
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2`}
                              onClick={() => {
                                if (mobileTabs == 7) {
                                  handleMobileTabs(null);
                                } else {
                                  handleMobileTabs(7);
                                  if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                                    handleSourcingInfoFn();
                                  }
                                  handleOpenMobileBottomDrawer();
                                  if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                    handleClearCanvas();
                                  }
                                }
                              }}
                            >
                              <span
                                className="d-flex align-items-center justify-content-center p-2 rounded-circle position-relative"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  background: mobileTabs == 4 ? "white" : "rgb(0 0 0 / 27%)",
                                  color: mobileTabs == 4 ? "black" : "white",
                                }}
                              >
                                <HiMiniWrenchScrewdriver
                                  style={{ width: "20px", height: "20px" }}
                                />

                              </span>
                              <span className="fs-7 mt-1 text-white">Parts</span>
                            </div>
                          </div>

                          {/* Nav - Sub Menu 5 Check-up */}
                          {(callDetailsObj?.ticket_detail?.category_name_chr === "Inspection") &&
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2`}
                                onClick={() => {
                                  if (mobileTabs == 5) {
                                    handleMobileTabs(null);
                                  } else {
                                    handleMobileTabs(5);
                                    getHomeAreaListFn();
                                    handleOpenMobileBottomDrawer();
                                    setCheckUpCounter(0);
                                    if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                      handleClearCanvas();
                                    }
                                  }
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center p-2 rounded-circle position-relative"
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    background: mobileTabs == 5 ? "white" : "rgb(0 0 0 / 27%)",
                                    color: mobileTabs == 5 ? "black" : "white",
                                  }}
                                >
                                  <HiMiniWrenchScrewdriver
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                  {checkUpCounter > 0 && (
                                    <span
                                      className="fs-5"
                                      style={{
                                        width: "10px",
                                        height: "10px",
                                        background: "red",
                                        position: "absolute",
                                        borderRadius: "100%",
                                        top: 0,
                                        right: 0,
                                      }}></span>
                                  )}

                                </span>
                                <span className="fs-7 mt-1 text-white">Check-up</span>
                              </div>
                            </div>
                          }

                          {/* Nav - Sub Menu Switch Camera  */}
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2`}
                              onClick={() => {
                                toggleFacingMode();
                              }}
                              style={{
                                pointerEvents: cameraCheckCustomer ? 'auto' : 'none',
                                opacity: cameraCheckCustomer ? '1' : '0.5',
                              }}
                            >
                              <span
                                className="d-flex align-items-center justify-content-center p-2 rounded-circle position-relative"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  background: mobileTabs == 4 ? "white" : "rgb(0 0 0 / 27%)",
                                  color: mobileTabs == 4 ? "black" : "white",
                                }}
                              >
                                <MdOutlineFlipCameraIos
                                  style={{ width: "20px", height: "20px" }}
                                />

                              </span>
                              <span className="fs-7 mt-1 text-white">Switch</span>
                            </div>
                          </div>

                        </div>

                      </div>

                    </div>
                  }


                  <div
                    className="row mx-0"
                    style={{ background: 'rgb(0 0 0 / 11%)', }}
                  >
                    <div className="col-12 px-0 overflow-auto d-flex  mobile-view-bottom-navbar">


                      {/* Nav - 5 Mute unmoute */}
                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            {!participantMicStatus && (
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 px-1 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  handleMute();
                                }}>
                                <span className="">
                                  <BsFillMicMuteFill
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span className="fs-7 mt-1">Mute</span>
                              </div>
                            )}

                            {participantMicStatus && (
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  handleUnmute();
                                }}>
                                <span className="">
                                  <BsFillMicFill
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span className="fs-7 mt-1">Unmute</span>
                              </div>
                            )}
                          </div>
                        )}

                      {/* Nav - 6 Switch camera */}
                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                              style={{
                                color: "rgb(131, 154, 192)",
                              }}
                              onClick={() => {
                                handleAnotherFlipCamera();
                              }}>
                              <span className="">
                                <MdOutlineFlipCameraIos
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span
                                className="fs-7 mt-1"
                                style={{ whiteSpace: "nowrap" }}>
                                Switch
                              </span>
                            </div>
                          </div>
                        )}

                      {/* Nav - 7 flash */}
                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                              style={{
                                color: "rgb(131, 154, 192)",
                              }}
                              onClick={() => {
                                handleFlashOn();
                              }}>
                              <span className="">
                                <MdOutlineFlashlightOff
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1">Flash</span>
                            </div>
                          </div>
                        )}

                      {/* Nav - 8 Laser */}
                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                              style={{
                                color: "rgb(131, 154, 192)",
                              }}
                              onClick={() => {
                                handleLaserLineAlone();
                              }}>
                              <span className="">
                                <GiLaserburn
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    color: laserLine ? "orange" : "rgb(131, 154, 192)",
                                  }}
                                />
                              </span>
                              <span
                                className="fs-7 mt-1"
                                onClick={() => {
                                  handleLaserLineAlone();
                                }}>
                                {" "}
                                Laser
                              </span>
                            </div>
                          </div>
                        )}

                      {/* Nav Measure */}
                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                              style={{
                                color: mobileTabs == 8 ? "orange" : "rgb(131, 154, 192)",
                              }}
                              onClick={() => {

                                if (!usePhoneApp) {
                                  handleClearCanvas();
                                  handleMobileTabs(8);
                                  handleOpenMobileBottomDrawer();
                                } else {
                                  setUsePhoneMessaegAlert(true);
                                  setUsePhoneModalMessage("Measure");
                                }
                              }}
                            >
                              <span className="">
                                <TbRulerMeasure
                                  onClick={() => {
                                    // handleOcrSend()
                                    // handleMobileTabs(6);
                                    // handleClearCanvas();
                                    // handleOpenMobileBottomDrawer();
                                  }}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1 text-center">Measure</span>
                            </div>
                          </div>
                        )}

                      {/* Nav - 9 OCR Capture text */}
                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2  px-1`}
                              style={{
                                color: mobileTabs == 6 ? "orange" : "rgb(131, 154, 192)",
                              }}
                              onClick={() => {
                                // handleOcrSend()
                                handleMobileTabs(6);
                                // handleClearCanvas();
                                handleOpenMobileBottomDrawer();
                                if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                  handleClearCanvas();
                                }
                              }}
                            >
                              <span className="">
                                <IoIosQrScanner
                                  onClick={() => {
                                    // handleOcrSend()
                                    // handleMobileTabs(6);
                                    // handleClearCanvas();
                                    // handleOpenMobileBottomDrawer();
                                  }}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1 text-center">Capture Text</span>
                            </div>
                          </div>
                        )}

                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                              style={{
                                color: "rgb(131, 154, 192)",
                              }}
                              onClick={() => {


                                if (!usePhoneApp) {
                                  zoomIn();
                                } else {
                                  setUsePhoneMessaegAlert(true);
                                  setUsePhoneModalMessage("Zoom");
                                }
                              }}>
                              <span className="">
                                <FaPlus
                                  onClick={() => {
                                    if (!usePhoneApp) {
                                      zoomIn();
                                    } else {
                                      setUsePhoneMessaegAlert(true);
                                      setUsePhoneModalMessage("Zoom");
                                    }
                                  }}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1">Zoom</span>
                            </div>
                          </div>
                        )
                      }

                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                              style={{
                                color: "rgb(131, 154, 192)",
                              }}
                              onClick={() => {
                                if (!usePhoneApp) {
                                  zoomReset();
                                } else {
                                  setUsePhoneMessaegAlert(true)
                                  setUsePhoneModalMessage("Zoom");
                                }

                              }}>
                              <span className="">
                                <MdOutlineResetTv
                                  onClick={() => {
                                    if (!usePhoneApp) {
                                      zoomReset();
                                    } else {
                                      setUsePhoneMessaegAlert(true)
                                      setUsePhoneModalMessage("Zoom");
                                    }
                                  }}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1">Reset</span>
                            </div>
                          </div>
                        )}

                      {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                        participants.length > 0 && (
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                              style={{
                                color: "rgb(131, 154, 192)",
                              }}
                              onClick={() => {

                                if (!usePhoneApp) {
                                  zoomOut();
                                } else {
                                  setUsePhoneMessaegAlert(true)
                                  setUsePhoneModalMessage("Zoom");
                                }
                              }}>
                              <span className="">
                                <FaMinus
                                  onClick={() => {
                                    if (!usePhoneApp) {
                                      zoomOut();
                                    } else {
                                      setUsePhoneMessaegAlert(true)
                                      setUsePhoneModalMessage("Zoom");
                                    }
                                  }}
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1">Zoom</span>
                            </div>
                          </div>
                        )}

                      {/* For customer to shown own controlls down */}
                      {!permissionArray.includes(
                        "CONTROL REMOTE SCREEN ACTIONS"
                      ) && (
                          <>
                            {/* Nav - 8 Mic */}
                            {/* My mic control */}
                            <div className="position-relative">
                              {micStatus ? (
                                <div
                                  className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}

                                  onClick={() => {
                                    handleMicStatus();
                                  }}>
                                  <span
                                    className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                    style={{
                                      width: "45px",
                                      height: "45px",
                                      background: "white",
                                      color: "black",
                                    }}
                                  >
                                    <BsFillMicFill
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                  </span>
                                  <span
                                    className="fs-5 mt-1 text-white"
                                    style={{ whiteSpace: "nowrap" }}>
                                    Unmute
                                  </span>
                                </div>
                              ) : (
                                <div
                                  className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                                  style={{
                                    // color: "rgb(131, 154, 192)",
                                  }}
                                  onClick={() => {
                                    handleMicOffStatus();
                                  }}>
                                  <span
                                    className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                    style={{
                                      width: "45px",
                                      height: "45px",
                                      background: "rgb(0 0 0 / 27%)",
                                      color: "white",
                                    }}
                                  >
                                    <BsFillMicMuteFill
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                  </span>
                                  <span
                                    className="fs-5 mt-1 text-white"
                                    style={{ whiteSpace: "nowrap" }}>
                                    Mute
                                  </span>
                                </div>
                              )}
                            </div>

                            {/* Nav - 9 Video */}
                            {/* My video Control */}
                            <div className="position-relative">
                              {cameraCheckCustomer ? (
                                <>
                                  {videoStatus && (
                                    <div
                                      className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                                      style={{
                                        // color: "rgb(131, 154, 192)",
                                      }}
                                      onClick={() => {
                                        handleVideoStatus();
                                      }}>
                                      <span
                                        className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                        style={{
                                          width: "45px",
                                          height: "45px",
                                          background: "white",
                                          color: "black",
                                        }}
                                      >
                                        <BsFillCameraVideoFill
                                          style={{ width: "20px", height: "20px" }}
                                        />
                                      </span>
                                      <span
                                        className="fs-5 mt-1 text-white"
                                        style={{ whiteSpace: "nowrap" }}>
                                        Video on
                                      </span>
                                    </div>
                                  )}

                                  {!videoStatus && (
                                    <div
                                      className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                                      style={{
                                        // color: "rgb(131, 154, 192)",
                                      }}
                                      onClick={() => {
                                        handleVideoOffStatus();
                                      }}>
                                      <span
                                        className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                        style={{
                                          width: "45px",
                                          height: "45px",
                                          background: "rgb(0 0 0 / 27%)",
                                          color: "white",
                                        }}
                                      >
                                        <BsFillCameraVideoOffFill
                                          style={{ width: "20px", height: "20px" }}
                                        />
                                      </span>
                                      <span
                                        className="fs-5 mt-1 text-white"
                                        style={{ whiteSpace: "nowrap" }}>
                                        Video off
                                      </span>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <>
                                  {videoStatus && (
                                    <div
                                      className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                                      style={{
                                        color: "rgb(131, 154, 192)",
                                        pointerEvents: "none",
                                        opacity: "0.5",
                                      }}>
                                      <span
                                        className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                        style={{
                                          width: "45px",
                                          height: "45px",
                                          background: "white",
                                          color: "black",
                                        }}
                                      >
                                        <BsFillCameraVideoFill
                                          style={{ width: "20px", height: "20px" }}
                                        />
                                      </span>
                                      <span
                                        className="fs-5 mt-1 text-white"
                                        style={{ whiteSpace: "nowrap" }}>
                                        Video on
                                      </span>
                                    </div>
                                  )}

                                  {!videoStatus && (
                                    <div
                                      className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}
                                      style={{
                                        color: "rgb(131, 154, 192)",
                                        pointerEvents: "none",
                                        opacity: "0.5",
                                      }}>
                                      <span
                                        className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                        style={{
                                          width: "45px",
                                          height: "45px",
                                          background: "rgb(0 0 0 / 27%)",
                                          color: "white",
                                        }}
                                      >
                                        <BsFillCameraVideoOffFill
                                          style={{ width: "20px", height: "20px" }}
                                        />
                                      </span>
                                      <span
                                        className="fs-5 mt-1 text-white"
                                        style={{ whiteSpace: "nowrap" }}>
                                        Video off
                                      </span>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>

                            {/* Nav - 10 Camera switch */}
                            {/* Swicth camera moved to sub-menu section*/}
                            {false &&
                              <div className="position-relative">
                                {cameraCheckCustomer ? (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      // color: "rgb(131, 154, 192)",
                                    }}
                                    onClick={() => {
                                      toggleFacingMode();
                                    }}>
                                    <span
                                      className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                      style={{
                                        width: "45px",
                                        height: "45px",
                                        background: "rgb(0 0 0 / 27%)",
                                        color: "white",
                                      }}
                                    >
                                      <MdOutlineFlipCameraIos
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-5 mt-1 text-white"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Switch
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                      pointerEvents: "none",
                                      opacity: "0.5",
                                    }}>
                                    <span
                                      className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                                      style={{
                                        width: "45px",
                                        height: "45px",
                                        background: "rgb(0 0 0 / 27%)",
                                        color: "white",
                                      }}
                                    >
                                      <MdOutlineFlipCameraIos
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-5 mt-1 text-white"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Switch
                                    </span>
                                  </div>
                                )}
                              </div>
                            }


                          </>
                        )}

                      {/* Nav - Notes Menu */}
                      <div className="position-relative">
                        <div
                          className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}

                          onClick={() => {
                            if (mobileTabs == 3) {
                              handleMobileTabs(null);
                            } else {
                              handleMobileTabs(3);
                              callNoteData();
                              setNotesCounter(0);
                              handleOpenMobileBottomDrawer();
                              if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                handleClearCanvas();
                              }
                            }
                          }}
                        >
                          <span
                            className="d-flex align-items-center justify-content-center p-2 rounded-circle position-relative"
                            style={{
                              width: "45px",
                              height: "45px",
                              background: mobileTabs == 3 ? "white" : "rgb(0 0 0 / 27%)",
                              color: mobileTabs == 3 ? "black" : "white",
                            }}
                          >
                            <CgNotes
                              style={{ width: "20px", height: "20px" }}
                            />
                            {(notesCounter > 0) && (
                              <span
                                className="fs-5"
                                style={{
                                  width: "10px",
                                  height: "10px",
                                  background: "red",
                                  position: "absolute",
                                  borderRadius: "100%",
                                  top: 0,
                                  right: 0,
                                }}></span>
                            )}
                          </span>
                          <span className="fs-5 mt-1 text-white">Notes</span>
                        </div>
                      </div>

                      {/* Nav - List Menu */}
                      <div className="position-relative">
                        <div
                          className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}

                          onClick={() => {
                            if (mobileTabs == 4) {
                              handleMobileTabs(null);
                            } else {
                              handleMobileTabs(4);
                              onLoadData();
                              setShoppingListCounter(0);
                              handleOpenMobileBottomDrawer();
                              if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                handleClearCanvas();
                              }
                            }
                          }}
                        >
                          <span
                            className="d-flex align-items-center justify-content-center p-2 rounded-circle position-relative"
                            style={{
                              width: "45px",
                              height: "45px",
                              background: mobileTabs == 4 ? "white" : "rgb(0 0 0 / 27%)",
                              color: mobileTabs == 4 ? "black" : "white",
                            }}
                          >
                            <MdChecklistRtl
                              style={{ width: "20px", height: "20px" }}
                            />
                            {(shoppingListCounter > 0) && (
                              <span
                                className="fs-5"
                                style={{
                                  width: "10px",
                                  height: "10px",
                                  background: "red",
                                  position: "absolute",
                                  borderRadius: "100%",
                                  top: 0,
                                  right: 0,
                                }}></span>
                            )}
                          </span>
                          <span className="fs-5 mt-1 text-white">List</span>
                        </div>
                      </div>

                      {/* Nav - More Menu */}
                      <div className="position-relative">
                        <div
                          className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}

                          onClick={() => {
                            if (mobileTabs == 9) {
                              handleMobileTabs(null);
                            } else {
                              handleMobileTabs(9);
                            }
                          }}
                        >
                          <span
                            className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                            style={{
                              width: "45px",
                              height: "45px",
                              background: mobileTabs == 9 ? "white" : "rgb(0 0 0 / 27%)",
                              color: mobileTabs == 9 ? "black" : "white",
                            }}
                          >
                            <FiMoreVertical
                              style={{ width: "20px", height: "20px" }}
                            />
                          </span>
                          <span className="fs-5 mt-1 text-white">More</span>
                        </div>
                      </div>

                      {/* Nav - End Call */}
                      <div className="position-relative">
                        <div
                          className={`align-items-center d-flex flex-column justify-content-center p-2 px-1`}

                          onClick={() => {
                            setEndCallPopUp(true);
                          }}
                        >
                          <span
                            className="d-flex align-items-center justify-content-center p-2 rounded-circle"
                            style={{
                              width: "45px",
                              height: "45px",
                              background: "rgba(216, 36, 36, 1)",
                              color: "white",
                            }}
                          >
                            <IoCloseSharp
                              style={{ width: "20px", height: "20px" }}
                            />
                          </span>
                          <span className="fs-5 mt-1 text-white">End</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Old design of navbar for the customer */}
                  {false &&
                    <div
                      className="row mx-0"
                      style={{ background: '#0000001c' }}
                    >
                      <div className="col-12 px-0 overflow-auto d-flex  mobile-view-bottom-navbar">
                        {/* Nav - 1 info */}
                        <div className="position-relative ms-2">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 
                          }`}
                            style={{
                              color:
                                mobileTabs == 1 ? "orange" : "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              handleMobileTabs(1);
                              // handleClearCanvas();
                              handleOpenMobileBottomDrawer();
                              if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                handleClearCanvas();
                              }
                            }}>
                            <span className="">
                              <FaCircleInfo
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                            <span className="fs-7 mt-1">Info</span>
                          </div>
                        </div>

                        {/* Nav - 2 Draw */}
                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2
                              }`}
                                style={{
                                  color:
                                    mobileTabs == 2
                                      ? "orange"
                                      : "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  handleMobileTabs(2);
                                  // startDrawing();
                                  handleCloseMobileBottomDrawer();
                                }}>
                                <span className="">
                                  <MdDraw style={{ width: "20px", height: "20px" }} />
                                </span>
                                <span className="fs-7 mt-1">Draw</span>
                              </div>
                            </div>
                          )}

                        {/* Nav - 3 Notes */}
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2
                          }`}
                            style={{
                              color:
                                mobileTabs == 3 ? "orange" : "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              handleMobileTabs(3);
                              callNoteData();
                              setNotesCounter(0);
                              handleOpenMobileBottomDrawer();
                              if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                handleClearCanvas();
                              }
                            }}>
                            <span className="">
                              <CgNotes style={{ width: "20px", height: "20px" }} />
                              {notesCounter > 0 && (
                                <span
                                  className="fs-5"
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    background: "red",
                                    position: "absolute",
                                    borderRadius: "100%",
                                  }}></span>
                              )}
                            </span>
                            <span className="fs-7 mt-1">Notes</span>
                          </div>
                        </div>

                        {/* Nav - 4 Shoping */}
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 
                          }`}
                            style={{
                              color:
                                mobileTabs == 4 ? "orange" : "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              handleMobileTabs(4);
                              onLoadData();
                              setShoppingListCounter(0);
                              handleOpenMobileBottomDrawer();
                              if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                handleClearCanvas();
                              }
                            }}>
                            <span className="">
                              <MdChecklistRtl
                                style={{ width: "20px", height: "20px" }}
                              />
                              {shoppingListCounter > 0 && (
                                <span
                                  className="fs-5"
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    background: "red",
                                    position: "absolute",
                                    borderRadius: "100%",
                                  }}></span>
                              )}
                            </span>
                            <span className="fs-7 mt-1">List</span>
                          </div>
                        </div>

                        {/* Nav - Parts and Manuals */}
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 
                          }`}
                            style={{
                              color:
                                mobileTabs == 7 ? "orange" : "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              handleMobileTabs(7);
                              if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                                handleSourcingInfoFn()
                              }
                              handleOpenMobileBottomDrawer();
                              if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                handleClearCanvas();
                              }
                            }}>
                            <span className="">
                              <HiMiniWrenchScrewdriver
                                style={{ width: "20px", height: "20px" }}
                              />

                            </span>
                            <span className="fs-7 mt-1">Parts</span>
                          </div>
                        </div>

                        {/* Nav - Check-up */}
                        {callDetailsObj?.ticket_detail?.category_name_chr === "Inspection" &&
                          // participants.length > 0 &&
                          <div className="position-relative">
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 
                            }`}
                              style={{
                                color:
                                  mobileTabs == 5 ? "orange" : "rgb(131, 154, 192)",
                              }}
                              onClick={() => {
                                handleMobileTabs(5);
                                getHomeAreaListFn();
                                handleOpenMobileBottomDrawer();
                                setCheckUpCounter(0);
                                if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                  handleClearCanvas();
                                }
                              }}>
                              <span className="">
                                <IoBagCheck
                                  style={{ width: "20px", height: "20px" }}
                                />

                                {
                                  checkUpCounter > 0 && (
                                    <span
                                      className="fs-5"
                                      style={{
                                        width: "10px",
                                        height: "10px",
                                        background: "red",
                                        position: "absolute",
                                        borderRadius: "100%",
                                      }}></span>
                                    // <div
                                    //   className="align-items-center d-flex justify-content-center position-absolute px-2 rounded-circle text-white"
                                    //   style={{
                                    //     background: "rgba(131, 154, 192, 1)",
                                    //     top: '5px',
                                    //     right: '6px',
                                    //   }}
                                    // >
                                    //   <span
                                    //     className="fs-7"
                                    //   >
                                    //     {checkUpCounter}
                                    //   </span>
                                    // </div>
                                  )
                                }
                              </span>
                              <span className="fs-7 mt-1 text-center">Check-up</span>
                            </div>
                          </div>
                        }

                        {/* Nav - 5 Mute unmoute */}
                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              {!participantMicStatus && (
                                <div
                                  className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                  style={{
                                    color: "rgb(131, 154, 192)",
                                  }}
                                  onClick={() => {
                                    handleMute();
                                  }}>
                                  <span className="">
                                    <BsFillMicMuteFill
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                  </span>
                                  <span className="fs-7 mt-1">Mute</span>
                                </div>
                              )}

                              {participantMicStatus && (
                                <div
                                  className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                  style={{
                                    color: "rgb(131, 154, 192)",
                                  }}
                                  onClick={() => {
                                    handleUnmute();
                                  }}>
                                  <span className="">
                                    <BsFillMicFill
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                  </span>
                                  <span className="fs-7 mt-1">Unmute</span>
                                </div>
                              )}
                            </div>
                          )}

                        {/* Nav - 6 Switch camera */}
                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  handleAnotherFlipCamera();
                                }}>
                                <span className="">
                                  <MdOutlineFlipCameraIos
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span
                                  className="fs-7 mt-1"
                                  style={{ whiteSpace: "nowrap" }}>
                                  Switch
                                </span>
                              </div>
                            </div>
                          )}

                        {/* Nav - 7 flash */}
                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  handleFlashOn();
                                }}>
                                <span className="">
                                  <MdOutlineFlashlightOff
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span className="fs-7 mt-1">Flash</span>
                              </div>
                            </div>
                          )}

                        {/* Nav - 8 Laser */}
                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  handleLaserLineAlone();
                                }}>
                                <span className="">
                                  <GiLaserburn
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      color: laserLine ? "orange" : "rgb(131, 154, 192)",
                                    }}
                                  />
                                </span>
                                <span
                                  className="fs-7 mt-1"
                                  onClick={() => {
                                    handleLaserLineAlone();
                                  }}>
                                  {" "}
                                  Laser
                                </span>
                              </div>
                            </div>
                          )}

                        {/* Nav Measure */}
                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2`}
                                style={{
                                  color: mobileTabs == 8 ? "orange" : "rgb(131, 154, 192)",
                                }}
                                onClick={() => {

                                  if (!usePhoneApp) {
                                    handleClearCanvas();
                                    handleMobileTabs(8);
                                    handleOpenMobileBottomDrawer();
                                  } else {
                                    setUsePhoneMessaegAlert(true);
                                    setUsePhoneModalMessage("Measure");
                                  }
                                }}
                              >
                                <span className="">
                                  <TbRulerMeasure
                                    onClick={() => {
                                      // handleOcrSend()
                                      // handleMobileTabs(6);
                                      // handleClearCanvas();
                                      // handleOpenMobileBottomDrawer();
                                    }}
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span className="fs-7 mt-1 text-center">Measure</span>
                              </div>
                            </div>
                          )}

                        {/* Nav - 9 OCR Capture text */}
                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2  `}
                                style={{
                                  color: mobileTabs == 6 ? "orange" : "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  // handleOcrSend()
                                  handleMobileTabs(6);
                                  // handleClearCanvas();
                                  handleOpenMobileBottomDrawer();
                                  if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                    handleClearCanvas();
                                  }
                                }}
                              >
                                <span className="">
                                  <IoIosQrScanner
                                    onClick={() => {
                                      // handleOcrSend()
                                      // handleMobileTabs(6);
                                      // handleClearCanvas();
                                      // handleOpenMobileBottomDrawer();
                                    }}
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span className="fs-7 mt-1 text-center">Capture Text</span>
                              </div>
                            </div>
                          )}

                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {


                                  if (!usePhoneApp) {
                                    zoomIn();
                                  } else {
                                    setUsePhoneMessaegAlert(true);
                                    setUsePhoneModalMessage("Zoom");
                                  }
                                }}>
                                <span className="">
                                  <FaPlus
                                    onClick={() => {
                                      if (!usePhoneApp) {
                                        zoomIn();
                                      } else {
                                        setUsePhoneMessaegAlert(true);
                                        setUsePhoneModalMessage("Zoom");
                                      }
                                    }}
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span className="fs-7 mt-1">Zoom</span>
                              </div>
                            </div>
                          )
                        }

                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  if (!usePhoneApp) {
                                    zoomReset();
                                  } else {
                                    setUsePhoneMessaegAlert(true)
                                    setUsePhoneModalMessage("Zoom");
                                  }

                                }}>
                                <span className="">
                                  <MdOutlineResetTv
                                    onClick={() => {
                                      if (!usePhoneApp) {
                                        zoomReset();
                                      } else {
                                        setUsePhoneMessaegAlert(true)
                                        setUsePhoneModalMessage("Zoom");
                                      }
                                    }}
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span className="fs-7 mt-1">Reset</span>
                              </div>
                            </div>
                          )}

                        {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                          participants.length > 0 && (
                            <div className="position-relative">
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {

                                  if (!usePhoneApp) {
                                    zoomOut();
                                  } else {
                                    setUsePhoneMessaegAlert(true)
                                    setUsePhoneModalMessage("Zoom");
                                  }
                                }}>
                                <span className="">
                                  <FaMinus
                                    onClick={() => {
                                      if (!usePhoneApp) {
                                        zoomOut();
                                      } else {
                                        setUsePhoneMessaegAlert(true)
                                        setUsePhoneModalMessage("Zoom");
                                      }
                                    }}
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span className="fs-7 mt-1">Zoom</span>
                              </div>
                            </div>
                          )}

                        {/* For customer to shown own controlls down */}
                        {!permissionArray.includes(
                          "CONTROL REMOTE SCREEN ACTIONS"
                        ) && (
                            <>
                              {/* Nav - 8 Mic */}
                              {/* My mic control */}
                              <div className="position-relative">
                                {micStatus ? (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                    }}
                                    onClick={() => {
                                      handleMicStatus();
                                    }}>
                                    <span className="">
                                      <BsFillMicFill
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-7 mt-1"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Unmute
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                    }}
                                    onClick={() => {
                                      handleMicOffStatus();
                                    }}>
                                    <span className="">
                                      <BsFillMicMuteFill
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-7 mt-1"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Mute
                                    </span>
                                  </div>
                                )}
                              </div>

                              {/* Nav - 9 Video */}
                              {/* My video Control */}
                              <div className="position-relative">
                                {cameraCheckCustomer ? (
                                  <>
                                    {videoStatus && (
                                      <div
                                        className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                        style={{
                                          color: "rgb(131, 154, 192)",
                                        }}
                                        onClick={() => {
                                          handleVideoStatus();
                                        }}>
                                        <span className="">
                                          <BsFillCameraVideoFill
                                            style={{ width: "20px", height: "20px" }}
                                          />
                                        </span>
                                        <span
                                          className="fs-7 mt-1"
                                          style={{ whiteSpace: "nowrap" }}>
                                          Video on
                                        </span>
                                      </div>
                                    )}

                                    {!videoStatus && (
                                      <div
                                        className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                        style={{
                                          color: "rgb(131, 154, 192)",
                                        }}
                                        onClick={() => {
                                          handleVideoOffStatus();
                                        }}>
                                        <span className="">
                                          <BsFillCameraVideoOffFill
                                            style={{ width: "20px", height: "20px" }}
                                          />
                                        </span>
                                        <span
                                          className="fs-7 mt-1"
                                          style={{ whiteSpace: "nowrap" }}>
                                          Video off
                                        </span>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {videoStatus && (
                                      <div
                                        className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                        style={{
                                          color: "rgb(131, 154, 192)",
                                          pointerEvents: "none",
                                          opacity: "0.5",
                                        }}>
                                        <span className="">
                                          <BsFillCameraVideoFill
                                            style={{ width: "20px", height: "20px" }}
                                          />
                                        </span>
                                        <span
                                          className="fs-7 mt-1"
                                          style={{ whiteSpace: "nowrap" }}>
                                          Video on
                                        </span>
                                      </div>
                                    )}

                                    {!videoStatus && (
                                      <div
                                        className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                        style={{
                                          color: "rgb(131, 154, 192)",
                                          pointerEvents: "none",
                                          opacity: "0.5",
                                        }}>
                                        <span className="">
                                          <BsFillCameraVideoOffFill
                                            style={{ width: "20px", height: "20px" }}
                                          />
                                        </span>
                                        <span
                                          className="fs-7 mt-1"
                                          style={{ whiteSpace: "nowrap" }}>
                                          Video off
                                        </span>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>

                              {/* Nav - 10 Camera switch */}
                              {/* Swicth camera */}
                              <div className="position-relative">
                                {cameraCheckCustomer ? (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                    }}
                                    onClick={() => {
                                      toggleFacingMode();
                                    }}>
                                    <span className="">
                                      <MdOutlineFlipCameraIos
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-7 mt-1"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Switch
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                      pointerEvents: "none",
                                      opacity: "0.5",
                                    }}>
                                    <span className="">
                                      <MdOutlineFlipCameraIos
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-7 mt-1"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Switch
                                    </span>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  }
                </>
              }

              {/* Bottom Navbar old design FOR THE PRO */}
              {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                <div
                  className="row mx-0"
                  style={{ borderTop: "2px solid orange", background: 'rgb(240, 243, 247)' }}
                >
                  <div className="col-12 px-0 overflow-auto d-flex  mobile-view-bottom-navbar">
                    {/* Nav - 1 info */}
                    <div className="position-relative ms-2">
                      <div
                        className={`align-items-center d-flex flex-column justify-content-center p-2  ${mobileTabs === 1 ? "active-tab-custom" : ""
                          }`}
                        style={{
                          color:
                            mobileTabs == 1 ? "orange" : "rgb(131, 154, 192)",
                        }}
                        onClick={() => {
                          handleMobileTabs(1);
                          // handleClearCanvas();
                          handleOpenMobileBottomDrawer();
                          if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                            handleClearCanvas();
                          }
                        }}>
                        <span className="">
                          <FaCircleInfo
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>
                        <span className="fs-7 mt-1">Info</span>
                      </div>
                    </div>

                    {/* Nav - 2 Draw */}
                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 ${mobileTabs === 2 ? "active-tab-custom" : ""
                              }`}
                            style={{
                              color:
                                mobileTabs == 2
                                  ? "orange"
                                  : "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              handleMobileTabs(2);
                              // startDrawing();
                              handleCloseMobileBottomDrawer();
                            }}>
                            <span className="">
                              <MdDraw style={{ width: "20px", height: "20px" }} />
                            </span>
                            <span className="fs-7 mt-1">Draw</span>
                          </div>
                        </div>
                      )}

                    {/* Nav - 3 Notes */}
                    <div className="position-relative">
                      <div
                        className={`align-items-center d-flex flex-column justify-content-center p-2 ${mobileTabs === 3 ? "active-tab-custom" : ""
                          }`}
                        style={{
                          color:
                            mobileTabs == 3 ? "orange" : "rgb(131, 154, 192)",
                        }}
                        onClick={() => {
                          handleMobileTabs(3);
                          callNoteData();
                          setNotesCounter(0);
                          handleOpenMobileBottomDrawer();
                          if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                            handleClearCanvas();
                          }
                        }}>
                        <span className="">
                          <CgNotes style={{ width: "20px", height: "20px" }} />
                          {notesCounter > 0 && (
                            <span
                              className="fs-5"
                              style={{
                                width: "10px",
                                height: "10px",
                                background: "red",
                                position: "absolute",
                                borderRadius: "100%",
                              }}></span>
                          )}
                        </span>
                        <span className="fs-7 mt-1">Notes</span>
                      </div>
                    </div>

                    {/* Nav - 4 Shoping */}
                    <div className="position-relative">
                      <div
                        className={`align-items-center d-flex flex-column justify-content-center p-2 ${mobileTabs === 4 ? "active-tab-custom" : ""
                          }`}
                        style={{
                          color:
                            mobileTabs == 4 ? "orange" : "rgb(131, 154, 192)",
                        }}
                        onClick={() => {
                          handleMobileTabs(4);
                          onLoadData();
                          setShoppingListCounter(0);
                          handleOpenMobileBottomDrawer();
                          if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                            handleClearCanvas();
                          }
                        }}>
                        <span className="">
                          <MdChecklistRtl
                            style={{ width: "20px", height: "20px" }}
                          />
                          {shoppingListCounter > 0 && (
                            <span
                              className="fs-5"
                              style={{
                                width: "10px",
                                height: "10px",
                                background: "red",
                                position: "absolute",
                                borderRadius: "100%",
                              }}></span>
                          )}
                        </span>
                        <span className="fs-7 mt-1">List</span>
                      </div>
                    </div>

                    {/* Nav - Parts and Manuals */}
                    <div className="position-relative">
                      <div
                        className={`align-items-center d-flex flex-column justify-content-center p-2 ${mobileTabs === 7 ? "active-tab-custom" : ""
                          }`}
                        style={{
                          color:
                            mobileTabs == 7 ? "orange" : "rgb(131, 154, 192)",
                        }}
                        onClick={() => {
                          handleMobileTabs(7);
                          if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                            handleSourcingInfoFn()
                          }
                          handleOpenMobileBottomDrawer();
                          if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                            handleClearCanvas();
                          }
                        }}>
                        <span className="">
                          <HiMiniWrenchScrewdriver
                            style={{ width: "20px", height: "20px" }}
                          />

                        </span>
                        <span className="fs-7 mt-1">Parts</span>
                      </div>
                    </div>

                    {/* Nav - Check-up */}
                    {callDetailsObj?.ticket_detail?.category_name_chr === "Inspection" &&
                      // participants.length > 0 &&
                      <div className="position-relative">
                        <div
                          className={`align-items-center d-flex flex-column justify-content-center p-2 ${mobileTabs === 5 ? "active-tab-custom" : ""
                            }`}
                          style={{
                            color:
                              mobileTabs == 5 ? "orange" : "rgb(131, 154, 192)",
                          }}
                          onClick={() => {
                            handleMobileTabs(5);
                            getHomeAreaListFn();
                            handleOpenMobileBottomDrawer();
                            setCheckUpCounter(0);
                            if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                              handleClearCanvas();
                            }
                          }}>
                          <span className="">
                            <IoBagCheck
                              style={{ width: "20px", height: "20px" }}
                            />

                            {
                              checkUpCounter > 0 && (
                                <span
                                  className="fs-5"
                                  style={{
                                    width: "10px",
                                    height: "10px",
                                    background: "red",
                                    position: "absolute",
                                    borderRadius: "100%",
                                  }}></span>
                                // <div
                                //   className="align-items-center d-flex justify-content-center position-absolute px-2 rounded-circle text-white"
                                //   style={{
                                //     background: "rgba(131, 154, 192, 1)",
                                //     top: '5px',
                                //     right: '6px',
                                //   }}
                                // >
                                //   <span
                                //     className="fs-7"
                                //   >
                                //     {checkUpCounter}
                                //   </span>
                                // </div>
                              )
                            }
                          </span>
                          <span className="fs-7 mt-1 text-center">Check-up</span>
                        </div>
                      </div>
                    }

                    {/* Nav - 5 Mute unmoute */}
                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          {!participantMicStatus && (
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                              style={{
                                color: "rgb(131, 154, 192)",
                              }}
                              onClick={() => {
                                handleMute();
                              }}>
                              <span className="">
                                <BsFillMicMuteFill
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1">Mute</span>
                            </div>
                          )}

                          {participantMicStatus && (
                            <div
                              className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                              style={{
                                color: "rgb(131, 154, 192)",
                              }}
                              onClick={() => {
                                handleUnmute();
                              }}>
                              <span className="">
                                <BsFillMicFill
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </span>
                              <span className="fs-7 mt-1">Unmute</span>
                            </div>
                          )}
                        </div>
                      )}

                    {/* Nav - 6 Switch camera */}
                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                            style={{
                              color: "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              handleAnotherFlipCamera();
                            }}>
                            <span className="">
                              <MdOutlineFlipCameraIos
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                            <span
                              className="fs-7 mt-1"
                              style={{ whiteSpace: "nowrap" }}>
                              Switch
                            </span>
                          </div>
                        </div>
                      )}

                    {/* Nav - 7 flash */}
                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                            style={{
                              color: "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              handleFlashOn();
                            }}>
                            <span className="">
                              <MdOutlineFlashlightOff
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                            <span className="fs-7 mt-1">Flash</span>
                          </div>
                        </div>
                      )}

                    {/* Nav - 8 Laser */}
                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                            style={{
                              color: "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              handleLaserLineAlone();
                            }}>
                            <span className="">
                              <GiLaserburn
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  color: laserLine ? "orange" : "rgb(131, 154, 192)",
                                }}
                              />
                            </span>
                            <span
                              className="fs-7 mt-1"
                              onClick={() => {
                                handleLaserLineAlone();
                              }}>
                              {" "}
                              Laser
                            </span>
                          </div>
                        </div>
                      )}

                    {/* Nav Measure */}
                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 ${mobileTabs === 8 ? "active-tab-custom" : ""}`}
                            style={{
                              color: mobileTabs == 8 ? "orange" : "rgb(131, 154, 192)",
                            }}
                            onClick={() => {

                              if (!usePhoneApp) {
                                handleClearCanvas();
                                handleMobileTabs(8);
                                handleOpenMobileBottomDrawer();
                              } else {
                                setUsePhoneMessaegAlert(true);
                                setUsePhoneModalMessage("Measure");
                              }
                            }}
                          >
                            <span className="">
                              <TbRulerMeasure
                                onClick={() => {
                                  // handleOcrSend()
                                  // handleMobileTabs(6);
                                  // handleClearCanvas();
                                  // handleOpenMobileBottomDrawer();
                                }}
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                            <span className="fs-7 mt-1 text-center">Measure</span>
                          </div>
                        </div>
                      )}

                    {/* Nav - 9 OCR Capture text */}
                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2  ${mobileTabs === 6 ? "active-tab-custom" : ""}`}
                            style={{
                              color: mobileTabs == 6 ? "orange" : "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              // handleOcrSend()
                              handleMobileTabs(6);
                              // handleClearCanvas();
                              handleOpenMobileBottomDrawer();
                              if (drawingArea && videoRefRemote?.current?.paused && participants.length != 0 && permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")) {
                                handleClearCanvas();
                              }
                            }}
                          >
                            <span className="">
                              <IoIosQrScanner
                                onClick={() => {
                                  // handleOcrSend()
                                  // handleMobileTabs(6);
                                  // handleClearCanvas();
                                  // handleOpenMobileBottomDrawer();
                                }}
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                            <span className="fs-7 mt-1 text-center">Capture Text</span>
                          </div>
                        </div>
                      )}

                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                            style={{
                              color: "rgb(131, 154, 192)",
                            }}
                            onClick={() => {


                              if (!usePhoneApp) {
                                zoomIn();
                              } else {
                                setUsePhoneMessaegAlert(true);
                                setUsePhoneModalMessage("Zoom");
                              }
                            }}>
                            <span className="">
                              <FaPlus
                                onClick={() => {
                                  if (!usePhoneApp) {
                                    zoomIn();
                                  } else {
                                    setUsePhoneMessaegAlert(true);
                                    setUsePhoneModalMessage("Zoom");
                                  }
                                }}
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                            <span className="fs-7 mt-1">Zoom</span>
                          </div>
                        </div>
                      )
                    }

                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                            style={{
                              color: "rgb(131, 154, 192)",
                            }}
                            onClick={() => {
                              if (!usePhoneApp) {
                                zoomReset();
                              } else {
                                setUsePhoneMessaegAlert(true)
                                setUsePhoneModalMessage("Zoom");
                              }

                            }}>
                            <span className="">
                              <MdOutlineResetTv
                                onClick={() => {
                                  if (!usePhoneApp) {
                                    zoomReset();
                                  } else {
                                    setUsePhoneMessaegAlert(true)
                                    setUsePhoneModalMessage("Zoom");
                                  }
                                }}
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                            <span className="fs-7 mt-1">Reset</span>
                          </div>
                        </div>
                      )}

                    {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                      participants.length > 0 && (
                        <div className="position-relative">
                          <div
                            className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                            style={{
                              color: "rgb(131, 154, 192)",
                            }}
                            onClick={() => {

                              if (!usePhoneApp) {
                                zoomOut();
                              } else {
                                setUsePhoneMessaegAlert(true)
                                setUsePhoneModalMessage("Zoom");
                              }
                            }}>
                            <span className="">
                              <FaMinus
                                onClick={() => {
                                  if (!usePhoneApp) {
                                    zoomOut();
                                  } else {
                                    setUsePhoneMessaegAlert(true)
                                    setUsePhoneModalMessage("Zoom");
                                  }
                                }}
                                style={{ width: "20px", height: "20px" }}
                              />
                            </span>
                            <span className="fs-7 mt-1">Zoom</span>
                          </div>
                        </div>
                      )}

                    {/* For customer to shown own controlls down */}
                    {!permissionArray.includes(
                      "CONTROL REMOTE SCREEN ACTIONS"
                    ) && (
                        <>
                          {/* Nav - 8 Mic */}
                          {/* My mic control */}
                          <div className="position-relative">
                            {micStatus ? (
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  handleMicStatus();
                                }}>
                                <span className="">
                                  <BsFillMicFill
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span
                                  className="fs-7 mt-1"
                                  style={{ whiteSpace: "nowrap" }}>
                                  Unmute
                                </span>
                              </div>
                            ) : (
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  handleMicOffStatus();
                                }}>
                                <span className="">
                                  <BsFillMicMuteFill
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span
                                  className="fs-7 mt-1"
                                  style={{ whiteSpace: "nowrap" }}>
                                  Mute
                                </span>
                              </div>
                            )}
                          </div>

                          {/* Nav - 9 Video */}
                          {/* My video Control */}
                          <div className="position-relative">
                            {cameraCheckCustomer ? (
                              <>
                                {videoStatus && (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                    }}
                                    onClick={() => {
                                      handleVideoStatus();
                                    }}>
                                    <span className="">
                                      <BsFillCameraVideoFill
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-7 mt-1"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Video on
                                    </span>
                                  </div>
                                )}

                                {!videoStatus && (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                    }}
                                    onClick={() => {
                                      handleVideoOffStatus();
                                    }}>
                                    <span className="">
                                      <BsFillCameraVideoOffFill
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-7 mt-1"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Video off
                                    </span>
                                  </div>
                                )}
                              </>
                            ) : (
                              <>
                                {videoStatus && (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                      pointerEvents: "none",
                                      opacity: "0.5",
                                    }}>
                                    <span className="">
                                      <BsFillCameraVideoFill
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-7 mt-1"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Video on
                                    </span>
                                  </div>
                                )}

                                {!videoStatus && (
                                  <div
                                    className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                    style={{
                                      color: "rgb(131, 154, 192)",
                                      pointerEvents: "none",
                                      opacity: "0.5",
                                    }}>
                                    <span className="">
                                      <BsFillCameraVideoOffFill
                                        style={{ width: "20px", height: "20px" }}
                                      />
                                    </span>
                                    <span
                                      className="fs-7 mt-1"
                                      style={{ whiteSpace: "nowrap" }}>
                                      Video off
                                    </span>
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          {/* Nav - 10 Camera switch */}
                          {/* Swicth camera */}
                          <div className="position-relative">
                            {cameraCheckCustomer ? (
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                }}
                                onClick={() => {
                                  toggleFacingMode();
                                }}>
                                <span className="">
                                  <MdOutlineFlipCameraIos
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span
                                  className="fs-7 mt-1"
                                  style={{ whiteSpace: "nowrap" }}>
                                  Switch
                                </span>
                              </div>
                            ) : (
                              <div
                                className={`align-items-center d-flex flex-column justify-content-center p-2 `}
                                style={{
                                  color: "rgb(131, 154, 192)",
                                  pointerEvents: "none",
                                  opacity: "0.5",
                                }}>
                                <span className="">
                                  <MdOutlineFlipCameraIos
                                    style={{ width: "20px", height: "20px" }}
                                  />
                                </span>
                                <span
                                  className="fs-7 mt-1"
                                  style={{ whiteSpace: "nowrap" }}>
                                  Switch
                                </span>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                  </div>
                </div>
              }

              {permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                participants.length > 0 && (
                  <div
                    className="row mx-0"
                    style={{ background: 'rgb(240, 243, 247)' }}
                  >
                    <div className="col-12 p-1 d-flex justify-content-center align-items-center text-center">
                      <span style={{ color: "rgb(131, 154, 192)" }}>{`${customerName.split(" ")[0]
                        } - Customer Controls`}</span>
                    </div>
                  </div>
                )}
            </div>
          </div>
          {/* Mobile View bottom container ends here */}

          {/* Mobile view more option action drawer starts */}

          <div
            className={`row mx-0 mobile-more-actions-drawer-custom ${mobileMoreActionsDrawer ? "open" : ""
              }`}
          >
            <div className="col-12 px-0 bg-white rounded-top">
              {/* Show external resources */}
              {mobileMoreActionsTabs == 4 && (
                <>
                  <div className="row mx-0">
                    <div className="col-12 p-4">
                      <div className="row mx-0 border-bottom pb-2">
                        <div
                          className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-between px-0"
                          style={{ color: 'rgba(131, 154, 192, 1)' }}
                        >
                          <div className=" d-flex align-items-center">
                            <span
                              onClick={() => {
                                handleCloseMobileMoreActionsDrawer();
                                setMobileMoreActionsTabs();
                              }}
                              className="cursor-pointer">
                              <MdClose />
                            </span>
                          </div>

                          <div className="d-flex align-items-center">
                            <span>
                              {`Sourcing Info`}
                            </span>
                          </div>

                          <div></div>
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          <div
                            className="py-2 overflow-auto px-2"
                            style={{ maxHeight: "80dvh" }}
                          >
                            <div className="row mx-0 mt-3 pb-2">
                              <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">

                                <div className="w-100">
                                  {sourcingInfoLoading ? <div>
                                    <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                    <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                    <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                    <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                  </div> :
                                    <>
                                      {sourcingInfoArr.length > 0 ?
                                        <>
                                          {sourcingInfoArr.map((item, index) => {
                                            return (
                                              <>
                                                <a target="_blank" href={item?.url} rel="noreferrer">
                                                  <div className="mx-0 row mb-2">
                                                    <div
                                                      className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                      style={{
                                                        background: "rgba(244, 248, 255, 1)",
                                                        border: "1px solid rgba(199, 212, 234, 1)",
                                                      }}
                                                    >
                                                      <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                        <div className="d-flex">
                                                          <i className="bi bi-filetype-pdf pe-2"></i>

                                                          <div className="d-flex flex-column">
                                                            <span className="fs-6 text-black">
                                                              {`${item?.name}`}
                                                            </span>
                                                            <span className="fs-7">
                                                              {`Source : ${item?.source ? item?.source : "-"}`}
                                                            </span>
                                                          </div>

                                                        </div>

                                                        <div>
                                                          <i className="bi bi-chevron-right" />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </a>
                                              </>
                                            )
                                          })}
                                        </> :
                                        <>
                                          <div>
                                            <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                              <div className="mb-2">
                                                <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                              </div>
                                              <span>
                                                {`No record found`}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      }
                                    </>
                                  }

                                  <div>
                                    <div className="mx-0 row mt-3">
                                      <div className="col-12  px-0 text-center">
                                        <PrimaryButton
                                          buttonName={"CLOSE"}
                                          onClick={() => {
                                            handleCloseMobileMoreActionsDrawer();
                                          }}
                                          style={{
                                            width: "100%",
                                            background:
                                              "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                            border: "2px solid rgba(255, 154, 32, 1)",
                                            boxShadow:
                                              "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}



              {/* Add new note more actions drawer */}
              {mobileMoreActionsTabs == 1 && (
                <>
                  <div className="row mx-0">
                    <div className="col-12 p-4">
                      <div className="row mx-0 border-bottom pb-2">
                        <div
                          className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-between px-0"
                          style={{ color: 'rgba(131, 154, 192, 1)' }}
                        >
                          <div className=" d-flex align-items-center">
                            <span
                              onClick={() => {
                                handleCloseMobileMoreActionsDrawer();
                                setMobileMoreActionsTabs();
                              }}
                              className="cursor-pointer">
                              <MdClose />
                            </span>
                          </div>

                          <div className="d-flex align-items-center">
                            <span>
                              {mobileNotesTabs == 1 || mobileNotesTabs == 2
                                ? "Notes options"
                                : mobileNotesTabs == 3
                                  ? "Add note"
                                  : mobileNotesTabs == 4
                                    ? "Delete note"
                                    : ""}
                            </span>
                          </div>

                          <div></div>
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          {/* Notes actions buttons */}
                          {mobileNotesTabs == 1 ? (
                            <>
                              <div className="row mx-0 py-2 border-bottom border-light mt-2 fw-bold cursor-pointer overlay-action-btn">
                                <div
                                  onClick={() => {
                                    setMobileNotesTabs(3);
                                  }}
                                  className="col-12 px-0 fs-5 text-black">
                                  <span className="pe-3">
                                    <LuPlusCircle />
                                  </span>
                                  <span className="">{"Add note"}</span>
                                </div>
                              </div>
                            </>
                          ) : // Delete Note option
                            mobileNotesTabs == 2 ? (
                              <>
                                <div className="row mx-0 py-2 border-bottom border-light fw-bold cursor-pointer overlay-action-btn">
                                  <div
                                    onClick={() => {
                                      setMobileNotesTabs(4);
                                    }}
                                    className="col-12 px-0  fs-5 text-danger">
                                    <span className="pe-3">
                                      <MdDeleteOutline />
                                    </span>
                                    <span className="">{"Delete"}</span>
                                  </div>
                                </div>
                              </>
                            ) : // Add new notes secion
                              mobileNotesTabs == 3 ? (
                                <>
                                  <div
                                    className="py-2 overflow-auto"
                                    style={{ maxHeight: "70dvh" }}>
                                    <div className="row mx-0 mt-3 pb-2">
                                      <div className="col-12 px-0">
                                        <TextArea
                                          labelName={txtMessage}
                                          value={discussionVal}
                                          onChange={discussionOnChange}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mx-0 pb-2">
                                      <div className="col-12 px-0">
                                        <span
                                          className="fs-5 font-w600"
                                          onClick={() => handleAttach()}>
                                          <input
                                            accept="image/*"
                                            type="file"
                                            multiple
                                            style={{ display: "none" }}
                                            ref={hiddenFileInput}
                                            onChange={(e) => {
                                              inputFileTarget(e);
                                            }}
                                          />{" "}
                                          <i className="bi bi-paperclip pe-2"></i>{" "}
                                          Attach file
                                        </span>
                                      </div>
                                    </div>

                                    {selectedFile?.map((previewFile, index) => {
                                      return (
                                        <div className="border-bottom border-light border-top fs-5 mx-0 py-2 row">
                                          <div className="col-12 px-0 d-flex align-items-center justify-content-between">
                                            <span
                                              className="overflow-auto"
                                              style={{ whiteSpace: "nowrap" }}>
                                              {previewFile?.name}
                                            </span>
                                            <span>
                                              <MdDeleteOutline
                                                onClick={() => deleteUpload(index)}
                                                style={{
                                                  width: "18px",
                                                  height: "18px",
                                                  color: "red",
                                                }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}

                                    {(selectedFile.length > 0 ||
                                      discussionVal !== "") &&
                                      (
                                        <div className="row mx-0 mt-3">
                                          <div className="col-12 px-0">
                                            <PrimaryButton
                                              onClick={handleSaveDiscussion}
                                              buttonName={"Submit"}
                                              style={{
                                                width: "100%",
                                                background: "green",
                                                border: "none",
                                              }}
                                              loadingMessage={"Saving..."}
                                              isLoading={saveLoading}
                                            />
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </>
                              ) : // Delete note
                                mobileNotesTabs == 4 ? (
                                  <>
                                    <div
                                      className="py-2 overflow-auto px-2"
                                      style={{ maxHeight: "80dvh" }}>
                                      <div className="row mx-0 mt-3 pb-2">
                                        <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                          <span className="fs-5">
                                            {
                                              "Are you sure you want to delete this note?"
                                            }
                                          </span>
                                        </div>
                                      </div>

                                      <div className="row mx-0 pb-2 mt-2">
                                        <div className="col-12 px-0">
                                          <PrimaryButton
                                            buttonName={"Yes, delete it"}
                                            onClick={(e) =>
                                              handleDeleteNote(noteObject, e)
                                            }
                                            style={{
                                              width: "100%",
                                              background: "#F31D1D",
                                              border: "none",
                                            }}
                                            loadingMessage={"deleting..."}
                                            isLoading={saveLoading}
                                          />
                                        </div>
                                      </div>

                                      <div className="row mx-0 pb-2 mt-2">
                                        <div
                                          onClick={() => {
                                            handleCloseMobileMoreActionsDrawer();
                                          }}
                                          className="col-12 px-0  d-flex justify-content-center align-items-center">
                                          <span className="fw-bold">{"Cancel"}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* Shopping list more actions drawer */}
              {mobileMoreActionsTabs == 2 && (
                <>
                  <div className="row mx-0">
                    <div className="col-12 p-4">
                      <div className="row mx-0 border-bottom pb-2">
                        <div
                          className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-between px-0"
                          style={{ color: 'rgba(131, 154, 192, 1)' }}
                        >
                          <div className=" d-flex align-items-center">
                            <span
                              onClick={() => {
                                handleCloseMobileMoreActionsDrawer();
                                setMobileMoreActionsTabs();
                                handleCloseCreatePurchaseItem();
                              }}
                              className="cursor-pointer">
                              <MdClose />
                            </span>
                          </div>

                          <div className="d-flex align-items-center">
                            <span>
                              {mobileShoppingListTabs == 1 ||
                                mobileShoppingListTabs == 2
                                ? "List item options"
                                : mobileShoppingListTabs == 3
                                  ? "Add list item"
                                  : mobileShoppingListTabs == 4
                                    ? "Edit list item"
                                    : mobileShoppingListTabs == 5
                                      ? "Delete list item"
                                      : mobileShoppingListTabs == 6
                                        ? "Send via Email or SMS"
                                        : mobileShoppingListTabs == 7
                                          ? "Shopping item details"
                                          : ""}
                            </span>
                          </div>

                          <div></div>
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          {/* Shopping actions buttons */}
                          {mobileShoppingListTabs == 1 ? (
                            <>
                              <div className="row mx-0 py-2 border-bottom border-light mt-2 fw-bold cursor-pointer overlay-action-btn">
                                <div
                                  onClick={() => {
                                    setMobileShoppingListTabs(3);
                                  }}
                                  className="col-12 px-0 fs-5 text-black">
                                  <span className="pe-3">
                                    <LuPlusCircle />
                                  </span>
                                  <span className="">
                                    {"Add list item"}
                                  </span>
                                </div>
                              </div>

                              <div
                                className="row mx-0 py-2 border-bottom border-light fw-bold cursor-pointer overlay-action-btn"
                                style={{
                                  pointerEvents:
                                    rows.length > 0 ? "auto" : "none",
                                  opacity: rows.length > 0 ? "1" : "0.5",
                                }}>
                                <div
                                  onClick={() => {
                                    setMobileShoppingListTabs(6);
                                  }}
                                  className="col-12 px-0 fs-5 text-black">
                                  <span className="pe-3">
                                    <VscSend />
                                  </span>
                                  <span className="">
                                    {"Send via Email or SMS"}
                                  </span>
                                </div>
                              </div>

                              <div
                                className="row mx-0 py-2 border-bottom border-light fw-bold cursor-pointer overlay-action-btn"
                                style={{
                                  pointerEvents:
                                    rows.length > 0 ? "auto" : "none",
                                  opacity: rows.length > 0 ? "1" : "0.5",
                                }}>
                                <a
                                  download
                                  href={
                                    process.env.REACT_APP_BASE_URL +
                                    `ServiceRequest/DownloadPurchaseList?user_id_ids=${localStorage.getItem("user_id") || ""
                                    }&ticket_id_ids=${localStorage.getItem(
                                      "ticket_id"
                                    )}&generated_date_dtm=${encodeDateString(
                                      currentTimeString
                                    )}`
                                  }
                                  target="_blank"
                                  rel="noreferrer noopen">
                                  <div
                                    onClick={() => { }}
                                    className="col-12 px-0 fs-5 text-black">
                                    <span className="pe-3">
                                      <FiDownload />
                                    </span>
                                    <span className="">
                                      {"Download list"}
                                    </span>
                                  </div>
                                </a>
                              </div>
                            </>
                          ) : // Edit Delete shopping options
                            mobileShoppingListTabs == 2 ? (
                              <>
                                <div className="row mx-0 py-2 border-bottom border-light mt-2 fw-bold cursor-pointer overlay-action-btn">
                                  <div
                                    onClick={(e) => {
                                      setMobileShoppingListTabs(4);
                                      handleUpdatePurchaseList(
                                        shoppingItemObject,
                                        e
                                      );
                                    }}
                                    className="col-12 px-0  fs-5 text-black">
                                    <span className="pe-3">
                                      <MdOutlineEdit />
                                    </span>
                                    <span className="">{"Edit"}</span>
                                  </div>
                                </div>

                                <div className="row mx-0 py-2 border-bottom border-light fw-bold cursor-pointer overlay-action-btn">
                                  <div
                                    onClick={() => {
                                      setMobileShoppingListTabs(5);
                                      handleViewPurchaseItem(shoppingItemObject);
                                    }}
                                    className="col-12 px-0  fs-5 text-danger">
                                    <span className="pe-3">
                                      <MdDeleteOutline />
                                    </span>
                                    <span className="">{"Delete"}</span>
                                  </div>
                                </div>
                              </>
                            ) : // Shopping add edit  form
                              mobileShoppingListTabs == 3 ||
                                mobileShoppingListTabs == 4 ? (
                                <>
                                  <div
                                    className="py-2 overflow-auto px-2"
                                    style={{ maxHeight: "80dvh" }}>
                                    <div className="row mx-0 mt-3 pb-2">
                                      <div className="col-12 px-0">
                                        <InputField
                                          labelName={"Item Name"}
                                          placeholderName={"Item Name"}
                                          value={itemName}
                                          onChange={handleItemName}
                                          onBlur={handleItemNameBlurCheck}
                                          errorOccured={itemNameErr}
                                          errorMeesage={"Please add item name"}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mx-0 pb-2">
                                      <div className="col-6 px-0 pe-2">
                                        <InputField
                                          labelName={"Quantity"}
                                          placeholderName={"Quantity"}
                                          value={`${quantity}`}
                                          onChange={handleQuantity}
                                          onBlur={() => { }}
                                        />
                                      </div>

                                      <div className="col-6 px-0 ps-2">
                                        <InputField
                                          labelName={"Cost Per Item ($)"}
                                          placeholderName={"Cost Per Item"}
                                          value={totalEstimatedCost}
                                          onChange={handleTotalEstimatedCost}
                                          onBlur={() => { }}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mx-0 pb-2">
                                      <div className="col-12 px-0">
                                        <InputField
                                          labelName={"Website or Location"}
                                          placeholderName={"Website or Location"}
                                          value={purchaseLink}
                                          onChange={handlePurchaseLink}
                                          onBlur={() => { }}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mx-0 pb-2">
                                      <div className="col-12 px-0">
                                        <TextArea
                                          labelName={"Item Description"}
                                          placeholder={"Item Description"}
                                          value={itemDescription}
                                          onChange={handleDescription}
                                          onBlur={() => { }}
                                        // onBlur={handleDescriptionBlurCheck}
                                        // errorOccured={itemDescriptionErr}
                                        // errorMessage={'Please add description'}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mx-0 pb-2">
                                      <div className="col-12 px-0">
                                        {mobileShoppingListTabs == 3 && (
                                          <PrimaryButton
                                            buttonName={"Submit"}
                                            onClick={handleSubmitPurchase}
                                            style={{
                                              width: "100%",
                                              background: "green",
                                              border: "none",
                                            }}
                                            loadingMessage={"Saving..."}
                                            isLoading={purchaseLoading}
                                          />
                                        )}

                                        {mobileShoppingListTabs == 4 && (
                                          <PrimaryButton
                                            buttonName={"Submit"}
                                            onClick={handleUpdatePurchase}
                                            style={{
                                              width: "100%",
                                              background: "green",
                                              border: "none",
                                            }}
                                            loadingMessage={"Saving..."}
                                            isLoading={purchaseLoading}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : // Delete shopping item
                                mobileShoppingListTabs == 5 || mobileShoppingListTabs == 7 ? (
                                  <>
                                    <div
                                      className="py-2 overflow-auto px-2"
                                      style={{ maxHeight: "80dvh" }}>
                                      <div className="row mx-0 mt-3 pb-2">
                                        <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                          <span className="fs-5">
                                            {
                                              "Are you sure you want to delete this item?"
                                            }
                                          </span>
                                        </div>
                                      </div>

                                      <div className="row mx-0 pb-2">
                                        <div className="col-5 px-0 font-w600 pe-2">
                                          <span>{"Item Name"}</span>
                                        </div>
                                        <div className="col-7 px-0">
                                          <span>{itemName}</span>
                                        </div>
                                      </div>

                                      {quantity && (
                                        <div className="row mx-0 pb-2">
                                          <div className="col-5 px-0 font-w600 pe-2">
                                            <span>{"Quantity"}</span>
                                          </div>
                                          <div className="col-7 px-0">
                                            <span>{`${quantity}`}</span>
                                          </div>
                                        </div>
                                      )}

                                      {totalEstimatedCost && (
                                        <div className="row mx-0 pb-2">
                                          <div className="col-5 px-0 font-w600 pe-2">
                                            <span>{"Total Estimated Cost"}</span>
                                          </div>
                                          <div className="col-7 px-0">
                                            <span>{`$ ${totalEstimatedCost.toFixed(
                                              2
                                            )}`}</span>
                                          </div>
                                        </div>
                                      )}

                                      {itemDescription && (
                                        <div className="row mx-0 pb-2">
                                          <div className="col-5 px-0 font-w600 pe-2">
                                            <span>{"Item Description"}</span>
                                          </div>
                                          <div className="col-7 px-0">
                                            <span>{itemDescription}</span>
                                          </div>
                                        </div>
                                      )}

                                      {purchaseLink && (
                                        <div className="row mx-0 pb-2">
                                          <div className="col-5 px-0 font-w600 pe-2">
                                            {urlPattern.test(purchaseLink) ?
                                              <span>{"Website"}</span> :
                                              <span>{"Location"}</span>
                                            }
                                          </div>
                                          <div className="col-7 px-0 overflow-hidden">
                                            {urlPattern.test(purchaseLink) ?
                                              <a
                                                className="text-black text-hovered text-decoration-underline"
                                                href={
                                                  // purchaseLink
                                                  purchaseLink && !purchaseLink.startsWith('http')
                                                    ? `https://${purchaseLink}`
                                                    : purchaseLink
                                                }
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{ wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word' }}
                                              >
                                                <span>{purchaseLink}</span>
                                              </a> :
                                              <span>{purchaseLink}</span>
                                            }
                                          </div>
                                        </div>
                                      )}

                                      {mobileShoppingListTabs == 5 ?
                                        <>
                                          <div className="row mx-0 pb-2 mt-2">
                                            <div className="col-12 px-0">
                                              <PrimaryButton
                                                buttonName={"Yes, delete it"}
                                                onClick={(e) =>
                                                  handleDeletePurchaseList(
                                                    shoppingItemObject,
                                                    e
                                                  )
                                                }
                                                style={{
                                                  width: "100%",
                                                  background: "#F31D1D",
                                                  border: "none",
                                                }}
                                                loadingMessage={"Saving..."}
                                                isLoading={purchaseLoading}
                                              />
                                            </div>
                                          </div>

                                          <div className="row mx-0 pb-2 mt-2">
                                            <div
                                              onClick={() => {
                                                handleCloseMobileMoreActionsDrawer();
                                              }}
                                              className="col-12 px-0  d-flex justify-content-center align-items-center">
                                              <span className="fw-bold">{"Cancel"}</span>
                                            </div>
                                          </div>
                                        </> :
                                        mobileShoppingListTabs == 7 ?
                                          <>
                                            <div className="row mx-0 mt-2 rounded-3 p-2"
                                              style={{ border: '1px solid black' }}
                                            >
                                              <div
                                                onClick={() => {
                                                  handleCloseMobileMoreActionsDrawer();
                                                }}
                                                className="col-12 px-0 text-black d-flex justify-content-center align-items-center">
                                                <span className="fw-bold">{"Cancel"}</span>
                                              </div>
                                            </div>
                                          </> : <></>
                                      }


                                    </div>
                                  </>
                                ) : // Send shopping list
                                  mobileShoppingListTabs == 6 ? (
                                    <>
                                      <div
                                        className="py-2 overflow-auto px-2"
                                        style={{ maxHeight: "80dvh" }}>
                                        <form
                                          onSubmit={(e) => handleSendPurchaseList(e)}>
                                          <div className="row mx-0 mt-3 pb-2">
                                            <div className="col-12 px-0">
                                              <EmailPhoneCombine
                                                inputValue={emailPhoneValue}
                                                handleChangeCode={handleDropdownValue}
                                                handleInputValue={handleEmailPhone}
                                                isEnteringNumber={isPhone}
                                                errorOccured={isEmailPhoneVal}
                                                errorMessage={
                                                  validEmail_OR_MobileNumberText
                                                }
                                                handleOnBlur={handleEmailPhoneBlur}
                                                defaultCodeValue={codeValue}
                                              />
                                            </div>
                                          </div>

                                          <div className="row mx-0 pb-2">
                                            <div className="col-12 px-0">
                                              <PrimaryButton
                                                buttonName={"Submit"}
                                                onClick={(e) =>
                                                  handleSendPurchaseList(e)
                                                }
                                                style={{
                                                  width: "100%",
                                                  background: "green",
                                                  border: "none",
                                                }}
                                                loadingMessage={"Saving..."}
                                                isLoading={purchaseLoading}
                                              />
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* Check-up more actions drawer */}
              {mobileMoreActionsTabs == 3 && (
                <>
                  <div className="row mx-0">
                    <div className="col-12 p-4">
                      <div className="row mx-0 border-bottom pb-2">
                        <div className="align-items-center col-12 d-flex font-w600 fs-4 justify-content-between px-0 text-black">
                          <div className=" d-flex align-items-center">
                            <span
                              onClick={() => {
                                handleCloseMobileMoreActionsDrawer();
                                setMobileMoreActionsTabs();
                                handleClearInventoryStates();
                              }}
                              className="cursor-pointer">
                              <MdClose />
                            </span>
                          </div>

                          <div className="d-flex align-items-center">
                            <span>
                              {mobileCheckUpTabs == 1
                                ? "Check-up options"
                                : mobileCheckUpTabs == 2
                                  ? "Add item"
                                  : mobileCheckUpTabs == 3
                                    ? `Edit ${inventoryType}`
                                    : mobileCheckUpTabs == 4
                                      ? "Delete inventory item"
                                      : ""}
                            </span>
                          </div>

                          <div></div>
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          { // Edit Delete Check-up options
                            mobileCheckUpTabs == 1 ? (
                              <>
                                <div
                                  style={{
                                    pointerEvents: startStopCheckLoading ? "none" : "auto",
                                    opacity: startStopCheckLoading ? 0.5 : 1,
                                  }}
                                >
                                  {/* {permissionArray?.includes("CONTROL REMOTE SCREEN ACTIONS") &&
                                    <div className="row mx-0 py-2 border-bottom border-light mt-2 fw-bold cursor-pointer overlay-action-btn">
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const value = individualProductObj?.is_checking_ysn ? 0 : 1;
                                          startStopCheckingItemFn(value);
                                        }}
                                        className="col-12 px-0  fs-5 text-black">
                                        <span className="pe-3">
                                          {!startStopCheckLoading ?
                                            <i className="bi bi-tools"></i> :
                                            <Spinner animation="border" size="sm" variant="primary" />
                                          }
                                        </span>
                                        <span className="">
                                          {individualProductObj?.is_checking_ysn ? `Stop checking` : `Start checking`}
                                        </span>
                                      </div>
                                    </div>
                                  } */}


                                  <div className="row mx-0 py-2 border-bottom border-light mt-2 fw-bold cursor-pointer overlay-action-btn">
                                    <div
                                      onClick={(e) => {
                                        setMobileCheckUpTabs(3);
                                        updateInventoryItemFn();
                                        // handleUpdatePurchaseList(
                                        //   shoppingItemObject,
                                        //   e
                                        // );
                                      }}
                                      className="col-12 px-0  fs-5 text-black">
                                      <span className="pe-3">
                                        <MdOutlineEdit />
                                      </span>
                                      <span className="">{"Edit"}</span>
                                    </div>
                                  </div>

                                  <div className="row mx-0 py-2 border-bottom border-light fw-bold cursor-pointer overlay-action-btn">
                                    <div
                                      onClick={() => {
                                        setMobileCheckUpTabs(4);
                                        setInventoryType(individualProductObj?.product_name_chr);
                                        setHomeAreaProductId(individualProductObj?.home_area_product_id_ids);
                                      }}
                                      className="col-12 px-0  fs-5 text-danger">
                                      <span className="pe-3">
                                        <MdDeleteOutline />
                                      </span>
                                      <span className="">{"Delete"}</span>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : // Check-up add edit  form
                              mobileCheckUpTabs == 2 ||
                                mobileCheckUpTabs == 3 ? (
                                <>
                                  <div
                                    className="py-2 overflow-auto px-2"
                                    style={{ maxHeight: "80dvh" }}>
                                    <div>
                                      {mobileCheckUpTabs == 2 &&
                                        <div className="row mx-0 mt-2">
                                          <div className="col-12 px-0">
                                            <SelectInputProductTypes
                                              labelName={"Inventory type"}
                                              onChange={(e) => handleChangeInventoryType(e)}
                                              defaultValue={inventoryType}
                                              options={productTypeArr}
                                              errorOccured={isInventoryTypeErr}
                                              errorMessage={"Please select inventory type"}
                                            // isForProdId={true}
                                            />
                                          </div>
                                        </div>
                                      }

                                      <div className="row mx-0 fs-6 mb-2">
                                        <div className="col-4 font-w600 mb-2">
                                          <span>{`Condition `}</span>
                                        </div>

                                        <div className="col-8">
                                          <div className="d-flex flex-wrap pb-1 w-100 justify-content-start">
                                            {conditionListArr.map((item, index) => {
                                              return (
                                                <>
                                                  {item?.condition_id_ids !== 0 &&
                                                    <span
                                                      key={index}
                                                      className="font-w500 me-2 px-3 py-1 rounded-pill text-white cursor-pointer fs-7 mb-1"
                                                      onClick={() => { setInventoryCondition(item?.condition_name_chr) }}
                                                      style={{
                                                        background:
                                                          (inventoryCondition === "Good" && item?.condition_name_chr === "Good") ? "rgba(45, 204, 99, 1)" :
                                                            (inventoryCondition === "Ok" && item?.condition_name_chr === "Ok") ? "rgba(255, 154, 32, 1)" :
                                                              (inventoryCondition === "Poor" && item?.condition_name_chr === "Poor") ? "rgba(240, 72, 72, 1)" : `rgba(131, 154, 192, 1)`,
                                                        boxShadow:
                                                          (inventoryCondition === "Good" && item?.condition_name_chr === "Good") ? '1px 1px 2px 0px grey' :
                                                            (inventoryCondition === "Ok" && item?.condition_name_chr === "Ok") ? '1px 1px 2px 0px grey' :
                                                              (inventoryCondition === "Poor" && item?.condition_name_chr === "Poor") ? '1px 1px 2px 0px grey' : `0px 0px 2px 0px grey`,
                                                      }}
                                                    >
                                                      {`${item?.condition_name_chr}`}
                                                    </span>
                                                  }
                                                </>
                                              )
                                            })}
                                          </div>
                                        </div>
                                      </div>

                                      <div className={`row mx-0 ${mobileCheckUpTabs !== 2 ? "mt-2" : ""}`}>
                                        <div className="col-12 px-0">
                                          <InputField
                                            labelName={"Brand"}
                                            value={inventoryBrand}
                                            onChange={(e) => { handleChangeInventoryBrand(e) }}
                                            onBlur={(e) => { }}
                                          />
                                        </div>
                                      </div>

                                      <div className="row mx-0">
                                        <div className="col-12">
                                          <InputField
                                            labelName={"Model"}
                                            value={inventoryModel}
                                            onChange={(e) => { handleChangeInventoryModel(e) }}
                                            onBlur={(e) => { }}
                                          />
                                        </div>
                                      </div>

                                      <div className="row mx-0">
                                        <div className="col-12">
                                          <InputField
                                            labelName={"Serial number"}
                                            value={inventorySerialNumber}
                                            onChange={(e) => { handleChangeInventorySerialNumber(e) }}
                                            onBlur={(e) => { }}
                                          />
                                        </div>
                                      </div>

                                      {/* <div className="row mx-0">
                                        <div className="col-12 px-0">
                                          <SelectInputCondition
                                            labelName={"Condition"}
                                            onChange={(e) => handleChangeInventoryCondition(e)}
                                            defaultValue={inventoryCondition}
                                            options={conditionListArr}
                                            errorOccured={false}
                                            errorMessage={"Please select device condition"}
                                          />
                                        </div>
                                      </div> */}

                                      <div className="row mx-0">
                                        <div className="col-12 px-0">
                                          <TextArea
                                            labelName={"Description (optional)"}
                                            value={inventoryDesc}
                                            rows={3}
                                            onChange={(e) => { handleChangeInventoryDesc(e) }}
                                            onBlur={(e) => { }}
                                          />
                                        </div>
                                      </div>

                                      <div className="row mx-0 ">
                                        <div className="col-sm-6 pe-sm-2 mb-2 d-flex align-items-center">
                                          {permissionArray.includes("SCAN TAB") &&
                                            <div
                                              className="text-hovered fs-5 cursor-pointer d-flex align-items-center font-w600"
                                              onClick={handleClickAttachedImage0}
                                            >
                                              <span className="me-2">
                                                <i className="bi bi-paperclip"></i>
                                              </span>
                                              <span>
                                                {`Attach file`}
                                              </span>
                                              <input ref={attachedImage0Ref} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage0(e) }} />
                                            </div>
                                          }
                                        </div>

                                        <div className="col-sm-6 ps-sm-2 mb-2">
                                          <PrimaryButton
                                            buttonName={"SUBMIT"}
                                            onClick={(e) => { addUpdateinventoryItemFn() }}
                                            isLoading={inventoryLoading}
                                            loadingMessage={"Loading..."}
                                            style={{
                                              width: '100%',
                                              background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                              border: '2px solid rgba(255, 154, 32, 1)',
                                              boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                            }}
                                          />
                                        </div>
                                      </div>

                                      {attachedImage0 &&
                                        <div className="row mx-0 mt-2">
                                          <div className="col-12 px-0 d-flex">
                                            <div className="position-relative">
                                              <i
                                                onClick={deleteAttachedImage0}
                                                className="bi bi-x-circle position-absolute cursor-pointer fs-3 text-orange bg-white rounded-circle"
                                                style={{
                                                  top: '-10px',
                                                  right: '-10px',
                                                }}
                                              ></i>
                                              <img
                                                src={attachedImage0}
                                                className="rounded-2 shadow-lg border border-danger"
                                                alt="Attachement"
                                                style={{
                                                  height: '50px',
                                                  width: '50px',
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </>
                              ) : // Delete inventory item
                                mobileCheckUpTabs == 4 ? (
                                  <>
                                    <div
                                      className="py-2 overflow-auto px-2"
                                      style={{ maxHeight: "80dvh" }}>
                                      <div className="row mx-0 mt-3 pb-2">
                                        <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                          <span className="fs-5">
                                            {
                                              `Are you sure you want to delete ${inventoryType} from this room?`
                                            }
                                          </span>
                                        </div>
                                      </div>

                                      <div className="row mx-0 pb-2 mt-2">
                                        <div className="col-12 px-0">
                                          <PrimaryButton
                                            buttonName={"YES, DELETE IT"}
                                            onClick={(e) => { deleteInventoryItemFn() }}
                                            isLoading={inventoryLoading}
                                            loadingMessage={"Loading..."}
                                            style={{
                                              width: '100%',
                                              background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                              border: '1px solid rgba(240, 72, 72, 1)',
                                              boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                            }}
                                          />
                                        </div>
                                      </div>

                                      <div className="row mx-0 pb-2 mt-2">
                                        <div
                                          onClick={() => {
                                            handleCloseMobileMoreActionsDrawer();
                                          }}
                                          className="col-12 px-0  d-flex justify-content-center align-items-center">
                                          <span className="fw-bold">{"Cancel"}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : // Send shopping list
                                  mobileShoppingListTabs == 6 ? (
                                    <>
                                      <div
                                        className="py-2 overflow-auto px-2"
                                        style={{ maxHeight: "80dvh" }}>
                                        <form
                                          onSubmit={(e) => handleSendPurchaseList(e)}>
                                          <div className="row mx-0 mt-3 pb-2">
                                            <div className="col-12 px-0">
                                              <EmailPhoneCombine
                                                inputValue={emailPhoneValue}
                                                handleChangeCode={handleDropdownValue}
                                                handleInputValue={handleEmailPhone}
                                                isEnteringNumber={isPhone}
                                                errorOccured={isEmailPhoneVal}
                                                errorMessage={
                                                  validEmail_OR_MobileNumberText
                                                }
                                                handleOnBlur={handleEmailPhoneBlur}
                                                defaultCodeValue={codeValue}
                                              />
                                            </div>
                                          </div>

                                          <div className="row mx-0 pb-2">
                                            <div className="col-12 px-0">
                                              <PrimaryButton
                                                buttonName={"Submit"}
                                                onClick={(e) =>
                                                  handleSendPurchaseList(e)
                                                }
                                                style={{
                                                  width: "100%",
                                                  background: "green",
                                                  border: "none",
                                                }}
                                                loadingMessage={"Saving..."}
                                                isLoading={purchaseLoading}
                                              />
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Mobile view more option action drawer ends */}

          {mobileBottomDrawer && (
            <div
              className="backdrop-for-drawer"
              onClick={handleCloseMobileBottomBackdrop}></div>
          )}

          {mobileMoreActionsDrawer && (
            <div
              className="backdrop-for-drawer-more-options"
              onClick={handleCloseMobileMoreActionsBackdrop}></div>
          )}

          {/* New UI design for mobile view ends here */}
        </div>
      </div >

      {/* <!-- Modal For the Maintenance plans operations --> */}
      <>
        <Modal
          className="fade"
          show={maintenanceModalTriggerMaintenanceTask}
          centered
        // onHide={handleClose} 
        >
          <Modal.Body>
            <div className='row mx-0'>
              <div className='col-12 px-0'>
                <div className='mx-0 row text-black mb-3'>
                  <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                    <span
                      onClick={() => handleCloseMaintenancePlanModalMaintenanceTask()}
                      className='cursor-pointer text-hovered'
                    >
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                  <div className='col-12 font-w600 fs-3 px-0 text-center'>
                    <span>
                      {toggleForMaintenancePlan === 1 ? `Edit maintenance plan` :
                        toggleForMaintenancePlan === 2 ? `Delete maintenance plan` : ''
                      }
                    </span>
                  </div>
                </div>

                <div className="row mx-0 mb-3">
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                    <span>
                      {(toggleForMaintenancePlan === 1) && `Fill in a maintenance plan for the item`}
                      {(toggleForMaintenancePlan === 2) && `Are you sure you want to delete the ${instructionMaintenanceTask ? `"${instructionMaintenanceTask}"` : ''} maintenace plan?`}
                    </span>
                  </div>
                </div>

                {(toggleForMaintenancePlan === 1) &&
                  <div
                    className="row mx-0 py-2 font-w700 d-flex align-items-center"
                    style={{
                      // background: 'rgb(199 212 234 / 30%)',
                      // pointerEvents: 'none',
                      // opacity: '0.5',
                    }}
                  >
                    <div className="col-12 p-2">
                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          <InputField
                            labelName={"Instruction"}
                            value={instructionMaintenanceTask}
                            onChange={(e) => { handleChangeInstructionMaintenanceTask(e) }}
                            onBlur={() => { handleBlurCheckInstrctionMaintenanceTask() }}
                            errorOccured={isInstructionErrMaintenanceTask}
                            errorMeesage={"Please enter instructions"}
                          />
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          <div className="row mx-0">
                            <div className="col-2 px-0 d-flex  justify-content-center">
                              <span className="font-w600 text-black">{`Every`}</span>
                            </div>
                            <div className="col-3 px-2">

                              <SelectInputFrequency
                                labelName={"Times"}
                                onChange={(e) => handleChangeFreqMaintenanceTask(e)}
                                defaultValue={frequencyMaintenanceTask}
                                options={frequencyArr}
                                errorOccured={isFrequencyErrMaintenanceTask}
                                errorMessage={"Please select frequencyMaintenanceTask"}
                              />

                            </div>
                            <div className="col-7 px-0">
                              <SelectInputPeriod
                                labelName={"Period"}
                                onChange={(e) => handleChangePeriodMaintenanceTask(e)}
                                defaultValue={periodMaintenanceTask}
                                options={periodListArrMaintenanceTask}
                                errorOccured={isPeriodErrMaintenanceTask}
                                errorMessage={"Please select periodMaintenanceTask"}
                              />
                            </div>

                          </div>
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          <InputField
                            labelName={"Purchase link (optional)"}
                            value={purchaseLinkMaintenanceTask}
                            onChange={(e) => { handleChangePurchaseLinkMaintenanceTask(e) }}
                            onBlur={() => { }}
                            errorOccured={false}
                            errorMeesage={"Please enter purchase link"}
                          />
                        </div>
                      </div>

                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          <PrimaryButton
                            buttonName={"SUBMIT"}
                            onClick={() => { addUpdateMaintenancePlanFnMaintenanceTask() }}
                            isLoading={maintenancePlanLoadingMaintenanceTask}
                            loadingMessage={"Loading..."}
                            style={{
                              width: '100%',
                              background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                              border: '2px solid rgba(255, 154, 32, 1)',
                              boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {(toggleForMaintenancePlan === 2) &&
                  <>
                    <div className="row mx-0">
                      <div className="col-sm-6 pe-sm-2 mb-2">
                        <PrimaryButton
                          buttonName={"NO, GO BACK"}
                          onClick={(e) => { handleCloseMaintenancePlanModalMaintenanceTask() }}
                          isLoading={false}
                          loadingMessage={"Loading..."}
                          style={{
                            width: '100%',
                            background: 'rgba(251, 252, 255, 1)',
                            border: '1px solid rgba(199, 212, 234, 1)',
                            boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                            color: 'black'
                          }}
                        />
                      </div>

                      <div className="col-sm-6 ps-sm-2 mb-2">
                        <PrimaryButton
                          buttonName={"YES, DELETE IT"}
                          onClick={(e) => { deletemaintenancePlanFnMaintenanceTask() }}
                          isLoading={maintenancePlanLoadingMaintenanceTask}
                          loadingMessage={"Loading..."}
                          style={{
                            width: '100%',
                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                            border: '1px solid rgba(240, 72, 72, 1)',
                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                          }}
                        />
                      </div>
                    </div>
                  </>
                }

              </div>
            </div>

          </Modal.Body>
        </Modal>
      </>

      {/* Image previewer */}
      {openDoc &&
        <ImagePreviewer
          openDoc={openDoc}
          handleCloseDoc={handleCloseDoc}
          imageAttachURL={imageAttachURL}
          notesMessage={notesMessage}
        />
      }
      <>

        <Modal className="fade" show={endCallPopUp} centered>
          <Modal.Body>
            <div className="row mx-0">
              <div className="col-12 px-0">
                {/* Update Account details  */}

                <div className="mx-0 row">
                  <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                    <span className="">
                      <i
                        className="bi bi-x-lg cursor-pointer"
                        onClick={() => {
                          setEndCallPopUp(false);
                        }}></i>
                    </span>
                  </div>
                </div>

                <div className="mx-0 row mb-4">
                  <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                    <span>{"End video call"}</span>
                  </div>
                </div>

                <div className="mx-0 row mb-4">
                  <div className="col-12 font-w600 fs-4 px-0 text-center text-black ">
                    <span>Are you sure you want to end this video call?</span>
                  </div>
                </div>

                <div className="row mx-0 justify-content-between mt-2">
                  <div className="col-md-6 px-0 pe-md-2 mb-2">
                    <PrimaryButton
                      buttonName={"Cancel"}
                      onClick={() => {
                        setEndCallPopUp(false);
                      }}
                      style={{
                        width: "100%",
                        backgroundColor: "white",
                        border: "1px solid white",
                        color: "gray",
                      }}
                    />
                  </div>

                  <div className="col-md-6 px-0  ps-md-2 mb-2">
                    <PrimaryButton
                      buttonName={"Yes, end it"}
                      onClick={handleLogout}
                      style={{
                        width: "100%",
                        background: "red",
                        border: "1px solid red",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>

      {/* Modal fo the customer to disconnect the Estimations call */}
      <Modal className="fade" show={isProGivingEstimationsReport} centered>
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">

              {/* <div className="mx-0 row">
                  <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                    <span className="">
                      <i
                        className="bi bi-x-lg cursor-pointer"
                        onClick={() => {
                          setIsProGivingEstimationsReport(false);
                        }}></i>
                    </span>
                  </div>
                </div> */}

              <div className="mx-0 row mb-4">
                <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                  <span>{"Call has ended"}</span>
                </div>
              </div>

              <div className="mx-0 row mb-4">
                <div className="col-12 font-w600 fs-5 px-0 text-center ">
                  <span>{`Please be patient while the Pro completes your estimation report.`}</span>
                </div>
              </div>

              <div className="row mx-0 justify-content-between mt-2">

                <div className="col-12 px-0">
                  <PrimaryButton
                    buttonName={"OKAY"}
                    onClick={handleLogout}
                    style={{
                      width: "100%",
                      background: "linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)",
                      border: "none",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal for Pro to fill the Diagnosis report */}
      <Modal className="fade" show={proCheckInfoModalTrigger} centered>
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              {/* Update Account details  */}

              <div className="mx-0 row">
                <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                  <span className="">
                    <i
                      className="bi bi-x-lg cursor-pointer"
                      onClick={() => {
                        setProCheckInfoModalTrigger(false);
                      }}></i>
                  </span>
                </div>
              </div>

              <div className="mx-0 row my-5">
                <div className="col-12 font-w600 fs-3 px-0 text-center text-black d-flex flex-column">
                  {/* <span>{"Now Complete The Customer Check-Up"}</span> */}
                  <span>{"Please Complete the"}</span>
                  <span>{"Customer Estimate"}</span>
                </div>
              </div>

              {/* <div className="mx-0 row mb-4">
                <div className="col-12 fs-4 px-0 text-center  ">
                  <span>{`Complete the customer check-in info before ending this call session.`}</span>
                </div>
              </div> */}

              <div className="row mx-0 justify-content-between mt-2">
                <div className="col-md-6 px-0 pe-md-2 mb-2">
                  <PrimaryButton
                    buttonName={"Cancel"}
                    onClick={() => {
                      setProCheckInfoModalTrigger(false);
                    }}
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      border: "1px solid white",
                      color: "gray",
                    }}
                  />
                </div>

                <div className="col-md-6 px-0  ps-md-2 mb-2">
                  <PrimaryButton
                    buttonName={"Okay"}
                    onClick={() => {
                      // getServiceDetailsFn();
                      setProCheckInfoModalTrigger(false);
                      dispatch(setIsCheckInCall(true));
                      setTimeout(() => {
                        handleLogout();
                      }, 500);

                      // handleTab(9);
                      // handleCreateComposeRecording();

                      // Flow has been changed as the Estimations will be given by Pro after disconnecting call
                      // setTabsPartsManuals('1');
                      // setProCheckInfoModalConfirmTrigger(true);
                      // setVideoStatus(false);
                      // setMicStatus(false);
                      // room.localParticipant.videoTracks.forEach(function (track) {
                      //   track.track.disable();
                      // });
                      // room.localParticipant.audioTracks.forEach(function (track) {
                      //   track.track.disable();
                      // });

                      const [localValue] = [...room.localParticipant.dataTracks.values()];
                      localValue.track.send("pro_giving_estimations_report");
                      // localValue?.track?.send("camera-off");
                    }}
                    style={{
                      width: "100%",
                      background: "linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)",
                      border: "none",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal for the taking check in for the last service request */}
      <Modal className='fade' centered show={proCheckInfoModalConfirmTrigger} size="lg"
        style={{
          backdropFilter: 'blur(5px)',
          background: 'black !important'
        }}
      >
        <Modal.Body>
          <div className='row mx-0'>
            <div className='col-12 px-0'>
              <>
                <div className='mx-0 row text-black mb-4'>
                  <div className='col-11 font-w600 fs-3 px-0 text-center'>
                    <span>
                      {`Check-in report for service request #${serviceDetailsObj?.display_id_int}`}
                    </span>
                  </div>
                  <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                    <span onClick={() => setProCheckInfoModalConfirmTrigger(false)} className='cursor-pointer fs-4 text-black text-hovered'>
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className='mx-0 row mb-4'>
                  <div className='col-12 font-w600 fs-5 px-0 text-center'>
                    <span>
                      {`Please fill the information below to complete the check-in for service request (#${serviceDetailsObj?.display_id_int})`}
                    </span>
                  </div>
                </div>



                <div className='mx-0 row'>
                  <div
                    className="col-md-6 pe-md-3 fs-6"
                    style={{ borderRight: '2px solid black' }}
                  >
                    {/* Navigations profile */}
                    <div
                      className='border-bottom mb-3 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                    >
                      <div className='col-12 d-flex px-0 fs-5 font-w500'>
                        <div
                          onClick={() => {
                            setTabsForEstimationsModal(1)
                          }}
                          className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative`}
                          style={{}}
                        >
                          <span className={`${tabsForEstimationsModal === 1 ? "text-black" : "text-grey"} ${tabsForEstimationsModal === 1 && "fw-bold"}`} >{"Info"}</span>
                          {tabsForEstimationsModal === 1 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                        </div>

                        <div
                          onClick={() => {
                            setTabsForEstimationsModal(2);
                            callNoteData();
                          }}
                          className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                          style={{}}
                        >
                          <span className={`${tabsForEstimationsModal === 2 ? "text-black" : "text-grey"} ${tabsForEstimationsModal === 2 && "fw-bold"}`}>{"Notes"}</span>
                          {tabsForEstimationsModal === 2 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                        </div>

                        <div
                          onClick={() => {
                            setTabsForEstimationsModal(3);
                            onLoadData();
                          }}
                          className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                          style={{}}
                        >
                          {/* Pro connection with own customers flow changes condition removed -> (serviceRequestFlagPro != 1)) */}
                          {/* <span className={`${userProfileTab === 3 ? "text-black" : "text-grey"} ${userProfileTab === 3 && "fw-bold"}`}>{`Payments ${((permissionArray.includes("UPDATE WORK INFORMATION") || (role == 4)) && (serviceRequestFlagPro != 1)) ? "and Payouts" : ""} `}</span> */}
                          <span className={`${tabsForEstimationsModal === 3 ? "text-black" : "text-grey"} ${tabsForEstimationsModal === 3 && "fw-bold"}`}>{`List`}</span>
                          {tabsForEstimationsModal === 3 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                        </div>

                        <div
                          onClick={() => {
                            setTabsForEstimationsModal(4)
                            if (productType !== "" && brandName !== "" && (sourcingManualsArr?.length == 0 && sourcingInfoArr?.length == 0 && supportsArr?.length == 0 && sourcingShoppingArr?.length == 0)) {
                              handleSourcingInfoFn()
                            }
                          }}
                          className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                          style={{}}
                        >
                          <span className={`${tabsForEstimationsModal === 4 ? "text-black" : "text-grey"} ${tabsForEstimationsModal === 4 && "fw-bold"}`}>{"Parts & Manuals"}</span>
                          {tabsForEstimationsModal === 4 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                        </div>

                      </div>
                    </div>
                    {/* Info */}
                    {tabsForEstimationsModal == 1 ? <>
                      <div
                        className="overflow-auto"
                        style={{
                          maxHeight: "400px",
                        }}
                      >
                        <div className=" mb-3">
                          <div>
                            <span className="text-black font-w600">{`Attachment : `}</span>
                            {/* {serviceDetailsObj?.attachment_data?.length < 0 && <span className="font-w500">{`No attachment found`}</span>} */}
                          </div>

                          {/* New attachments */}
                          {/* Image attachments comes here */}
                          <div
                            className="w-100 position-relative d-flex align-items-center justify-content-center"
                            style={{
                              background: "#AAA",
                              // borderRadius: "15px 0 0 15px",
                              height: "250px",
                              maxHeight: "250px",
                            }}
                          >

                            {serviceDetailsObj?.attachment_data?.length > 0 &&
                              <div
                                className="align-items-center bg-black d-flex fs-7 justify-content-center position-absolute px-3 py-2 w-100"
                                style={{ bottom: "0px", left: "50%", transform: "translateX(-50%)", background: 'rgba(244, 248, 255, 1)', zIndex: 1 }}
                              >
                                {/* New image pagination */}
                                <div className="border rounded d-flex " style={{ height: '33px' }}>
                                  <div
                                    onClick={() => {
                                      handlePrevAttachImg()
                                    }}
                                    className="d-flex justify-content-center align-items-center cursor-pointer border-end text-hovered overlay-action-btn fs-5 text-black"
                                    style={{
                                      width: '30px',
                                      pointerEvents: attachImageIndex === 0 ? 'none' : 'auto',
                                      opacity: attachImageIndex === 0 ? '0.5' : '1'
                                    }}
                                  >
                                    <i class="bi bi-chevron-left"></i>
                                  </div>
                                  <div className="d-flex justify-content-center align-items-center" style={{ width: '50px' }}>
                                    <span className="fs-5 font-w600" style={{ color: '#FF8934' }}>{`${attachImageIndex + 1}`}</span> &nbsp;{`/`}&nbsp;
                                    <span className="fs-5 font-w600">{`${serviceDetailsObj?.attachment_data?.length}`}</span>
                                  </div>
                                  <div
                                    onClick={() => {
                                      handleNextAttachImg()
                                    }}
                                    className="d-flex justify-content-center align-items-center border-start cursor-pointer text-hovered overlay-action-btn fs-5 text-black"
                                    style={{
                                      width: '30px',
                                      pointerEvents: (attachImageIndex >= serviceDetailsObj?.attachment_data?.length - 1) ? 'none' : 'auto',
                                      opacity: (attachImageIndex >= serviceDetailsObj?.attachment_data?.length - 1) ? '0.5' : '1'
                                    }}
                                  >
                                    <i class="bi bi-chevron-right"></i>
                                  </div>
                                </div>



                                <div className="d-flex align-items-center justify-content-center ps-2">
                                  <span className="fs-6 font-w600 pe-1">{`Zoom`}</span>
                                  <input
                                    className=""
                                    type="range"
                                    min="1"
                                    max="3"
                                    value={scale}
                                    step="0.1"
                                    onChange={handleZoomChange}
                                    style={{
                                      width: '80px',
                                      margin: '20px 0',
                                      cursor: 'pointer',
                                      background: 'linear-gradient(to right, #ddd 0%, #ddd 100%)',
                                      borderRadius: '5px',
                                      height: '4px',
                                      outline: 'none',
                                      opacity: '0.7',
                                      transition: 'opacity 0.2s',
                                    }}
                                  />
                                  {(scale !== 1 || position.x !== 0 || position.y !== 0) &&
                                    <div className=' ms-2'>
                                      <div className="tooltipCustom">
                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Reset photo"}</span>
                                        <i
                                          class="bi bi-arrow-clockwise fs-4 text-black text-hovered cursor-pointer"
                                          onClick={() => {
                                            handleResetImage();
                                          }}
                                        ></i>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }

                            {/* {isLoadingImg &&
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                  }}
                                >
                                  <Spinner animation="border" size="lg" style={{}} />
                                </div>
                              } */}

                            {serviceDetailsObj?.attachment_data?.length > 0 ? (
                              <div
                                // ref={imageRef}
                                className="align-items-center border-end d-flex  justify-content-center w-100"
                              >
                                {isLoadingImg &&
                                  <div
                                    className="d-flex align-items-center justify-content-center w-100"
                                    style={{
                                      maxWidth: `250px`,
                                      maxHeight: `250px`,
                                      // minWidth: `${imgMaxWidth}px`,
                                      // minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  >
                                    <Spinner animation="border" size="lg" style={{}} />
                                  </div>
                                }
                                <div
                                  className="overflow-hidden w-100"
                                  style={{ cursor: dragging ? 'grabbing' : 'grab' }}
                                  onMouseMove={handleDragging}
                                  onMouseLeave={handleDragEnd}
                                  onMouseUp={handleDragEnd}
                                  onTouchMove={handleDragging}
                                  onTouchEnd={handleDragEnd}
                                >
                                  <img
                                    src={serviceDetailsObj?.attachment_data[attachImageIndex]?.url}
                                    alt=""
                                    className=""
                                    onLoad={handleImageLoaded}
                                    onError={handleImageError}
                                    onMouseDown={handleDragStart}
                                    onTouchStart={handleDragStart}
                                    style={{
                                      maxWidth: `100%`,
                                      maxHeight: `250px`,
                                      minWidth: `100%`,
                                      minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                                      width: "100%",
                                      height: "250px",
                                      objectFit: "contain",
                                      // borderRadius: "15px 0 0 15px",
                                      transition: 'transform 0.25s ease',
                                      transformOrigin: 'center',
                                      transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                                      cursor: dragging ? 'grabbing' : 'grab',
                                      display: isLoadingImg ? 'none' : 'block'
                                    }}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div
                                className="fs-1 text-white border-end d-flex  justify-content-center align-items-center"
                                style={{
                                  maxWidth: `100%`,
                                  maxHeight: `250px`,
                                  minWidth: `100%`,
                                  minHeight: '250px',
                                  width: "100%",
                                  height: "100%",
                                }}
                              >
                                <i class="bi bi-file-image-fill"></i>
                              </div>
                            )}
                          </div>

                        </div>

                        <div className="mb-2">
                          <span className="text-black font-w600">{`Problem description : `}</span>
                          <span className="font-w500">{`${serviceDetailsObj?.problem_description_chr || 'No description found'}`}</span>
                        </div>
                        <div className="mb-2">
                          <span className="text-black font-w600">{`Summary : `}</span>
                          <span className="font-w500">{`${serviceSummaryMetaData?.recognized_image_summary || 'No summary found'}`}</span>
                        </div>

                        <div className="mb-2">
                          <span className="text-black font-w600">{`Created on : `}</span>
                          <span className="font-w500">
                            {`${serviceDetailsObj?.created_date_dtm ?
                              new Intl.DateTimeFormat("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: true
                              }).format(
                                serviceDetailsObj?.created_date_dtm * 1000
                              ) : '-'}`}
                          </span>
                        </div>
                      </div>
                    </> :
                      // Notes
                      tabsForEstimationsModal == 2 ?
                        <>
                          <div
                            className="col-12 overflow-auto"
                            style={{
                              maxHeight: "400px",
                            }}
                          >
                            {callNoteDetailsArr.length === 0 && (
                              <div className="row mt-4">
                                {/* <span className="fs-7  ">
                                    No notes added yet
                                  </span> */}

                                <div className="mb-3 d-flex justify-content-center align-items-center flex-column">
                                  <div className="mb-2">
                                    <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                  </div>
                                  <span>
                                    {`No notes added yet`}
                                  </span>
                                </div>
                              </div>
                            )}

                            {callNoteDetailsArr?.map((element, index) => (
                              <div
                                className="mb-3 pb-2"
                                style={{ borderBottom: "1px solid gray" }}
                              >
                                <div className="row mx-0">
                                  <div className="col-12 px-0 d-flex justify-content-between">
                                    <div className="d-flex justify-content-center align-items-center">
                                      <div className="pe-3">
                                        <img src={element?.preferred_profile_picture_url} className="rounded-2" style={{ width: "40px", height: "40px" }} alt="" />
                                      </div>

                                      <div className="d-flex flex-column">
                                        <div>
                                          <span className="text-black font-w600">{`${element?.created_by_name}`}</span>
                                        </div>

                                        <div>
                                          <span>
                                            {new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.created_date_dtm * 1000
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    {/* {localStorage.getItem("user_id") &&
                                      <div>
                                        <OverlayTrigger
                                          key={index}
                                          trigger="click"
                                          placement="bottom"
                                          // overlay={popover}
                                          overlay={popoverNoteActions(index)}
                                          rootClose={true}
                                          show={activePopoverNotes === index}
                                          onToggle={(show) =>
                                            setActivePopoverNotes(
                                              show ? index : null
                                            )
                                          }>
                                          <span
                                            style={{ position: "relative" }}>
                                            <LuMoreVertical
                                              className="pointer"
                                              onClick={() => {
                                                handleMenuClickNotes(
                                                  element,
                                                  index
                                                );
                                              }}
                                              style={{ color: "black" }}
                                            />
                                          </span>
                                        </OverlayTrigger>
                                      </div>
                                    } */}
                                  </div>

                                  <div className="col-12 mt-3">
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: element?.note_chr,
                                      }}
                                    />
                                  </div>

                                  <div className='col-12 mt-2 d-flex overflow-auto'>
                                    {element?.attachment_url?.length > 0 &&
                                      <>
                                        {element?.attachment_url?.map((item, i) => {
                                          return (
                                            <div key={i}>
                                              <img
                                                className="me-2 mb-2 rounded-3 cursor-pointer border"
                                                src={item}
                                                alt=""
                                                style={{ width: '50px', height: '60px' }}
                                                onClick={() => {
                                                  handleOpenDoc();
                                                  setImageAttachURL(item);
                                                  element?.note_chr && setNotesMessage(element?.note_chr);
                                                }}
                                              />
                                            </div>
                                          )
                                        })}
                                      </>
                                    }
                                  </div>

                                </div>
                              </div>
                            ))}
                          </div>
                        </> :
                        // Shopping List
                        tabsForEstimationsModal == 3 ?
                          <>
                            <div
                              className="col-12 overflow-auto"
                              style={{
                                height: "400px",
                              }}
                            >
                              {/* <div className="row mt-4">
                              <span className="fs-7  ">
                                No shopping items added yet
                              </span>
                            </div> */}
                              <div
                                className="row mt-2 pb-2"
                                style={{
                                  borderBottom: "1px solid darkgrey",
                                }}
                              >
                                <div className="col-12 px-0 d-flex align-items-center justify-content-between">
                                  <div>
                                    <span>{`Added : `}</span>
                                    <span className='font-w600 text-black'>{` ${rows.length} items`}</span>
                                  </div>

                                  <div>
                                    <span>{`Total cost : `}</span>
                                    <span className='font-w600 text-black'>
                                      {USDollar.format(
                                        parseFloat(totalCost.toFixed(2))
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>


                              {rows.length > 0 ?
                                <>
                                  {rows?.map((element, index) => {
                                    return (
                                      <div
                                        className="row mt-4 pb-2 border-bottom"
                                        style={{
                                          pointerEvents: purchaseLoading ? 'none' : 'auto',
                                          opacity: purchaseLoading ? '0.5' : '1',
                                        }}
                                      >
                                        <div
                                          className="col-12 p-2 d-flex bg-white-hovered rounded-2"
                                        // onClick={(e) => {
                                        //   e?.preventDefault();
                                        //   handleViewPurchaseItemDesktop(element, 5);
                                        // }}
                                        >

                                          {/* <div className='pe-3 d-flex justify-content-center'>
                                            <div>
                                              {
                                                <div className='rounded-2 shadow-lg'>
                                                  <div
                                                    className='rounded-2 d-flex justify-content-center align-items-center'
                                                    style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                  >
                                                    <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          </div> */}
                                          <div className="w-100">
                                            <div className="row mx-0">
                                              <div className="col-6 d-flex justify-content-start align-items-center">
                                                <span className="fs-7">
                                                  <span className='pe-2'>{index + 1}.</span>
                                                  <span className="text-black font-w600">{element?.item_name_chr}</span>
                                                </span>
                                              </div>

                                              <div className="col-6 d-flex justify-content-end align-items-center">
                                                <span
                                                  className="fs-7 text-black font-w600"
                                                  style={{}}>
                                                  ({element?.quantity_int}) X{" "}
                                                  {USDollar.format(
                                                    element?.estimated_price_float /
                                                    element?.quantity_int
                                                  )}{" "}
                                                  &nbsp; &nbsp;{" "}
                                                  {/* <OverlayTrigger
                                                    key={index}
                                                    trigger="click"
                                                    placement="bottom"
                                                    // overlay={popover}
                                                    overlay={popoverShoppingActions(
                                                      index
                                                    )}
                                                    rootClose={true}
                                                    show={
                                                      activePopoverShopping === index
                                                    }
                                                    onToggle={(show) =>
                                                      setActivePopoverShopping(
                                                        show ? index : null
                                                      )
                                                    }
                                                  >
                                                    <span style={{}}>
                                                      <LuMoreVertical
                                                        className="cursor-pointer text-black"
                                                        onClick={(e) => {
                                                          e?.preventDefault();
                                                          e.stopPropagation();
                                                          handleMenuClickShopping(
                                                            element,
                                                            index
                                                          );
                                                        }}
                                                      />
                                                    </span>
                                                  </OverlayTrigger> */}
                                                </span>
                                              </div>
                                            </div>

                                            <div className="row mx-0  mt-2">
                                              <span className="fs-7">
                                                {element?.description_chr}
                                              </span>
                                            </div>

                                            {element?.purchase_link_chr != "" && (
                                              <div className="row mx-0  mt-2" ref={shoppingItemLinkWidthRef}>
                                                <div className="col-12 d-flex justify-content-start align-items-center">
                                                  {urlPattern.test(element?.purchase_link_chr) ?
                                                    <>
                                                      <div className="d-flex align-items-center">
                                                        <span className="text-black font-w600 fs-7 me-2">{`Website: `}</span>
                                                        <a
                                                          className="text-black text-hovered text-decoration-underline"
                                                          href={
                                                            // element?.purchase_link_chr
                                                            element?.purchase_link_chr && !element?.purchase_link_chr.startsWith('http')
                                                              ? `https://${element?.purchase_link_chr}`
                                                              : element?.purchase_link_chr
                                                          }
                                                          target="_blank"
                                                          rel="noreferrer"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                          }}
                                                        >
                                                          <span
                                                            className="fs-7 cursor-pointer text-truncate d-flex"
                                                            // style={{ maxWidth: `calc(${shoppingItemLinkWidth}px - 80px)` }}
                                                            style={{ maxWidth: `180px` }}
                                                          // onClick={() => {
                                                          //   navigator.clipboard.writeText(
                                                          //     `${element?.purchase_link_chr}`
                                                          //   );
                                                          //   copyToClipboard();
                                                          // }}
                                                          >
                                                            {`${element?.purchase_link_chr}`}
                                                            {/* <FaArrowRightLong />{" "} */}
                                                          </span>
                                                        </a>
                                                        <span >{`...`}</span>
                                                      </div>
                                                    </> :
                                                    <div>
                                                      <span className="text-black font-w600 fs-7 me-2">{`Location: `}</span>
                                                      <span
                                                        className="fs-7 text-black"
                                                      >
                                                        {element?.purchase_link_chr}
                                                      </span>
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                            )}

                                            {
                                              <div className="row mx-0  mt-2">
                                                <div className={`col-12 d-flex fs-7 font-w600 `}>
                                                  <div className="d-flex align-items-center justify-content-between w-100">
                                                    <div
                                                      className="me-4 d-flex align-items-center"
                                                      style={{
                                                        pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                        opacity: purchaseLoading ? '0.5' : '1'
                                                      }}
                                                    >
                                                      <span
                                                        className="me-2"
                                                      >
                                                        {purchaseLoading && (element?.item_id_ids === shoppingItemId) ?
                                                          <Spinner animation="border" size="sm" /> :
                                                          <input
                                                            type="checkbox"
                                                            checked={element?.is_purchased_ysn}
                                                            className="form-check-input"
                                                            id="customCheckBox4"
                                                            onChange={(e) => {
                                                              e?.preventDefault();
                                                              e.stopPropagation();

                                                              handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                              setShoppingItemId(element?.item_id_ids)
                                                            }}
                                                            onClick={(e) => {
                                                              e?.preventDefault();
                                                              e.stopPropagation();

                                                              handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                              setShoppingItemId(element?.item_id_ids)
                                                            }}
                                                          />
                                                        }
                                                      </span>
                                                      <span
                                                        className="pt-1 cursor-pointer text-hovered"
                                                        onClick={(e) => {
                                                          e?.preventDefault();
                                                          e?.stopPropagation();

                                                          handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                          setShoppingItemId(element?.item_id_ids)
                                                        }}
                                                      >
                                                        {`Item Acquired`}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            }

                                            <div className="row mx-0  mt-2">
                                              <div className='col-12 px-0 d-flex justify-content-end'>
                                                {element?.is_purchased_ysn ?
                                                  <span className='font-w600 fs-7 text-success'>{`Purchased`}</span> :
                                                  <span className='font-w600 fs-7'>{`Not purchased yet`}</span>
                                                }
                                              </div>
                                            </div>


                                          </div>

                                        </div>

                                      </div>
                                    );
                                  })}
                                </> :
                                <>
                                  <div className="mb-3 mt-4 d-flex justify-content-center align-items-center flex-column">
                                    <div className="mb-2">
                                      <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                    </div>
                                    <span>
                                      {`No items added yet`}
                                    </span>
                                  </div>
                                </>
                              }

                            </div>
                          </> :
                          // Parts and Manuals
                          tabsForEstimationsModal == 4 ?
                            <>
                              {/* Navigation Menu for Parts and Manuals */}
                              <div className="row mx-0 bg-white">
                                <div className="col-12 px-0 position-relative">
                                  {/* Left Scroll Button */}
                                  {canScrollLeft && false && (
                                    <span
                                      className="scroll-btn-left position-absolute cursor-pointer text-hovere text-white shadow d-flex align-items-center justify-content-center"
                                      style={{
                                        left: 0,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        zIndex: '1',
                                        height: '35px',
                                        width: '26px',
                                        borderRadius: '0 50% 50% 0',
                                        background: 'gray'
                                      }}
                                      onClick={(e) => {
                                        e?.stopPropagation();
                                        scrollLeft()
                                      }}
                                    >
                                      <FaChevronLeft />
                                    </span>
                                  )}

                                  {/* Right Scroll Button */}
                                  {canScrollRight && false && (
                                    <span
                                      className="scroll-btn-right position-absolute cursor-pointer text-hovered text-white shadow d-flex align-items-center justify-content-center"
                                      style={{
                                        right: 0,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        zIndex: '1',
                                        height: '35px',
                                        width: '26px',
                                        borderRadius: '50% 0 0 50%',
                                        background: 'gray'
                                      }}
                                      onClick={(e) => {
                                        e?.stopPropagation();
                                        scrollRight()
                                      }}
                                    >
                                      <FaChevronRight />
                                    </span>
                                  )}


                                  {/* Navigations */}
                                  <div
                                    ref={navRef}
                                    className='border-bottom overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                                    style={{ scrollBehavior: 'smooth', display: 'flex' }}
                                  >
                                    <div className='col-12 d-flex px-0 fs-5 font-w500'>
                                      <div
                                        onClick={() => {
                                          // handleSourcingInfoFn(1);
                                          setTabsPartsManuals('1');
                                        }}
                                        className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative`}
                                        style={{}}
                                      >
                                        <div
                                          className={`${tabsPartsManuals === '1' ? "text-black" : "text-grey"} ${tabsPartsManuals === '1' && "fw-bold"} d-flex align-items-center justify-content-center flex-column`}
                                        >
                                          <span className={``}>{`Manuals`}</span>
                                          {/* <span className={``}>{`manual`}</span> */}
                                        </div>
                                        {/* <span className={`${tabsPartsManuals === 1 ? "text-black" : "text-grey"} ${tabsPartsManuals === 1 && "fw-bold"}`} >{"Owners manual"}</span> */}
                                        {tabsPartsManuals === '1' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}

                                      </div>

                                      <div
                                        onClick={() => {
                                          // handleSourcingInfoFn(0);
                                          setTabsPartsManuals('2');
                                        }}
                                        className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                                        style={{}}
                                      >
                                        <div
                                          className={`${tabsPartsManuals === '2' ? "text-black" : "text-grey"} ${tabsPartsManuals === '2' && "fw-bold"} d-flex align-items-center justify-content-center flex-column`}
                                        >
                                          <span className={``}>{`Parts`}</span>
                                        </div>
                                        {/* <span className={`${tabsPartsManuals === 2 ? "text-black" : "text-grey"} ${tabsPartsManuals === 2 && "fw-bold"}`}>{`Parts and tools`}</span> */}
                                        {tabsPartsManuals === '2' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                      </div>

                                      <div
                                        onClick={() => {
                                          // handleSourcingInfoFn(0);
                                          setTabsPartsManuals('3');
                                        }}
                                        className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center p-2 position-relative'
                                        style={{}}
                                      >
                                        <span className={`${tabsPartsManuals === '3' ? "text-black" : "text-grey"} ${tabsPartsManuals === '3' && "fw-bold"} align-self-center`}>{`Replacements`}</span>
                                        {tabsPartsManuals === '3' && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="row mx-0 overflow-auto"
                                style={{ maxHeight: "400px" }}
                              >
                                <div className="col-12 p-2">

                                  {tabsPartsManuals == '2' && productType !== "" && brandName !== "" &&
                                    <div className="row mx-0 mb-3">
                                      <div className="col-12 px-0">

                                        <div className="row mx-0">
                                          <div className="col-12 px-0 d-flex">
                                            <div
                                              onClick={() => {
                                                setSourcingInfoTabs(1)
                                              }}
                                              className={`${sourcingInfoTabs === 1 ? "text-white font-w600 bg-black" : "text-black bg-light overlay-action-btn cursor-pointer"} align-items-center d-flex justify-content-center me-2 rounded p-2 `}
                                              style={{ minWidth: '50px' }}
                                            >
                                              <span>{`All`}</span>
                                            </div>

                                            <div
                                              onClick={() => {
                                                setSourcingInfoTabs(2)
                                              }}
                                              className={`${sourcingInfoTabs === 2 ? "text-white font-w600 bg-black" : "text-black bg-light overlay-action-btn cursor-pointer"} align-items-center d-flex justify-content-center me-2 rounded p-2 `}
                                              style={{ minWidth: '50px' }}
                                            >
                                              <span>{`Supports`}</span>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  }

                                  <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">

                                      <div className="w-100">
                                        {sourcingInfoLoading ? <div>
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                          <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                                        </div> :
                                          <>
                                            {tabsPartsManuals == '1' ?
                                              <>
                                                {sourcingManualsArr?.length > 0 ?
                                                  <>
                                                    {sourcingManualsArr?.map((item, index) => {
                                                      return (
                                                        <>
                                                          <a target="_blank" href={item?.url} rel="noreferrer">
                                                            <div className="mx-0 row mb-2">
                                                              <div
                                                                className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                style={{
                                                                  background: "rgba(244, 248, 255, 1)",
                                                                  border: "1px solid rgba(199, 212, 234, 1)",
                                                                }}
                                                              >
                                                                <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                  <div className="d-flex">
                                                                    <div
                                                                      className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                      style={{ width: "30px", height: "30px" }}
                                                                    >
                                                                      <img
                                                                        src={item?.image}
                                                                        style={{ width: "30px", height: "30px" }}
                                                                        className="rounded-3"
                                                                        alt=""
                                                                      />
                                                                    </div>

                                                                    {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                    <div className="d-flex flex-column">
                                                                      <span className="fs-6 text-black">
                                                                        {`${item?.name}`}
                                                                      </span>
                                                                      <span className="fs-7">
                                                                        {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                      </span>
                                                                    </div>

                                                                  </div>

                                                                  <div>
                                                                    <i className="bi bi-chevron-right" />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </a>
                                                        </>
                                                      )
                                                    })}
                                                  </> :
                                                  <>
                                                    <div>
                                                      <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                        <div className="mb-2">
                                                          <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                        </div>
                                                        <span>
                                                          {`No record found`}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </>
                                                }
                                              </> :
                                              tabsPartsManuals == '2' ?
                                                <>
                                                  {sourcingInfoTabs == 1 ?
                                                    <>
                                                      {sourcingInfoArr?.length > 0 ?
                                                        <>
                                                          {sourcingInfoArr?.map((item, index) => {
                                                            return (
                                                              <>
                                                                <a target="_blank" href={item?.url} rel="noreferrer">
                                                                  <div className="mx-0 row mb-2">
                                                                    <div
                                                                      className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                      style={{
                                                                        background: "rgba(244, 248, 255, 1)",
                                                                        border: "1px solid rgba(199, 212, 234, 1)",
                                                                      }}
                                                                    >
                                                                      <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                        <div className="d-flex">
                                                                          <div
                                                                            className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                            style={{ width: "30px", height: "30px" }}
                                                                          >
                                                                            <img
                                                                              src={item?.image}
                                                                              style={{ width: "30px", height: "30px" }}
                                                                              className="rounded-3"
                                                                              alt=""
                                                                            />
                                                                          </div>

                                                                          {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                          <div className="d-flex flex-column">
                                                                            <span className="fs-6 text-black">
                                                                              {`${item?.name}`}
                                                                            </span>
                                                                            <span className="fs-7">
                                                                              {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                            </span>
                                                                          </div>

                                                                        </div>

                                                                        <div>
                                                                          <i className="bi bi-chevron-right" />
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </a>
                                                              </>
                                                            )
                                                          })}
                                                        </> :
                                                        <>
                                                          <div>
                                                            <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                              <div className="mb-2">
                                                                <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                              </div>
                                                              <span>
                                                                {`No record found`}
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </>
                                                      }
                                                    </> :
                                                    sourcingInfoTabs == 2 ?
                                                      <>
                                                        {supportsArr?.length > 0 ?
                                                          <>
                                                            {supportsArr?.map((item, index) => {
                                                              return (
                                                                <>
                                                                  <a target="_blank" href={item?.url} rel="noreferrer">
                                                                    <div className="mx-0 row mb-2">
                                                                      <div
                                                                        className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                        style={{
                                                                          background: "rgba(244, 248, 255, 1)",
                                                                          border: "1px solid rgba(199, 212, 234, 1)",
                                                                        }}
                                                                      >
                                                                        <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                          <div className="d-flex">
                                                                            <div
                                                                              className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                              style={{ width: "30px", height: "30px" }}
                                                                            >
                                                                              <img
                                                                                src={item?.image}
                                                                                style={{ width: "30px", height: "30px" }}
                                                                                className="rounded-3"
                                                                                alt=""
                                                                              />
                                                                            </div>

                                                                            {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                            <div className="d-flex flex-column">
                                                                              <span className="fs-6 text-black">
                                                                                {`${item?.name}`}
                                                                              </span>
                                                                              <span className="fs-7">
                                                                                {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                              </span>
                                                                            </div>

                                                                          </div>

                                                                          <div>
                                                                            <i className="bi bi-chevron-right" />
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </a>
                                                                </>
                                                              )
                                                            })}
                                                          </> :
                                                          <>
                                                            <div>
                                                              <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                                <div className="mb-2">
                                                                  <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                                </div>
                                                                <span>
                                                                  {`No record found`}
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </>
                                                        }
                                                      </> : <></>
                                                  }
                                                </> :
                                                tabsPartsManuals == '3' ?
                                                  <>
                                                    {sourcingShoppingArr?.length > 0 ?
                                                      <>
                                                        {sourcingShoppingArr?.map((item, index) => {
                                                          return (
                                                            <>
                                                              <a target="_blank" href={item?.url} rel="noreferrer">
                                                                <div className="mx-0 row mb-2">
                                                                  <div
                                                                    className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                                                    style={{
                                                                      background: "rgba(244, 248, 255, 1)",
                                                                      border: "1px solid rgba(199, 212, 234, 1)",
                                                                    }}
                                                                  >
                                                                    <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                                      <div className="d-flex">
                                                                        <div
                                                                          className="d-flex align-items-center justify-content-center rounded-3 me-2"
                                                                          style={{ width: "30px", height: "30px" }}
                                                                        >
                                                                          <img
                                                                            src={item?.image}
                                                                            style={{ width: "30px", height: "30px" }}
                                                                            className="rounded-3"
                                                                            alt=""
                                                                          />
                                                                        </div>

                                                                        {/* <i className="bi bi-filetype-pdf pe-2"></i> */}

                                                                        <div className="d-flex flex-column">
                                                                          <span className="fs-6 text-black">
                                                                            {`${item?.name}`}
                                                                          </span>
                                                                          <span className="fs-7">
                                                                            {`Description: ${item?.snippet ? item?.snippet : "-"}`}
                                                                          </span>
                                                                        </div>

                                                                      </div>

                                                                      <div>
                                                                        <i className="bi bi-chevron-right" />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </a>
                                                            </>
                                                          )
                                                        })}
                                                      </> :
                                                      <>
                                                        <div>
                                                          <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                                            <div className="mb-2">
                                                              <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                            </div>
                                                            <span>
                                                              {`No record found`}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </>
                                                    }
                                                  </>
                                                  : <></>
                                            }


                                          </>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </> : <></>
                    }

                  </div>

                  <div className="col-md-6 ps-md-3">
                    <form
                      onSubmit={(e) => {
                        handleUpdateTicketSummary(e)
                      }}
                      className="mt-1"
                    >
                      <div className='row mb-4'>
                        <div className='col-12 px-0'>
                          <div className="row mx-0">
                            <div className="row">
                              <div className="col-12 px-0">
                                <TextArea
                                  labelName={"Diagnosis *"}
                                  placeholderName={"Diagnosis"}
                                  value={`${proDiagnosis}`}
                                  onChange={(e) => { handleProDiagnosis(e) }}
                                  onBlur={() => { }}
                                  errorOccured={proDiagnosisErr}
                                  errorMessage={"Please add Diagnosis"}
                                  isRequired={true}
                                  rows={3}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 px-0 mb-2">
                                <span className="fs-5 text-black font-w500">{`Estimated Cost Range`}</span>
                              </div>

                              <div className="row">
                                <div className="col-6 px-0 pe-2">
                                  <InputField
                                    labelName={"Low ($)"}
                                    placeholderName={"Low ($)"}
                                    value={`${proEstimatedCostMin}`}
                                    onChange={(e) => { handleProEstimatedCostMin(e) }}
                                    onBlur={() => { }}
                                    errorOccured={false}
                                    errorMeesage={"Please add Labor"}
                                  />
                                </div>
                                <div className="col-6 px-0 ps-2">
                                  <InputField
                                    labelName={"High ($)"}
                                    placeholderName={"High ($)"}
                                    value={`${proEstimatedCostMax}`}
                                    onChange={(e) => { handleProEstimatedCostMax(e) }}
                                    onBlur={() => { }}
                                    errorOccured={false}
                                    errorMeesage={"Please add Labor"}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 px-0 mb-3">
                                <span className="fs-5 text-black font-w500">{`Solution recommendation`}</span>
                              </div>

                              <div className="row">
                                <div
                                  className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                  onClick={() => {
                                    setProRecommendedSolution(1);
                                  }}
                                  style={{
                                    border: proRecommendedSolution == 1 ? "2px solid orange" : "2px solid lightgray",
                                    background: proRecommendedSolution == 1 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                    color: proRecommendedSolution == 1 ? "white" : "black",
                                  }}
                                >
                                  <span className="fs-5 font-w600 text-center">{`DIY with Chilll Toolbox`}</span>
                                  <span className="fs-6 text-center">{`Free`}</span>
                                </div>

                                <div
                                  className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                  onClick={() => {
                                    setProRecommendedSolution(2);
                                  }}
                                  style={{
                                    border: proRecommendedSolution == 2 ? "2px solid orange" : "2px solid lightgray",
                                    background: proRecommendedSolution == 2 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                    color: proRecommendedSolution == 2 ? "white" : "black",
                                  }}
                                >
                                  <span className="fs-5 font-w600 text-center">{`DIY with Remote Pro`}</span>
                                  <span className="fs-6 text-center">
                                    {`${USDollar.format(
                                      parseFloat(callChargeAmount?.toFixed(2))
                                    )} for ${callDurationTimeLimit} minutes`}
                                  </span>
                                </div>

                                <div
                                  className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
                                  onClick={() => {
                                    setProRecommendedSolution(3);
                                  }}
                                  style={{
                                    border: proRecommendedSolution == 3 ? "2px solid orange" : "2px solid lightgray",
                                    background: proRecommendedSolution == 3 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
                                    color: proRecommendedSolution == 3 ? "white" : "black",
                                  }}
                                >
                                  <span className="fs-5 font-w600 text-center">{`Get Local Pro`}</span>
                                  <span className="fs-6 text-center">{`Free matching on your terms`}</span>
                                </div>
                              </div>

                              {proRecommendedSolutionErr &&
                                <div>
                                  <span className="text-danger font-w500 fs-12">{`Please select one of the above options`}</span>
                                </div>
                              }
                            </div>



                          </div>
                        </div>
                      </div>

                      <div className='row mx-0 mt-2'>
                        <div className='col-12 px-0'>
                          <PrimaryButton
                            onClick={(e) => {
                              handleUpdateTicketSummary(e);
                            }}
                            buttonName={"SUBMIT"}
                            type="submit"
                            loadingMessage="SUBMITTING..."
                            isLoading={updateTicketSummaryLoading}
                            style={{
                              width: "100%",
                              background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                              boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                              border: '1px solid rgba(255, 154, 32, 1)',
                              fontWeight: '600',
                            }}
                          />
                        </div>
                      </div>

                    </form>
                  </div>
                </div>
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal >

      {/* Modal for shopping list starts */}
      {/* <!-- Modal --> */}
      <Modal
        className="fade"
        show={purchaseListTrigger}
        // onHide={handleClose}
        centered>
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <div className="row mx-0">
                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                  <span
                    onClick={() => handleClosePurchaseList()}
                    className="cursor-pointer">
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <div className="row mx-0 mb-3">
                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                  <span className="">
                    {toggleForPurchase === 1
                      ? "Add Shopping Item"
                      : toggleForPurchase === 2
                        ? "Edit Shopping Item"
                        : toggleForPurchase === 3
                          ? "Share Shopping List"
                          : toggleForPurchase === 4
                            ? "Are you sure to delete shopping item"
                            : toggleForPurchase === 5
                              ? "Shopping item details" : ""}
                  </span>
                </div>
              </div>

              {toggleForPurchase === 1 || toggleForPurchase === 2 ? (
                <>
                  <div className="row mx-0">
                    <div className="col-12 px-0">
                      <InputField
                        labelName={"Item Name"}
                        placeholderName={"Item Name"}
                        value={itemName}
                        onChange={handleItemName}
                        onBlur={handleItemNameBlurCheck}
                        errorOccured={itemNameErr}
                        errorMeesage={"Please add item name"}
                      />
                    </div>
                  </div>

                  <div className="row mx-0">
                    <div className="col-md-6 px-0 pe-md-2">
                      <InputField
                        labelName={"Quantity"}
                        placeholderName={"Quantity"}
                        value={quantity ? `${quantity}` : ""}
                        onChange={handleQuantity}
                      // onBlur={handleQuantityBlurCheck}
                      // errorOccured={quantityErr}
                      // errorMeesage={"Please add quantity"}
                      />
                    </div>

                    <div className="col-md-6 px-0 ps-md-2">
                      <InputField
                        labelName={"Cost Per Item"}
                        placeholderName={"Cost Per Item"}
                        value={totalEstimatedCost ? totalEstimatedCost : ""}
                        onChange={handleTotalEstimatedCost}
                      // onBlur={handleTotalEstimatedCostBlurCheck}
                      // errorOccured={totalEstimatedCostErr}
                      // errorMeesage={"Please add total estimated cost"}
                      />
                    </div>
                  </div>

                  {/* <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                labelName={"Cost Per Item"}
                                                placeholderName={"Cost Per Item"}
                                                value={totalEstimatedCost ? `${totalEstimatedCost}` : ''}
                                                onChange={handleTotalEstimatedCost}
                                            // onBlur={handleTotalEstimatedCostBlurCheck}
                                            // errorOccured={totalEstimatedCostErr}
                                            // errorMeesage={"Please add total estimated cost"}
                                            />
                                        </div>
                                    </div> */}

                  <div className="row mx-0">
                    <div className="col-12 px-0">
                      <InputField
                        labelName={"Website or Location"}
                        placeholderName={"Website or Location"}
                        value={purchaseLink}
                        onChange={handlePurchaseLink}
                      // onBlur={handlePurchaseLinkBlurCheck}
                      // errorOccured={purchaseLinkErr}
                      // errorMeesage={"Please add purchase link"}
                      />
                    </div>
                  </div>

                  <div className="row mx-0">
                    <div className="col-12 px-0">
                      <TextArea
                        labelName={"Item Description"}
                        placeholder={"Item Description"}
                        value={itemDescription}
                        onChange={handleDescription}
                      // onBlur={handleDescriptionBlurCheck}
                      // errorOccured={itemDescriptionErr}
                      // errorMessage={'Please add description'}
                      />
                    </div>
                  </div>

                  <div className="row mx-0 mb-3">
                    <div className="col-12 px-0">
                      <span>{"Total Estimated Cost : "}</span>
                      <span className="fw-bold">
                        ${(quantity * totalEstimatedCost).toFixed(2)}
                      </span>
                    </div>
                  </div>

                  {toggleForPurchase === 1 && (
                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        <PrimaryButton
                          buttonName={"Submit"}
                          onClick={(e) => handleSubmitPurchase(e)}
                          loadingMessage={"Loading..."}
                          isLoading={purchaseLoading}
                          style={{ width: "100%", background: "green" }}
                        />
                      </div>
                    </div>
                  )}

                  {toggleForPurchase === 2 && (
                    <div className="row mx-0">
                      <div className="col-12 px-0">
                        <PrimaryButton
                          buttonName={"Submit"}
                          onClick={(e) => handleUpdatePurchase(e)}
                          loadingMessage={"Loading..."}
                          isLoading={purchaseLoading}
                          style={{ width: "100%", background: "green" }}
                        />
                      </div>
                    </div>
                  )}
                </>
              ) : toggleForPurchase === 3 ? (
                <>
                  <div>
                    <div className="row mx-0 ">
                      <div className="col-12 px-0 text-center">
                        <span className="fw-bold fs-5 ">
                          {
                            "You can send all shopping items to the third party to their email or phone number"
                          }
                        </span>
                      </div>
                    </div>
                    <form onSubmit={(e) => handleSendPurchaseList(e)}>
                      <EmailPhoneCombine
                        inputValue={emailPhoneValue}
                        handleChangeCode={handleDropdownValue}
                        handleInputValue={handleEmailPhone}
                        isEnteringNumber={isPhone}
                        errorOccured={isEmailPhoneVal}
                        errorMessage={validEmail_OR_MobileNumberText}
                        handleOnBlur={handleEmailPhoneBlur}
                        defaultCodeValue={codeValue}
                      />

                      <div className="row mx-0">
                        <div className="col-12 px-0">
                          <PrimaryButton
                            buttonName={"Submit"}
                            onClick={(e) => handleSendPurchaseList(e)}
                            loadingMessage={"Loading..."}
                            isLoading={purchaseLoading}
                            style={{ width: "100%", background: "green" }}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              ) : (toggleForPurchase === 4 || toggleForPurchase === 5) ? (
                <>
                  <div className="row mx-0 text-black lh-lg">
                    <div className="col-6 px-0 font-w600">
                      <span>{"Item Name"}</span>
                    </div>
                    <div className="col-6 px-0">
                      <span>{itemName}</span>
                    </div>
                  </div>

                  {quantity && (
                    <div className="row mx-0 text-black lh-lg">
                      <div className="col-6 px-0 font-w600">
                        <span>{"Quantity"}</span>
                      </div>
                      <div className="col-6 px-0">
                        <span>{quantity}</span>
                      </div>
                    </div>
                  )}

                  {totalEstimatedCost && (
                    <div className="row mx-0 text-black lh-lg">
                      <div className="col-6 px-0 font-w600">
                        <span>{"Total Estimated Cost"}</span>
                      </div>
                      <div className="col-6 px-0">
                        <span>{`$ ${totalEstimatedCost.toFixed(2)}`}</span>
                      </div>
                    </div>
                  )}

                  {itemDescription && (
                    <div className="row mx-0 text-black lh-lg">
                      <div className="col-6 px-0 font-w600">
                        <span>{"Item Description"}</span>
                      </div>
                      <div className="col-6 px-0">
                        <span>{itemDescription}</span>
                      </div>
                    </div>
                  )}

                  {purchaseLink && (
                    <div className="row mx-0 text-black lh-lg">
                      <div className="col-6 px-0 font-w600">
                        {urlPattern.test(purchaseLink) ?
                          <span>{"Website"}</span> :
                          <span>{"Location"}</span>
                        }

                      </div>
                      <div className="col-6 px-0 overflow-hidden">
                        {urlPattern.test(purchaseLink) ?
                          <a
                            className="text-black text-hovered text-decoration-underline"
                            href={
                              // purchaseLink
                              purchaseLink && !purchaseLink.startsWith('http')
                                ? `https://${purchaseLink}`
                                : purchaseLink
                            }
                            target="_blank"
                            rel="noreferrer"
                            style={{ wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word' }}
                          >
                            <span>{purchaseLink}</span>
                          </a> :
                          <span>{purchaseLink}</span>
                        }

                      </div>
                    </div>
                  )}

                  {toggleForPurchase === 4 ?
                    <div className="row mx-0 text-black mt-4">
                      <div className="col-sm-6 pe-sm-2 font-w600 mb-2">
                        <PrimaryButton
                          onClick={(e) => handleClosePurchaseList()}
                          buttonName={"NO, GO BACK"}
                          style={{
                            width: "100%",
                            backgroundColor: "white",
                            border: "1px solid grey",
                            color: "black",
                            fontWeight: '600',
                          }}
                        />
                      </div>


                      <div className="col-sm-6 ps-sm-2 font-w600 mb-2">

                        <PrimaryButton
                          onClick={(e) => handleDeletePurchaseList(shoppingItemObject, e)}
                          buttonName={"YES, DELETE IT"}
                          loadingMessage={"DELETING..."}
                          isLoading={purchaseLoading}
                          style={{
                            width: "100%",
                            backgroundColor: "red",
                            border: "none",
                            fontWeight: '600',
                          }}
                        />

                      </div>
                    </div> :
                    toggleForPurchase === 5 ?
                      <>
                        <div className="col-12 font-w600 mt-4">
                          <PrimaryButton
                            onClick={(e) => handleClosePurchaseList()}
                            buttonName={"CLOSE"}
                            style={{
                              width: "100%",
                              backgroundColor: "white",
                              border: "1px solid grey",
                              color: "black",
                              fontWeight: '600',
                            }}
                          />
                        </div>
                      </> : <></>
                  }


                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal for shopping list ends */}

      {/* Modal for delete notes starts */}
      <Modal
        className="fade"
        show={modalTriggerNotes}
        // onHide={handleClose}
        centered>
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <div className="row mx-0">
                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                  <span
                    onClick={() => handleCloseModalNotes()}
                    className="cursor-pointer">
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <div className="row mx-0 mb-3">
                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                  <span className="">{"Delete note"}</span>
                </div>
              </div>

              <div className="row mx-0 mt-3 pb-2">
                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                  <span className="fs-5">
                    {"Are you sure you want to delete this note?"}
                  </span>
                </div>
              </div>

              <div className="row mx-0 text-black mt-2">
                <div className="col-sm-6 pe-sm-2 font-w600 mb-2">
                  <PrimaryButton
                    onClick={(e) => handleCloseModalNotes()}
                    buttonName={"NO, GO BACK"}
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      border: "1px solid grey",
                      color: "black",
                      fontWeight: '600',
                    }}
                  />
                </div>


                <div className="col-sm-6 ps-sm-2 font-w600 mb-2">

                  <PrimaryButton
                    onClick={(e) => handleDeleteNote(noteObject, e)}
                    buttonName={"YES, DELETE IT"}
                    loadingMessage={"DELETING..."}
                    isLoading={saveLoading}
                    style={{
                      width: "100%",
                      backgroundColor: "red",
                      border: "none",
                      fontWeight: '600',
                    }}
                  />

                </div>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal for delete notes ends */}

      {/* Modal for Confirm the scan results starts */}
      <Modal
        className="fade"
        show={confirmScanInfoModal}
        // onHide={handleClose}
        centered>
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <div className="row mx-0">
                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                  <span
                    onClick={() => handleCloseConfirmScanInfoModal()}
                    className="cursor-pointer">
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <div className="row mx-0 mb-3">
                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                  <span className="">{"Confirm details"}</span>
                </div>
              </div>

              <div className="row mx-0 mt-3 pb-2">
                <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                  <span className="fs-5 text-center">
                    {"We've detected the following device information. Please confirm if it's correct before proceeding."}
                  </span>
                </div>
              </div>

              <div className="mb-3">
                {confirmProductType && <div className="row mx-0 text-black lh-lg">
                  <div className="col-6 px-0 font-w600">
                    <span>{"Device type"}</span>
                  </div>
                  <div className="col-6 px-0">
                    <span>{confirmProductType}</span>
                  </div>
                </div>}

                {confirmBrandName && <div className="row mx-0 text-black lh-lg">
                  <div className="col-6 px-0 font-w600">
                    <span>{"Brand"}</span>
                  </div>
                  <div className="col-6 px-0">
                    <span>{confirmBrandName}</span>
                  </div>
                </div>}

                {confirmModelNumber && <div className="row mx-0 text-black lh-lg">
                  <div className="col-6 px-0 font-w600">
                    <span>{"Model number"}</span>
                  </div>
                  <div className="col-6 px-0">
                    <span>{confirmModelNumber}</span>
                  </div>
                </div>}
              </div>



              <div className="row mx-0 text-black mt-2">
                <div className="col-sm-6 pe-sm-2 font-w600 mb-2">
                  <PrimaryButton
                    onClick={(e) => handleCloseConfirmScanInfoModal()}
                    buttonName={"CANCEL"}
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      border: "1px solid grey",
                      color: "black",
                      fontWeight: '600',
                    }}
                  />
                </div>


                <div className="col-sm-6 ps-sm-2 font-w600 mb-2">

                  <PrimaryButton
                    onClick={(e) => { handleConfirmScanInfo(e) }}
                    buttonName={"CONFIRM"}
                    loadingMessage={"DELETING..."}
                    isLoading={false}
                    style={{
                      fontWeight: '600',
                      width: '100%',
                      background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                      border: '1px solid rgba(255, 154, 32, 1)',
                      boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                    }}
                  />

                </div>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal for Confirm the scan results ends */}


      {
        remoteSayMuteMic && (
          <>
            <AcceptRejectModal
              text={"Professional want's to mute you ?"}
              onClickReject={() => {
                setRemoteSayMuteMic(false);
              }}
              onClickAccept={() => {
                handleMicStatus();
                setRemoteSayMuteMic(false);
              }}
              modalStatus={true}
              yesBtnTxt={"Agree"}
              noBtnTxt={"Disagree"}
            />
          </>
        )
      }

      {
        remoteSayUnmuteMic && (
          <>
            <AcceptRejectModal
              text={"Professional want's to Unmute you ?"}
              onClickReject={() => {
                setRemoteSayUnmuteMic(false);
              }}
              onClickAccept={() => {
                handleMicOffStatus();
                setRemoteSayUnmuteMic(false);
              }}
              modalStatus={true}
              yesBtnTxt={"Agree"}
              noBtnTxt={"Disagree"}
            />
          </>
        )
      }

      {
        remoteSayOcr && (
          <>
            <AcceptRejectModal
              text={""}
              onClickReject={() => {
                setRemoteSayOcr(false);
              }}
              onClickAccept={() => {
                setIsLoadingActive(true);
              }}
              modalStatus={true}
              yesBtnTxt={"Agree"}
              noBtnTxt={"Disagree"}
              loadingButtonName={"Gathering the text from your screen"}
              loaderActive={true}
            />
          </>
        )
      }
      {
        messageFromOcr && (
          <>
            <AcceptRejectModal
              text={""}
              onClickReject={() => {
                setRemoteSayOcr(false);
              }}
              onClickAccept={() => {
                setIsLoadingActive(true);
              }}
              modalStatus={true}
              yesBtnTxt={"Agree"}
              noBtnTxt={"Disagree"}
              loadingButtonName={
                permissionArray.includes("CONTROL REMOTE SCREEN ACTIONS")
                  ? "Gathering the text on user's screen"
                  : "Gathering the text from your screen"
              }
              loaderActive={true}
            />
          </>
        )
      }
      {
        ocrResultModal && (
          <>
            <OcrResponseModal
              text={ocrOutput}
              onClickReject={() => {
                if (!drawingArea) {
                  const video = document.getElementById("LP");

                  if (!video) return;
                  video.play();
                }
                setOcrResultModal(false);
                const [localValue] = [
                  ...room.localParticipant.dataTracks.values(),
                ];

                localValue.track.send("stop_ocr");
              }}
              onClickAccept={() => {
                if (!drawingArea) {
                  const video = document.getElementById("LP");

                  if (!video) return;
                  video.play();
                }
                const [localValue] = [
                  ...room.localParticipant.dataTracks.values(),
                ];
                localValue.track.send("notes_attachment");

                localValue.track.send("stop_ocr");

                handleSaveNoteFromOcr();
              }}
              modalStatus={true}
              yesBtnTxt={"SAVE TO NOTES"}
              noBtnTxt={"Cancel"}
              loadingButtonName={"Saving"}
              loaderActive={isLoadingActive}
            />
          </>
        )
      }

      {
        remoteSayFlipCamera && (
          <>
            <AcceptRejectModal
              text={"Professional want's to flip your camera ?"}
              onClickReject={() => {
                setRemoteSayFlipCamera(false);
              }}
              onClickAccept={() => {
                toggleFacingMode();
                setRemoteSayFlipCamera(false);
              }}
              modalStatus={true}
              yesBtnTxt={"Agree"}
              noBtnTxt={"Disagree"}
            />
          </>
        )
      }

      {
        chargeForCallModalStatus &&
        (
          <>
            <AcceptRejectModal
              text={timeLeftToEndCall < 120000 ?
                `${joinCallRes?.remote_user_name} has agreed to help you longer if you need it. Would you like to pay $25 for an additional ${formatTimeCommon(joinCallRes.total_call_time_limit_in_sec)} to extend your conversation? You will be charged in ${formatTimeCommon(timeLeftToEndCall / 1000)}` :
                `${joinCallRes?.remote_user_name} has agreed to help you longer if you need it. Would you like to pay $25 for an additional ${formatTimeCommon(joinCallRes.total_call_time_limit_in_sec)} to extend your conversation? You will be charge again after 2 minutes`}
              onClickReject={() => {
                localStorage.setItem("ChargeMe", 0)
                setChargeMeStatus(false)
                setChargeForCallModalStatus(false)
                console.log("No charge ")
              }}
              onClickAccept={() => {
                localStorage.setItem("ChargeMe", 1)
                setChargeMeStatus(true)
                setChargeForCallModalStatus(false)
                console.log("charge me ")
              }}
              modalStatus={chargeForCallModalStatus}
              yesBtnTxt={`YES, ADD ${formatTimeCommon(joinCallRes.total_call_time_limit_in_sec)}`}
              noBtnTxt={"NO, GO BACK"}
            />
          </>
        )
      }

      {/* Text draw modal */}
      {
        textAlert && (
          <>
            <DrawTextModal
              modalStatus={true}
              labelName={"Enter Text"}
              placeholderName={"Enter Text"}
              onChange={handleTextChange}
              errorOccured={textShapeMessageErr}
              errorMeesage={"Please enter text name"}
              value={localStorage.getItem("keyText")}
              yesBtnTxt={"Done"}
              noBtnTxt={"Cancel"}
              onClickReject={() => {
                setTextAlert(false);
                localStorage.setItem("keyText", "");
                localStorage.setItem("currentShape", "rec");
                setDrawCircle(false);
                setDrawRectangle(true);
                setDrawLine(false);
                setDrawText(false);
              }}
              onClickAccept={() => {
                if (localStorage.getItem("keyText").trim() !== "") {
                  setTextAlert(false);
                } else {
                  setTextShapeMessageErr(true);
                }
              }}
            />
          </>
        )
      }

      {
        openChatAlert && (
          <ResponceToaster
            toasterType={"info"}
            message={customerName + ":  " + messageOfChat}
            onClick={() => handleMessageToast()}
          />
        )
      }

      {
        screenshotModal && (
          <TwilioRoomScreenShotModal
            roomValue={room}
            handleCloseAddUser={() => {
              // setTabOpen(3);
              setScreenshotModal(false);
              callNoteData();
            }}
            joinCallResult={joinCallRes}
          />
        )
      }

      {
        openParticipantDisconnectMsg && (
          <ResponceToaster
            toasterType={"info"}
            message={"Participant has disconnected from call"}
          />
        )
      }

      {
        handleToaster && (
          <ResponceToaster toasterType={toasterType} message={responceMsg} />
        )
      }
      {
        feedbackModal && (
          <FeedbackModal
            addUserTrigger={feedbackModal}
            handleCloseAddUser={handleFeedbackModal}
          />
        )
      }
      {
        resourceModal && (
          <AvailableResources
            room={room}
            value={resourceModal}
            onClose={() => {
              setResourceModal(false);
            }}
            micOnOff={micStatus}
            videoOnOff={videoStatus}
            onResourceChange={(v) => {
              // console.log("vvvvvv",v)
              setVideoTracks(trackpubsToTracks(v));

              handleVideoOffStatus();
              videoTracks[0]?.restart({
                ...{ video: true },
              });
            }}
          />
        )
      }

      <Modal
        className="fade"
        show={cameraPermissionDialog}
      // onHide={handleClose}
      >
        <Modal.Header style={{ borderBottom: "none" }}>
          <Modal.Title>Camera Microphone Alert</Modal.Title>
          <Button
            variant=""
            className="btn-close btn-close-service"
            onClick={() => {
              setCameraPermissionDialog(false);
            }}></Button>
        </Modal.Header>

        <Modal.Body>
          <p>
            Chilll requires access to your camera and microphone. Click camera
            blocked icon in your browser's address bar or check you have valid
            source of mic and video
          </p>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <img
              src={CameraAlertImg}
              alt="Error camera alert"
              style={{
                boxShadow: "1px 1px 6px 2px black",
                borderRadius: "8px",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "15px",
            }}>
            <PrimaryButton
              buttonName={"Dismiss"}
              style={{ width: "100%" }}
              onClick={() => {
                setCameraPermissionDialog(false);
              }}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="fade"
        show={usePhoneMessageAlert}
      // onHide={handleClose}
      >
        <Modal.Header style={{ borderBottom: "none" }}>
          <Modal.Title>Chilll Alert</Modal.Title>
          <Button
            variant=""
            className="btn-close btn-close-service"
            onClick={() => {
              setUsePhoneMessaegAlert(false);
            }}></Button>
        </Modal.Header>

        <Modal.Body>
          <p>
            {usePhoneModalMessage == "Measure" ?
              `Virtual measuring tool only works when customer downloads and uses the app` :
              usePhoneModalMessage == "Flash" ?
                `Flash light only works when customer downloads and uses the app` :
                usePhoneModalMessage == "Zoom" ?
                  `Zoom only works when customer downloads and uses the app` :
                  `This functionality is not available on remote side`
            }

          </p>
        </Modal.Body>
      </Modal>

      {/* Modal for Sourcing Info*/}
      <>
        <Modal
          className="fade"
          show={sourcingInfoModalTrigger}
          // onHide={handleClose}
          centered
          size=""
        >
          <Modal.Body style={{ padding: "5px" }}>
            <div className="row mx-0">
              <div className="col-12 px-0 position-relative">
                <div
                  className="mx-0 row  schedule-modal-close-btn position-absolute text-hovered "
                  style={{
                    top: "5px",
                    right: "10px",
                  }}>
                  <div className="col-12 d-flex fs-4 justify-content-end px-0">
                    <span
                      onClick={() => handleCloseSourcingInfoModal()}
                      className="cursor-pointer">
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <div className="row mx-0 ">

                  <div className="col-12" style={{}}>
                    <div className="row h-100 w-100">
                      <div className="col-12 p-3 d-flex flex-column justify-content-between">
                        <div>


                          <div className="mx-0 row text-black mb-3">
                            <div className="col-12 font-w600 fs-3 px-0 text-center">
                              <span>{"Sourcing Info"}</span>
                            </div>
                          </div>

                          {sourcingInfoLoading ? <div>
                            <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                            <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                            <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                            <SkeletonDivElement height={'40px'} marginBottom={'7px'} borderRadius={'5px'} />
                          </div> :
                            <>
                              {sourcingInfoArr.length > 0 ?
                                <>
                                  {sourcingInfoArr.map((item, index) => {
                                    return (
                                      <>
                                        <a key={index} target="_blank" href={item?.url} rel="noreferrer">
                                          <div className="mx-0 row mb-2">
                                            <div
                                              className="col-12  px-0 rounded p-2 d-flex align-items-center overlay-action-btn cursor-pointer"
                                              style={{
                                                background: "rgba(244, 248, 255, 1)",
                                                border: "1px solid rgba(199, 212, 234, 1)",
                                              }}
                                            >
                                              <div className="w-100 font-w600 d-flex align-items-center justify-content-between px-3 fs-4">
                                                <div className="d-flex">
                                                  <i className="bi bi-filetype-pdf pe-2"></i>

                                                  <div className="d-flex flex-column">
                                                    <span className="fs-6 text-black">
                                                      {`${item?.name}`}
                                                    </span>
                                                    <span className="fs-7">
                                                      {`Source : ${item?.source ? item?.source : "-"}`}
                                                    </span>
                                                  </div>
                                                </div>

                                                <div>
                                                  <i className="bi bi-chevron-right" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </a>
                                      </>
                                    )
                                  })}
                                </> :
                                <>
                                  <div>
                                    <div className="my-5 d-flex justify-content-center align-items-center flex-column">

                                      <div className="mb-2">
                                        <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                      </div>
                                      <span>
                                        {`No record found`}
                                      </span>
                                    </div>
                                  </div>
                                </>

                              }
                            </>}


                        </div>

                        <div>
                          <div className="mx-0 row mt-3">
                            <div className="col-12  px-0 text-center">
                              <PrimaryButton
                                buttonName={"CLOSE"}
                                onClick={() => {
                                  handleCloseSourcingInfoModal();
                                }}
                                style={{
                                  width: "100%",
                                  background:
                                    "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                  border: "2px solid rgba(255, 154, 32, 1)",
                                  boxShadow:
                                    "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </Modal.Body>
        </Modal>
        <VideoCropperModal
          videoRef={videoRefRemote}
          modalStatus={ocrCropModal}
          buttonName={"Scan"}
          handleClose={(img) => {
            const [localValue] = [...room.localParticipant.dataTracks.values()];

            localValue.track.send("start_ocr");
            const video = document.getElementById("LP");
            video.pause();
            setRemoteSayOcr(true);
            setOcrCropModal(true)
            handleScreenShot(img);

            setImage(img)

            setOcrCropModal(false);

          }}
          handleCloseOnly={() => {
            setOcrCropModal(false)
            handleClearOCRSteps()
          }}
        />

        <VideoCropperModal
          videoRef={videoRefRemote}
          modalStatus={partsManualsCropModal}
          buttonName={"Scan"}
          handleClose={(img) => {
            const video = document.getElementById("LP");
            video.play();
            setImgForPartsManuals(img)
            handleScanDevicePartsManuals(img);
            setPartsManualsCropModal(false)
          }}
          handleCloseOnly={() => {
            setPartsManualsCropModal(false)
          }}
        />

      </>

      {/* <ScanQrModalTwilio/> */}
    </>
  );
};

export default Room;